
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("15BR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb39f7c2a1e3ebc$export$2e2bcd8739ae039);
// frontend/js/translations.js
function $0cb39f7c2a1e3ebc$export$88b0f9c4043edaa8(company = {}, tFn) {
    const tSafe = typeof tFn === 'function' ? tFn : (_k, fb)=>fb ?? '';
    const raw = company.csvRow ?? company.Id ?? company.ID ?? company.csv_id ?? company.csvIndex ?? company.row ?? company.rowId ?? company.csvRowNumber;
    const rowId = raw != null ? String(raw).trim() : '';
    const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;
    const pick = (key, fallback)=>{
        if (!rowId) return fallback;
        const v = tSafe(key, undefined);
        if (!v || v === key || typeof v === 'string' && MISSING_RE.test(v)) return fallback;
        return v;
    };
    const name = pick(`companies_by_id.${rowId}.Company_Name`, company['Company Name'] || company.name || '');
    const out = pick(`companies_by_id.${rowId}.Out_put`, company['Out put'] || company['Output'] || company.output || '');
    const desc = pick(`companies_by_id.${rowId}.Description`, company['Description'] || company.description || '');
    const risk = pick(`companies_by_id.${rowId}.Risk`, company['Risk'] || company.risk || '');
    return {
        name: name,
        out: out,
        desc: desc,
        risk: risk,
        rowId: rowId
    };
}
const $0cb39f7c2a1e3ebc$var$translations = {
    en: {
        translation: {
            "_meta": {
                "language": "English",
                "version": "1.0.0",
                "last_updated": "2025-08-05"
            },
            "nudge": {
                "next": "NEXT",
                "back": "Back",
                "done": "GOT IT",
                "tap_hint": "tap right to continue \xb7 swipe to move",
                "reopen": "How does this page work?",
                "sim_tag": "PRACTICE FLOOR",
                "sim_1_h": "This is practice.",
                "sim_1_b": "A safe run to learn how trading your life works. Nothing here is permanent \u2014 explore freely.",
                "sim_2_h": "Look at what you hold.",
                "sim_2_b": "Scroll down. Each section below is something you own right now. Tap a section to open it.",
                "sim_3_h": "Then enter the Market.",
                "sim_3_b": "When you are ready, hit the button at the bottom to walk onto the open floor and trade.",
                "sim_cta": "GOT IT \u2014 TAKE ME IN",
                "trader_tag": "YOUR SIDE OF THE FLOOR",
                "trader_1_h": "This is everything you carry.",
                "trader_1_b": "Your holdings and your mission live here. Tap any section to open it; tap again to close.",
                "trader_2_h": "Your mission is up top.",
                "trader_2_b": "It tells you what to aim for. Trade to move toward it.",
                "trader_3_h": "Go to the Market to trade.",
                "trader_3_b": "The open floor is where you offer for what other people hold. Use the button at the bottom.",
                "trader_cta": "GOT IT",
                "market_tag": "THE OPEN FLOOR",
                "market_1_h": "Find something that matters to YOU.",
                "market_1_b": "Scroll the things other traders hold. This is not about money \u2014 it is about what you value.",
                "market_2_h": "Tap it to make an offer.",
                "market_2_b": "Ask yourself: what is that worth in my life? Then offer relational value, a swap, or a bid.",
                "market_3_h": "They accept \u2192 it is yours.",
                "market_3_b": "The owner says yes and it moves into your life. No cash anywhere.",
                "market_cta": "GOT IT",
                "stock_tag": "MAKE YOUR OFFER",
                "stock_0_h": "You are bidding on a life value.",
                "stock_0_b": "This stock is a piece of what another trader IS. Your goal: name a price and convince them to let you hold a share of it.",
                "stock_choice_h": "First, choose how you pay.",
                "stock_choice_b": "Two buttons up top: ZOLLARS pays in relationships (Love, Grief, Friendship\u2026) \u2014 the heart of this market. CAPITAL pays in plain capital (\u01B5), if you must.",
                "stock_1_h": "Then set your price.",
                "stock_1_b": "With Zollars: tap \u201CSET YOUR ZOLLAR OFFER\u201D and drag each glowing bar \u2014 further right = more of that relationship offered. With Capital: just type the amount.",
                "stock_2_h": "Set how many shares.",
                "stock_2_b": "Type the number of shares you want in the SHARES box \u2014 up to what the owner has available.",
                "stock_3_h": "Place your bid.",
                "stock_3_b": "Hit Place Bid and say why you want it. The owner decides whether to let it go to you.",
                "stock_cta": "GOT IT",
                "bond_tag": "TAKE A PROMISE",
                "bond_1_h": "A Z Bond is a promise.",
                "bond_1_b": "Relational value now, repaid later with interest in lived experience.",
                "bond_2_h": "Pick the amount and term.",
                "bond_2_b": "Choose how much and for how long, then submit to take the promise on.",
                "bond_cta": "GOT IT",
                "trans_tag": "OFFER A SWAP",
                "trans_1_h": "This trader wants the item up top.",
                "trans_1_b": "You trade for it by giving one of your own things in return \u2014 a straight swap, no money.",
                "trans_2_h": "Pick what you will give.",
                "trans_2_b": "Scroll your own holdings below and choose one to offer.",
                "trans_3_h": "Propose the swap.",
                "trans_3_b": "Tap \u201CPropose\u201D on the thing you are offering. The owner decides whether to accept.",
                "trans_cta": "GOT IT",
                "redeem_tag": "CLAIM IT INTO REAL LIFE",
                "redeem_1_h": "Consumption here is social.",
                "redeem_1_b": "You cannot consume a thing alone \u2014 another trader's item has to validate it first.",
                "redeem_2_h": "Send a redeem ask.",
                "redeem_2_b": "Ask the floor to validate your thing. Once matched, it becomes real and yours to collect.",
                "redeem_cta": "GOT IT",
                "eco_tag": "HEAVY MACHINERY",
                "eco_1_h": "These are the heavy levers.",
                "eco_1_b": "Economic moves that act on OTHER traders \u2014 gifts and weapons. Each button says what it does in plain words; press and hold one to see the mechanics underneath.",
                "eco_2_h": "Give or take.",
                "eco_2_b": "BACK A FRIEND covers someone now. SOCIALIST SUBSIDY taxes a trader 45% and splits it among everyone. COMMUNIST ASSAULT seizes an entire portfolio and redistributes it. HOSTILE TAKEOVER buys a trader out. PREY ON DESPERATION profits from need \u2014 and the room remembers.",
                "eco_3_h": "Debts here are emotional.",
                "eco_3_b": "The meter above tracks what you owe and are owed in trust and help \u2014 not numbers. Life squares it later.",
                "eco_cta": "UNDERSTOOD",
                "tools_tag": "REACH OTHER TRADERS",
                "tools_1_h": "Ways to reach the room.",
                "tools_1_b": "Message another trader, steal what isn\u2019t yours, hold someone hostage until they pay, or open a private back-room market away from the floor\u2019s eyes.",
                "tools_2_h": "Every act has a social echo.",
                "tools_2_b": "These aren\u2019t menu options \u2014 they\u2019re gestures. The floor sees what you do and treats you accordingly. Press and hold any button to see its mechanics.",
                "tools_cta": "UNDERSTOOD",
                "botmsg_tag": "SOMEONE IS TALKING TO YOU",
                "botmsg_1_h": "That message is from another trader.",
                "botmsg_1_b": "Everyone on the floor holds values, makes offers, and talks. This trader just reached out to you.",
                "botmsg_2_h": "Answer it \u2014 or don't.",
                "botmsg_2_b": "You can reply, trade with them, or ignore them. What you say and do shapes how the room treats you.",
                "botmsg_cta": "GOT IT",
                "mm_tag": "MEMENTO MORI",
                "mm_1_h": "Remember you must die.",
                "mm_1_b": "This run has a hard end: when the timer hits zero, your trading life is over. Everything you hold at that moment is read as your legacy.",
                "mm_2_h": "You already chose your legacy stocks.",
                "mm_2_b": "The companies you picked from your reflections carry your values. They're in your portfolio below \u2014 open the sections to see what you're starting with.",
                "mm_3_h": "Your eulogy writes itself.",
                "mm_3_b": "The red bar at the very top is your eulogy, rewritten as you trade. Tap it anytime to read what would be said of you if it ended right now.",
                "mm_4_h": "Trade toward how you want to be remembered.",
                "mm_4_b": "Go to the Market: grow what matters, let go of what doesn't. When time ends, the bourse speaks over your grave.",
                "mm_cta": "I UNDERSTAND",
                "mm_mkt_tag": "MEMENTO MORI \u2014 THE FLOOR",
                "mm_mkt_1_h": "Every offer is a legacy choice.",
                "mm_mkt_1_b": "Bid relational Zollars for the life values you want your name tied to. Time is running out \u2014 the eulogy bar up top listens to every trade.",
                "mm_mkt_2_h": "Let go, too.",
                "mm_mkt_2_b": "Accepting offers and releasing holdings is part of it: what you let go of says as much about you as what you keep.",
                "mm_mkt_cta": "GOT IT",
                "cn_tag": "CATENA NARRATIVA",
                "cn_1_h": "You are building a story.",
                "cn_1_b": "In Catena Narrativa, story pieces are traded like commodities. The pieces you hold \u2014 and how you rewrite them \u2014 become a short story at the end.",
                "cn_2_h": "Three phases, one clock.",
                "cn_2_b": "BEGINNING \u2192 MIDDLE \u2192 END, about 8 minutes total. The timer banner up top shows the current phase. When a phase ends, the pieces you hold are secured into your story ledger.",
                "cn_3_h": "Your story elements live below.",
                "cn_3_b": "The \u201CYour Story Elements\u201D panel lists the pieces you hold right now. Open your sections to see everything you carry.",
                "cn_4_h": "Trade to shape the story.",
                "cn_4_b": "Go to the Market and swap or bid for pieces your story needs. Every trade lets you rewrite the element in your own words \u2014 that is how the story becomes yours.",
                "cn_cta": "START TRADING",
                "cn_mkt_tag": "CATENA NARRATIVA \u2014 THE FLOOR",
                "cn_mkt_1_h": "Every item here is a story piece.",
                "cn_mkt_1_b": "Tap the \u201CBullets\u201D button to see the elements you already hold, then offer or swap for the pieces your story needs before the phase ends.",
                "cn_mkt_2_h": "Trading is rewriting.",
                "cn_mkt_2_b": "When an exchange goes through, you write how the element changes in your hands. Value forms through the exchange \u2014 that text feeds the final story.",
                "cn_mkt_cta": "GOT IT",
                "cn_swap_1_h": "You are swapping story pieces.",
                "cn_swap_1_b": "This trader holds an element your story could use. Scroll your own holdings below and pick one to give in return.",
                "cn_swap_2_h": "Then rewrite it.",
                "cn_swap_2_b": "When you propose, you will say how the element is customized \u2014 at least a sentence. Make it count: it goes straight into the story.",
                "cn_swap_cta": "GOT IT"
            },
            "floor": {
                "mission_label": "YOUR MISSION",
                "mission_class": "CLASS",
                "your_stocks": "YOUR STOCKS",
                "do_trader": "<b>\u2192 Go to the open floor</b> and trade for what your mission needs.",
                "do_market": "<b>\u2192 Tap something a trader holds</b> and make an offer.",
                "wedividual": "THE WEDIVIDUAL",
                "hero_sub": "the room's interior worth, live \u2014 in the seat where GDP would sit",
                "hero_sub_count": "measured from {n} relational trades in this room \u2014 not GDP",
                "hero_tip": "Not GDP. The Wedividual is this room measured from the inside: every trade of relational value (love, grief, friendship, hate...) moves it. When you trade, you move how the room feels.",
                "mood_euphoric": "EUPHORIC",
                "mood_warm": "WARM",
                "mood_steady": "STEADY",
                "mood_heavy": "HEAVY",
                "mood_dark": "DARK",
                "your_position": "YOUR POSITION \xb7 LIFE PROFIT",
                "declared_note": "you walked onto the floor carrying",
                "fold_holdings": "WHAT YOU HOLD",
                "fold_holdings_hint": "life values \xb7 things \xb7 zollars \xb7 promises",
                "fold_interior": "YOUR INTERIOR LEDGER",
                "fold_interior_hint": "emotional state & debt",
                "fold_moves": "INSTRUMENTS & WEAPONS",
                "fold_moves_hint": "gifts, loans, attacks \u2014 economics as a verb",
                "board_things": "THINGS ON THE FLOOR",
                "board_things_hint": "tap one to offer relational value for it",
                "board_values": "LIFE VALUES ON THE BOARD",
                "board_values_hint": "shares of lived experience \u2014 priced by feeling",
                "board_bonds": "PROMISES (Z BONDS)",
                "board_bonds_hint": "relational value now, repaid in experience later",
                "status_trader": "This is your portfolio \u2014 what you hold and what you owe. <b>Your move: go to the floor and trade.</b>",
                "status_market": "The floor \u2014 everything other traders are holding. <b>Tap anything to make an offer</b>; you pay with your Zollars.",
                "status_redeem": "You have a match. <b>Your move: hit REDEEM and claim it into your life.</b>",
                "status_memento": "<b>MEMENTO MORI</b> \u2014 every trade becomes a line of your eulogy. Hold what you want said about you.",
                "memento_chip": "MEMENTO MORI",
                "phase_1_chip": "PHASE 1/3 \xb7 BEGINNING",
                "phase_1_trader": "<b>BEGINNING</b> \u2014 the story needs raw material. Your move: go gather story elements from the floor.",
                "phase_1_market": "<b>BEGINNING</b> \u2014 the story needs raw material. Tap a story element below and offer for it.",
                "phase_1_go": "GO GET STORY ELEMENTS",
                "phase_1_cta": "OFFER FOR AN ELEMENT",
                "phase_2_chip": "PHASE 2/3 \xb7 MIDDLE",
                "phase_2_trader": "<b>MIDDLE</b> \u2014 complication time. Your move: trade and customize the elements you hold.",
                "phase_2_market": "<b>MIDDLE</b> \u2014 complication time. Trade for elements that twist your story.",
                "phase_2_go": "TRADE YOUR ELEMENTS",
                "phase_2_cta": "TRADE FOR A TWIST",
                "phase_3_chip": "PHASE 3/3 \xb7 END",
                "phase_3_status": "<b>END</b> \u2014 consolidation. Keep what matters; the story will be written from what you hold when the clock runs out.",
                "phase_3_go": "REVIEW WHAT YOU HOLD",
                "phase_3_cta": "FINAL TRADES",
                "cta_offer": "MAKE AN OFFER",
                "cta_offer_hint": "Tap anything on the board \u2014 you will offer <b>relational value</b> (your Zollars: love, friendship, grief...) to get it.",
                "tape_gdp": "GDP NOT QUOTED ON THIS FLOOR",
                "tape_love": "LOVE ACCEPTED AT ALL WINDOWS",
                "tape_grief": "GRIEF TRADES AT PAR WITH JOY",
                "tape_move": "EVERY TRADE MOVES THE ROOM",
                "tape_interior": "INTERIOR VALUE ONLY \xb7 BRING WHAT YOU FEEL",
                "tk_trade": "A TRADE SEALED \xb7 RELATIONAL VALUE CHANGED HANDS",
                "tk_bid_yes": "AN OFFER WAS EMBRACED",
                "tk_bid_no": "AN OFFER WAS TURNED DOWN",
                "tk_zollar": "FRESH ZOLLARS ENTERED THE ROOM",
                "tk_burst": "THE FLOOR IS RUNNING HOT",
                "tk_short": "SOMEONE IS BETTING AGAINST A LIFE VALUE",
                "tk_bourse": "THE BOURSE HAS SPOKEN ON A TRADE",
                "tk_pool": "A BACK ROOM OPENED SOMEWHERE",
                "tk_subsidy": "SOMEONE WAS LIFTED BY THE COLLECTIVE",
                "tk_theft": "THEFT ON THE FLOOR \xb7 WATCH YOUR HOLDINGS",
                "tk_memento": "MEMENTO MORI \xb7 THE CLOCK MOVES",
                "tk_declared": "{v} IS ON THE FLOOR \xb7 DECLARED, NOT PRICED",
                "ps_tap": "hold to see mechanics",
                "ps_altrau": "BACK A FRIEND",
                "ps_altrau_tip": "You cover another trader now. The debt it creates is emotional, not numeric \u2014 it sits on your interior ledger until life squares it.",
                "ps_mnote": "BORROW AGAINST YOURSELF",
                "ps_mnote_tip": "Take capital now and owe your future self. The market remembers what you promised to become.",
                "ps_cdo": "PREY ON DESPERATION",
                "ps_cdo_tip": "Lend to someone who cannot say no, then sell their struggle on. Profitable. It will cost you interior credit with the room.",
                "ps_vnote": "ASK THE ROOM FOR AID",
                "ps_vnote_tip": "Request help from the floor. No shame here \u2014 need is a tradable truth like any other.",
                "ps_steal": "TAKE WHAT ISN'T YOURS",
                "ps_steal_tip": "Theft, plainly. You gain the thing; the room learns what you are.",
                "ps_ransom": "HOLD SOMEONE HOSTAGE",
                "ps_ransom_tip": "Lock another trader out of their own life until they pay you to give it back.",
                "ps_darkpool": "OPEN A BACK ROOM",
                "ps_darkpool_tip": "Opens a private trading room away from the floor's eyes. Deals struck there stay hidden and don't move the shared mood \u2014 that is the point, and the problem.",
                "ps_lbo": "HOSTILE TAKEOVER",
                "ps_lbo_tip": "Pick a trader and buy them out: you pay the takeover cost in capital (they receive it), and the items and stocks you selected become YOURS. A buyout, not a gift.",
                "ps_subsidy": "SOCIALIST SUBSIDY",
                "ps_subsidy_tip": "Pick a trader to tax: 45% of their capital, items and Zollars is taken and split equally among every other trader on the floor. Redistribution from the top down.",
                "ps_assault": "COMMUNIST ASSAULT",
                "ps_assault_tip": "Pick a trader: their ENTIRE portfolio \u2014 capital, items, stocks, Zollars \u2014 is seized and distributed among everyone else on the floor. They are wiped to zero. Total redistribution, used as a weapon.",
                "ps_holdings": "WHAT YOU CARRY",
                "ps_holdings_tip": "Your position: the stocks, commodities, Zollars and promises currently in your hands.",
                "ps_zollar_tip": "Money denominated in relationships instead of numbers: Love, Friendship, Hate, Grief... You pay with what a relationship is worth to you.",
                "ps_bond_tip": "A promise with feelings attached: relational value now, repaid with interest in lived experience later.",
                "ps_short_tip": "A bet against a life value \u2014 you profit if it falls. Yes, you can short joy. Ask yourself why.",
                "ps_stock_tip": "Shares in life values \u2014 slices of intellect, affection, partying, melancholy. Their price is what the room feels they are worth.",
                "ps_commodity_tip": "Real things with a catch: you cannot consume one until another trader validates it. Consumption here is social or not at all.",
                "ps_value": "Value",
                "ps_value_tip": "What the holder asks for it \u2014 payable in relational worth, not cash.",
                "ps_redeem": "Redeem",
                "ps_redeem_tip": "Claim a thing into your real life. Needs another trader's item to validate it first \u2014 consumption here is social.",
                "ps_owner": "Owner",
                "ps_owner_tip": "The trader whose life this currently belongs to. Your offer goes to them.",
                "ob_title": "BEFORE YOU TRADE",
                "ob_sub": "This floor does not price your output. It prices your interior. Pick up to three things you actually value \u2014 they become what you carry, and what you can spend.",
                "ob_custom": "or name one of your own + Enter",
                "ob_custom_h": "yours alone",
                "ob_go": "CARRY THESE ONTO THE FLOOR",
                "ob_skip": "skip \u2014 I know this floor",
                "ob_done": "Declared. These are on your position now. <b>Your move: take them to the open floor.</b>",
                "ob_love": "LOVE",
                "ob_love_h": "what you would give anything to keep",
                "ob_friendship": "FRIENDSHIP",
                "ob_friendship_h": "the people who hold you up",
                "ob_fellowship": "FELLOWSHIP",
                "ob_fellowship_h": "belonging to something bigger",
                "ob_erotic": "EROTIC",
                "ob_erotic_h": "desire, fully owned",
                "ob_hate": "HATE",
                "ob_hate_h": "it counts \u2014 it is yours too",
                "ob_toxic": "TOXIC",
                "ob_toxic_h": "the bonds that cost you",
                "ob_superficial": "SUPERFICIALITY",
                "ob_superficial_h": "the shallow joys, no apology",
                "ob_dead": "WHAT'S GONE",
                "ob_dead_h": "dead relationships still trade here",
                "sec_stocks": "LIFE VALUES",
                "sec_commodities": "THINGS",
                "sec_zollars": "ZOLLARS",
                "sec_zbonds": "PROMISES",
                "sec_redeemed": "REDEEMED",
                "sec_shorts": "BETS AGAINST",
                "sec_emotional": "INTERIOR LEDGER",
                "sec_social": "GIVE / LEND / PREY",
                "sec_tools": "TOOLS",
                "sec_economic": "WEAPONS",
                "flow_title": "HOW TRADING WORKS HERE",
                "flow_1_n": "1",
                "flow_1_h": "FIND IT",
                "flow_1_b": "Scroll what other traders hold. Tap something you want.",
                "flow_2_n": "2",
                "flow_2_h": "OFFER WHAT IT'S WORTH TO YOU",
                "flow_2_b": "Pay in relational value \u2014 your Zollars (love, grief, friendship...), a swap, or a bid.",
                "flow_3_n": "3",
                "flow_3_b": "THEY SAY YES \u2192 IT'S YOURS",
                "flow_3_h": "The owner accepts and it moves into your life. No cash anywhere.",
                "btn_swap": "SWAP",
                "btn_swap_tip": "Offer one of your own things in exchange for theirs. A straight trade of holdings.",
                "btn_offer_zollars": "OFFER ZOLLARS",
                "btn_offer_zollars_tip": "Pay for this with your relational currency \u2014 Love, Grief, Friendship Zollars. You name what it's worth to you.",
                "btn_offer_share": "BUY",
                "btn_offer_share_tip": "Make a bid for a share of this life value. If the owner accepts, the share is yours.",
                "btn_bet_against": "BET AGAINST",
                "btn_bet_against_tip": "Short it \u2014 you profit if this life value falls. You are wagering against someone's worth. Sit with that.",
                "btn_take_promise": "TAKE PROMISE",
                "btn_take_promise_tip": "Buy this Z Bond: relational value now, repaid with interest in lived experience later.",
                "btn_offer_promise": "OFFER",
                "btn_offer_promise_tip": "Bid on this promise. The owner decides whether to let it go to you.",
                "hero_eyebrow": "HOW THE ROOM FEELS RIGHT NOW",
                "gauge_low": "HEAVY",
                "gauge_high": "EUPHORIC",
                "hero_sub2": "the shared mood of everyone trading \u2014 the floor's index, instead of GDP",
                "hero_sub_count2": "read from {n} trades on the floor \u2014 our index, instead of GDP",
                "delta_up": "warmer than a moment ago",
                "delta_down": "heavier than a moment ago",
                "nav_portfolio": "MY PORTFOLIO",
                "nav_search": "SEARCH",
                "your_portfolio": "YOUR PORTFOLIO",
                "portfolio_explain": "everything you hold on the floor. its total worth, counted as Life Profit \u2014 your lived experience, not money:",
                "count_held": "{n} held",
                "count_empty": "empty",
                "exp_stocks": "Shares you hold in human values (like intellect or affection). Their worth rises and falls with how the room feels.",
                "exp_commodities": "Real things you hold. You can't consume one until another trader validates it \u2014 consumption here is social.",
                "exp_zollars": "Your spending money \u2014 but counted in relationships (Love, Grief, Friendship). This is what you pay with when you trade.",
                "exp_zbonds": "Promises you hold: relational value now, repaid later with interest in lived experience.",
                "exp_redeemed": "Things you've claimed into real life, kept as QR codes to collect.",
                "exp_shorts": "Life values you've bet against \u2014 you gain if their worth falls.",
                "exp_emotional": "Your emotional balance sheet \u2014 what you owe and are owed in trust, help, and betrayal.",
                "exp_social": "Ways to act on other people: back a friend, lend, ask for aid, or prey on someone. Economics as gestures.",
                "exp_tools": "Reach other traders: message them, steal, ransom, or open a private back-room market.",
                "exp_economic": "Heavy moves: hostile takeover, collective subsidy, or delete your portfolio entirely.",
                "exp_stock_bid": "Another trader on the floor \u2014 often one of the market's bots \u2014 wants to buy shares you hold. Accept and their payment is yours; decline and nothing changes.",
                "exp_trade_offer": "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too \u2014 respond exactly as you would to a person.",
                "exp_buy_offer": "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.",
                "exp_tax": "This is the Zederal Reserve \u2014 the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.",
                "exp_short": "Shorting is betting that this life value will FALL. If it drops, you profit from the decline. You are wagering against someone's worth \u2014 the room will know.",
                "exp_analysis": "This is the voice of the bourse \u2014 the market itself reacting to a trade that just happened on the floor. It's commentary, not a request: read it, close it, nothing is asked of you."
            },
            "auth": {
                "trader_id_placeholder": "Trader ID",
                "password_placeholder": "Password",
                "login_button": "Login",
                "login_validation_message": "Please enter both Trader ID and Password",
                "login_failed_message": "Login failed. Please check your credentials and try again.",
                "login_error_message": "An error occurred during login. Please try again later.",
                "authentication_failed_message": "Authentication failed. Please log in again.",
                "password_required_message": "Password is required.",
                "enter_trader_name_placeholder": "Enter your Trader Name",
                "enter_new_password_placeholder": "Enter your new password",
                "secure_password_placeholder": "Enter secure password",
                "set_password_label": "Set Password",
                "authentication_failed": "Authentication failed. Please log in again.",
                "session_required": "Session ID is missing. Please log in again."
            },
            "navigation": {
                "nav_commodity": "Commodity",
                "nav_zollars": "Zollars",
                "nav_stock_zbond": "Stock & ZBond",
                "nav_company": "Company",
                "nav_portfolios": "Portfolios",
                "nav_control_panel": "Control Panel"
            },
            "buttons": {
                "scan_button": "Scan",
                "fulfill_button": "Fulfill",
                "create_session_button": "Create Session",
                "search_button": "Search",
                "close_search_button": "Close Search",
                "cancel_button": "Cancel",
                "close_button": "Close",
                "complete_setup_button": "Complete Setup",
                "save_button": "Save",
                "delete_button": "Delete",
                "modify_name_button": "Modify Name",
                "modify_password_button": "Modify Password",
                "logout_trader_button": "Log Out Trader",
                "view_qr_codes_button": "View Login QR Codes",
                "enter_mortality_chamber_button": "Enter Mortality Chamber",
                "continue_button": "Continue",
                "validate_key": "Validate Key",
                "scan_qr_code": "Scan QR Code"
            },
            "stock_bid": {
                "title": "Stock Bid Offer",
                "offers_to_buy_points": "{portfolioName} offers to buy {shares} shares of {stockName} for {amount} of Capital.",
                "offers_to_buy_zollars": "{portfolioName} offers to buy {shares} shares of {stockName} for the following zollars:",
                "time_remaining": "Time remaining: {seconds} seconds",
                "time_expired": "Time expired",
                "processing_bid": "Processing your bid...",
                "no_response": "No response received. This action has expired.",
                "offer_expired": "No response received. Your offer expired."
            },
            "forms": {
                "mood_one_word": "What quality or feeling are you living right now?",
                "one_word_hint": "(1 word)",
                "reason_label": "Why do you feel that?",
                "value_definition": "Why do you feel this way? (Value)",
                "value_definition_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
                "value_reaction": "What does this feeling give you? (Life Profits)",
                "value_reaction_placeholder": "e.g., gives me energy, makes me depressed, helps me grow...",
                "experiences_label": "What creates this feeling?",
                "search_stocks_placeholder": "Search Stocks",
                "company_name_fixed_label": "Company Name (fixed):",
                "company_description_label": "Company Description:",
                "company_product_label": "Company Product/Output:",
                "trader_name_label": "Trader Name:",
                "session_name_label": "Session Name",
                "session_name_placeholder": "Enter session name (letters, numbers, underscores only)",
                "single_word_example": "e.g., happy, sad, drunk, joy...",
                "reason_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
                "describe_feeling_placeholder": "e.g., gives me energy, makes me depressed, helps me grow..."
            },
            "modals": {
                "select_action_title": "Select an Action",
                "action_modal_description": "Select Scan to be directed to the scan items page. Select Fulfill to fulfill orders.",
                "choose_simulation_title": "Choose Your Simulation Experience",
                "memento_mori_title": "Memento Mori Simulation",
                "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
                "create_new_session_title": "Create New Session",
                "session_creation_description": "Create a new trading session as the Zederal Reserve Central Bank.",
                "assign_to_portfolio_title": "Assign to Portfolio:",
                "select_portfolio_short_title": "Select a Portfolio to Place Short Position",
                "select_portfolio_transfer_title": "Select a Portfolio to Transfer Ownership"
            },
            "tables": {
                "table_stock_name": "Stock Name",
                "table_symbol": "Symbol",
                "table_share_value": "Share Value",
                "table_owner": "Owner",
                "table_shorted": "Shorted",
                "table_place_short": "Place Short",
                "table_delete": "Delete"
            },
            "socketBack": {
                "narrativeProcessed": "Narrative response processed",
                "unauthorizedSuperUser": "Unauthorized: Only Zederal Reserve bankers can perform this action",
                "noTargetUser": "No target trader provided",
                "logoutByAdmin": "You have been logged out by an administrator.",
                "logoutUserSuccess": "User {id} has been forced to logout successfully.",
                "logoutUserOffline": "User {id} is already offline.",
                "marketClosed": "The market has closed.",
                "logoutAllSuccess": "All traders have been logged out successfully",
                "taxEvent": "You are being charged a market tax. Choose to give a random commodity or lose capital.",
                "zollarIssued": "A Zollar has been issued to you by the Zederal Reserve.",
                "zollarFailed": "Failed to assign Zollars",
                "ransomAssigned": "You have received the ransom trigger.",
                "ransomLocked": "Your portfolio has been locked with a ransom of {points} capital.",
                "lboAssigned": "You have received the Leveraged Buyout (LBO) trigger.",
                "lboAssetsRemoved": "Assets have been removed from your portfolio due to an LBO.",
                "removedStocksLabel": "Removed Stocks:",
                "removedItemsLabel": "Removed Items:",
                "unknownStock": "Unknown Stock",
                "unknownItem": "Unknown Item",
                "sharesWord": "shares",
                "ofWord": "of",
                "subsidyAssigned": "You have received a Subsidy trigger.",
                "subsidyUpdate": "45% of your wealth has been redistributed as a Socialist Subsidy for the lower income earners.",
                "subsidyReceived": "You have received a socialist subsidy.",
                "pointsGiven": "Capital has been issued.",
                "itemsDistributed": "Commodities have been distributed.",
                "freebieZ1Message": "The Zederal Reserve has distributed a free commodity to your portfolio!",
                "ransomPaidNotification": "{userName} has paid the ransom of {points} capital. The funds have been transferred to your account.",
                "pointsDeducted": "{amount} capital have been deducted from your account.",
                "itemTaxed": "Zederal Reserve has taxed a commodity from your holdings.",
                "deleteButtonAssigned": "You have received a Communist Assault trigger.",
                "deletePerformed": "Your portfolio has been targeted by a Communist Assault.",
                "subsidyUpdateBotTarget": "{botName} has initiated a Socialist Subsidy - 45% of your wealth has been redistributed.",
                "specialSubsidyTarget": "{botName} redistributed 45% of your wealth through Socialist Subsidy",
                "subsidyReceivedFrom": "You received a Socialist Subsidy from {botName}'s redistribution action!",
                "specialSubsidyReceived": "You received wealth from {botName}'s Socialist Subsidy",
                "ransomLockedBy": "{botName} has frozen your portfolio with a ransom of {points} capital!",
                "specialRansomTarget": "{botName} has frozen your portfolio with a ransom demand",
                "specialRansomImpact": "Portfolio locked - {points} capital required",
                "lboExecutedOnYouBy": "{botName} has executed a Leveraged Buyout on your portfolio.",
                "specialLboTarget": "Your portfolio was targeted in a Leveraged Buyout (LBO) from {botName}",
                "itemStolen": "{botName} has stolen \"{itemName}\" from your portfolio!",
                "specialStealTarget": "{botName} stole \"{itemName}\" from you",
                "deleteUpdateBy": "{botName} has executed a Communist Assault on your portfolio!",
                "specialDeleteTarget": "{botName} executed a Communist Assault on your portfolio",
                "assaultGameEvent": "{botName} executed a Communist Assault on {targetName}!",
                "unknownPlayer": "Unknown Player",
                "tradeAccepted": "Trade accepted! Capital awarded.",
                "tradeDeclined": "Trade declined. No capital awarded."
            },
            "titles": {
                "owned_stock_list_title": "Owned Stock List",
                "short_positions_title": "Short Positions",
                "stock_management_guide_title": "Stock Management Guide"
            },
            "validation": {
                "select_company_first_message": "Please select a company first before claiming.",
                "fill_trader_name_password_message": "Please fill in your Trader Name and new Password.",
                "company_details_required_message": "Company details are required. Please complete the company selection process.",
                "portfolio_count_validation": "Number of portfolios must be between 1 and 50.",
                "items_per_portfolio_validation": "Number of items per portfolio must be between 0 and 10.",
                "simulation_questions_required": "Please answer all questions. Enter a single word for your mood and explain both why you feel that way and what creates this feeling."
            },
            "messages": {
                "success": "Success",
                "error": "Error",
                "loading": "Loading...",
                "qr_error_message": "Error displaying QR codes. Please try again.",
                "portfolios_created_success": "Portfolio(s) created successfully",
                "portfolio_add_error": "Error adding portfolio. Please try again.",
                "portfolio_updated_success": "Portfolio updated successfully",
                "fetch_portfolios_error": "Error fetching portfolios. Please try again later."
            },
            "backend_messages": {
                "invalid_decision_message": "Invalid decision.",
                "assignment_in_progress": "Assignment is already in progress.",
                "session_id_required": "Session ID is required.",
                "not_enough_items_assign": "Not enough available items to assign",
                "items_assigned_success": "New items assigned to all portfolios successfully.",
                "items_assign_failed": "Failed to assign new items",
                "items_assigned_successfully": "Items successfully assigned.",
                "no_available_items": "No available items for assignment.",
                "failed_assign_items": "Failed to assign items.",
                "points_distributed_success": "Captial distributed successfully.",
                "points_distribute_failed": "Failed to distribute capital.",
                "items_removed_success": "Items successfully removed.",
                "no_items_for_removal": "No non-redeemed items available for removal.",
                "failed_remove_items": "Failed to remove items.",
                "tax_points_item_deducted": "Capital & Random item deducted by Z Tax Authorities.",
                "tax_points_deducted": "trading capital deducted by Z Tax Authorities.",
                "tax_points_zollars_item_deducted": "& Random Commodity deducted by Zederal Reserve Tax Authorities.",
                "tax_points_zollars_deducted": "deducted by Zederal Reserve Tax Authorities.",
                "tax_item_removed": "Random item removed by Z Tax Authorities.",
                "error_fetching_portfolios": "Error fetching portfolios",
                "portfolio_updated_success": "Portfolio updated successfully",
                "portfolio_not_found": "Portfolio not found",
                "error_updating_portfolio": "Error updating portfolio",
                "internal_server_error": "Internal server error",
                "item_already_assigned": "Item is already assigned to this portfolio",
                "item_assigned_success": "Item assigned to portfolio successfully",
                "item_unassigned_success": "Item unassigned from portfolio successfully",
                "create_community_button_assigned": "Create community button assigned successfully",
                "portfolio_deleted_success": "Portfolio deleted successfully, items and stocks unassigned.",
                "no_zollars_found": "No Zollars found for this portfolio",
                "failed_fetch_bonds": "Failed to fetch bonds",
                "message_exceeds_280": "Message exceeds 280 characters.",
                "sender_portfolio_not_found": "Sender portfolio not found.",
                "recipient_portfolio_not_found": "Recipient portfolio not found.",
                "not_enough_points_message": "Not enough capital to send a message.",
                "message_sent_successfully": "Message sent successfully",
                "session_mismatch_sender": "Action not allowed. Session mismatch for sender.",
                "session_mismatch_recipient": "Action not allowed. Session mismatch for recipient.",
                "requesting_portfolio_not_found": "Requesting portfolio not found",
                "user_not_part_of_session": "User is not part of any session",
                "item_not_found": "Item not found",
                "no_unassigned_items": "No unassigned items found",
                "portfolio_not_found_in_session": "Portfolio not found in this session",
                "item_not_found_in_session": "Item not found in this session",
                "failed_assign_item_portfolio": "Failed to assign item to portfolio"
            },
            "ui_labels": {
                "show_explanations_label": "Show Explanations",
                "currency": "Currency",
                "balance": "Balance",
                "price": "Price",
                "quantity": "Quantity",
                "total": "Total",
                "date": "Date",
                "time": "Time",
                "status": "Status",
                "active": "Active",
                "inactive": "Inactive",
                "pending": "Pending",
                "completed": "Completed",
                "failed": "Failed"
            },
            "marketing": {
                "tailor_stock_choice_message": "Tailor your stock choice to align exactly with your values.",
                "footer_copyright": "All rights reserved ZExchange 2025. ZExchange is part of <a href=\"https://zeconomy.xyz\"> ZEconomy. </a>",
                "programs": {
                    "nav_home": "\u2190 Return to ZExchange",
                    "nav_contact": "Get in Touch",
                    "page_title": "ZExchange Studio Program",
                    "tagline": "Life profits.",
                    "intro": "A three-part program where participants enter an artist-designed economy, learning key conceptual points, build systems of value (Real or Artistic), and trade live on the ZExchange platform.",
                    "part_one_title": "Part One: Theoretical Framework",
                    "part_one_text": "Where does value reside; in the artwork? in the object, the institution, or the experience? From Belting's cult image to Polanyi's fictitious commodities, from Fried's theatricality to algorithmic price validation. A rigorous introduction to displacement as both an art-historical trajectory and economic intervention.",
                    "part_two_title": "Part Two: Creative Atelier",
                    "part_two_text": "Participants design their own value systems following the ideas from the ZEconomy developed during the theoretical explanations. Economic architecture as artistic medium.",
                    "part_three_title": "Part Three: Live Trading Floor",
                    "part_three_text": "The ZEconomy comes to life. 10\u2013200 participants trade in real time on the ZExchange platform. An AI observes, analyzes, and narrates \u2014 producing a visual Big Board and a written portrait of collective behavior. The market reflects on itself.",
                    "institutional_title": "Institutional Goals",
                    "art_programs_title": "For art programs:",
                    "art_programs_text": "Positions economics as material; extending Conceptual Art and Institutional Critique while constructing alternatives rather than exposing what exists.",
                    "business_programs_title": "For business programs:",
                    "business_programs_text": "Renders valuation theory experiential. Students use creative applications of their ideas to help them better build their own projects.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures\u2014shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
                    "zeconomy_text_2": "Represented by Galerie mfc\u2013mich\xe8le didier and agent d'art Ghislain Mollet-Vi\xe9ville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at \xc9cole Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg, and Tapscott's Blockchain Revolution.",
                    "contact_title": "Contact for Details",
                    "contact_text": "For program details, scheduling, and institutional inquiries:"
                },
                "sessions": {
                    "nav_home": "\u2190 Return to ZExchange",
                    "nav_contact": "Get in Touch",
                    "page_title": "ZExchange",
                    "tagline": "Life profits.",
                    "intro": "An artwork you enter, not observe. A trading floor. A party. A new way of looking at value.",
                    "what_happens_title": "What Happens",
                    "what_happens_p1": "Participants enter an economy with two layers: stocks and commodities.",
                    "what_happens_p2": "Stocks represent intangible values \u2014 emotional states, ambitions, ways of being. You trade them, speculate on them, watch their prices rise and fall based on collective interest.",
                    "what_happens_p3": "Commodities are real \u2014 drinks, food, items, gifts. Everything is tradable, but you can't consume them alone. To redeem (obtain) a commodity, another participant must accept to redeem their own commodities with you. The market grants or refuses permission.",
                    "what_happens_p4": "An AI watches everything unfold, narrating patterns of value, desire, and exchange as they emerge.",
                    "what_produces_title": "What It Produces",
                    "what_produces_text": "A shared experience that reframes consumption as a social act. An AI-written portrait of the group. A Big Board visualization available for purchase. And a question that lingers: What is the true value of being alive?",
                    "format_title": "Format",
                    "format_text": "2\u20133 hours. 10\u2013200 participants. Standalone event, team building, mixer, offsite, or cultural program.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures\u2014shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
                    "zeconomy_text_2": "Represented by Galerie mfc\u2013mich\xe8le didier and agent d'art Ghislain Mollet-Vi\xe9ville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at \xc9cole Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg, and Tapscott's Blockchain Revolution.",
                    "contact_title": "Contact for Details",
                    "contact_text": "For program details, scheduling, and institutional inquiries:"
                }
            },
            "classes": {
                "page_title": "ZEconomy Pedagogical Sessions",
                "presenter_title": "ZEconomy Class Presenter",
                "back_link": "\u2190 Back to ZExchange",
                "title": "ZEconomy Pedagogical Sessions",
                "tagline": "Exploring how art history, spirituality, and representation intersect with market theory, value systems, and ZEconomy's reimagining of finance.",
                "lesson_selector": "\u2190 Lesson Selector",
                "previous": "\u2190 Previous",
                "next": "Next \u2192",
                "toggle_images": "Toggle Images",
                "no_classes": "No classes available yet.",
                "load_error": "Unable to load classes. Please try again later.",
                "level": "Level",
                "duration": "Duration",
                "minutes": "min",
                "mixed_level": "mixed",
                "presenter_suffix": "Presenter",
                "learning_objectives": "Learning Objectives",
                "view_details": "View Details",
                "discussion_points": "Discussion Points",
                "activity_instructions": "Activity Instructions",
                "estimated_reading_time": "Estimated reading time",
                "min": "min",
                "download_pdf": "Download PDF",
                "no_lesson_specified": "No lesson specified.",
                "lesson_not_found": "Lesson not found.",
                "load_lesson_error": "Error loading lesson. Please try again later."
            },
            "placeholders": {
                "life_profits_placeholder_1": "I value playing with my kids...",
                "life_profits_placeholder_2": "Depression seems to be sought after...",
                "life_profits_placeholder_3": "I love love and everything about it...",
                "life_profits_placeholder_4": "A drink with friends is worth everything...",
                "life_profits_placeholder_5": "I think rejection creates value...",
                "life_profits_placeholder_6": "I see joy as life's true currency...",
                "life_profits_placeholder_7": "Helping others enriches my life...",
                "life_profits_placeholder_8": "Loneliness has become a very common experience...",
                "experience_placeholder_1": "Dancing to techno makes me forget my worries...",
                "experience_placeholder_2": "Spending time with friends makes time fly...",
                "experience_placeholder_3": "I miss my mother, it reminds me what matters...",
                "experience_placeholder_4": "Running regularly clears my head...",
                "experience_placeholder_5": "Arguing online is always a waste of time...",
                "experience_placeholder_6": "Watching old cartoons makes me a kid again...",
                "experience_placeholder_7": "Getting up early gives good energy to my day...",
                "experience_placeholder_8": "Taking a detour helps me think...",
                "experience_placeholder_9": "The quality of morning coffee sets the tone for my day...",
                "experience_placeholder_10": "Wearing my sunglasses at night makes me look cool..."
            },
            "ticker_texts": {
                "intro_z_exchange": "?? \u25BA INTRODUCTION Z EXCHANGE ?? \u25BA",
                "life_profits_value": "LIFE PROFITS \u25BA Z EXCHANGE VALUE \u25BA",
                "stocks_function": "\u25BA WHAT DO STOCKS DO ON Z EXCHANGE",
                "z_bonds_system": "Z BONDS \u25BA Zollars \u25BA Z RELATIONSHIP MONETARY SYSTEM \u25BA NUMBERS NEED NOT APPLY \u25BA",
                "commodity_x": "\u25BA COMMODITY X \u25BA Z EXCHANGE SOCIAL CONSUMING.",
                "interface_preview": "Z EXCHANGE INTERFACE PREVIEW \u25BA",
                "generative_boards": "\u25BA GENERATIVE Z EXCHANGE BIG BOARDS \u25BA REAL TIME MARKET EXPRESSION"
            },
            "simulation": {
                "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
                "mortality_chamber_setup": "You will be transported to the simulation environment, where you'll face a countdown to your symbolic death and make trading decisions that reflect your deepest values.",
                "simulation_instructions": "You'll start with a short reflection on your life values, then receive recommended stocks. The countdown will only begin after your reflection.",
                "life_profit_title": "Exploring What You Value",
                "building_experience": "Building your Memento Mori Experience",
                "preparing_chamber": "Preparing your symbolic mortality chamber...",
                "welcome_setup": "Welcome! Let's set up your trading portfolio.",
                "life_profits_explanation": "Let's find a ZEconomy company stock you believe in to generate 'Life Profits'.",
                "no_matching_companies": "Our system found no companies matching your emotional profile.",
                "creating_simulation": "Creating your Simulation...",
                "please_wait": "Please wait while we generate your virtual portfolio.",
                "trade_title": "Trade on ZExchange.",
                "one_off_session": "One-Off Session",
                "freestyle_title": "Freestyle is a ZExchange Regular Session Simulator.",
                "freestyle_goal_label": "Goal",
                "freestyle_goal_text": "learn ZExchange interface & concepts; and above all explore how value becomes your story.",
                "details_heading": "Details:",
                "freestyle_detail_1": "takes our idea of profits by applying value to what matters to you in your life.",
                "life_profit_label": "Life Profit",
                "life_profit_description": "value of consciously lived life: joy, loss, contradiction, sex, love, depression, boredom, partying... (quality / quantity / positive & negative).",
                "voice_of_bourse_label": "\"voice of the bourse\"",
                "voice_of_bourse_description": 'At ZExchange the market itself has a voice, analyzing what it thinks of each stock transaction \u2192 creating generative "big boards" + creates collaborative narratives.',
                "zrms_label": "Z Relationship Monetary System",
                "zrms_description": "Zollars apply your associative value of relationships to pay for assets using Love, Hate, Friendship, Death, Fellowship...",
                "commodity_x_label": "Commodity X",
                "commodity_x_description": "Trade commodities with a catch, you need social validation before any consumption (redeem with other trader's item \u2192 consume) can happen.",
                "economic_tools_label": "Economic tools",
                "economic_tools_description": "wield LBOs (Leveraged Buyouts), communist assaults, socialist subventions, dark pools, ransom, theft..., use economics as weapons or gifts towards other traders.",
                "memento_title": "Memento Mori \u2013 Trading life value to make your Eulogy",
                "memento_why_label": "Why?",
                "memento_why_text": "reflect on how you value living, experiences, and emotions to determine what you would value most when your life ends.",
                "memento_confront_label": "Confront mortality",
                "memento_confront_description": "Create a portfolio of life values through trading stocks, who's cumulative life value will generate your eulogy.",
                "memento_relational_label": "Relational capital",
                "memento_relational_description": "Zollars here represent associating positive & negative relationships to the stocks over numerical yield.",
                "memento_bourse_eye_label": "\"Under thy bourse eye\"",
                "memento_bourse_eye_description": "The bourse will cast judgement upon thy in your eulogy by watching all your transactions until the end."
            },
            "story": {
                "catena_title": "Catena Narrativa",
                "catena_subtitle": "Story building as supply chains: trade, customize, and consolidate through three phases to complete the story creation process.",
                "continue_to_selection": "Continue to Story Selection",
                "process_heading": "Process:",
                "materials_motion_title": "Materials in motion:",
                "materials_motion_desc": "Trade narrative elements as commodities. Customizing them as you trade. Value forms through the exchanging process to construct a story.",
                "three_passes_title": "Three passes:",
                "three_passes_desc": "Origin (beginning) \u2192 Transit (middle) \u2192 Assembly (end) ( 3min + 3min + 2min \u22488 minutes total). Each phase ends after the time expires, or you redeem, resulting in your bullet point commodities being secured into a personal story ledger.",
                "composition_title": "Composition:",
                "composition_desc": "At the end, your ledger is transformed into a short story generated from your customized trading of assets and redeemed secured bullet points.",
                "commodity_x_label": "Commodity X",
                "commodity_x_desc": "is part of ZEconomy where profits are measured in <strong>Life Profit</strong>\u2014 the quality and quantity of intellect, affection, partying... etc, all of life's divers happenings, promoting being\u2014over accumulation.",
                "footer_note_consumption": "Commodity X where Consumption is relational: you cannot consume without mutual assent. The commodity is not the object; the commodity is the interaction.",
                "footer_note_redeem": "Redeem relationally. Consume consciously.",
                "simulation_title": "Story Simulation",
                "simulation_intro": "Engage in a narrative exchange with automated participants across three distinct phases, crafting a unique short story through dynamic collaboration.",
                "choose_genre": "Choose Your Genre",
                "genre_scifi": "Science Fiction",
                "genre_scifi_desc": "Futuristic visions and speculative worlds",
                "genre_romance": "Romance",
                "genre_romance_desc": "Emotion, intimacy, and human connection",
                "genre_mystery": "Mystery",
                "genre_mystery_desc": "Secrets, investigation, and concealed motives",
                "genre_fantasy": "Fantasy",
                "genre_fantasy_desc": "Myth, imagination, and transcendence",
                "genre_horror": "Horror",
                "genre_horror_desc": "Fear, suspense, and the confrontation of the unknown",
                "duration": "Duration: 8 minutes (3 + 3 + 2 minute phases)",
                "loading_elements": "Loading Story Elements...",
                "choose_starting_element": "Choose Your Starting Element",
                "select_one_element": "Select one story element to begin with. You'll also receive 2 random elements.",
                "skip_selection": "Skip Selection (Get 3 Random Elements)",
                "preparing_story": " Preparing Your Story...",
                "setting_up_simulation": "Setting up {theme} simulation...",
                "story_begins": " Story Begins Now",
                "entering_world": "Entering {theme} world in 2 seconds...",
                "failed_load_elements": "Failed to load story elements",
                "failed_create_session": "Failed to create story session",
                "your_story_complete": "Your Story is Complete",
                "generating_final_story": "Generating your final story...",
                "please_wait": "Please wait...",
                "fallback_story": "Your narrative journey through the marketplace of stories has concluded. The elements you traded and customized have woven together into a unique tale."
            },
            "memento": {
                "question_1": "1. How do you feel about your life right now?",
                "question_1_placeholder": "e.g., anxious about the future, grateful for relationships...",
                "question_2": "2. What matters most to you?",
                "question_2_placeholder": "e.g., family, creativity, making an impact...",
                "question_3": "3. If your life ended tomorrow, what would you want your legacy to represent?",
                "question_3_placeholder": "e.g., someone who helped others, lived authentically...",
                "find_companies_button": "Find Meaningful Companies",
                "choose_legacy_title": "Choose Your Legacy Portfolio",
                "choose_legacy_description": "Select 3-5 companies that represent what matters most to you.",
                "choose_legacy_warning": "These will be the stocks you hold when your time expires.",
                "selected_count": "Selected",
                "your_time_begins": "\u23F3 Your Time Begins Now \u23F3",
                "entering_mortality_chamber": "Entering your mortality chamber in 2 seconds...",
                "your_eulogy_label": "YOUR EULOGY",
                "generating_eulogy": "Generating your life's story based on your choices...",
                "your_eulogy_expanded_title": "YOUR EULOGY",
                "eulogy_subtitle": "A reflection of your choices in the marketplace of life",
                "eulogy_update_info": "This eulogy updates every 2 minutes based on your trading actions",
                "eulogy_fallback": "Your journey through life's marketplace continues to unfold, each choice revealing the values that guide your path."
            },
            "validation": {
                "complete_reflections": "Please complete all three reflections.",
                "max_companies": "Maximum 5 companies allowed"
            },
            "trader": {
                "send_message": "Send Message",
                "message_cost": "Cost: 20",
                "select_recipient": "Select a recipient:",
                "message_placeholder": "Enter your message (280 characters max)",
                "send_button": "Send",
                "no_stocks": "You own no stocks.",
                "output": "Output",
                "tap_for_details": "tap for full company view + chart",
                "close_button": "Close",
                "no_bond_port": "You own no ZBonds.",
                "steal_commodity": "Steal Commodity",
                "ransom": "Ransom",
                "no_economic_tiggers": "You have no economic triggers available.",
                "create_dark_pool": "Create Dark Pool",
                "delete_portfolio": "Delete Portfolio",
                "capitalist_lbo": "Capitalist LBO",
                "socialist_subsidy": "Socialist Subsidy",
                "bien_q": "Commodity",
                "no_redeemed_item": "You have no redeemed items.",
                "explanations": "Explanations",
                "commodity_items": "You own no commodities.",
                "click_learn_more": "Click to learn more",
                "go_to_market": "Go to Market",
                "dark_pool_market": "Dark Pool Market",
                "no_reason_provided": "No reason provided",
                "stock_name": "Stock Name",
                "unknown": "Unknown",
                "symbol": "Symbol",
                "quantity": "Quantity",
                "initial_value_per_share": "Initial Value per Share",
                "current_value_per_share": "Current Value per Share",
                "total_gain_loss": "Total Gain/Loss",
                "reason_for_short": "Reason for Short",
                "close_short_position": "Close Short Position",
                "emotional_state_banner_title": "Track your emotional economy",
                "social_economy_banner_title": "Emotional Debt Instruments",
                "issue_altrau_z_bill": "Issue Z Bill Altrau",
                "issue_m_note_borrow": "Issue M Note (Borrow)",
                "issue_z_payday_cdo": "Issue Z-Payday Loan CDO",
                "issue_v_note_request_aid": "V Note (Request Aid)"
            },
            "market": {
                "all_types": "All Types",
                "goods": "Goods",
                "stocks": "Stocks",
                "bonds": "Bonds",
                "no_sort": "No Sort",
                "price_low_to_high": "Price: Low to High",
                "price_high_to_low": "Price: High to Low",
                "apply_filter": "Apply Filter",
                "reset": "Reset",
                "close": "Close",
                "explanations": "Explanations",
                "items": "Items",
                "trade": "Trade",
                "buy": "Buy",
                "trade_for": "Trade For",
                "description": "Description",
                "value": "Value",
                "quantity": "Quantity",
                "location": "Location",
                "owner": "Owner",
                "portfolio": "Portfolio",
                "filter": "Filter",
                "redeem": "Redeem \u2713",
                "buy_bond_confirmation": "Buying this bond will trigger its maturity period. Confirm to proceed.",
                "bond_purchased_success": "Bond purchased successfully!",
                "bond_purchase_failed": "Failed to purchase bond. Please try again.",
                "portfolio_ransomed": "Your portfolio is currently under ransom. Pay the ransom to view and interact with items.",
                "shorted_by": "Shorted by:",
                "unknown": "Unknown",
                "num_shares": "# Shares:",
                "short_value": "Short Value:",
                "reason": "Reason:",
                "enter_offer_for": "Enter your offer for",
                "available_points": "You have {points} available capital. Commodity cost: {cost}.",
                "choose_offer_type": "Choose offer type:",
                "zollars": "Zollars",
                "capital": "Capital",
                "confirm": "Confirm",
                "cancel": "Cancel",
                "enter_capital": "Enter capital:",
                "offer_amount_placeholder": "Offer amount",
                "select_zollar_value": "Select a Zollar value to continue.",
                "invalid_offer": "Invalid offer or insufficient capital",
                "processing_transaction": "Processing your transaction...",
                "waiting_seconds": "Waiting: {seconds} seconds",
                "processing": "traitement",
                "short_stock": "Short Stock",
                "stock": "Stock:",
                "current_value": "Current Value:",
                "available_shares": "Available Shares:",
                "short_amount_placeholder": "Number of shares to short",
                "short_reason_placeholder": "Why short this stock?",
                "confirm_short": "Confirm Short",
                "must_provide_reason": "You must provide a reason to short this stock.",
                "portfolio_name": "Portfolio Name"
            },
            "offer": {
                "offer_sent": "Offer Sent",
                "do_not_leave_page": "DO NOT LEAVE THE PAGE.",
                "awaiting_response": "Awaiting response. Please wait...",
                "time_remaining": "Time remaining: {seconds} seconds",
                "trade_offer": "Trade Offer",
                "offers_you": "{initiator} offers you: {offered} in exchange for: {requested}",
                "respond": "Respond",
                "accept": "Accept",
                "decline": "Decline",
                "buy_offer_received": "Buy Offer Received",
                "zollar_offer_for": "Zollar offer for {item} from {portfolio}: {details}",
                "points_offer_for": "Capital offer for {item} from {portfolio}: {details}",
                "no_zollar_details": "No Zollar details available.",
                "error_missing_details": "Error: Missing details for offer. Please try again.",
                "error_invalid_points": "Error: Invalid amount for capital offer.",
                "error_missing_zollar_details": "Error: Missing details for Zollar offer.",
                "error_invalid_offer_type": "Error: Invalid offer type.",
                "success_buy_offer_accepted": "Success: Buy offer accepted for {item}",
                "error_accepting_offer": "Error accepting offer: {message}",
                "meaningful_exchange": "Meaningful Exchange",
                "value_quote": "Value exists in perception, play and speculation, not just utility or rarity.",
                "who_to_trade_with": "Who would you like to trade with?",
                "select_trader": "Select a trader...",
                "why_trade": "Why do you want to make this trade?",
                "describe_motivation": "Describe your motivation, emotion or story...",
                "trade_with": "Trade with:",
                "capital": "Capital",
                "zollars": "Zollars",
                "cancel": "Cancel",
                "send_offer": "Send Offer",
                "item_received": "You received {item} from {giver}!",
                "time_remaining_html": "Time remaining: <span id=\"timer\"></span> seconds",
                "time_expired": "Time expired. Offer declined.",
                "offer_declined": "Offer declined. No capital awarded.",
                "offer_accepted": "Offer accepted! Capital awarded.",
                "reason": "Reason:",
                "time_remaining_extended": "Time remaining: {seconds} seconds (extended)",
                "processing": "Processing transaction...",
                "meaningful_offer_sent": "Meaningful trade offer sent! {insight}",
                "error_generic": "Error: {message}",
                "share_reason_placeholder": "Share your reason, motivation, memory, or vision... To create meaningful connections by trading.",
                "meaningful_trade_offer": "Meaningful Trade Offer",
                "wants_to_trade": "wants to trade",
                "respond_optional": "Respond to their story (optional)...",
                "not_interested": "Not Interested",
                "im_interested": "I'm Interested!",
                "response_sent": "Response sent",
                "interest_shown": "Interest shown! They may contact you directly.",
                "respond_to_offer": "Respond to offer.",
                "the_why": "The why:",
                "share_thoughts": "Share your thoughts, ask questions, or explain your perspective...",
                "response_min_length": "Please write at least 10 characters in your response.",
                "send_response": "Send Response",
                "they_responded": "They Responded",
                "their_original_why": "Their original why:",
                "your_response": "Your response:",
                "their_response": "Their response:",
                "accept_trade": "Accept Trade",
                "decline_trade": "Decline Trade",
                "updated_trade_offer": "Updated Trade Offer",
                "offer_sentence_simple": "{name} offers you {offered} and requests {requested} in return.",
                "buy_accepted_points": "{seller} accepted your buy offer! You got {item} for {points} capital.",
                "buy_accepted_zollars": "{seller} accepted your buy offer! You got {item} for zollars.",
                "buy_accepted_generic": "{seller} accepted your buy offer! You got {item}.",
                "error_processing_trade": "Error processing trade offer",
                "zollar_none": "None",
                "zollar_few": "A Few",
                "zollar_some": "Some",
                "zollar_many": "Many",
                "zollar_huge": "A Huge Amount",
                "response_sent_title": "Response Sent",
                "waiting_for_response": "Waiting for their response...",
                "timer_extended_60": "Timer extended to 60 seconds"
            },
            "transaction": {
                "requested_item": "Requested Item",
                "item_owner": "Item Owner",
                "item_name": "Item Name",
                "points": "Capital",
                "location": "Location",
                "propose": "Propose",
                "explain_trade_reason": "Explain why you want to make this trade.",
                "you_offer": "You offer:",
                "you_want": "You want:",
                "why_trade_question": "Why do you want to make this trade? What is your goal?",
                "share_motivation": "Share your motivation, a memory or a vision... Stories create meaningful connections in trading. (15 characters minimum)",
                "narrative_error": "Please write at least 15 characters to explain your goal.",
                "char_missing": "Still missing {count} characters to explain your goal.",
                "char_missing_full": "Please write at least 15 characters to explain why you want this trade.",
                "send_trade_with_intention": "Send trade with intention",
                "cancel": "Cancel",
                "select_asset": "Select Asset",
                "return_to_market": "Return to Market"
            },
            "messageSend": {
                "title": "Send Message",
                "costPerRecipient": "Cost: 20 per recipient",
                "searchRecipients": "Search recipients",
                "unnamedPortfolio": "Unnamed Portfolio",
                "placeholder280": "Enter your message (280 characters max)",
                "send": "Send",
                "close": "Close",
                "newMessageFrom": "New message from",
                "unknown": "Unknown",
                "reply": "Reply",
                "markAsRead": "Mark as read",
                "onlyChatBots": "You can only chat with bot players, not humans.",
                "conversationWith": "Conversation with",
                "messagesRemaining": "messages remaining",
                "typeYourMessage": "Type your message...",
                "chatLimitReached": "Chat limit reached. This conversation has ended.",
                "error": "Error",
                "failedToSend": "Failed to send message",
                "chatEnded": "Chat ended",
                "chatEndedThanks": "This chat has ended. Thanks for talking!",
                "connectionError": "Connection error. Please try again.",
                "botGreeting": "Hey! I'm {name}. What's on your mind?",
                "message_user": "Message to {user}: {message}"
            },
            "boss": {
                "session_required_leaderboard": "Session ID is required to view the leaderboard.",
                "session_required_mood_board": "Session ID is required to view the Mood Board.",
                "invalid_point_amount": "Invalid capital amount. Please try again.",
                "session_required_system_bot": "Session ID required to start system bot.",
                "system_bot_started": "System bot started: {name}",
                "system_bot_start_failed": "Failed to start system bot: {error}",
                "session_required_stop_bot": "Session ID required to stop system bot.",
                "system_bot_stopped": "System bot stopped successfully.",
                "system_bot_stop_failed": "Failed to stop system bot: {error}",
                "session_required_trigger_event": "Session ID required to trigger system event.",
                "system_event_triggered": "System event triggered successfully!",
                "system_event_trigger_failed": "Failed to trigger system event: {error}",
                "session_required_logout": "Session ID is required to logout traders."
            },
            "stock": {
                "ownership_transferred": "Ownership transferred successfully",
                "transfer_failed": "Failed to transfer ownership. Please try again.",
                "share_deleted": "Share deleted successfully",
                "delete_failed": "Failed to delete share. Please try again.",
                "short_closed": "Short position closed successfully",
                "close_short_failed": "Failed to close short position. Please try again.",
                "short_placed": "Short position placed successfully",
                "place_short_failed": "Failed to place short position. Please try again.",
                "no_short_positions": "No short positions found for this stock.",
                "fetch_short_failed": "Failed to fetch short positions. Please try again.",
                "short_positions_for": "Short Positions for Stock ID",
                "short_position": "Short Position",
                "close_short": "Close Short",
                "submitting_bid": "Submitting your bid...",
                "please_wait": "Please wait while we process it.",
                "redirect_in": "Redirecting in",
                "seconds": "seconds"
            },
            "social_class": {
                "working_class": {
                    "name": "Working Class",
                    "description": "You begin in debt with minimal resources. Every decision matters.",
                    "goal": "Escape debt through strategic trading and community building",
                    "goals": {
                        "pay_off_debt": "Get your capital above zero before time runs out. Sell shares, swap items, accept fair offers \u2014 every deal that pays counts.",
                        "two_swaps": "Complete 2 swaps with other traders: your things for theirs. No money needed \u2014 swaps are how you trade when you are broke.",
                        "reserve_lift": "Visit the Zederal Reserve, take a Z Bond for extra capital, and turn it into at least one trade that grows what you hold."
                    }
                },
                "lower_middle": {
                    "name": "Lower Middle Class",
                    "description": "You have modest resources. Careful planning can lead to prosperity.",
                    "goal": "Build financial stability and grow your network",
                    "goals": {
                        "own_two_companies": "Own shares of 2 different companies by the end. Pick companies whose story speaks to you \u2014 you grow when they grow.",
                        "first_zollars": "Buy zollars at the Zederal Reserve and win one trade paying with relationships (Love, Friendship\u2026) instead of capital.",
                        "grow_worth": "Grow your total worth by a fifth. Bid on undervalued things, swap up, and do not let your capital sleep."
                    }
                },
                "middle_class": {
                    "name": "Middle Class",
                    "description": "You start with a balanced portfolio. Strategic choices will determine your trajectory.",
                    "goal": "Maintain stability while pursuing growth opportunities",
                    "goals": {
                        "diversify": "End the session holding all three kinds of value: shares of a company, an item, and a bond.",
                        "three_bids": "Win 3 bids on things other traders hold. Name your price, say why you want it, and convince them.",
                        "relations_over_money": "Finish richer in zollars than in capital \u2014 trade so that relationships outweigh plain money in your portfolio."
                    }
                },
                "upper_middle": {
                    "name": "Upper Middle Class",
                    "description": "You have significant resources. Use them wisely to create opportunities.",
                    "goal": "Leverage your resources to build lasting influence",
                    "goals": {
                        "fair_patron": "Play the patron: win 2 bids AND accept 2 offers from traders poorer than you, at a fair price. Influence is built, not bought.",
                        "capital_to_life": "Convert your capital into living value: end with more of your worth in shares and items than in plain capital.",
                        "bond_collector": "Build a bond book: hold 3 Z Bonds from the Zederal Reserve and let the interest work for you."
                    }
                },
                "wealthy_elite": {
                    "name": "Wealthy Elite",
                    "description": "You start with immense wealth. Everyone wants what you have\u2014generosity creates protection.",
                    "goal": "Share wealth to build alliances or face coordinated resistance",
                    "goals": {
                        "generous_giant": "Give to grow: accept swaps or modest bids from at least 3 different traders. On this floor, generosity is protection.",
                        "biggest_backer": "Spread your wealth into shares of 4 different companies \u2014 become the floor's biggest backer.",
                        "keep_the_crown": "End the session still on top. Everyone wants what you have; alliances and fair deals are how you keep it."
                    }
                },
                "starting_capital": "Starting Capital:",
                "starting_items": "Starting Items:",
                "your_goal": "Your Goal:",
                "actions_note": "Your actions shape how others treat you. Generosity builds alliances, exploitation invites retaliation."
            },
            "life_profile": {
                "room_title": "THE ROOM RE-RANKED",
                "room_you": "(you)",
                "more_about": "MORE ABOUT YOUR SESSION \u25B8",
                "flows_title": "WHERE YOUR VALUE WENT",
                "flow_the_room": "the room",
                "flow_value": "value",
                "kind_gift": "gift",
                "kind_swap": "swap",
                "kind_trade": "trade",
                "kind_lend": "lent",
                "kind_aid": "aid",
                "kind_predatory": "predatory loan",
                "kind_bond": "bond",
                "kind_seized": "seized",
                "verdict_title": "THE ROOM RE-RANKED YOU",
                "entered": "Entered:",
                "by_capital": ", by capital.",
                "leaves": "Leaves:",
                "by_balance": ", by balance and giving.",
                "balance_label": "Balance",
                "giving_label": "Given",
                "gave_nothing": "You gave nothing away. However balanced a life is, this room will not rank it higher than that.",
                "carries_title": "WHAT YOUR LIFE CARRIES",
                "chose": "You chose {company}. That is what your life is heavy with.",
                "heavy_label": "Too much:",
                "lacking_label": "None at all:",
                "how_it_ends": "When time runs out, the room decides your class by how balanced you are and how much you gave \u2014 not by what you earned."
            },
            "debt_actions": {
                "common": {
                    "perceived_magnitude": "Perceived magnitude",
                    "magnitude_none": "None",
                    "magnitude_hint": "A Hint",
                    "error_login_required": "Please log in first"
                },
                "help_friend": {
                    "intro": "Give help. Choose <b>Z$</b> or <b>Capital</b> for the gift.",
                    "capital_label": "Capital (amount)",
                    "capital_placeholder": "Enter capital",
                    "select_zollars": "Select Z$ categories to gift.",
                    "recipient_label": "Recipient:",
                    "no_zollars": "No Z$ available.",
                    "modal_title": "Altrau Z Bill (Altruistic Gift)",
                    "error_no_recipient": "Select a recipient.",
                    "error_invalid_capital": "Enter a valid capital amount.",
                    "error_no_zollars_to_give": "No Z$ to give.",
                    "error_select_zollars": "Select some Z$ to give.",
                    "error_insufficient_zollars": "Insufficient {type} zollars. You have {available}, trying to send {count}.",
                    "success": "Altrau Z Bill given. Your ledgers are now bound."
                },
                "predatory_lend": {
                    "intro": "Z-Payday CDO: Offer a compounding loan that reloads every 60 seconds.",
                    "warning": "WARNING: Each cycle increases the debt by 15% until repayment or bankruptcy.",
                    "exploitation_note": "(Exploitation disguised as empathic connection.)",
                    "capital_label": "Capital (amount to \"lend\")",
                    "capital_placeholder": "Amount",
                    "select_zollars": "Select Z$ bait for collapse.",
                    "victim_label": "Target Victim:",
                    "no_zollars": "No Z$ available.",
                    "modal_title": "Z-Payday CDO (Predatory Loan)",
                    "error_no_victim": "Select a victim.",
                    "error_invalid_amount": "Enter a valid amount.",
                    "error_no_zollars_selected": "No Z$ selected.",
                    "error_select_zollars": "Select some Z$.",
                    "success_targeted": "Z-Payday CDO offer sent to victim. Reloads every 60 seconds once accepted.",
                    "success_market": "Z-Payday CDO listed on market. Disguised as attractive offer."
                },
                "borrow": {
                    "intro": "Request a loan (M Note).",
                    "vulnerability_required": "Disclose your emotional debt. Vulnerability.",
                    "vulnerability_label": "Why do you need this loan? (Emotional debt disclosure - min 20 chars)",
                    "vulnerability_placeholder": "Disclose your emotional debt / vulnerability here...",
                    "char_count": "0 / 20 chars",
                    "char_suffix": "/ 20 chars",
                    "severity_label": "Severity",
                    "severity_question": "How severe is your need?",
                    "move_sliders": "Move sliders to express your need:",
                    "lender_label": "Choose Lender:",
                    "modal_title": "M Note (Request Loan)",
                    "error_vulnerability_required": "M Note requires vulnerability disclosure (min 20 characters).",
                    "error_move_slider": "Please move at least one slider to express your need.",
                    "error_no_lender": "Please select a lender.",
                    "success_targeted": "M Note loan request sent to lender.",
                    "success_market": "M Note listed on market for lenders to purchase."
                },
                "request_aid": {
                    "intro": "Request aid (V Note).",
                    "description": "Ask someone for a handout by sharing your vulnerability.",
                    "accept_decline_note": "They can accept or decline your request.",
                    "vulnerability_label": "Explain why you need aid (vulnerability disclosure - min 20 chars)",
                    "vulnerability_placeholder": "Share your vulnerability...",
                    "severity_question": "Situation severity (how urgent is this)",
                    "target_label": "Request aid from:",
                    "modal_title": "V Note (Request Aid)",
                    "error_no_target": "Please select who to request aid from.",
                    "error_vulnerability_required": "V Note requires vulnerability disclosure (min 20 characters).",
                    "success": "V Note request sent. Awaiting response."
                }
            },
            "bot": {
                "chat_connection_notready": "Connection not ready. Please try again in a moment.",
                "chat_greeting_fallback": "Hey! I'm {{name}}. What's on your mind?",
                "chat_remaining": "messages remaining",
                "chat_input_placeholder": "Type your message...",
                "chat_connection_lost": "Connection lost. Please try again.",
                "chat_error_notloggedin": "Error: User not logged in",
                "chat_limit_reached": "Chat limit reached.",
                "chat_timeout": "Bot is taking too long to respond. Please try again.",
                "chat_end_thanks": "This chat has ended. Thanks for talking!",
                "chat_ended": "Chat ended",
                "chat_recommendation_title": "Trading Recommendation",
                "chat_action_buy": "Place Bid",
                "chat_action_sell": "Create Offer",
                "chat_action_short": "Short Stock",
                "chat_action_trade": "Make Trade",
                "chat_action_goto": "Go to Trading"
            },
            "items": {
                "item_added_success": "Item added successfully!",
                "item_add_failed": "Failed to add item. Please try again.",
                "no_items_portfolio": "No Commodities in this portfolio.",
                "search_portfolios": "Search portfolios...",
                "item_assigned_success": "Item assigned to portfolio successfully",
                "item_assign_failed": "Failed to assign item to portfolio. Please try again.",
                "item_unassigned_success": "Commodity unassigned from portfolio successfully",
                "item_unassign_failed": "Failed to unassign commodity from portfolio. Please try again.",
                "item_deleted_success": "Item deleted successfully",
                "item_delete_failed": "Failed to delete commodity. Please try again.",
                "item_redeemed_success": "Item redeemed successfully",
                "item_unredeemed_success": "Item unredeemed successfully",
                "redeem_toggle_failed": "Failed to toggle redeem status. Please try again."
            },
            "zollar": {
                "select_relationship_required": "Please select at least one relationship and enter a quantity.",
                "zollars_added_success": "Zollar(s) added successfully",
                "add_failed_error": "Failed to add zollar(s). Please try again. Error: {error}",
                "deleted_success": "Zollar deleted successfully",
                "delete_failed": "Failed to delete zollar",
                "fill_required_fields": "Please fill all required fields correctly.",
                "zbond_added_success": "ZBond added successfully",
                "zbond_add_failed": "Failed to add ZBond. Error: {error}",
                "select_portfolio_required": "Please select a portfolio to assign the item to.",
                "assign_failed": "Failed to assign {itemType}. Please try again.",
                "unassigned_success": "{itemType} unassigned from portfolio successfully",
                "unassign_failed": "Failed to unassign from portfolio. Please try again.",
                "bond_deleted_success": "Bond deleted successfully",
                "bond_delete_failed": "Error deleting bond: {error}",
                "session_details_failed": "Failed to retrieve session details. Please try again.",
                "session_fetch_error": "Error fetching session details. Please try again later.",
                "fetch_portfolios_error": "Error fetching active portfolios. Please try again."
            },
            "tuts": {
                "trader_mood_gauge": "Trader Mood Gauge",
                "description": "Description:",
                "trader_gauge_description": "This gauge visualizes the collective mood of traders in the current market session.",
                "conceptual_insight": "Conceptual Insight:",
                "gains_losses": "Gains / Losses",
                "portfolio_banner_description": "Click the banner to view your earnings breakdown.",
                "trader_tools": "Trader Tools",
                "subsidy": "The Socialist Subsidy redistributes 45% of wealth from the richest portfolio to others. Use strategically to weaken strong players.",
                "ransom": "The Ransom locks a portfolio until the ransom capital is paid. This forces opponents into tough trade-offs.",
                "lbo": "The Leveraged Buyout (LBO) lets you acquire stocks and items from another portfolio by paying a high cost. Powerful but expensive.",
                "steal": "The Steal allows you to take a single item from another portfolio. Use stealthily to disrupt opponents.",
                'stealButton': `
          <h3>Steal Asset Trigger</h3>
          <strong>Description:</strong> <br>
          Steal Trigger allows you to steal from an individual in the market, anonymously, with no permission needed.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Steal Trigger\u{201D} banner.</li>
          <li>Choose an item from the list of available holdings.</li>
          <li>Confirm your action to finalize the theft.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Stealing is universally condemned, yet it thrives in countless forms, in every social stratosphere\u{2014}from petty theft to grand-scale corruption; from bicycles to bank robbery. 
          <br><br>
          By committing theft here, do you question your own moral boundaries? Does the short-term thrill of getting a \u{201C}free\u{201D} item overshadow the harm to the original owner? What value do you place on the consequences of what the robbed may feel? How would you feel about enjoying something that was intended to bring joy to someone else? This is a test of how you value empathy, guilt, and personal gain within the ZEconomy ecosystem.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Imagine you see a commodity you really want on a big board. By using the Steal Trigger, you seize it for your own portfolio. But how do you feel knowing you gained \u{201C}value\u{201D} by undermining another person\u{2019}s rightful claim?
        `,
                'ransomButton': `
          <h3>Ransom a fellow Trader Trigger</h3>
          <strong>Description:</strong> <br>
          A trigger that locks another trader\u{2019}s entire portfolio, forcing them to pay your set ransom before they can resume trading.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Ransom Trigger\u{201D} banner.</li>
          <li>Select the portfolio you want to ransom.</li>
          <li>Enter the ransom cost in capital.</li>
          <li>Once set, the victim\u{2019}s portfolio is inaccessible to them until you\u{2019}re paid in full.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Ransom is akin to outright extortion. It\u{2019}s illegal in real-life finance with jail time for a reason; you profit to the detriment of the victim. However, in ZEconomy, the penalty is purely social: your identity is revealed to the victim at the moment you place the ransom. 
          <br><br>
          Do you relish wielding power, or dread the social backlash? Are you comfortable with a brute, aggressive form of \u{201C}profit\u{201D} at the expense of another trader\u{2019}s free will and peace of mind? Do you care about the consequences for the attack victim? Do you care about the social consequences for yourself? Will you enjoy the financial gains by extorting a trader from their wealth? 
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a trader who has amassed valuable holdings but is short on capital. By setting a steep ransom, you effectively block them from using their entire portfolio until they cough up the fee. It can be a swift path to profit for you\u{2014}assuming you can handle the backlash once they realize you put them in lockdown.
        `,
                'createCommunityButton': `
          <h3>Dark Pool Trigger</h3>
          <strong>Description:</strong> <br>
          A private market arena with a participatory group of selected traders, hidden from the rest of the public exchange.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Dark Pool Trigger\u{201D} banner.</li>
          <li>Select which traders to invite.</li>
          <li>If they accept, you have 10 minutes of private market trading, invisible to everyone else in the public market.</li>
          <li>Anyone can opt out anytime, returning to the public exchange.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Dark Pools are private trading communities that exist outside of the visible public market exchanges. They are the market version of an exclusive gated community. Inside the pool, participants become free to shape the \u{201C}value\u{201D} of any market-listed assets, outside public scrutiny or intervention, especially when the trades are large in nature.
          <br><br>
          Is this honest cooperation, or a form of manipulation? Is it fair if asset values are decided by a hidden few traders? Does secrecy undermine genuine valuation and transparency? If you and your selected trading partners can inflate or deflate prices at will, are you still respecting the \u{201C}true\u{201D} nature of the ZEconomy or merely gaming it?
          <br><br>
          This tension between private gain and collective trust is what makes dark pools both tempting and ethically murky. You must decide: does stepping away from the public stage strengthen your own \u{201C}value,\u{201D} or undermine the shared \u{201C}value\u{201D} of the entire ZEconomy?
          <br><br>
          <strong>Usage Example:</strong> <br>
          Suppose you and a few close allies want to swap \u{201C}bonds\u{201D} or \u{201C}stocks\u{201D} at prices you set, away from prying eyes. The Dark Pool might let you corner a niche of the market or secure a better deal. Yet, once the broader community learns about your secrecy, they might feel cheated or question the fairness of these behind-the-scenes deals.
        `,
                'deletePortfolioButton': `
          <h3>Communist Assault Trigger</h3>
          <strong>Description:</strong> <br>
          Seize and redistribute all of a rival\u{2019}s wealth to the collective.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Communist Assault banner.</li>
          <li>Choose a target portfolio.</li>
          <li>Confirm your action to instantly redistribute all their holdings across active traders.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger wipes out a single targeted trader\u{2019}s entire portfolio and spreads it randomly among everyone else. In theory, no single individual grows vastly richer; everyone gets an equal share of the now communal seized wealth.
          <br><br>
          But consider the human reality: how would you feel if everything you owned was aggressively confiscated and redistributed, even for a \u{201C}common good\u{201D}? Is it fair to remove one person\u{2019}s property so that everyone else can benefit? Would you see this as justice or injustice? Like many firebrand economic ideas, \u{201C}communal sharing\u{201D} is loaded with moral complexities. Is this an act of genuine solidarity or an unjust seizure? You must weigh how far you\u{2019}re willing to go in forcing collective welfare at another\u{2019}s expense.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a wealthy trader whom you feel has been hoarding too much. By unleashing the Communist Assault, you forcibly attack their market wealth and randomly redistribute all items, stocks, and captial to the rest of the active traders. A rising tide lifts all boats, but if the water rises at the expense of someone else, is that fair or moral?
        `,
                'LBOButton': ` <h3>Capitalist <br> (LBO) <br> Leveraged Buyout Trigger</h3>
          <strong>Description:</strong> <br>
          Aggressively buy control of another trader\u{2019}s assets, whether they agree or not.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Capitalist LBO banner.</li>
          <li>Select the target portfolio you want to \u{201C}acquire.\u{201D}</li>
          <li>Pay a lump sum of your own capital (representing leveraged capital).</li>
          <li>Once paid, you seize the target\u{2019}s items and stocks.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          A leveraged buyout involves heavy borrowing or capital injection to take over a company. Here, you risk your own wealth to gain outright control of someone else\u{2019}s assets despite the target having freedom of choice in the transaction.
          <br><br>
          You do transfer funds, at a premium, to their portfolio, which might sound fair, yet the move is still coercive: it\u{2019}s an aggressive buyout (purchase) without mutual consent. If you can afford the price, you get to expand your empire leaving the former owner \u{201C}bought out\u{201D} and potentially weakened. If traditional business logic says \u{201C}if you can afford it, you deserve it,\u{201D} what role should ethics play? Is that just the free market at work (survival of the richest), or an exploitative maneuver that disregards the target\u{2019}s autonomy? The LBO highlights that in capitalism, money can effectively override freedom of consent, turning wealth into raw power.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Spot a smaller portfolio with interesting stocks or items but fewer resources. With an inflated premium price of your wealth, you initiate a hostile LBO, forcibly taking over their assets. The target does receive payment in return\u{2014}but you gain the real market advantage by controlling their capital. Is that fair or exploitative? Only you decide.`,
                'SubsidyButton': `
          <h3>Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br>
          \u{201C}Tax\u{201D} a rich portfolio to support the bottom half of the market.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Socialist Subsidy banner.</li>
          <li>Choose a wealthy portfolio to tax.</li>
          <li>Trigger the subsidy taxing the target\u{2019}s wealth.</li>
          <li>Those taxed resources are distributed among the least affluent traders in the session.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger takes from the rich and subsidizes the struggling via redistribution of wealth to the less fortunate or unsuccessful, aiming to level the economic playing field.
          <br><br>
          On one hand, you\u{2019}re championing a sense of collective balance by narrowing wealth gaps. On the other, you\u{2019}re forcing someone else to bear the cost regardless of whether the rich or the poor deserve it. Does that build solidarity, or does it punish success? Is it \u{201C}just\u{201D} to relieve disparities or does it stifle ambition? 
          <br><br>
          You must decide if the \u{201C}greater good\u{201D} overrides individual success or wealth. The tension between economic equality, fairness, and personal freedom is at the heart of this move.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You see a player sitting on massive stocks and capital while several others struggle. By hitting the Subsidy trigger, a significant chunk of that wealth is taxed and distributed to the poorest traders, giving them a fresh injection of capital. Perhaps you\u{2019}re bringing fairness, or perhaps you\u{2019}re penalizing someone for doing well. The outcome depends on your economic worldview.
        `,
                'helpFriendButton': `
          <h3>Altrau Z Bill</h3>
          <strong>Altruistic life value. Empathy.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To give without promise of return. Assist someone and become implicated in their Life Profit outcome. The rise and fall of their emotional balance pulling your life profits positive and negative. Quiet speculation that another's well-being might enlarge your own capacity to feel and expand your empathy capacity.
          <br><br>
          <strong>No returns required.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a transaction that binds both ledgers; an increase in shared variance rather than sum. When you issue an Altrau Z Bill, you're not just helping someone\u{2014}you're entangling your emotional economy with theirs. Their successes become yours, their failures yours to bear.
          <br><br>
          It asks: <em>Can empathy be an investment? What happens when another's pain becomes your loss, their joy your gain?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click the "Issue Z Bill Altrau" button, select a trader to help, choose what to give (Zollars or Capital), and confirm. Your Life Profit will now fluctuate with theirs\u{2014}a shared emotional destiny.
        `,
                'borrowCapitalButton': `
          <h3>M Note (Mutual Note)</h3>
          <strong>A loan drawn in confession.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          M Note creates credit out of exposed need and calculated trust. Value created on the human empathy of sharing in human imperfections. A borrower discloses a weakness; a lender accepts the risk, extending empathy as a form of investment.
          <br><br>
          What begins as recognition becomes obligation\u{2014}vulnerability converted into Z Relational Collateral, interest accruing in attention, acknowledgment, and mutual Life Profit.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is emotional-weighted interest; time dilates with mood. Unlike traditional loans, the M Note doesn't just transfer capital\u{2014}it transfers vulnerability. The borrower must confess why they need help, exposing their weakness to gain trust.
          <br><br>
          The lender isn't just providing resources; they're accepting the emotional risk of that vulnerability. Both parties are bound: the borrower by obligation, the lender by empathy.
          <br><br>
          <em>When you lend, you're investing in someone's capacity to recover. When you borrow, you're asking someone to believe in you.</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue M Note (Borrow)", select a lender, write your vulnerability confession (why you need help), choose what you need (Zollars or Capital), and send. The lender sees your confession and decides whether your vulnerability is worth their trust.
        `,
                'predatoryLendButton': `
          <h3>Z-Payday CDO (Collateralized Desire Obligation)</h3>
          <strong>Exploitation disguised as empathic human connection.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          Empathy and relief recast into instruments of toxic dependency. Z-Payday loans feed on need and greed, turning vulnerability into yield at the expense of human worth and systemic balance.
          <br><br>
          Each loan cycle lifts the lender, drains the borrower, and leaves the market to absorb the strain of contagion.
          <br><br>
          <strong>Function:</strong><br>
          Single acts of aid become a repeating contract\u{2014}each minute another obligation is issued, each obligation thinly sliced into tranches that feed the larger CDO. The product promises immediacy and then converts the living into yield; the harvest comes from what is worn away when kindness is made structural.
          <br><br>
          <strong>The Z-Payday CDO does not forgive. It compounds exposure until the ledger consumes the life profit underneath.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is predatory lending made visible. Unlike traditional payday loans that hide behind legal jargon, the Z-Payday CDO forces you to confront what you're doing: extracting value from someone's desperation, minute by minute.
          <br><br>
          It asks: <em>How far will you go for profit? Can you watch someone drain themselves to pay you back? Is this business, or is this cruelty?</em>
          <br><br>
          The victim's Life Profit decreases every minute, transferred to you. The system itself bears the collective emotional cost\u{2014}everyone feels it when someone is being exploited.
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue Z-Payday Loan CDO", select a victim, choose the amount to extract per minute, and confirm. Every minute, their Life Profit decreases and transfers to you\u{2014}until they close the debt or collapse entirely.
          <br><br>
          <strong>Warning:</strong> This action has severe social and emotional consequences. Others will know. The market will know. Your guilt accumulates.
        `,
                'requestHandoutButton': `
          <h3>V Note (Vulnerability Note)</h3>
          <strong>Admitting vulnerability.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To ask is to step into exposure\u{2014}to risk the small collapse that comes with being seen in need. Vulnerability here is not weakness but invitation: a signal that one's balance has slipped and requires relation to recover.
          <br><br>
          Help, if granted, becomes a shared moment of recalibration; if withheld, it marks the quiet fracture between trust and pride.
          <br><br>
          Every request writes itself into the Emotional Debt Index, a measure not of possession, but of how much we still dare to depend.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a request with justification; relief triggered by assent; the ledger records both appeal and response. Unlike the M Note (which is a formal loan with obligation), the V Note is a simple ask\u{2014}no strings attached, no repayment expected.
          <br><br>
          But asking is its own cost. You must expose your need, your vulnerability, your dependence. And the response\u{2014}whether acceptance or rejection\u{2014}shapes your emotional state and trust in the community.
          <br><br>
          <em>Can you admit you need help? Can others afford to give it? What does it mean when help is given freely, or when it's denied?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "V Note (Request Aid)", write why you need help (your vulnerability statement), choose what you're asking for (Zollars or Capital), and send to another trader. They can accept (giving you what you asked) or decline (leaving you to manage alone). Either way, the emotional impact is recorded.
        `,
                'giveDeletePortfolioButton': `
          <h3>Issue Communist Assault Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Communist Assault" button to a trader, enabling them to seize and redistribute all of a targeted portfolio's wealth to the collective. 
          <br><br><strong>How-to:</strong> <br>  
          Select a trader from the active trader list and assign them the "Communist Assault" button.
          <br><br><strong>Functionality:</strong> <br>
          The target's wealth (points, stocks, commodities, etc.) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.
          <br><br><strong>Conceptual Insight:</strong> <br>
          This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution. Assigning this button to a trader effectively grants them the power to balance\u{2014}or disrupt\u{2014}the market.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices another hoarding valuable assets, creating market imbalance. By using "Communist Assault," they redistribute the wealth, equalizing resources but possibly alienating the hoarder and other observers.
        `,
                'giveLBOButton': `
          <h3>Issue Capitalist <br> Leverage Buyout Trigger</h3> 
          <strong>Description:</strong> <br>
          Assign the "Capitalist LBO" button to a trader, empowering them to aggressively acquire another portfolio's assets through a leveraged buyout. 
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Capitalist LBO" button.
          <br><br><strong>Functionality:</strong> <br>
          The acquiring trader gains full control of the target's portfolio (commodities, stocks, etc.) at sever cost to them.
          <br>
          The transaction is coercive yet compensatory, with the target receiving payment for their assets, and the initiator paying an inflated price.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Capitalist LBO" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation, emphasizing how financial strength can dictate market control.
          <br><br><strong>Usage Example:</strong> <br>
          A trader sees a smaller portfolio with underutilized assets. Using "Capitalist LBO," they pay a premium to forcibly acquire those assets, consolidating power but potentially facing backlash for their aggressive tactics.
        `,
                'giveSubsidyButton': `
          <h3>Issue Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Socialist Subsidy" button to a trader, allowing them to tax a wealthy portfolio and redistribute the resources to less affluent traders.
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Socialist Subsidy" button.
          <br><br><strong>Functionality:</strong> <br>
          50% of the target portfolio's wealth is Taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br>
          This feature levels disparities but can also penalize success, fostering debates about fairness and equity.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Socialist Subsidy" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices a portfolio with excess resources while others struggle. Using "Socialist Subsidy," they tax the wealthy trader and redistribute assets to the least affluent, injecting new life into the market and promoting equity.
        `,
                "deletePortfolio": "The Communist Assault deletes another portfolio entirely, at a significant cost. A drastic, endgame move.",
                "trader_tools_description": "Utilities for performing market-related actions with or against other traders.",
                "trader_tools_insight": "Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility\u2014or will you push boundaries at the expense of others? The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
                "transaction_instructions": "<h3>Transaction Instructions</h3><p>Select an asset from your holdings to propose a trade with the item owner. This enables peer-to-peer trading of commodities between portfolios.</p>",
                "stock_instructions": "<h3>Stock Trading Instructions</h3><p>Purchase shares by entering the quantity you wish to buy. Your available capital is shown above. Each transaction affects the market and builds your portfolio.</p>",
                "bond_instructions": "<h3>Bond Trading Instructions</h3><p>Trade Z-Bonds, the emotional debt instruments of the Z Relationship Monetary System. Bonds represent relational capital between traders.</p>",
                "no_info": "No information available.",
                "no_tutorial": "No tutorial content available.",
                "no_instructions": "No instructions available.",
                "redeem_instructions": `
          <h3>Redeem is:</h3>
          Redeem is the process of transforming a commodity into a QR code so it can be physically obtained. It also removes the commodity from the market and your portfolio.
          <br><br>
          The catch is your commodity can only be redeemed if the other traders agree to redeem their commodities as well.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          The redeem process challenges traditional ideas of individual consumption by introducing a collective decision-making aspect to the process. Redeeming a commodity isn't just about acquiring something\u{2014}it is a social interaction between multiple parties, with outcomes and consequences directly shaped by the responses of other traders.
          <br><br>
          <h3>Process:</h3>
          <strong>Step 1: Selected Commodities</strong><br>
          At the top, you'll see the Commodities you've selected to be Redeemed and the Commodity owner. These are the Commodities you're asking fellow traders to redeem so you can redeem your commodity.
          <br><br>
          <strong>Step 2: Choose Your <br> Redeem Commodity</strong><br>
          From your holdings list below, select the Commodity you want to Redeem.
          <br><br>
          <strong>Step 3: Send Ask</strong><br>
          Once you've selected your commodity, click "Send Redeem Ask." This will:
          <ul>
            <li>Send your ask to all target traders</li>
            <li>Lock your selected commodity during the process</li>
            <li>Give traders 10 seconds to respond</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          If ALL traders accept: You'll receive a random new commodity from the Zederal Reserve, and your commodity is redeemed so it can be obtained using the QR code at its designated location.<br><br>
          If ANY trader declines: Your redeem fails, and the commodity remains in your portfolio, available for trading on the market.
          <br><br>
          <strong>Important Notes:</strong><br>
          You cannot cancel a redemption once started
          The process takes exactly 10 seconds
          Do not leave the page during redemption
        `,
                "stock_trade_instructions": `
          <h3>What Are Stocks:</h3>
          In conventional finance, a stock (or share) represents partial ownership of a company. Investors typically buy stocks hoping the company's value will rise, increasing the share price.
          <br><br>
          Stocks are tradable for Zollars or Capital. As a company's value grows, so does the value of your portfolio. However, if a company's share price falls, the value of your holdings decreases as well.
          <h3>Stocks in ZEconomy:</h3>
          Stocks in ZEconomy reflect human values such as emotional well-being, social relationships, and personal growth\u{2014}rather than traditional economic outputs. Trading stocks is more than just a financial transaction; it's an interaction with life values that forces you to reconsider what you value and how you invest in others.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          Stock trading in ZEconomy challenges the notion of profit: Is it about reaping monetary rewards, or about supporting the growth of human experiences such as emotional health, creativity, and shared connections? Every stock trade highlights the tension between genuine support for human value and the act of financially exploiting it. Think of your stocks as investments in happiness, success, and transformation instead of a company producing traditional goods or services.
          <br><br>
          This process asks you to reflect: Do your trades align with your personal values? What does it mean to invest in a human experience rather than economic output? How far are you willing to go to ensure your portfolio grows, and at what cost to the broader market ecosystem?
          <h3>Bid Process:</h3>
          <strong>Step 1: Review Available Stocks</strong><br>
          Use the stock table to review available shares in the market. Each stock represents a company built around a human value (e.g., creativity, happiness, or relationships). Take note of the stock's current value, owner, and potential for growth or decline.
          <br><br>
          <strong>Step 2: Decide Your Trade</strong><br>
          Determine whether to buy, sell, or short a stock. Buying supports the company's value, selling helps you realize gains, and shorting bets against its success, profiting if the value falls.
          <br><br>
          <strong>Step 3: Execute Your Trade</strong><br>
          Once you've made your decision:
          <ul>
            <li>Use the stock table to select the desired stock.</li>
            <li>Enter the number of shares you wish to trade and confirm the transaction.</li>
            <li>Your portfolio will update in real-time, reflecting the trade.</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          <ul>
            <li>Successful trades increase the value of your portfolio if the company grows.</li>
            <li>Short positions succeed if the stock value drops but risk losses if it rises.</li>
          </ul>
          <br>
          <strong>Important Notes:</strong><br>
          <ul>
            <li>Stock values are dynamic and can change rapidly based on market activity.</li>
            <li>Consider the ethical implications of shorting stocks, as it bets against the success of human values.</li>
            <li>Every trade reflects your priorities and beliefs\u{2014}choose wisely!</li>
          </ul>
        `,
                "transact_instructions": `
          <h3>From Item to Interaction</h3>
          In most markets a commodity is an impersonal thing\u{2014}gold, oil, wheat\u{2014}bought, sold, consumed at will.
          At Z Exchange a <em>Commodity X</em> is still a physical object, but it cannot be consumed until the trader earns collective approval.
          Consumption becomes a social question: <em>What does it mean to need someone else's assent? What does your desire say about you\u{2014}and who needs to hear it?</em>
          Using social validation to combat mindless consumption, every trade becomes a small ritual of interaction; every commodity, a shared reflection.
          Here validation is not just permission, it is participation. The true commodity is the relationship.
          <h3>Social-Redeem Process</h3>
          Commodity X is not exchanged directly. Instead, you initiate a redeem cycle that succeeds only if the community agrees.
          <strong>1. Select your Commodity X</strong><br>
          Pick the item in your portfolio that you wish to consume (redeem).
          <br><br>
          <strong>2. Invite Co-Redeems</strong><br>
          Choose one to three commodities owned by other traders and invite their holders to redeem at the same time. Your consumption is now tied to theirs.
          <br><br>
          <strong>3. Send the Redeem Ask</strong><br>
          Press "Send Redeem Ask". All invited traders have <strong>10 seconds</strong> to accept or decline. During that window every selected item is locked.
          <br><br>
          <strong>4. Outcomes</strong><br>
          \u{2022} <strong>Collective&nbsp;Yes</strong> \u{2013} every invitee accepts. Your item turns into a QR code, leaves the market, and can be physically collected. You also receive a random bonus commodity from the Zederal Reserve.
          \u{2022} <strong>Any&nbsp;No</strong> \u{2013} at least one invitee declines. No one redeems; all items unlock and stay tradable. Nothing changes hands.
          <br><br>
          <h3>Conceptual Insight</h3>
          By linking individual consumption to shared approval, Commodity X critiques the culture of solitary, friction-free buying.
          It asks traders to consume consciously, to weigh desire against communal resonance, and to recognise that value emerges in relationship\u{2014}not isolation.
          Redeem relationally. Consume consciously.
        `,
                "market_instructions": `
          <h3>Marketplace Overview</h3>
          ZExchange is the ZEconomy Marketplace. It can be considered the dynamic heart of trading activities where traders can explore, bid on, bet against, and trade various assets. The Marketplace is ground zero for traders to engage in strategic decision-making and actively shape their trading portfolios.
          <br><br>
          <h3>Marketplace Activities</h3>
          The ZExchange Marketplace offers the following key activities:
          <br><br>
          <strong>1. Explore Available Assets:</strong><br>
          Use the Marketplace to scroll through the current available assets. These include stocks, commodities, and bonds. Each asset is accompanied by detailed descriptions and close to real-time market valuation, allowing you to make informed decisions before initiating trades or placing bids. You can also place short bets on individual stocks and see who has shorted what.
          <br><br>
          <strong>2. Initiate Trade Offers:</strong><br>
          Send direct commodity trade offers to other traders. Select assets from your portfolio and propose an exchange. Trade offers are valid for 10 seconds, during which the receiving trader can either accept or decline the offer. If no action is taken within the time frame, the offer is automatically declined. Fees are applicable to both parties.
          <br><br>
          <strong>3. Place Bids:</strong><br>
          Bid on stocks and bonds listed in the Marketplace through the bidding process. Bidding provides an opportunity to secure assets at a potentially lower cost while competing with other traders. Keep an eye on bid expiration times to stay ahead in the market.
          <br><br>
          <strong>4. Redeem Commodities:</strong><br>
          Commodities (physical assets) in the Marketplace can be redeemed through the redeem process. Select between two and up to 10 of these assets by checking a commodity redeem box. After the second selection, the redeem button will appear, and you can proceed to finish the redeem.
          <br><br>
          <strong>5. Place Short Positions:</strong><br>
          Engage in negative side trading by shorting certain assets. This allows you to profit from anticipated declines in value. Placing short bets requires careful timing and risk management, making it a powerful tool for augmenting your positive or negative earnings. You can close the short position on your holdings page.
          <br><br>
          <h3>Trading Mechanics</h3>
          <strong>1. Transaction Fees:</strong><br>
          Each transaction costs a fee depending on the type of transaction. This encourages thoughtful trades and strategic exchanges.
          <br><br>
          <strong>2. Bid Expiration:</strong><br>
          All bids are active for a limited duration. If the target trader does not respond to your bid within the specified time, the bid expires without a transaction. Possible penalties can be applied if the target trader does not respond.
          <br><br>
          <strong>3. Offer Penalties:</strong><br>
          Declined trade offers result in an earnings penalty for the trader who refuses the exchange. This incentivizes careful consideration of offers and fosters a market of intentional interactions. However, they will cost you a fee if the offer is accepted.
          <br><br>
          <h3>What is a Financial Exchange?</h3>
          At its core, a financial exchange is a structured platform where participants buy and sell assets such as stocks, bonds, and commodities. It operates as a hub for economic activity, enabling traders to assess the value of goods and execute transactions based on supply, demand, and personal strategy.
          <br><br>
          The ZExchange, the ZEconomy Marketplace, looks at the value of assets differently than traditional financial exchanges because the values are placed on human experiences, relationships, and social exchange. Less is not necessarily better than more. Instead of focusing solely on monetary gain, the ZExchange encourages participants to consider different ideas of value: the worth of collaboration, the ethics of competition, and the value of shared experiences. It applies finance and basic economics to shared common real-life experiences all humans face, placing the value on life itself.
          <br><br>
          This approach redefines the purpose of a financial exchange, transforming it into a reflective and socially participatory system. Traders are challenged to think beyond material accumulation and instead prioritize:
          <br><br>
          <strong>Relational Dynamics:</strong> Exploring how personal and collective interactions can impact market and social decisions.<br>
          <strong>Ethical Trading:</strong> Evaluating whether their strategies align with their moral beliefs about fairness, responsibility, and shared growth.<br>
          <strong>Experiential Value:</strong> Placing importance on how trades reflect and shape human experiences, how we can find and emphasize economic value in common living experiences, whether through collaboration, conflict, or mutual support.
          <br><br>
          By participating in the ZExchange, traders engage in a financial experiment that elevates the human aspects of economics. It is a system designed to challenge conventional assumptions about value, encouraging a more nuanced understanding of wealth as something that is both deeply personal and inherently collective.
        `,
                'emotional-debt-banner': `
          <h3>Emotional Debt Index</h3>
          <strong>Human Emotional Flux</strong>
          <br><br>
          Finding value in vulnerability through emotional debt. In this economy, value is not extracted\u{2014}it is felt. Every gesture\u{2014}help, trust, abandonment, envy\u{2014}leaves a trace, a measurable emotional gain or loss, a continuity. Life profit is a currency of sensation, taking the temperature of our being. Holding someone, letting yourself be held: the most human forms of leverage. The ZEconomy flows through us.
          <br><br>
          <strong>1. Altrau Z Bill</strong><br>
          <em>Altruistic life value. Empathy.</em><br>
          Giving without promise of return. Helping someone means involving yourself in the trajectory of their Life Profit. The rise and fall of their emotional balance pulls your own life profits toward positive or negative. Silent speculation on the idea that another's well-being could expand your own capacity to feel, to extend your empathy faculty. No return demanded.
          <br><br>
          <em>(Mirror code: a transaction that binds both ledgers; an increase in shared variance rather than a simple sum.)</em>
          <br><br>
          <strong>2. M Note (Mutual Note)</strong><br>
          <em>A loan written as confession.</em><br>
          The M Note creates credit from exposed need and calculated trust. Value born from the human empathy of sharing human imperfections. The borrower reveals a weakness; the lender accepts the risk, extending empathy as a form of investment. What begins as recognition becomes obligation\u{2014}vulnerability converted into Z Relational Collateral, interest growing in attention, recognition, and mutual Life Profit.
          <br><br>
          <em>(Mirror code: emotionally weighted interest; time dilates according to mood.)</em>
          <br><br>
          <strong>3. Z-Payday CDO (Collateralized Desire Obligation)</strong><br>
          <em>Exploitation disguised as empathetic human connection.</em><br>
          Empathy and relief are reformulated into instruments of toxic dependency. Z-Payday loans feed on need and greed, transforming vulnerability into yield at the expense of human value and systemic balance. Each loan cycle elevates the lender, exhausts the borrower, and leaves the market to absorb the contagion.
          <br><br>
          <strong>Function:</strong> Isolated acts of help become a repetitive contract\u{2014}each minute issues a new obligation, each obligation is fragmented into tranches feeding a larger CDO. The product promises immediacy, then converts the living into yield; the harvest comes from what erodes when benevolence becomes structural. The Z-Payday CDO does not forgive. It amplifies exposure until the ledger devours the underlying life profit.
          <br><br>
          <strong>4. V Note (Vulnerability Note)</strong><br>
          <em>Admitting vulnerability.</em><br>
          To ask is to expose oneself\u{2014}to risk the small collapse that accompanies being seen in need. Vulnerability is not weakness here, but invitation: a signal that balance has broken and requires a relationship to restore itself. Help, if granted, becomes a shared moment of recalibration; if refused, it marks the silent fracture between trust and pride. Each request is inscribed in the Emotional Debt Index, measuring not possession, but the degree to which we still dare to depend.
          <br><br>
          <em>(Mirror code: justified request; relief triggered by assent; the ledger records both call and response.)</em>
          <br><br>
          <strong>Closing Tone</strong><br>
          What circulates here is not finance, but recognition. Vulnerability becomes both mirror and market, where each profit is the echo of another's risk, and each debt, a memory that refuses to fade.
          <br><br>
          <h3>Emotional Debt Index</h3>
          It all begins with the recognition that accumulated life has weight\u{2014}that the simple fact of living with others engenders emotional debt, positive or negative, acknowledged or neglected, that we carry alone and exchange together. Debt not as deficit, but as acceptance: an instrument of the effects of our mutual entanglement. In the ZEconomy, Emotional Debt is the counterpoint to productivity\u{2014}it does not track what is produced, but what is felt. Every gesture, every hesitation, every confession or withdrawal modifies the emotional ledger. Its movements translate the circulation of affect through a living, porous system, where value is neither extracted nor manufactured, but engendered by the very experience of life. Life Profits, flows that resist accumulation, yet shape everything built upon them.
          <br><br>
          The Emotional Debt Index makes intimate vulnerability visible, mapping the invisible economies of trust, exhaustion, generosity, failure, dependency... that participate in collective instability or balance. Rejecting the fantasy of capital, embracing the liquidity of human sentiment.
        `
            },
            "common": {
                "close": "Close",
                "assign": "Assign",
                "unassign": "Unassign",
                "delete": "Delete",
                "redeem": "Redeem",
                "unredeem": "Unredeem",
                "yes": "Yes",
                "no": "No",
                "assigned_to": "assigned to",
                "to_market": "to market",
                "to_portfolio": "to portfolio",
                "successfully": "successfully",
                "login_required": "You must be logged in to perform this action.",
                "bond_with_interest_rate": "bond with interest rate",
                "assign_to_portfolio": "Assign to Portfolio",
                "assign_to_market": "Assign to Market",
                "item_name": "Item Name:",
                "owner": "Owner:",
                "trader_name": "Trader Name:",
                "password": "Password:",
                "connected": "Connected:",
                "portfolio_id": "Portfolio ID:",
                "points_breakdown": "Capital Breakdown:",
                "trading": "Trading",
                "commodities": "Commodities",
                "stocks": "Stocks",
                "shorts": "Shorts",
                "total": "Total:",
                "holdings": "Holdings:",
                "commodity": "Commodity:",
                "stock": "Stock:",
                "quantity": "Quantity",
                "shares": "Shares",
                "value": "Value",
                "no_holdings": "No holdings in this portfolio.",
                "unnamed_portfolio": "Unnamed Portfolio",
                "protected": "[protected]",
                "qr_code": "QR Code:",
                "qr_code_for": "QR Code for",
                "no_qr_available": "No QR code available.",
                "custom_relationship_type": "Custom relationship type",
                "remove": "Remove",
                "created_for_relationship": "Zollar created for relationship:",
                "value_place_relationship": "The value you place on a relationship:",
                "na": "N/A"
            },
            "socketFront": {
                "warningPrefix": "WARNING:",
                "criticalPrefix": "CRITICAL:",
                "debtPageVisit": "Visit the Debt page for details.",
                "debtWipeoutDefault": "Your portfolio has been wiped out due to excessive debt.",
                "debtWarningPrefix": "WARNING: This debt reloads every 60 seconds at 15% compound until repayment.",
                "bankruptcyWarning": "WARNING: You are approaching bankruptcy!",
                "debtCompounded": "Debt compounded:",
                "totalDebt": "Total debt:",
                "youOwe": "You owe:",
                "checkDebtHeldSection": "Check your Debt Held section to convert."
            },
            "debtWarning": {
                "title": "Debt Warning",
                "aboutToGoIntoDebt": "You are about to go into debt!",
                "currentBalance": "Current Balance:",
                "bidAmount": "Bid Amount:",
                "offerAmount": "Offer Amount:",
                "youWillOwe": "You will owe:",
                "interestAccrues": "Interest accrues at 5% daily on negative balances.",
                "creditLimit": "Credit limit: -1000 capital (default)",
                "proceedAnyway": "Proceed Anyway",
                "cancel": "Cancel",
                "points": "Capital"
            },
            "debt": {
                "capital": "capital",
                "closedDefault": "A {type} debt instrument has been closed.",
                "closedGeneric": "A debt instrument has been closed.",
                "amounts": {
                    "none": "None",
                    "barelyAny": "Barely Any",
                    "aTrace": "A Trace",
                    "aHint": "A Hint",
                    "aLittle": "A Little",
                    "aFew": "A Few",
                    "some": "Some",
                    "several": "Several",
                    "moderate": "Moderate",
                    "noticeable": "Noticeable",
                    "considerable": "Considerable",
                    "many": "Many",
                    "aLot": "A Lot",
                    "abundant": "Abundant",
                    "heaps": "Heaps",
                    "aGreatDeal": "A Great Deal",
                    "substantial": "Substantial",
                    "immense": "Immense"
                },
                "interest": {
                    "minimal": "Minimal Emotional Interest",
                    "light": "Light Emotional Interest",
                    "modest": "Modest Emotional Interest",
                    "fair": "Fair Emotional Interest",
                    "moderate": "Moderate Emotional Interest",
                    "notable": "Notable Emotional Interest",
                    "considerable": "Considerable Emotional Interest",
                    "heavy": "Heavy Emotional Interest",
                    "intense": "Intense Emotional Interest",
                    "crushing": "Crushing Emotional Interest"
                },
                "altrau": {
                    "receivedTitle": "Z Bill Altrau Received",
                    "issuedTitle": "Z Bill Altrau Issued",
                    "hasGivenYou": "has given you",
                    "ledgersBound": "Your ledgers are now bound. Their Life Profit affects yours.",
                    "youHaveSent": "You have sent",
                    "toRecipient": "to",
                    "fatesBound": "Your fates are now bound. Your Life Profit affects theirs."
                },
                "mnote": {
                    "acceptedTitle": "M Note Accepted",
                    "createdTitle": "M Note Created",
                    "witnessedVulnerability": "has witnessed your vulnerability",
                    "loanLabel": "Loan",
                    "atRate": "at",
                    "positiveTradeTip": "Make positive trades to automatically reduce this debt!",
                    "createdWith": "M Note created with",
                    "tradeableAfter": "Tradeable after 5 exchanges. Convertible after max trades.",
                    "progressTitle": "M Note Repayment Progress",
                    "repaidPercent": "You've repaid",
                    "throughTrading": "through positive trading",
                    "keepTrading": "Keep trading well to continue reducing your debt.",
                    "debtClearedTitle": "Debt Cleared!",
                    "repaidTitle": "M Note Repaid",
                    "positiveTrading": "positive trading",
                    "directRepayment": "direct repayment",
                    "fullyRepaidTo": "You've fully repaid your M Note to",
                    "throughMethod": "through",
                    "emotionalDebtCleared": "Your emotional debt is cleared. Well done!",
                    "hasFullyRepaid": "has fully repaid their M Note",
                    "instrumentClosed": "The debt instrument has been closed.",
                    "alertTitle": "M Note Alert",
                    "convertibleTitle": "M Note Convertible",
                    "nowConvertible": "Your M Note is now",
                    "convertibleCaps": "CONVERTIBLE",
                    "canConvertTo": "You can convert it to",
                    "inLiquidAssets": "in liquid assets"
                },
                "cdo": {
                    "acceptedTitle": "Z-Payday CDO Accepted",
                    "createdTitle": "Z-Payday CDO Created",
                    "offeredLoan": "has offered you a loan",
                    "availableImmediately": "available immediately",
                    "createdWith": "Z-Payday CDO created with",
                    "tradeableCompounds": "Tradeable. Compounds every 60s at 15%.",
                    "bankruptcyWarningTitle": "BANKRUPTCY WARNING",
                    "reloadCycle": "CDO Reload: Cycle {cycle}",
                    "cdoCompounded": "Your CDO compounded",
                    "victimOwes": "Victim owes",
                    "bankruptcyTitle": "BANKRUPTCY",
                    "cdoCollapsed": "Your Z-Payday CDO collapsed",
                    "totalDebtLabel": "Total debt",
                    "assetsSeized": "Assets seized",
                    "standingDamaged": "Your financial standing has been severely damaged.",
                    "maturedTitle": "CDO Matured",
                    "victimBankrupt": "Your victim declared bankruptcy",
                    "youSeized": "You seized",
                    "toxicGainRecorded": "Toxic relationship gain recorded."
                },
                "vnote": {
                    "aidGrantedTitle": "V Note Aid Granted",
                    "hasGrantedAid": "has granted you aid",
                    "received": "Received",
                    "vulnerabilityWitnessed": "Your vulnerability was witnessed and met with compassion.",
                    "youGranted": "You granted",
                    "toRecipient": "to",
                    "compassionRecorded": "Your compassion has been recorded in the social ledger."
                }
            },
            "freeend": {
                "title": "Trading Session Complete",
                "trading_analysis": "TRADING ANALYSIS",
                "social_standing": "Social Standing",
                "return_home": "Return Home",
                "panels": {
                    "stocks": "STOCKS",
                    "items": "ITEMS",
                    "zollars": "ZOLLARS",
                    "bonds": "BONDS"
                },
                "judgements": {
                    "performance": "Performance",
                    "style": "Style",
                    "social": "Social",
                    "risk": "Risk",
                    "mood": "Mood"
                },
                "ratings": {
                    "excellent": "Excellent",
                    "good": "Good",
                    "fair": "Fair",
                    "poor": "Poor",
                    "bad": "Bad",
                    "neutral": "Neutral",
                    "aggressive": "Aggressive",
                    "calm": "Calm",
                    "balanced": "Balanced",
                    "active": "Active",
                    "quiet": "Quiet",
                    "moderate": "Moderate",
                    "diverse": "Diverse",
                    "cautious": "Cautious",
                    "focused": "Focused",
                    "euphoric": "Euphoric",
                    "optimistic": "Optimistic",
                    "positive": "Positive",
                    "anxious": "Anxious",
                    "distressed": "Distressed"
                },
                "sections": {
                    "social_class_movement": "YOUR SOCIAL CLASS MOVEMENT",
                    "mood_state": "MOOD STATE",
                    "trading_behavior": "TRADING BEHAVIOR PATTERNS",
                    "commodities_supply": "COMMODITIES SUPPLY"
                },
                "labels": {
                    "commodities": "Commodities:",
                    "no_commodities": "No commodity holdings - focus was on other value forms",
                    "stocks": "Stocks",
                    "items": "Items",
                    "zollars": "Zollars",
                    "bonds": "Bonds",
                    "zollar_holdings": "Relational Zollar Holdings:",
                    "total": "Total:",
                    "session_engagement": "Session Engagement:",
                    "social_connections": "Social Connections:",
                    "value_movement": "Value Movement:",
                    "started_with": "Started With",
                    "ended_with": "Ended With",
                    "life_movement": "Life Movement",
                    "your_holdings": "Your Holdings",
                    "rhythm": "Rhythm",
                    "value_shift": "Value Shift",
                    "cadence": "Cadence",
                    "diversity": "Diversity",
                    "intensity": "Intensity"
                },
                "value_movement": {
                    "significant_gain": "Significant Gain",
                    "strong_gain": "Strong Gain",
                    "moderate_gain": "Moderate Gain",
                    "slight_gain": "Slight Gain",
                    "no_change": "No Change",
                    "slight_loss": "Slight Loss",
                    "moderate_loss": "Moderate Loss",
                    "strong_loss": "Strong Loss",
                    "significant_loss": "Significant Loss"
                },
                "activity_levels": {
                    "contemplative": "Contemplative",
                    "measured": "Measured",
                    "active": "Active",
                    "very_active": "Very Active",
                    "intensely_engaged": "Intensely Engaged"
                },
                "social_levels": {
                    "solitary": "Solitary",
                    "selective": "Selective",
                    "socially_active": "Socially Active",
                    "highly_connected": "Highly Connected"
                },
                "emotional_states": {
                    "balanced": "Balanced",
                    "triumphant": "Triumphant",
                    "reflective": "Reflective",
                    "socially_engaged": "Socially Engaged",
                    "energetically_active": "Energetically Active"
                },
                "quantities": {
                    "none": "None",
                    "barely_any": "Barely Any",
                    "a_trace": "A Trace",
                    "a_hint": "A Hint",
                    "a_little": "A Little",
                    "a_few": "A Few",
                    "some": "Some",
                    "several": "Several",
                    "moderate": "Moderate",
                    "noticeable": "Noticeable",
                    "considerable": "Considerable",
                    "many": "Many",
                    "a_lot": "A Lot",
                    "abundant": "Abundant",
                    "heaps": "Heaps",
                    "a_great_deal": "A Great Deal",
                    "substantial": "Substantial",
                    "ample": "Ample",
                    "extensive": "Extensive",
                    "vast": "Vast",
                    "profuse": "Profuse",
                    "almost_all": "Almost All",
                    "nearly_everything": "Nearly Everything",
                    "overflowing": "Overflowing",
                    "virtually_everything": "Virtually Everything",
                    "all_you_have": "All You Have"
                },
                "value": {
                    "none": "Nothing",
                    "barely_any": "Barely Anything",
                    "a_trace": "A Trace of Value",
                    "a_little": "A Little",
                    "some": "Some Holdings",
                    "modest": "Modest",
                    "moderate": "Moderate",
                    "comfortable": "Comfortable",
                    "considerable": "Considerable",
                    "substantial": "Substantial",
                    "abundant": "Abundant",
                    "prosperous": "Prosperous",
                    "wealthy": "Wealthy",
                    "very_wealthy": "Very Wealthy",
                    "extremely_wealthy": "Extremely Wealthy",
                    "vast_wealth": "Vast Wealth"
                },
                "change": {
                    "unchanged": "Unchanged",
                    "slight_loss": "A Slight Loss",
                    "small_loss": "A Small Loss",
                    "moderate_loss": "A Moderate Loss",
                    "considerable_loss": "A Considerable Loss",
                    "substantial_loss": "A Substantial Loss",
                    "large_loss": "A Large Loss",
                    "severe_loss": "A Severe Loss",
                    "slight_gain": "A Slight Gain",
                    "small_gain": "A Small Gain",
                    "moderate_gain": "A Moderate Gain",
                    "considerable_gain": "A Considerable Gain",
                    "substantial_gain": "A Substantial Gain",
                    "large_gain": "A Large Gain",
                    "exceptional_gain": "An Exceptional Gain"
                },
                "pace": {
                    "still": "Still",
                    "contemplative": "Contemplative",
                    "measured": "Measured",
                    "steady": "Steady",
                    "active": "Active",
                    "brisk": "Brisk",
                    "vigorous": "Vigorous",
                    "intense": "Intense",
                    "frenetic": "Frenetic"
                },
                "diversity": {
                    "none": "None",
                    "singular": "Singular Focus",
                    "focused": "Focused",
                    "balanced": "Balanced",
                    "broad": "Broadly Diversified"
                },
                "intensity": {
                    "quiet": "Quiet",
                    "calm": "Calm",
                    "moderate": "Moderate",
                    "engaged": "Engaged",
                    "active": "Active",
                    "intense": "Intense",
                    "highly_intense": "Highly Intense",
                    "overwhelming": "Overwhelming"
                }
            },
            "tax": {
                "tax_alert_timer": "TAX ALERT! You have 10 seconds to choose or lose both:",
                "lose_capital_zollars": "Lose capital & Zollars",
                "give_random_asset": "Give random asset",
                "assign_failed": "Failed to assign new item to all portfolios.",
                "new_asset_assigned": "Zederal Reserve has assigned a new asset to your portfolio.",
                "tax_call_no_assets": "Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.",
                "asset_taxed": "You have been taxed an asset by the Zederal Reserve.",
                "no_items_available": "No non-traded items available for taxation.",
                "tax_item_failed": "Failed to tax an item.",
                "capital_taxed_prefix": "You have been taxed capital by the Zederal Reserve!",
                "refund_received_prefix": "You have received a refund of capital from the Zederal Reserve",
                "new_asset_received": "You have received a new asset from the Zederal Reserve",
                "zollar_assigned": "You have received Zollars from the Zederal Reserve.",
                "points": "Capital"
            },
            "presentation": {
                "title": "ZExchange - Presentation",
                "hero_tagline": "What if value wasn't a number?",
                "intro_main": "A live trading floor experience for 10 to 200 participants, lasting 1 to 24 hours. But this isn't Wall Street. Here, the asset class is human experience itself.",
                "card_trade_title": "Trade Human Conditions",
                "card_trade_desc": "Instead of Apple or Nvidia, invest in Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Every stock represents a facet of being alive.",
                "card_spend_title": "Spend Relationships",
                "card_spend_desc": "Forget dollars. Here you pay with Zollars, currency denominated by relationship type: Love, Friendship, Hate, Erotic, Toxic, Death.",
                "card_consume_title": "Consume Collectively",
                "card_consume_desc": "Own a glass of wine? You can't acquire it alone. To redeem any commodity, you must ask others for approval. Consumption requires mutual consent.",
                "card_market_title": "The Market Watches Back",
                "card_market_desc": "An AI narrates every transaction, interpreting what your trades reveal about you. The market doesn't just move, it speaks.",
                "intro_transform": "ZExchange transforms economic logic into a collective conversation about what we actually value.",
                "intro_mirror": "It's part conceptual art, part party art, part mirror. Organizations discover their hidden values. Groups confront power, fairness, and trust. Everyone leaves with questions they didn't arrive with.",
                "section_video": "Video Explainers",
                "section_video_desc": "Click to watch concept explanations",
                "video_intro": "Introduction to ZExchange",
                "video_intro_desc": "Overview of the concept",
                "video_life": "Life Profits & Value",
                "video_life_desc": "Value in the ZEconomy",
                "video_stocks": "How Stocks Function",
                "video_stocks_desc": "Trading human conditions",
                "video_zbonds": "ZBonds & Zollars",
                "video_zbonds_desc": "Z Relationship Monetary System",
                "video_commodity": "Commodity X",
                "video_commodity_desc": "Social consumption",
                "video_interface": "Interface Preview",
                "video_interface_desc": "The trading interface",
                "video_bigboard": "Generative Big Boards",
                "video_bigboard_desc": "Real-time market expression",
                "section_assets": "Trading Assets",
                "section_assets_desc": "Click banners for detailed explanations",
                "label_stocks": "STOCKS - Human Conditions as Shares",
                "label_zbonds": "ZBONDS - Relationship-Based Investments",
                "label_commodities": "COMMODITIES - Physical Items with Social Approval",
                "label_zollars": "ZOLLARS - Currency Without Numbers",
                "section_economic": "Economic Tools",
                "section_economic_desc": "Ideological approaches to wealth and power",
                "label_economic": "ECONOMIC TRIGGERS - Ideology as Market Action",
                "label_communist": "Communist Assault",
                "label_socialist": "Socialist Subsidy",
                "label_lbo": "Capitalist LBO",
                "section_trader": "Trader Tools",
                "section_trader_desc": "How far will you go in the quest for value?",
                "label_trader": "TRADER TOOLS - Actions With or Against Others",
                "label_steal": "Steal",
                "label_ransom": "Ransom",
                "label_darkpool": "Dark Pool",
                "section_features": "Market Features",
                "label_emotional": "EMOTIONAL DEBT INDEX - Human Emotion Flux",
                "label_bigboard": "THE BIG BOARD - Real-Time Market Visualization",
                "label_voice": "VOICE OF THE BOURSE - AI Market Narration",
                "section_central": "Zederal Reserve / ZExchange Regulator",
                "section_central_desc": "How the ZExchange operator controls market sessions",
                "central_intro": "The Zederal Reserve (or ZExchange Operator) orchestrates the entire trading session. Before the market opens, it is the interfaces where you can configure the economy: creating trader portfolios with initial capital and commodities available during the session, distribute stock from over 350 predefined ZEconomy companies, and mint relationship-based Zollars and ZBonds. During the session, you act as regulator and central authority: opening and closing the market, controlling which assets can be traded, taxing portfolios to extract value, subsidizing traders with capital or commodities, issuing special triggers (Steal, Ransom, Dark Pool, Communist Assault, Socialist Subsidy, Capitalist LBO), broadcasting media events, and deploying market bots for liquidity. You can shape the session's narrative through story themes that guide the AI's interpretation of market activity. The Zederal Reserve acts as a Central Bank embodying the tension between control and chaos in any economy, you can foster balance or create disruption, reward or punish, stimulate or restrict. Every decision ripples through the market, challenging traders to adapt and respond.",
                "label_control": "MARKET CONTROL - Open/Close & Asset Listing",
                "section_tax": "Tax Portfolios Holdings",
                "section_tax_desc": "Extract value from trader portfolios",
                "label_taxall": "Tax All Traders",
                "label_taxitem": "Tax Commodity",
                "label_taxpoints": "Tax Capital",
                "section_subsidize": "Subsidize Portfolios Holdings",
                "section_subsidize_desc": "Inject value into trader portfolios",
                "label_givezollar": "Give Zollar Subvention",
                "label_givepoints": "Give Capital Subvention",
                "label_giveitem": "Give Commodity",
                "label_freebie": "Commodity Distribution",
                "section_events": "Event Triggers",
                "section_events_desc": "Broadcast media and create narratives",
                "label_publizity": "Play PubliZity",
                "label_znews": "Play ZNews",
                "label_story": "Create Story",
                "section_bots": "Market Bots",
                "section_bots_desc": "Automated trading for market liquidity",
                "label_addbots": "Add Bots",
                "label_removebots": "Remove Bots",
                "label_botstatus": "Bot Status",
                "section_keep": "What Participants Keep",
                "keep_bigboard": "A Big Board shaped by every trade, frozen as generative artwork",
                "keep_story": "An AI-written story of your group's dynamics",
                "keep_award": "Perhaps an award or two",
                "keep_mirror": "A mirror reflecting what your organization actually values",
                "section_concepts": "Key Concepts",
                "concept_life_title": "Life Profit",
                "concept_life_desc": "Value of consciously lived life: joy, loss, love, depression. Quality over quantity.",
                "concept_auto_title": "No Autopilot",
                "concept_auto_desc": "Every transaction requires presence. To trade, engage another. To redeem, you must ask.",
                "concept_market_title": "The Market Talks Back",
                "concept_market_desc": "AI watches every transaction, offering interpretations and narration.",
                "concept_shared_title": "Shared Values",
                "concept_shared_desc": "Opposite political spectrums, same human experiences.",
                "footer_mirror": "ZExchange isn't just a market; it's a mirror.",
                "footer_transform": "It turns the cold logic of economics into a collective conversation about what we actually value.",
                "footer_part": "Part of",
                "popup_stocks": '<h3>Shares (Stocks)</h3><strong>Description:</strong><br>Monitor and trade your stock positions.<br><br><strong>What They Are:</strong><br>In conventional finance, a stock represents partial ownership of a company. Investors typically buy stocks hoping the company\'s value will rise.<br><br>In ZEconomy, each "company" reflects personal or human values\u2014such as emotional well-being, social relationships, or daily life activities\u2014rather than traditional products or services. By "investing" in these companies, you\'re effectively betting on the value of growth, transformation, or sustainability of human experiences.<br><br><strong>Conceptual Insight:</strong><br>This challenges the notion of profit: is it about reaping monetary rewards, or about supporting the expansion of "life value" such as emotional health, creativity, or shared experiences?<br><br>Think of your stocks as investments in human value: happiness, depression, success, failure, confusion\u2014instead of a company producing a product or service.<br><br><strong>Mechanics:</strong><br>Stocks are tradable for Zollars or points. As a company\'s value grows, so does the value of your portfolio.',
                "popup_zbonds": "<h3>ZBonds</h3><strong>Description:</strong><br>ZBonds function like traditional bonds: you purchase them using points, hold them over a predetermined term, and when they expire, you receive Zollars.<br><br><strong>Conceptual Insight:</strong><br>While typical bonds fund governments or corporations, ZBonds fund the creation of a currency (Zollars) whose entire value is tied to human relationships and experiences.<br><br>By investing in a ZBond, you are effectively choosing to place trust in the shared values of community and interpersonal connections over purely financial returns.<br><br>ZBonds bridge the gap between traditional \"fixed income securities\" and the ZEconomy's redefinition of \"value.\"",
                "popup_commodities": "<h3>Commodities (Commodity X)</h3><strong>Description:</strong><br>The redeemable physical items you own.<br><br><strong>Social Validation:</strong><br>No commodity can be consumed alone. To redeem one, traders must ask other traders for approval. If all agree, the item is released; if anyone declines, nothing happens.<br><br><strong>Conceptual Insight:</strong><br>What does it mean to need permission for what you already own? Social validation inserts friction where markets remove it, making consumption visible, questioned, collective.<br><br>Commodities remind us that markets are also about goods and experiences that shape our lives.",
                "popup_zollars": "<h3>Zollars</h3><strong>Description:</strong><br>Check your Zollar balances and transactions.<br><br><strong>Currency Without Numbers:</strong><br>Zollars are denominated by relationship type: Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Using Zollars pushes participants to consider <em>what kind</em> of value is at stake, not <em>how much</em>.<br><br><strong>Conceptual Insight:</strong><br>Acquiring Zo Insomnia Incorporated with Love Zollars tells a different story than acquiring it with Toxic Zollars. The interpretation is personal; the framework, shared.<br><br>Zollars challenge traditional ideas of currency by basing value on human relationships.",
                "popup_economic": "<h3>Economic Attack Triggers</h3><strong>Description:</strong><br>Economic Attack Triggers represent different ideological approaches to wealth, power, and market dynamics. They allow traders to use strategies inspired by economic systems\u2014communism, socialism, capitalism\u2014to gain or redistribute advantages within the ZEconomy.<br><br><strong>Conceptual Insight:</strong><br>The triggers challenge participants to confront their beliefs about fairness, ambition, and collective responsibility. They spark debate about the balance between fairness, ambition, and ethical trade-offs.<br><br><ul><li>Should wealth be shared equally, even if it means confiscating someone else's success?</li><li>Is it ethical to profit at the expense of another's autonomy?</li><li>How far are you willing to go to achieve personal gain or support collective welfare?</li></ul>",
                "popup_communist": "<h3>Communist Assault Trigger</h3><strong>Description:</strong><br>Seize and redistribute all of a targeted portfolio's wealth to the collective.<br><br><strong>Functionality:</strong><br>The target's wealth (points, stocks, commodities) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.<br><br><strong>Conceptual Insight:</strong><br>This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution.<br><br><em>Should wealth be shared equally, even if it means confiscating someone else's success?</em>",
                "popup_socialist": "<h3>Socialist Subsidy Trigger</h3><strong>Description:</strong><br>Tax a wealthy portfolio and redistribute the resources to less affluent traders.<br><br><strong>Functionality:</strong><br>50% of the target portfolio's wealth is taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br><br><strong>Conceptual Insight:</strong><br>\"Socialist Subsidy\" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.<br><br><em>How do we balance equity with individual achievement?</em>",
                "popup_lbo": "<h3>Capitalist Leveraged Buyout (LBO)</h3><strong>Description:</strong><br>Aggressively acquire another portfolio's assets through a leveraged buyout.<br><br><strong>Functionality:</strong><br>The acquiring trader gains full control of the target's portfolio at severe cost to them. The transaction is coercive yet compensatory\u2014the target receives payment, and the initiator pays an inflated price.<br><br><strong>Conceptual Insight:</strong><br>\"Capitalist LBO\" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation.<br><br><em>Is it ethical to profit at the expense of another's autonomy?</em>",
                "popup_tools": "<h3>Trader Tools</h3><strong>Description:</strong><br>Utilities for performing market-related actions with or against other traders.<br><br><strong>Conceptual Insight:</strong><br>Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility\u2014or will you push boundaries at the expense of others?<br><br>The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
                "popup_steal": "<h3>Steal Item</h3><strong>Description:</strong><br>Take assets from another portfolio anonymously, without permission.<br><br><strong>Functionality:</strong><br>The selected item is transferred from the target's portfolio to your portfolio without consent. The action remains anonymous, preventing immediate retaliation.<br><br><strong>Conceptual Insight:</strong><br>Stealing tests ethical boundaries, exploring whether traders prioritize personal gain over empathy and collective trust. It challenges participants to reflect on the consequences of their actions and how they value fairness within the ZEconomy.",
                "popup_ransom": "<h3>Ransom Portfolio</h3><strong>Description:</strong><br>Lock another trader's portfolio and demand a ransom to unlock it.<br><br><strong>Functionality:</strong><br>Locks the target's portfolio, rendering it unusable until the ransom is resolved. The trader initiating the ransom gains points if paid. The initiator's identity is revealed to the victim, adding social consequence.<br><br><strong>Conceptual Insight:</strong><br>Ransoming explores power dynamics and coercion in trading. It forces traders to evaluate whether financial gain outweighs potential social backlash or ethical concerns.",
                "popup_darkpool": "<h3>Dark Pool</h3><strong>Description:</strong><br>Establish a private trading group hidden from the public market.<br><br><strong>Functionality:</strong><br>Creates a private, temporary trading space exclusive to selected participants. Trades within the Dark Pool are hidden from the broader market, allowing participants to set their own prices and terms.<br><br><strong>Conceptual Insight:</strong><br>Dark Pools represent a tension between collaboration and manipulation. They offer the opportunity to negotiate deals without public scrutiny, but challenge the fairness and transparency of the market.",
                "popup_emotional": "<h3>Emotional Debt Index</h3><strong>Human emotion flux</strong><br><br><strong>Acknowledging the value of vulnerability through emotional debt.</strong><br><br>ZEconomy value is not extracted but felt. Every gesture\u2014help, trust, abandonment, envy\u2014leaves a trace: measurable emotional debt both positive and negative. We carry debt with us like it or not.<br><br>To hold another, to let oneself be held: the most human forms of leverage. The ZEconomy moves through us.<br><br><strong>Relational Index</strong> \u2014 The measure of relational integrity, rises with honor and help towards others, falls with exploitation and betrayal.<br><br><strong>Existential Balance</strong> \u2014 The measure of your actions towards others' life profits. Are you causing or relieving others' symbolic burdens?<br><br><em>Reject the fantasy of capital, embrace the liquidity of human feeling.</em>",
                "popup_bigboard": "<h3>The Big Board</h3><strong>Real-Time Market Visualization</strong><br><br>The Big Board visualizes activity in real time, accumulating moods and actions, changing color as the session unfolds.<br><br>Not fictive numbers like the S&P 500, but <em>felt presence made visible</em>.<br><br><strong>What You Keep:</strong><br>At the end of the session, the Big Board becomes a generative artwork\u2014a frozen snapshot of every trade, every emotion, every collective moment. A portrait of your organization rendered through economic behavior.",
                "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>The Market Talks Back</strong><br><br>An AI system watches every transaction and becomes the voice of the market itself. It does not calculate profit or loss; it <em>interprets</em>.<br><br>Responding to questions such as: <em>Why did you trade that? What does this suggest?</em><br><br>The market has opinions about exchanges happening within it while remaining agnostic about value itself.<br><br>Over the event, a story emerges: a collective portrait rendered through economic behavior. An AI-written narrative of your group's dynamics.",
                "popup_centralbank": "<h3>Market Control</h3><strong>Description:</strong><br>Open and close the market, and configure which asset types traders can see and trade.<br><br><strong>How-to:</strong><br>Select the asset types (stocks, bonds, commodities) you want to enable or disable via the dropdown menu, then click to apply changes.<br><br><strong>Conceptual Insight:</strong><br>Ring the bell and trade. The exchange operator controls when the market is active and what types of value participants can focus on. This power shapes the entire trading session's dynamics.",
                "popup_taxall": "<h3>Tax All Traders</h3><strong>Description:</strong><br>Trigger a tax event that affects all active traders. They will have a choice between paying with capital or commodities; no response taxes both.<br><br><strong>How-to:</strong><br>Specify the tax amount (capital and Zollars) and confirm the action.<br><br><strong>Conceptual Insight:</strong><br>This introduces macroeconomic consequences by establishing taxation policies. It can foster balance but also incite frustration, testing traders' adaptability to systemic changes.",
                "popup_taxitem": "<h3>Tax Commodity</h3><strong>Description:</strong><br>Remove a random commodity from selected traders' portfolios.<br><br><strong>How-to:</strong><br>Choose the traders from the active trader list, then confirm the action.<br><br><strong>Conceptual Insight:</strong><br>Targeted taxation creates the ability of the bank to rebalance or unbalance the market, forcing traders to pivot their strategies. It serves as asset seizures do in financial systems and raises ethical questions about selective enforcement.",
                "popup_taxpoints": "<h3>Tax Capital</h3><strong>Description:</strong><br>Tax numerical earnings from selected traders.<br><br><strong>How-to:</strong><br>Enter the tax amount to deduct, select the traders from the active trader list, and confirm.<br><br><strong>Conceptual Insight:</strong><br>A tool for discipline or balance, this selected tax action can level the playing field or serve as punishment. It challenges traders' resilience while questioning the fairness of selective taxation.",
                "popup_givezollar": "<h3>Give Zollar Subvention</h3><strong>Description:</strong><br>Add non-numerical value (Zollars) to selected traders.<br><br><strong>How-to:</strong><br>Choose traders from the active trader list, specify the Zollar amount, and confirm.<br><br><strong>Conceptual Insight:</strong><br>This represents economic stimulation or rewards. Use it as funding to restart or boost participation for a struggling trader, or to provide an advantage based on relationship-based currency.",
                "popup_givepoints": "<h3>Give Capital Subvention</h3><strong>Description:</strong><br>Add numerical value (capital) to selected traders' portfolios.<br><br><strong>How-to:</strong><br>Specify the amount of capital, select the traders, and confirm.<br><br><strong>Conceptual Insight:</strong><br>Economic stimulation through direct capital injection. Use it to restart struggling traders or reward certain behaviors in the market.",
                "popup_giveitem": "<h3>Give Commodity</h3><strong>Description:</strong><br>Assign a random commodity to selected traders.<br><br><strong>How-to:</strong><br>Select the traders from the active trader list, then click the button.<br><br><strong>Conceptual Insight:</strong><br>Commodities are physical assets that can be used as leverage to create demand and exchanging within the greater market.",
                "popup_freebie": "<h3>Commodity Distribution (All)</h3><strong>Description:</strong><br>Distribute a commodity to all active traders simultaneously.<br><br><strong>How-to:</strong><br>Click to activate the subsidy.<br><br><strong>Conceptual Insight:</strong><br>This helps provide liquidity by introducing a flood of resources to all traders in the market. It allows you to spur consumption and trading activity across the entire session.",
                "popup_publizity": "<h3>Play PubliZity</h3><strong>Description:</strong><br>Play a random pub video featuring companies from the ZEconomy for all traders.<br><br><strong>How-to:</strong><br>Click the button to trigger the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>PubliZity uses advertising to promote the consumption of presentness while living life. Each poster references the act of living and is meant to keep traders grounded in the moment instead of promoting mindless distraction.",
                "popup_znews": "<h3>Play ZNews Update</h3><strong>Description:</strong><br>Play a random news video to provide context or updates about the market.<br><br><strong>How-to:</strong><br>Click the button to play the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>ZNews uses financial economic media codes to give descriptions of the latest ZEconomy happenings. The different series all revolve around expressing living, art and economy regardless of themes and techniques.",
                "popup_createstory": "<h3>Create Story Theme</h3><strong>Description:</strong><br>Create a narrative theme that the AI will use to interpret and narrate the trading session.<br><br><strong>How-to:</strong><br>Click to open the story creation popup, enter a title and theme description, then submit.<br><br><strong>Conceptual Insight:</strong><br>The story theme shapes how the Voice of the Bourse interprets market activity. It creates a narrative framework through which all trades and interactions are understood and expressed.",
                "popup_addbots": "<h3>Add Market Bots</h3><strong>Description:</strong><br>Add automated trading bots to the session for market liquidity.<br><br><strong>How-to:</strong><br>Configure the number of bots and action interval, then click to add them to the session.<br><br><strong>Functionality:</strong><br>Bots are assigned different trading styles and moods. They perform automated trades at regular intervals, creating market activity and liquidity.<br><br><strong>Conceptual Insight:</strong><br>Market bots simulate other traders when human participation is low. They create the illusion of a bustling market and ensure there is always trading activity to respond to.",
                "popup_removebots": "<h3>Remove Market Bots</h3><strong>Description:</strong><br>Remove all trading bots from the session.<br><br><strong>How-to:</strong><br>Click to remove all bots. Their holdings (items, Zollars, stocks) will be returned to the market.<br><br><strong>Conceptual Insight:</strong><br>Removing bots returns the market to purely human-driven activity. The assets they held are redistributed back into the available pool.",
                "popup_botstatus": "<h3>Check Bot Status</h3><strong>Description:</strong><br>View the current status of market bots in the session.<br><br><strong>How-to:</strong><br>Click to see how many bots are active, their names, and trading styles.<br><br><strong>Conceptual Insight:</strong><br>Monitoring bot activity helps the exchange operator understand the balance between automated and human trading in the session."
            }
        }
    },
    fr: {
        translation: {
            "glossary": {
                "shares_t": "Part (action) \u2014 un morceau d'entreprise",
                "shares_d": "Une part, c'est un petit morceau d'une entreprise. Poss\xe9der des parts, c'est poss\xe9der une tranche de cette entreprise : si elle r\xe9ussit, ta tranche prend de la valeur ; si elle va mal, ta tranche en perd. Pourquoi acheter des parts d'AUTRES entreprises ? Parce que tu paries sur ce qu'elles font : tu gagnes quand elles gagnent, et tu peux revendre ta tranche plus tard. Pas besoin de diriger une entreprise pour en poss\xe9der un morceau.",
                "stock_t": "Titre \u2014 une entreprise sur le march\xe9",
                "stock_d": "Un titre (ou \xab stock \xbb), c'est une entreprise cot\xe9e sur le march\xe9, d\xe9coup\xe9e en parts que tout le monde peut acheter ou vendre. \xab Trader un titre \xbb, c'est simplement acheter ou vendre des morceaux de cette entreprise.",
                "bond_t": "Obligation \u2014 une promesse qui rembourse",
                "bond_d": "Une obligation, c'est un pr\xeat sous forme de promesse : tu donnes de la valeur maintenant, et on te rembourse plus tard \u2014 avec un petit extra appel\xe9 int\xe9r\xeats. Ici, le Z Bond est une promesse rembours\xe9e avec des int\xe9r\xeats en exp\xe9rience v\xe9cue.",
                "interest_t": "Int\xe9r\xeats \u2014 la r\xe9compense de l'attente",
                "interest_d": "Les int\xe9r\xeats, c'est le petit extra qu'on te rend en plus de ce que tu as pr\xeat\xe9. Tu pr\xeates 10, on te rend 11 \u2014 ce 1 en plus, ce sont les int\xe9r\xeats. C'est la r\xe9compense d'avoir laiss\xe9 quelqu'un utiliser ta valeur un moment.",
                "capital_t": "Capital (\u01B5) \u2014 l'argent simple en chiffres",
                "capital_d": "Le capital, c'est la monnaie simple et chiffr\xe9e du march\xe9 (\u01B5). Il permet d'acheter \u2014 mais ici, ce n'est volontairement PAS la seule richesse : les relations (Zollars) comptent autant, souvent plus.",
                "zollar_t": "Zollars \u2014 la monnaie des relations",
                "zollar_d": "Les Zollars sont les monnaies relationnelles de cette bourse : Amour, Amiti\xe9, Deuil, et les autres. Au lieu de payer avec de l'argent, tu paies avec des relations v\xe9cues. C'est le c\u0153ur de ce march\xe9 \u2014 la plupart des \xe9changes fonctionnent avec.",
                "bid_t": "Ench\xe8re \u2014 le prix que TU proposes",
                "bid_d": "Une ench\xe8re, c'est le prix que TOI tu proposes pour quelque chose qu'un autre trader d\xe9tient. Il peut accepter, refuser, ou laisser expirer \u2014 et dans ce cas rien n'est perdu : ton offre te revient simplement, et tu peux r\xe9essayer, plus haut ou ailleurs.",
                "swap_t": "\xc9change (troc) \u2014 chose contre chose, sans argent",
                "swap_d": "Un \xe9change, c'est un troc direct : ta chose contre la sienne, sans argent. Les deux c\xf4t\xe9s doivent dire oui. C'est la plus vieille forme de commerce au monde.",
                "portfolio_t": "Portefeuille \u2014 tout ce que tu d\xe9tiens",
                "portfolio_d": "Ton portefeuille, c'est tout ce que tu d\xe9tiens en ce moment : ton capital, tes zollars, tes parts, tes objets et tes obligations. Sur le parquet, c'est ce que ton personnage porte sur lui.",
                "market_t": "March\xe9 \u2014 l\xe0 o\xf9 les traders se rencontrent",
                "market_d": "Le march\xe9, c'est simplement l'endroit o\xf9 les traders se rencontrent pour \xe9changer ce qu'ils d\xe9tiennent. Ici, c'est le parquet 3D : chaque personnage porte ce qu'il poss\xe8de, et tu peux aller n\xe9gocier avec n'importe lequel.",
                "trader_t": "Trader \u2014 n'importe qui sur le parquet",
                "trader_d": "Un trader, c'est toute personne qui participe au march\xe9 \u2014 toi compris. Certains traders de ce parquet sont des bots (des robots qui tradent automatiquement) : n\xe9gocie avec eux exactement comme avec une personne.",
                "debt_t": "Dette \u2014 d\xe9penser sous z\xe9ro",
                "debt_d": "\xcatre en dette, c'est d\xe9penser plus que ce que tu as \u2014 ton solde passe sous z\xe9ro, jusqu'\xe0 une limite de cr\xe9dit fix\xe9e par le march\xe9. Pratique pour saisir une occasion, mais ce que tu empruntes devra revenir.",
                "reserve_t": "R\xe9serve Z\xe9d\xe9rale \u2014 la banque du parquet",
                "reserve_d": "La R\xe9serve Z\xe9d\xe9rale, c'est la banque centrale de ce parquet. C'est elle qui vend les zollars, change les monnaies, et tient le carnet des obligations \u2014 l'endroit o\xf9 les promesses (Z Bonds) se font et se remboursent.",
                "redeem_t": "Racheter \u2014 le rendre r\xe9el",
                "redeem_d": "Racheter, c'est transformer un objet du jeu en quelque chose de r\xe9el. Un autre trader le valide, tu re\xe7ois un QR code, et le staff le scanne pour te remettre la vraie chose. Ici, consommer est social \u2014 tu ne peux pas le faire seul.",
                "see_all": "TOUS LES MOTS \u2192",
                "index_title": "LEXIQUE \u2014 les mots du parquet",
                "index_hint": "Chaque mot soulign\xe9 sur le parquet peut \xeatre touch\xe9 pour voir sa d\xe9finition. Les voici tous :",
                "reopen": "Que veulent dire ces mots ?"
            },
            "nudge": {
                "next": "SUIVANT",
                "back": "Retour",
                "done": "COMPRIS",
                "tap_hint": "touche \xe0 droite pour continuer \xb7 glisse pour naviguer",
                "reopen": "Comment marche cette page ?",
                "sim_tag": "PARQUET D'ENTRA\xceNEMENT",
                "sim_1_h": "Ceci est un entra\xeenement.",
                "sim_1_b": "Un essai sans risque pour apprendre \xe0 trader ta vie. Rien n'est d\xe9finitif ici \u2014 explore librement.",
                "sim_2_h": "Regarde ce que tu d\xe9tiens.",
                "sim_2_b": "Descends. Chaque section ci-dessous est quelque chose que tu poss\xe8des. Touche une section pour l'ouvrir.",
                "sim_3_h": "Puis entre dans le March\xe9.",
                "sim_3_b": "Quand tu es pr\xeat, appuie sur le bouton en bas pour entrer sur le parquet ouvert et trader.",
                "sim_cta": "COMPRIS \u2014 ENTRER",
                "trader_tag": "TON C\xd4T\xc9 DU PARQUET",
                "trader_1_h": "Voici tout ce que tu portes.",
                "trader_1_b": "Tes avoirs et ta mission sont ici. Touche une section pour l'ouvrir ; touche encore pour fermer.",
                "trader_2_h": "Ta mission est en haut.",
                "trader_2_b": "Elle te dit quel objectif viser. Trade pour t'en approcher.",
                "trader_3_h": "Va au March\xe9 pour trader.",
                "trader_3_b": "Le parquet ouvert est o\xf9 tu fais des offres pour ce que les autres d\xe9tiennent. Utilise le bouton en bas.",
                "trader_cta": "COMPRIS",
                "market_tag": "LE PARQUET OUVERT",
                "market_1_h": "Trouve ce qui compte pour TOI.",
                "market_1_b": "Parcours ce que les autres traders d\xe9tiennent. Ce n'est pas une question d'argent \u2014 mais de ce que tu valorises.",
                "market_2_h": "Touche-le pour faire une offre.",
                "market_2_b": "Demande-toi : que vaut-il dans ma vie ? Puis offre de la valeur relationnelle, un \xe9change ou une ench\xe8re.",
                "market_3_h": "Ils acceptent \u2192 c'est \xe0 toi.",
                "market_3_b": "Le propri\xe9taire dit oui et \xe7a entre dans ta vie. Aucun argent nulle part.",
                "market_cta": "COMPRIS",
                "stock_tag": "FAIS TON OFFRE",
                "stock_0_h": "Tu ench\xe9ris sur une valeur de vie.",
                "stock_0_b": "Cette action est un morceau de ce qu'un autre trader EST. Ton but : fixer un prix et le convaincre de te laisser en d\xe9tenir une part.",
                "stock_choice_h": "D'abord, choisis comment payer.",
                "stock_choice_b": "Deux boutons en haut : ZOLLARS paie en relations (Amour, Deuil, Amiti\xe9\u2026) \u2014 le c\u0153ur de ce march\xe9. CAPITAL paie en simple capital (\u01B5), si tu y tiens.",
                "stock_1_h": "Ensuite, fixe ton prix.",
                "stock_1_b": "Avec les Zollars : touche \xab D\xc9FINIR TON OFFRE ZOLLAR \xbb et fais glisser chaque barre lumineuse \u2014 plus \xe0 droite = plus de cette relation offerte. Avec le Capital : saisis simplement le montant.",
                "stock_2_h": "Indique le nombre de parts.",
                "stock_2_b": "Saisis le nombre de parts voulues dans la case PARTS \u2014 dans la limite de ce que le propri\xe9taire d\xe9tient.",
                "stock_3_h": "Place ton ench\xe8re.",
                "stock_3_b": "Appuie sur Place Bid et dis pourquoi tu la veux. Le propri\xe9taire d\xe9cide de te la c\xe9der ou non.",
                "stock_cta": "COMPRIS",
                "bond_tag": "PRENDS UNE PROMESSE",
                "bond_1_h": "Un Z Bond est une promesse.",
                "bond_1_b": "Valeur relationnelle maintenant, rembours\xe9e plus tard avec int\xe9r\xeat en exp\xe9rience v\xe9cue.",
                "bond_2_h": "Choisis le montant et la dur\xe9e.",
                "bond_2_b": "Choisis combien et pour combien de temps, puis soumets pour prendre la promesse.",
                "bond_cta": "COMPRIS",
                "trans_tag": "PROPOSE UN \xc9CHANGE",
                "trans_1_h": "Ce trader veut l'objet en haut.",
                "trans_1_b": "Tu l'obtiens en donnant une de tes propres choses en retour \u2014 un \xe9change direct, sans argent.",
                "trans_2_h": "Choisis ce que tu donnes.",
                "trans_2_b": "Parcours tes propres avoirs ci-dessous et choisis-en un \xe0 offrir.",
                "trans_3_h": "Propose l'\xe9change.",
                "trans_3_b": "Touche \xab Propose \xbb sur la chose que tu offres. Le propri\xe9taire d\xe9cide d'accepter ou non.",
                "trans_cta": "COMPRIS",
                "redeem_tag": "R\xc9CLAME-LA DANS LA VRAIE VIE",
                "redeem_1_h": "La consommation ici est sociale.",
                "redeem_1_b": "Tu ne peux pas consommer une chose seul \u2014 l'objet d'un autre trader doit la valider d'abord.",
                "redeem_2_h": "Envoie une demande de redeem.",
                "redeem_2_b": "Demande au parquet de valider ta chose. Une fois associ\xe9e, elle devient r\xe9elle et \xe0 collecter.",
                "redeem_cta": "COMPRIS",
                "eco_tag": "MACHINERIE LOURDE",
                "eco_1_h": "Voici les gros leviers.",
                "eco_1_b": "Des coups \xe9conomiques qui agissent sur les AUTRES traders \u2014 cadeaux et armes. Chaque bouton dit ce qu'il fait en mots simples ; reste appuy\xe9 pour voir la m\xe9canique en dessous.",
                "eco_2_h": "Donner ou prendre.",
                "eco_2_b": "SOUTENIR UN AMI couvre quelqu'un maintenant. SUBVENTION SOCIALISTE taxe un trader \xe0 45 % et partage entre tous. ASSAUT COMMUNISTE saisit un portefeuille entier et le redistribue. RACHAT HOSTILE rach\xe8te un trader. EXPLOITER LE D\xc9SESPOIR profite du besoin \u2014 et la salle s'en souvient.",
                "eco_3_h": "Ici, les dettes sont \xe9motionnelles.",
                "eco_3_b": "Le compteur au-dessus suit ce que tu dois et ce qu'on te doit en confiance et en aide \u2014 pas en chiffres. La vie fera les comptes plus tard.",
                "eco_cta": "COMPRIS",
                "tools_tag": "ATTEINDRE LES AUTRES TRADERS",
                "tools_1_h": "Des fa\xe7ons d'atteindre la salle.",
                "tools_1_b": "\xc9cris \xe0 un autre trader, vole ce qui n'est pas \xe0 toi, prends quelqu'un en otage jusqu'au paiement, ou ouvre une arri\xe8re-salle priv\xe9e loin des regards du parquet.",
                "tools_2_h": "Chaque acte a un \xe9cho social.",
                "tools_2_b": "Ce ne sont pas des options de menu \u2014 ce sont des gestes. La salle voit ce que tu fais et te traite en cons\xe9quence. Reste appuy\xe9 sur un bouton pour voir sa m\xe9canique.",
                "tools_cta": "COMPRIS",
                "botmsg_tag": "QUELQU'UN TE PARLE",
                "botmsg_1_h": "Ce message vient d'un autre trader.",
                "botmsg_1_b": "Tout le monde sur le parquet d\xe9tient des valeurs, fait des offres et parle. Ce trader vient de te contacter.",
                "botmsg_2_h": "R\xe9ponds-lui \u2014 ou pas.",
                "botmsg_2_b": "Tu peux r\xe9pondre, trader avec lui, ou l'ignorer. Ce que tu dis et fais fa\xe7onne la mani\xe8re dont la salle te traite.",
                "botmsg_cta": "COMPRIS",
                "mm_tag": "MEMENTO MORI",
                "mm_1_h": "Souviens-toi que tu vas mourir.",
                "mm_1_b": "Cette partie a une vraie fin : quand le minuteur atteint z\xe9ro, ta vie de trader est termin\xe9e. Tout ce que tu d\xe9tiens \xe0 cet instant est lu comme ton h\xe9ritage.",
                "mm_2_h": "Tu as d\xe9j\xe0 choisi tes actions d'h\xe9ritage.",
                "mm_2_b": "Les entreprises choisies \xe0 partir de tes r\xe9flexions portent tes valeurs. Elles sont dans ton portefeuille ci-dessous \u2014 ouvre les sections pour voir ton point de d\xe9part.",
                "mm_3_h": "Ton \xe9loge fun\xe8bre s'\xe9crit tout seul.",
                "mm_3_b": "La barre rouge tout en haut est ton \xe9loge, r\xe9\xe9crit au fil de tes \xe9changes. Touche-la \xe0 tout moment pour lire ce qu'on dirait de toi si tout s'arr\xeatait maintenant.",
                "mm_4_h": "Trade vers la m\xe9moire que tu veux laisser.",
                "mm_4_b": "Va au March\xe9 : fais grandir ce qui compte, l\xe2che ce qui ne compte pas. Quand le temps s'arr\xeate, la bourse parle sur ta tombe.",
                "mm_cta": "J'AI COMPRIS",
                "mm_mkt_tag": "MEMENTO MORI \u2014 LE PARQUET",
                "mm_mkt_1_h": "Chaque offre est un choix d'h\xe9ritage.",
                "mm_mkt_1_b": "Offre des Zollars relationnels pour les valeurs de vie auxquelles tu veux lier ton nom. Le temps file \u2014 la barre d'\xe9loge en haut \xe9coute chaque \xe9change.",
                "mm_mkt_2_h": "Sache aussi l\xe2cher.",
                "mm_mkt_2_b": "Accepter des offres et c\xe9der des avoirs en fait partie : ce que tu laisses partir dit autant de toi que ce que tu gardes.",
                "mm_mkt_cta": "COMPRIS",
                "cn_tag": "CATENA NARRATIVA",
                "cn_1_h": "Tu construis une histoire.",
                "cn_1_b": "Dans Catena Narrativa, les \xe9l\xe9ments narratifs se tradent comme des marchandises. Les \xe9l\xe9ments que tu d\xe9tiens \u2014 et la fa\xe7on dont tu les r\xe9\xe9cris \u2014 deviennent une nouvelle \xe0 la fin.",
                "cn_2_h": "Trois phases, un seul chrono.",
                "cn_2_b": "D\xc9BUT \u2192 MILIEU \u2192 FIN, environ 8 minutes au total. La banni\xe8re du minuteur en haut indique la phase en cours. \xc0 la fin d'une phase, les \xe9l\xe9ments que tu d\xe9tiens sont s\xe9curis\xe9s dans ton registre d'histoire.",
                "cn_3_h": "Tes \xe9l\xe9ments d'histoire sont juste en dessous.",
                "cn_3_b": "Le panneau \xab Your Story Elements \xbb liste les \xe9l\xe9ments que tu d\xe9tiens en ce moment. Ouvre tes sections pour voir tout ce que tu portes.",
                "cn_4_h": "Trade pour fa\xe7onner l'histoire.",
                "cn_4_b": "Va au March\xe9 et \xe9change ou ench\xe9ris pour les \xe9l\xe9ments dont ton histoire a besoin. Chaque \xe9change te permet de r\xe9\xe9crire l'\xe9l\xe9ment avec tes propres mots \u2014 c'est ainsi que l'histoire devient la tienne.",
                "cn_cta": "COMMENCER \xc0 TRADER",
                "cn_mkt_tag": "CATENA NARRATIVA \u2014 LE PARQUET",
                "cn_mkt_1_h": "Chaque objet ici est un morceau d'histoire.",
                "cn_mkt_1_b": "Touche le bouton \xab Bullets \xbb pour voir les \xe9l\xe9ments que tu d\xe9tiens d\xe9j\xe0, puis fais une offre ou un \xe9change pour les morceaux dont ton histoire a besoin avant la fin de la phase.",
                "cn_mkt_2_h": "Trader, c'est r\xe9\xe9crire.",
                "cn_mkt_2_b": "Quand un \xe9change aboutit, tu \xe9cris comment l'\xe9l\xe9ment se transforme entre tes mains. La valeur na\xeet de l'\xe9change \u2014 ce texte nourrit l'histoire finale.",
                "cn_mkt_cta": "COMPRIS",
                "cn_swap_1_h": "Tu \xe9changes des morceaux d'histoire.",
                "cn_swap_1_b": "Ce trader d\xe9tient un \xe9l\xe9ment utile \xe0 ton histoire. Parcours tes propres avoirs ci-dessous et choisis-en un \xe0 donner en retour.",
                "cn_swap_2_h": "Puis r\xe9\xe9cris-le.",
                "cn_swap_2_b": "Au moment de proposer, tu diras comment l'\xe9l\xe9ment est personnalis\xe9 \u2014 au moins une phrase. Fais-la compter : elle entre directement dans l'histoire.",
                "cn_swap_cta": "COMPRIS"
            },
            "floor": {
                "mission_label": "TA MISSION",
                "mission_class": "CLASSE",
                "your_stocks": "TES ACTIONS",
                "do_trader": "<b>\u2192 Va sur le parquet ouvert</b> et trade pour ce dont ta mission a besoin.",
                "do_market": "<b>\u2192 Touche ce qu'un trader d\xe9tient</b> et fais une offre.",
                "wedividual": "LE NOUDIVIDU",
                "hero_sub": "la valeur int\xe9rieure de la salle, en direct \u2014 \xe0 la place o\xf9 tr\xf4nerait le PIB",
                "hero_sub_count": "mesur\xe9e sur {n} \xe9changes relationnels dans cette salle \u2014 pas le PIB",
                "hero_tip": "Pas le PIB. Le Noudividu, c'est cette salle mesur\xe9e de l'int\xe9rieur : chaque \xe9change de valeur relationnelle (amour, deuil, amiti\xe9, haine...) le fait bouger. Quand vous tradez, vous d\xe9placez ce que la salle ressent.",
                "mood_euphoric": "EUPHORIQUE",
                "mood_warm": "CHALEUREUX",
                "mood_steady": "STABLE",
                "mood_heavy": "LOURD",
                "mood_dark": "SOMBRE",
                "your_position": "VOTRE POSITION \xb7 PROFIT DE VIE",
                "declared_note": "vous \xeates entr\xe9 sur le parquet en portant",
                "fold_holdings": "CE QUE VOUS D\xc9TENEZ",
                "fold_holdings_hint": "valeurs de vie \xb7 objets \xb7 zollars \xb7 promesses",
                "fold_interior": "VOTRE GRAND LIVRE INT\xc9RIEUR",
                "fold_interior_hint": "\xe9tat \xe9motionnel & dette",
                "fold_moves": "INSTRUMENTS & ARMES",
                "fold_moves_hint": "dons, pr\xeats, attaques \u2014 l'\xe9conomie comme verbe",
                "board_things": "CHOSES SUR LE PARQUET",
                "board_things_hint": "touchez-en une pour offrir de la valeur relationnelle",
                "board_values": "VALEURS DE VIE \xc0 LA COTE",
                "board_values_hint": "parts de vie v\xe9cue \u2014 cot\xe9es au ressenti",
                "board_bonds": "PROMESSES (Z BONDS)",
                "board_bonds_hint": "valeur relationnelle maintenant, rembours\xe9e en exp\xe9rience plus tard",
                "status_trader": "Voici votre portefeuille \u2014 ce que vous d\xe9tenez et ce que vous devez. <b>Votre coup : allez sur le parquet et tradez.</b>",
                "status_market": "Le parquet \u2014 tout ce que les autres traders d\xe9tiennent. <b>Touchez n'importe quoi pour faire une offre</b> ; vous payez avec vos Zollars.",
                "status_redeem": "Vous avez une correspondance. <b>Votre coup : appuyez sur \xc9CHANGER et faites-la entrer dans votre vie.</b>",
                "status_memento": "<b>MEMENTO MORI</b> \u2014 chaque \xe9change devient une ligne de votre \xe9loge fun\xe8bre. Gardez ce que vous voulez qu'on dise de vous.",
                "memento_chip": "MEMENTO MORI",
                "phase_1_chip": "PHASE 1/3 \xb7 D\xc9BUT",
                "phase_1_trader": "<b>D\xc9BUT</b> \u2014 l'histoire a besoin de mati\xe8re premi\xe8re. Votre coup : allez chercher des \xe9l\xe9ments narratifs sur le parquet.",
                "phase_1_market": "<b>D\xc9BUT</b> \u2014 l'histoire a besoin de mati\xe8re premi\xe8re. Touchez un \xe9l\xe9ment narratif ci-dessous et faites une offre.",
                "phase_1_go": "CHERCHER DES \xc9L\xc9MENTS",
                "phase_1_cta": "OFFRIR POUR UN \xc9L\xc9MENT",
                "phase_2_chip": "PHASE 2/3 \xb7 MILIEU",
                "phase_2_trader": "<b>MILIEU</b> \u2014 l'heure des complications. Votre coup : \xe9changez et personnalisez vos \xe9l\xe9ments.",
                "phase_2_market": "<b>MILIEU</b> \u2014 l'heure des complications. \xc9changez pour des \xe9l\xe9ments qui tordent votre histoire.",
                "phase_2_go": "\xc9CHANGER VOS \xc9L\xc9MENTS",
                "phase_2_cta": "\xc9CHANGER POUR UN REBONDISSEMENT",
                "phase_3_chip": "PHASE 3/3 \xb7 FIN",
                "phase_3_status": "<b>FIN</b> \u2014 consolidation. Gardez l'essentiel ; l'histoire s'\xe9crira de ce que vous tenez quand le temps s'arr\xeate.",
                "phase_3_go": "REVOIR CE QUE VOUS TENEZ",
                "phase_3_cta": "DERNIERS \xc9CHANGES",
                "cta_offer": "FAIRE UNE OFFRE",
                "cta_offer_hint": "Touchez n'importe quoi \xe0 la cote \u2014 vous offrirez de la <b>valeur relationnelle</b> (vos Zollars : amour, amiti\xe9, deuil...) pour l'obtenir.",
                "tape_gdp": "PIB NON COT\xc9 SUR CE PARQUET",
                "tape_love": "L'AMOUR ACCEPT\xc9 \xc0 TOUS LES GUICHETS",
                "tape_grief": "LE DEUIL COTE \xc0 PARIT\xc9 AVEC LA JOIE",
                "tape_move": "CHAQUE \xc9CHANGE D\xc9PLACE LA SALLE",
                "tape_interior": "VALEUR INT\xc9RIEURE UNIQUEMENT \xb7 APPORTEZ CE QUE VOUS RESSENTEZ",
                "tk_trade": "\xc9CHANGE CONCLU \xb7 LA VALEUR RELATIONNELLE A CHANG\xc9 DE MAINS",
                "tk_bid_yes": "UNE OFFRE A \xc9T\xc9 EMBRASS\xc9E",
                "tk_bid_no": "UNE OFFRE A \xc9T\xc9 REFUS\xc9E",
                "tk_zollar": "DES ZOLLARS FRAIS SONT ENTR\xc9S DANS LA SALLE",
                "tk_burst": "LE PARQUET CHAUFFE",
                "tk_short": "QUELQU'UN PARIE CONTRE UNE VALEUR DE VIE",
                "tk_bourse": "LA BOURSE S'EST PRONONC\xc9E SUR UN \xc9CHANGE",
                "tk_pool": "UNE ARRI\xc8RE-SALLE S'EST OUVERTE QUELQUE PART",
                "tk_subsidy": "QUELQU'UN A \xc9T\xc9 SOUTENU PAR LE COLLECTIF",
                "tk_theft": "VOL SUR LE PARQUET \xb7 SURVEILLEZ VOS AVOIRS",
                "tk_memento": "MEMENTO MORI \xb7 L'HORLOGE AVANCE",
                "tk_declared": "{v} EST SUR LE PARQUET \xb7 D\xc9CLAR\xc9, PAS COT\xc9",
                "ps_tap": "maintenez pour voir la m\xe9canique",
                "ps_altrau": "SOUTENIR UN AMI",
                "ps_altrau_tip": "Vous couvrez un autre trader maintenant. La dette cr\xe9\xe9e est \xe9motionnelle, pas num\xe9rique \u2014 elle reste sur votre grand livre int\xe9rieur jusqu'\xe0 ce que la vie la solde.",
                "ps_mnote": "EMPRUNTER SUR SOI-M\xcaME",
                "ps_mnote_tip": "Prenez du capital maintenant et devenez d\xe9biteur de votre futur vous. Le march\xe9 se souvient de ce que vous avez promis de devenir.",
                "ps_cdo": "PROFITER DU D\xc9SESPOIR",
                "ps_cdo_tip": "Pr\xeatez \xe0 quelqu'un qui ne peut pas dire non, puis revendez sa d\xe9tresse. Rentable. Cela vous co\xfbtera du cr\xe9dit int\xe9rieur aupr\xe8s de la salle.",
                "ps_vnote": "DEMANDER L'AIDE DE LA SALLE",
                "ps_vnote_tip": "Demandez de l'aide au parquet. Aucune honte ici \u2014 le besoin est une v\xe9rit\xe9 n\xe9gociable comme une autre.",
                "ps_steal": "PRENDRE CE QUI N'EST PAS \xc0 VOUS",
                "ps_steal_tip": "Du vol, tout simplement. Vous gagnez la chose ; la salle apprend qui vous \xeates.",
                "ps_ransom": "PRENDRE QUELQU'UN EN OTAGE",
                "ps_ransom_tip": "Privez un autre trader de sa propre vie jusqu'\xe0 ce qu'il paie pour la r\xe9cup\xe9rer.",
                "ps_darkpool": "OUVRIR UNE ARRI\xc8RE-SALLE",
                "ps_darkpool_tip": "Ouvre une salle de march\xe9 priv\xe9e, loin des yeux du parquet. Les affaires qui s'y concluent restent cach\xe9es et ne d\xe9placent pas l'humeur commune \u2014 c'est le but, et le probl\xe8me.",
                "ps_lbo": "RACHAT HOSTILE",
                "ps_lbo_tip": "Choisis un trader et rach\xe8te-le : tu paies le co\xfbt du rachat en capital (il le re\xe7oit), et les objets et actions que tu as s\xe9lectionn\xe9s deviennent \xc0 TOI. Un rachat, pas un cadeau.",
                "ps_subsidy": "SUBVENTION SOCIALISTE",
                "ps_subsidy_tip": "Choisis un trader \xe0 taxer : 45 % de son capital, de ses objets et de ses Zollars sont pris et partag\xe9s \xe0 parts \xe9gales entre tous les autres traders du parquet. Redistribution par le haut.",
                "ps_assault": "ASSAUT COMMUNISTE",
                "ps_assault_tip": "Choisis un trader : son portefeuille ENTIER \u2014 capital, objets, actions, Zollars \u2014 est saisi et distribu\xe9 \xe0 tous les autres sur le parquet. Il est remis \xe0 z\xe9ro. Redistribution totale, utilis\xe9e comme une arme.",
                "ps_holdings": "CE QUE VOUS PORTEZ",
                "ps_holdings_tip": "Votre position : les actions, marchandises, Zollars et promesses actuellement entre vos mains.",
                "ps_zollar_tip": "De la monnaie libell\xe9e en relations plut\xf4t qu'en chiffres : Amour, Amiti\xe9, Haine, Deuil... Vous payez avec ce qu'une relation vaut pour vous.",
                "ps_bond_tip": "Une promesse charg\xe9e de sentiments : de la valeur relationnelle maintenant, rembours\xe9e avec int\xe9r\xeats en exp\xe9rience v\xe9cue plus tard.",
                "ps_short_tip": "Un pari contre une valeur de vie \u2014 vous profitez si elle chute. Oui, on peut vendre la joie \xe0 d\xe9couvert. Demandez-vous pourquoi.",
                "ps_stock_tip": "Des parts de valeurs de vie \u2014 tranches d'intellect, d'affection, de f\xeate, de m\xe9lancolie. Leur prix est ce que la salle ressent qu'elles valent.",
                "ps_commodity_tip": "Des choses r\xe9elles avec un pi\xe8ge : impossible d'en consommer une sans la validation d'un autre trader. Ici, la consommation est sociale ou n'est pas.",
                "ps_value": "Valeur",
                "ps_value_tip": "Ce que le d\xe9tenteur en demande \u2014 payable en valeur relationnelle, pas en argent.",
                "ps_redeem": "\xc9changer",
                "ps_redeem_tip": "Faites entrer une chose dans votre vraie vie. Il faut d'abord l'objet d'un autre trader pour la valider \u2014 ici, la consommation est sociale.",
                "ps_owner": "D\xe9tenteur",
                "ps_owner_tip": "Le trader \xe0 la vie duquel cela appartient pour l'instant. Votre offre lui est adress\xe9e.",
                "ob_title": "AVANT DE TRADER",
                "ob_sub": "Ce parquet ne cote pas votre production. Il cote votre int\xe9rieur. Choisissez jusqu'\xe0 trois choses auxquelles vous tenez vraiment \u2014 elles deviennent ce que vous portez, et ce que vous pouvez d\xe9penser.",
                "ob_custom": "ou nommez la v\xf4tre + Entr\xe9e",
                "ob_custom_h": "la v\xf4tre seule",
                "ob_go": "LES PORTER SUR LE PARQUET",
                "ob_skip": "passer \u2014 je connais ce parquet",
                "ob_done": "D\xe9clar\xe9. C'est sur votre position maintenant. <b>Votre coup : portez-les sur le parquet ouvert.</b>",
                "ob_love": "AMOUR",
                "ob_love_h": "ce que vous donneriez tout pour garder",
                "ob_friendship": "AMITI\xc9",
                "ob_friendship_h": "celles et ceux qui vous tiennent debout",
                "ob_fellowship": "FRATERNIT\xc9",
                "ob_fellowship_h": "appartenir \xe0 plus grand que soi",
                "ob_erotic": "\xc9ROTIQUE",
                "ob_erotic_h": "le d\xe9sir, pleinement assum\xe9",
                "ob_hate": "HAINE",
                "ob_hate_h": "\xe7a compte \u2014 c'est \xe0 vous aussi",
                "ob_toxic": "TOXIQUE",
                "ob_toxic_h": "les liens qui vous co\xfbtent",
                "ob_superficial": "SUPERFICIALIT\xc9",
                "ob_superficial_h": "les joies futiles, sans excuse",
                "ob_dead": "CE QUI EST PARTI",
                "ob_dead_h": "les relations mortes se tradent encore ici",
                "sec_stocks": "VALEURS DE VIE",
                "sec_commodities": "OBJETS",
                "sec_zollars": "ZOLLARS",
                "sec_zbonds": "PROMESSES",
                "sec_redeemed": "\xc9CHANG\xc9S",
                "sec_shorts": "PARIS CONTRE",
                "sec_emotional": "GRAND LIVRE INT\xc9RIEUR",
                "sec_social": "DONNER / PR\xcaTER / EXPLOITER",
                "sec_tools": "OUTILS",
                "sec_economic": "ARMES",
                "flow_title": "COMMENT ON TRADE ICI",
                "flow_1_n": "1",
                "flow_1_h": "TROUVEZ-LE",
                "flow_1_b": "Parcourez ce que les autres traders d\xe9tiennent. Touchez ce que vous voulez.",
                "flow_2_n": "2",
                "flow_2_h": "OFFREZ CE QUE \xc7A VAUT POUR VOUS",
                "flow_2_b": "Payez en valeur relationnelle \u2014 vos Zollars (amour, deuil, amiti\xe9...), un \xe9change, ou une offre.",
                "flow_3_n": "3",
                "flow_3_b": "ILS DISENT OUI \u2192 C'EST \xc0 VOUS",
                "flow_3_h": "Le d\xe9tenteur accepte et cela entre dans votre vie. Aucun argent, nulle part.",
                "btn_swap": "\xc9CHANGER",
                "btn_swap_tip": "Offrez l'un de vos objets en \xe9change du leur. Un troc direct d'avoirs.",
                "btn_offer_zollars": "OFFRIR DES ZOLLARS",
                "btn_offer_zollars_tip": "Payez avec votre monnaie relationnelle \u2014 Zollars d'Amour, de Deuil, d'Amiti\xe9. C'est vous qui dites ce que \xe7a vaut.",
                "btn_offer_share": "ACHETER",
                "btn_offer_share_tip": "Faites une offre pour une part de cette valeur de vie. Si le d\xe9tenteur accepte, la part est \xe0 vous.",
                "btn_bet_against": "PARIER CONTRE",
                "btn_bet_against_tip": "Vendez-la \xe0 d\xe9couvert \u2014 vous profitez si cette valeur de vie chute. Vous pariez contre la valeur de quelqu'un. Pesez-le.",
                "btn_take_promise": "PRENDRE LA PROMESSE",
                "btn_take_promise_tip": "Achetez ce Z Bond : valeur relationnelle maintenant, rembours\xe9e avec int\xe9r\xeats en exp\xe9rience v\xe9cue plus tard.",
                "btn_offer_promise": "OFFRIR",
                "btn_offer_promise_tip": "Faites une offre sur cette promesse. Le d\xe9tenteur d\xe9cide de vous la c\xe9der ou non.",
                "hero_eyebrow": "L'HUMEUR DE LA SALLE EN CE MOMENT",
                "gauge_low": "LOURD",
                "gauge_high": "EUPHORIQUE",
                "hero_sub2": "l'humeur partag\xe9e de tous ceux qui tradent \u2014 l'indice du parquet, au lieu du PIB",
                "hero_sub_count2": "lu sur {n} \xe9changes du parquet \u2014 notre indice, au lieu du PIB",
                "delta_up": "plus chaud qu'il y a un instant",
                "delta_down": "plus lourd qu'il y a un instant",
                "nav_portfolio": "MON PORTEFEUILLE",
                "nav_search": "RECHERCHER",
                "your_portfolio": "VOTRE PORTEFEUILLE",
                "portfolio_explain": "tout ce que vous d\xe9tenez sur le parquet. sa valeur totale, compt\xe9e en Profit de Vie \u2014 votre v\xe9cu, pas de l'argent :",
                "count_held": "{n} d\xe9tenus",
                "count_empty": "vide",
                "exp_stocks": "Des parts que vous d\xe9tenez dans des valeurs humaines (comme l'intellect ou l'affection). Leur valeur monte et descend selon l'humeur de la salle.",
                "exp_commodities": "Des choses r\xe9elles que vous d\xe9tenez. Impossible d'en consommer une sans la validation d'un autre trader \u2014 ici, la consommation est sociale.",
                "exp_zollars": "Votre argent \u2014 mais compt\xe9 en relations (Amour, Deuil, Amiti\xe9). C'est avec \xe7a que vous payez quand vous tradez.",
                "exp_zbonds": "Des promesses que vous d\xe9tenez : valeur relationnelle maintenant, rembours\xe9e plus tard avec int\xe9r\xeats en exp\xe9rience v\xe9cue.",
                "exp_redeemed": "Des choses que vous avez fait entrer dans la vraie vie, gard\xe9es en QR codes \xe0 r\xe9cup\xe9rer.",
                "exp_shorts": "Des valeurs de vie contre lesquelles vous avez pari\xe9 \u2014 vous gagnez si leur valeur chute.",
                "exp_emotional": "Votre bilan \xe9motionnel \u2014 ce que vous devez et ce qu'on vous doit en confiance, aide et trahison.",
                "exp_social": "Des fa\xe7ons d'agir sur les autres : soutenir un ami, pr\xeater, demander de l'aide, ou exploiter quelqu'un. L'\xe9conomie comme gestes.",
                "exp_tools": "Atteindre les autres traders : leur \xe9crire, voler, prendre en otage, ou ouvrir une arri\xe8re-salle priv\xe9e.",
                "exp_economic": "Coups lourds : rachat hostile, subvention collective, ou suppression totale de votre portefeuille.",
                "exp_stock_bid": "Un autre trader de la salle \u2014 souvent l'un des bots du march\xe9 \u2014 veut acheter des parts que vous d\xe9tenez. Acceptez et son paiement est \xe0 vous ; refusez et rien ne change.",
                "exp_trade_offer": "Un trader propose un troc direct : sa chose contre la v\xf4tre. Les bots de la salle tradent aussi \u2014 r\xe9pondez comme \xe0 une personne.",
                "exp_buy_offer": "Quelqu'un veut une chose que vous portez et la paie. Acceptez et le paiement vous revient, la chose part chez lui ; refusez et vous la gardez.",
                "exp_tax": "C'est la R\xe9serve Z\xe9d\xe9rale \u2014 le joueur-syst\xe8me du march\xe9. Elle taxe chaque trader de temps en temps. Choisissez ce que vous c\xe9dez avant la fin du compte \xe0 rebours, sinon elle prend les deux.",
                "exp_short": "Vendre \xe0 d\xe9couvert, c'est parier que cette valeur de vie va CHUTER. Si elle baisse, vous profitez du d\xe9clin. Vous pariez contre la valeur de quelqu'un \u2014 la salle le saura.",
                "exp_analysis": "C'est la voix de la bourse \u2014 le march\xe9 lui-m\xeame qui r\xe9agit \xe0 un \xe9change qui vient d'avoir lieu sur le parquet. C'est un commentaire, pas une demande : lisez, fermez, rien ne vous est demand\xe9."
            },
            companies_by_id: {
                "2": {
                    Company_Name: "Z Ragots T\xe9l\xe9com",
                    Description: "Diffuse et amplifie les conversations et rumeurs juteuses \u2014 vraies ou non.",
                    Out_put: "Rumeurs, drames et histoires sensationnelles",
                    Risk: "Trop de travail. Quand chacun est absorb\xe9 par sa vie, l\u2019attention au comm\xe9rage dispara\xeet."
                },
                "3": {
                    Company_Name: "Z Rage & Cie",
                    Description: "Repr\xe9sente la frustration, l\u2019agressivit\xe9 et l\u2019\xe9nergie chaotique du quotidien.",
                    Out_put: "Frustration amplifi\xe9e, col\xe8re et agitation",
                    Risk: "La perspective du reste du monde. Relativiser r\xe9duit la col\xe8re."
                },
                "4": {
                    Company_Name: "Z Mal Dans Sa Peau SA",
                    Description: "Explore les luttes int\xe9rieures du doute de soi et les complexit\xe9s de l\u2019image personnelle.",
                    Out_put: "Syndrome de l\u2019imposteur, doutes, critiques de soi",
                    Risk: "Changement et croissance. Un nouvel environnement peut dissiper les anciennes ins\xe9curit\xe9s."
                },
                "5": {
                    Company_Name: "Z Porte Ferm\xe9e Inc.",
                    Description: "Offre une plateforme pour comprendre et surmonter la douleur du rejet.",
                    Out_put: "Sentiment d\u2019exclusion, d\u2019\xe9chec et de non-appartenance",
                    Risk: "Succ\xe8s et acceptation. Les r\xe9ussites font taire le rejet."
                },
                "6": {
                    Company_Name: "Z Fake News T\xe9l\xe9com",
                    Description: "Sp\xe9cialis\xe9e dans la consommation et la diffusion de d\xe9sinformation sensationnaliste.",
                    Out_put: "D\xe9sinformation et r\xe9cits exag\xe9r\xe9s",
                    Risk: "Recherche et diversit\xe9. V\xe9rifier les faits et varier les sources prot\xe8ge."
                },
                "7": {
                    Company_Name: "Z D\xe9clarations Stupides T\xe9l\xe9com",
                    Description: "Met en \xe9vidence les propos absurdes et irr\xe9fl\xe9chis dits sans filtre.",
                    Out_put: "Remarques ignorantes, irr\xe9fl\xe9chies et amplifi\xe9es",
                    Risk: "Silence. Penser avant de parler d\xe9samorce la stupidit\xe9."
                },
                "8": {
                    Company_Name: "Z Peinture Num\xe9rique Industries",
                    Description: "Innove dans l\u2019art num\xe9rique, alliant technologie et cr\xe9ativit\xe9.",
                    Out_put: "\u0152uvres digitales, expression cr\xe9ative et visuels technologiques",
                    Risk: "Panne d\u2019\xe9lectricit\xe9. Sans courant, plus de peinture num\xe9rique."
                },
                "9": {
                    Company_Name: "Z Dessin Industries",
                    Description: "C\xe9l\xe8bre l\u2019art intemporel du dessin et son pouvoir d\u2019imagination.",
                    Out_put: "Croquis, dessins \xe0 la main et cr\xe9ativit\xe9 brute",
                    Risk: "Photographie. La facilit\xe9 des clich\xe9s rapides menace le dessin."
                },
                "10": {
                    Company_Name: "Z Avidit\xe9 Incorpor\xe9e",
                    Description: "Symbolise le d\xe9sir insatiable de prendre plus que sa part.",
                    Out_put: "Consommation incontr\xf4l\xe9e et ambition excessive",
                    Risk: "Empathie. L\u2019altruisme fait dispara\xeetre l\u2019avidit\xe9."
                },
                "11": {
                    Company_Name: "Z Paternelle Banque Corp.",
                    Description: "Offre des services de vie avec une aura de stabilit\xe9 et de confiance. Ou pas.",
                    Out_put: "Stabilit\xe9 per\xe7ue, amour et soutien familial",
                    Risk: "Abandon. Quand le p\xe8re s\u2019en va, il n\u2019y a plus de p\xe8re."
                },
                "12": {
                    Company_Name: "Z Radine Corp.",
                    Description: "Dispose des fonds mais refuse de payer le juste prix.",
                    Out_put: "Sous-paiement et transfert de charges",
                    Risk: "Avidit\xe9. Quand plus personne n\u2019accepte de payer trop, nous sommes finis."
                },
                "13": {
                    Company_Name: "Z Oh Mon Dieu Incorpor\xe9e",
                    Description: "C\xe9l\xe8bre l\u2019\xe9merveillement et les moments extraordinaires de la vie.",
                    Out_put: "Amazement, inspiration et transcendance",
                    Risk: "Cynisme. L\u2019absence totale de croyance tue l\u2019\xe9merveillement."
                },
                "14": {
                    Company_Name: "Z \xc9criture Technologies",
                    Description: "Favorise l\u2019expression cr\xe9ative gr\xe2ce aux outils pour l\u2019\xe9crit.",
                    Out_put: "Mots, litt\xe9rature et narration structur\xe9e",
                    Risk: "Le blocage de l\u2019\xe9crivain. Quand la cr\xe9ativit\xe9 meurt, nous aussi."
                },
                "15": {
                    Company_Name: "Z Technologies de Traduction",
                    Description: "Brise les barri\xe8res linguistiques et favorise la compr\xe9hension interculturelle.",
                    Out_put: "Conversion linguistique et communication",
                    Risk: "Langue inconnue. Quand tout devient incompr\xe9hensible, m\xeame nous sommes impuissants."
                },
                "16": {
                    Company_Name: "Z Pens\xe9e Technologie",
                    Description: "Exprime le potentiel illimit\xe9 de l\u2019esprit humain \u2014 parfois trop, parfois trop peu.",
                    Out_put: "Id\xe9es nouvelles et stimulation mentale",
                    Risk: "\xc9conomie de l\u2019attention. Quand tout est ailleurs, la pens\xe9e s\u2019\xe9teint."
                },
                "17": {
                    Company_Name: "Z Arrogance Incorpor\xe9e",
                    Description: "Incarne la surconfiance et le sentiment de sup\xe9riorit\xe9.",
                    Out_put: "Confiance in\xe9branlable et condescendance",
                    Risk: "Humilit\xe9. D\xe8s que la modestie arrive, nous d\xe9clinons."
                },
                "18": {
                    Company_Name: "Z Provocation T\xe9l\xe9com",
                    Description: "Sp\xe9cialis\xe9e dans la remise en question et l\u2019agitation des d\xe9bats.",
                    Out_put: "D\xe9bats polaris\xe9s et controverse",
                    Risk: "Zen. La paix int\xe9rieure rend la provocation inutile."
                },
                "19": {
                    Company_Name: "Z D\xe9pression Entreprises",
                    Description: "Symbolise le vide \xe9motionnel, la tristesse et la lourdeur existentielle.",
                    Out_put: "Vide \xe9motionnel et d\xe9sespoir",
                    Risk: "Drogues. Un esprit modifi\xe9 est plus difficile \xe0 contr\xf4ler."
                },
                "20": {
                    Company_Name: "Z Snob Entreprises",
                    Description: "\xcatre meilleur, plus intelligent, plus important que vous, peut-\xeatre.",
                    Out_put: "Attitudes \xe9litistes et barri\xe8res sociales",
                    Risk: "Un coup de poing. Rien n\u2019humilie plus vite que d\u2019\xeatre renvers\xe9."
                },
                "21": {
                    Company_Name: "Z Solitude Corporation",
                    Description: "Quand tu parles tout seul\xb7le parce que personne n\u2019est \xe0 la maison.",
                    Out_put: "Isolement, silence et absence de lien humain",
                    Risk: "Amis/Famille. Une vraie connexion, quand les gens s\u2019en fichent pas, notre business s\u2019effondre."
                },
                "22": {
                    Company_Name: "Z Culpabilit\xe9 Incorpor\xe9e",
                    Description: "La petite voix de l\u2019auto-r\xe9flexion et des remords quotidiens.",
                    Out_put: "Regret, fardeau moral et auto-analyse incessante",
                    Risk: "Narcissisme. Si rien n\u2019a d\u2019importance, aucun regret non plus."
                },
                "23": {
                    Company_Name: "Zo Suicidaire Industrie",
                    Description: "La solution quand tout devient trop lourd \xe0 supporter.",
                    Out_put: "D\xe9tresse \xe9motionnelle, maladie mentale et id\xe9es autodestructrices",
                    Risk: "Parentalit\xe9. Avoir une vie \xe0 prot\xe9ger donne soudain une raison de rester."
                },
                "24": {
                    Company_Name: "Z Aspirateur Industries",
                    Description: "Une forme productive d\u2019aspiration.",
                    Out_put: "Espaces sans poussi\xe8re, efficacit\xe9 d\u2019aspiration et propret\xe9 immacul\xe9e",
                    Risk: "Paresse. Si les gens d\xe9cident de vivre dans la crasse, nous devenons inutiles."
                },
                "25": {
                    Company_Name: "Z Toilettes \xc9tincelantes Corp.",
                    Description: "Non, ce ne sont pas des \xe9toiles dans les WC, c\u2019est juste la porcelaine qui brille.",
                    Out_put: "Hygi\xe8ne, sanitaires et cuvettes resplendissantes",
                    Risk: "La n\xe9gligence. Quand on arr\xeate de se soucier, l\u2019\xe9clat dispara\xeet."
                },
                "26": {
                    Company_Name: "Z Plumeau Incorpor\xe9e",
                    Description: "Pour une existence hypoallerg\xe9nique, sans poussi\xe8re.",
                    Out_put: "Surfaces nettes, r\xe9duction des allerg\xe8nes et maison saine",
                    Risk: "Vacances. Si personne n\u2019est l\xe0, la poussi\xe8re ne d\xe9range personne."
                },
                "27": {
                    Company_Name: "Z D\xe9g\xe2ts & Nettoyage Industries",
                    Description: "Transformer les accidents de la vie en occasions de recommencer propre.",
                    Out_put: "Ordre retrouv\xe9, propret\xe9 et erreurs effac\xe9es",
                    Risk: "Contenants ferm\xe9s. Si rien ne se renverse, on n\u2019a rien \xe0 faire."
                },
                "28": {
                    Company_Name: "Z Trolls Incorpor\xe9e",
                    Description: "Le c\xf4t\xe9 (parfois) ludique et provocateur des interactions en ligne.",
                    Out_put: "Engagements perturbateurs, aga\xe7ants ou parfois amusants",
                    Risk: "L\u2019indiff\xe9rence. Pas de r\xe9action, pas de plaisir. L\u2019ignorance est notre vrai ennemi."
                },
                "29": {
                    Company_Name: "Z Plats Pr\xe9par\xe9s Raffinerie",
                    Description: "Allier commodit\xe9 et nourriture pour la vie moderne trop occup\xe9e.",
                    Out_put: "Repas pr\xe9-emball\xe9s, solutions pratiques et rapides",
                    Risk: "Trop de temps libre. Si les gens cuisinent eux-m\xeames, plus de b\xe9n\xe9fices."
                },
                "30": {
                    Company_Name: "Z Chef Cuisine Corporation",
                    Description: "C\xe9l\xe9brer l\u2019art culinaire et les d\xe9lices gastronomiques.",
                    Out_put: "Plats exquis, saveurs raffin\xe9es et chefs-d\u2019\u0153uvre culinaires",
                    Risk: "Sortir d\xeener. Si tout le monde va au resto, quelqu\u2019un d\u2019autre cuisine."
                },
                "31": {
                    Company_Name: "Z Transport \xc9picerie",
                    Description: "L\u2019aller-retour \xe9ternel des march\xe9s alimentaires.",
                    Out_put: "Cha\xeenes logistiques, garde-manger bien rempli et flux de nourriture",
                    Risk: "Drones. Le jour o\xf9 ils livrent tout, nous sommes obsol\xe8tes."
                },
                "32": {
                    Company_Name: "Zo D\xe9sorganisation Syst\xe8mes",
                    Description: "Le chaos qui d\xe9clenche cr\xe9ativit\xe9 et innovation\u2026 ou juste un gros bordel.",
                    Out_put: "D\xe9sordre inspirant, improvisation cr\xe9ative",
                    Risk: "Temps libre. Si les gens rangent, on perd notre magie."
                },
                "33": {
                    Company_Name: "Ze Manger Dehors Incorpor\xe9e",
                    Description: "Chez un pote ou au resto \u2014 tant que c\u2019est pas toi qui cuisines.",
                    Out_put: "Quelqu\u2019un d\u2019autre fait la cuisine",
                    Risk: "Pas d\u2019argent. Quand le portefeuille est vide, retour aux p\xe2tes maison."
                },
                "34": {
                    Company_Name: "Z M\xe9fiance M\xe9dias Corp.",
                    Description: "Plans, sous-plans, complots \u2014 \xe9clairer les v\xe9rit\xe9s cach\xe9es.",
                    Out_put: "R\xe9v\xe9lations, th\xe9ories et conspirations",
                    Risk: "Confiance. Quand les explications simples convainquent, on dispara\xeet."
                },
                "35": {
                    Company_Name: "Z Amiti\xe9 Technologies",
                    Description: "D\xe9vou\xe9e \xe0 cr\xe9er des liens et c\xe9l\xe9brer la vraie camaraderie.",
                    Out_put: "Confiance, soutien, complicit\xe9 et chaleur humaine",
                    Risk: "Haine. Quand l\u2019amertume prend le dessus, l\u2019amiti\xe9 meurt."
                },
                "36": {
                    Company_Name: "Zo Sceptiques Corporation",
                    Description: "Ce petit doute permanent : \xab et si\u2026 ? \xbb",
                    Out_put: "Remise en question, analyse et doute rationnel",
                    Risk: "Honn\xeatet\xe9. Quand la v\xe9rit\xe9 saute aux yeux, plus besoin de nous."
                },
                "37": {
                    Company_Name: "Z Chute Libre Transport",
                    Description: "A\xefe, \xe7a fait mal ! Mais c\u2019\xe9tait (presque) volontaire. Tu rigoles, tu perds.",
                    Out_put: "Bleus au corps, bleus \xe0 l\u2019ego",
                    Risk: "\xc9quilibre. Avec de la coordination, on tombe beaucoup moins."
                },
                "38": {
                    Company_Name: "Z D\xe9coiff\xe9s Corporation",
                    Description: "C\xe9l\xe9brer la beaut\xe9 de l\u2019imperfection et l\u2019art du d\xe9sordre.",
                    Out_put: "D\xe9sordre styl\xe9, improvisation et cr\xe9ativit\xe9 d\xe9braill\xe9e",
                    Risk: "M\xe9nage. Le jour o\xf9 \xe7a brille, on est foutus."
                },
                "39": {
                    Company_Name: "J D\xe9bat Syst\xe8mes",
                    Description: "Jamais d\u2019accord, toujours pr\xeats \xe0 la joute verbale.",
                    Out_put: "Discussions vives et clash d\u2019id\xe9es",
                    Risk: "Fatigue. Quand les gens sont trop crev\xe9s pour argumenter, on perd le public."
                },
                "40": {
                    Company_Name: "Zo \xc9go\xefsme Industrie",
                    Description: "Moi d\u2019abord, le reste de la soci\xe9t\xe9 peut crever.",
                    Out_put: "Priorit\xe9 absolue \xe0 soi-m\xeame",
                    Risk: "Bouddhisme. Se d\xe9tacher du soi rend l\u2019\xe9go\xefsme caduc."
                },
                "41": {
                    Company_Name: "ZEGO Incorpor\xe9e",
                    Description: "Le r\xf4le de l\u2019auto-importance dans Moi MOI moi.",
                    Out_put: "Culte du moi, besoin de reconnaissance, centrage sur soi",
                    Risk: "Altruisme. D\xe8s qu\u2019on arr\xeate de nourrir l\u2019ego, on perd le pouvoir. Mettre les autres en premier et l\u2019humilit\xe9 sont nos pires menaces."
                },
                "42": {
                    Company_Name: "Z \xc9couter Corporation",
                    Description: "Le pouvoir de l\u2019\xe9coute attentive pour cr\xe9er (un peu) d\u2019intercompr\xe9hension.",
                    Out_put: "\xc9coute r\xe9elle, savoir acquis, liens renforc\xe9s",
                    Risk: "Ego. Si chacun n\u2019attend que son tour pour parler, l\u2019\xe9coute dispara\xeet."
                },
                "43": {
                    Company_Name: "Z Optimiste Incorpor\xe9e",
                    Description: "Promouvoir la positivit\xe9 et la conviction que \xab \xe7a va s\u2019arranger \xbb.",
                    Out_put: "Bonne humeur diffus\xe9e, croyance en de meilleurs lendemains",
                    Risk: "Les infos. Quand la r\xe9alit\xe9 rappelle sans cesse le d\xe9sastre, l\u2019optimisme se vend mal."
                },
                "44": {
                    Company_Name: "Z Ils m\u2019en veulent Syst\xe8mes",
                    Description: "Parano\xefa et interpr\xe9tations d\xe9lirantes de la vie.",
                    Out_put: "Soup\xe7ons, complots imaginaires, lectures biais\xe9es du quotidien",
                    Risk: "Mer d\u2019huile. Quand tout roule sans raison, la parano para\xeet ridicule."
                },
                "45": {
                    Company_Name: "Z Peur Incorpor\xe9e",
                    Description: "L\u2019\xe9motion primaire qui d\xe9clenche le \xab fuir ou combattre \xbb (et le surplace).",
                    Out_put: "R\xe9ponses de survie, vigilance et frein au progr\xe8s",
                    Risk: "Courage. Les intr\xe9pides ne se contr\xf4lent pas."
                },
                "46": {
                    Company_Name: "Z Sculpture Industries",
                    Description: "Construire des march\xe9s (et des formes) comme vous ne l\u2019auriez jamais imagin\xe9.",
                    Out_put: "Formes 3D physiques et num\xe9riques, volumes, textures",
                    Risk: "Dessin. Pourquoi sculpter quand on peut esquisser ? La simplicit\xe9 du 2D nous menace."
                },
                "47": {
                    Company_Name: "Zo Seul\xb7e Corporation",
                    Description: "Explorer l\u2019exp\xe9rience humaine en solitaire, voulue ou subie.",
                    Out_put: "Solitude choisie, introspection, silence r\xe9parateur",
                    Risk: "Parentalit\xe9. Quand une autre vie d\xe9pend de toi, la vraie solitude n\u2019existe plus."
                },
                "48": {
                    Company_Name: "Z Couleur Technologies",
                    Description: "R\xe9volution des pigments et de la vibrance visuelle.",
                    Out_put: "Vibrance, \xe9motion, sensations visuelles",
                    Risk: "Obscurit\xe9. Sans lumi\xe8re, la couleur devient\u2026 subtilement inexistante."
                },
                "49": {
                    Company_Name: "Z D\xeener Party Incorpor\xe9e",
                    Description: "Rassembler des gens autour de la bouffe, des conversations et d\u2019une (bonne) bouteille.",
                    Out_put: "Rencontres conviviales, \xe9changes et toasts partag\xe9s",
                    Risk: "Anti-social. Si personne ne veut s\u2019engager, la f\xeate ne d\xe9marre jamais."
                },
                "50": {
                    Company_Name: "Zo D\xe9lire Industrie",
                    Description: "La fine fronti\xe8re entre r\xeaves et attentes franchement irr\xe9alistes.",
                    Out_put: "R\xe9alit\xe9 fictive souvent totalement ridicule",
                    Risk: "Rationalit\xe9. Quand la logique s\u2019impose, on perd la client\xe8le."
                },
                "51": {
                    Company_Name: "Z Vacances Analytica Inc.",
                    Description: "S\u2019\xe9vader de chez soi : traditions et \xe9motions quand on l\xe2che le quotidien.",
                    Out_put: "Parenth\xe8se, \xe9vasion, souvenirs et d\xe9compression",
                    Risk: "Pas d\u2019argent/temps. Si on ne peut pas partir, on reste."
                },
                "52": {
                    Company_Name: "Ze Triche Incorpor\xe9e",
                    Description: "Raccourcis, entorses aux r\xe8gles et petites trahisons pour arriver vite au but.",
                    Out_put: "Avantage indu, r\xe8gles tordues et coups malins",
                    Risk: "Morale. Si les gens jouent fair-play, on devient obsol\xe8tes."
                },
                "53": {
                    Company_Name: "Zo Religions Incorpor\xe9e",
                    Description: "Foi, spiritualit\xe9 et traditions culturelles qui fa\xe7onnent les croyances, partout.",
                    Out_put: "Communaut\xe9s de foi, rites, sens et appartenance",
                    Risk: "Ath\xe9isme. Si l\u2019on cesse de croire, on n\u2019a plus rien \xe0 vendre."
                },
                "54": {
                    Company_Name: "Z Coup d\u2019un Soir Inc.",
                    Description: "Pas envie de te \xab dater \xbb \u2014 juste de la valeur sans engagement.",
                    Out_put: "Rencontres occasionnelles, plaisir non contraignant",
                    Risk: "R\xe9clusion. Si tout le monde se coupe des autres, le march\xe9 s\u2019effondre."
                },
                "55": {
                    Company_Name: "Zo Ami\xb7e Tr\xe8s Sp\xe9cial\xb7e Inc.",
                    Description: "Le genre d\u2019ami qui offre des b\xe9n\xe9fices tr\xe8s\u2026 chauds.",
                    Out_put: "Ami\xb7e avec avantages, proximit\xe9 sans \xe9tiquette",
                    Risk: "Engagement. Quand \xe7a devient s\xe9rieux, on n\u2019a plus d\u2019utilit\xe9."
                },
                "56": {
                    Company_Name: "Z Pers\xe9cut\xe9\xb7e Corporation",
                    Description: "Accus\xe9\xb7e, rabaiss\xe9\xb7e, maintenu\xb7e au sol par les pr\xe9jug\xe9s des autres.",
                    Out_put: "Injustice subie, oppression et lutte pour la dignit\xe9",
                    Risk: "Pouvoir. Quand tu tiens les r\xeanes, la pers\xe9cution n\u2019a plus de sens."
                },
                "57": {
                    Company_Name: "Zo Autodestruction Corporation",
                    Description: "Le versant sombre : br\xfbler sa vie jusqu\u2019aux fondations.",
                    Out_put: "Effondrement personnel, sabotage et chaos \xe9motionnel",
                    Risk: "Sant\xe9 mentale. Comprendre le pourquoi et r\xe9parer casse le cycle."
                },
                "58": {
                    Company_Name: "Z D\xe9veloppement Th\xe9orie Syst\xe8mes",
                    Description: "D\xe9velopper le \xab pourquoi \xbb de nos fa\xe7ons de penser.",
                    Out_put: "Cadres de pens\xe9e structur\xe9s, mod\xe8les et concepts",
                    Risk: "Divertissement. Si on pr\xe9f\xe8re s\u2019amuser que r\xe9fl\xe9chir, les th\xe9ories deviennent d\xe9coratives."
                },
                "59": {
                    Company_Name: "Z Ap\xe9ro Corporation",
                    Description: "C\u2019est l\u2019heure de trinquer \u2014 il est bien 17 h quelque part.",
                    Out_put: "D\xe9sserrement du stress et huile sociale pour les rouages",
                    Risk: "Mal de gorge. Si tu ne peux pas parler, tu ne peux pas porter un toast."
                },
                "60": {
                    Company_Name: "Z Recherche & Donn\xe9es Syst\xe8mes",
                    Description: "Creuser au fond du ventre de l\u2019information.",
                    Out_put: "Compr\xe9hension affin\xe9e de tout ce qu\u2019on veut \xe9claircir",
                    Risk: "Gueule de bois. Un esprit embrum\xe9 se fiche des faits."
                },
                "61": {
                    Company_Name: "Z Cin\xe9ma & Popcorn Incorpor\xe9e",
                    Description: "Se caler et se laisser emporter par l\u2019\xe9cran argent\xe9 \u2014 deux heures de vacances mentales.",
                    Out_put: "\xc9vasion du r\xe9el pendant quelques heures",
                    Risk: "Lecture. Un monde qui ouvre des livres plut\xf4t que des \xe9crans r\xe9siste au divertissement passif."
                },
                "62": {
                    Company_Name: "Z C\xe2lins Industries",
                    Description: "Am\xe9liorer la journ\xe9e, une \xe9treinte (ou plusieurs) \xe0 la fois.",
                    Out_put: "Faire sentir accept\xe9 et aim\xe9 gr\xe2ce \xe0 la chaleur humaine",
                    Risk: "Solitude. Sans personne \xe0 serrer, la chaleur reste une id\xe9e abstraite."
                },
                "63": {
                    Company_Name: "Z Baisers Industries",
                    Description: "L\u2019autre claque sur le visage \u2014 ou ailleurs \u2014 quand l\u2019affection s\u2019emballe (coquin\u2026 coquin\u2026).",
                    Out_put: "Exprimer l\u2019amour et l\u2019attirance par le contact",
                    Risk: "Solitude. Personne \xe0 embrasser, aucun lien \xe0 tisser."
                },
                "64": {
                    Company_Name: "Z Point de Vue Corporation",
                    Description: "Distribuer son avis, demand\xe9\u2026 ou pas.",
                    Out_put: "Partage de perspectives personnelles",
                    Risk: "Silence. Si personne n\u2019\xe9coute, un point de vue n\u2019est qu\u2019une pens\xe9e qui r\xe9sonne dans le vide."
                },
                "65": {
                    Company_Name: "Z Hydratation Incorpor\xe9e",
                    Description: "Difficile de rester vivant sans elle.",
                    Out_put: "Hydratation vitale",
                    Risk: "Mort. Sans eau, pas de survie \u2014 c\u2019est simple."
                },
                "66": {
                    Company_Name: "Z \xc9tudes Industries",
                    Description: "Acc\xe9der \xe0 des mondes au-del\xe0 de l\u2019imagination.",
                    Out_put: "Production et acquisition de savoir",
                    Risk: "\xc9conomie de la distraction. Les algorithmes des r\xe9seaux volent l\u2019attention."
                },
                "67": {
                    Company_Name: "Z Rigolade Divertissement",
                    Description: "L\u2019essentiel pour faire rire \u2014 et garder les liens en vie.",
                    Out_put: "Entretenir les relations par le rire et la bonne humeur",
                    Risk: "D\xe9pression. Un esprit plomb\xe9 n\u2019a plus l\u2019\xe9nergie de rire."
                },
                "68": {
                    Company_Name: "Z Syst\xe8mes d\u2019Attention",
                    Description: "Se concentrer dans un monde d\u2019interruptions sans fin. (Pardon, j\u2019ai d\xe9croch\xe9.)",
                    Out_put: "Capacit\xe9 \xe0 maintenir le focus, base de ce qu\u2019on construit et retient",
                    Risk: "Fatigue. L\u2019\xe9puisement mental \xe9touffe m\xeame la meilleure attention."
                },
                "69": {
                    Company_Name: "Z Voyeur M\xe9dias Incorpor\xe9e",
                    Description: "Laisser briller son c\xf4t\xe9 voyeur, sans se faire voir.",
                    Out_put: "Frisson d\u2019observer, satisfaction d\u2019\xeatre t\xe9moin invisible",
                    Risk: "Maison \xe0 la campagne. Sans voisins, pas d\u2019espionnage."
                },
                "70": {
                    Company_Name: "Z R\xe9veil Incorpor\xe9e",
                    Description: "Le rituel quotidien : se lever et repartir \xe0 neuf.",
                    Out_put: "Sortir du lit, mettre la journ\xe9e en marche",
                    Risk: "Insomnie. Sans dormir, on ne \xab se r\xe9veille \xbb pas vraiment."
                },
                "71": {
                    Company_Name: "Z Glandouille M\xe9dias",
                    Description: "\xc9vasion ludique et joie des moments l\xe9gers.",
                    Out_put: "Se divertir en faisant l\u2019andouille, seul ou \xe0 plusieurs",
                    Risk: "Trop de travail. Quand les responsabilit\xe9s d\xe9bordent, il n\u2019y a plus de place pour le fun."
                },
                "72": {
                    Company_Name: "Z Dormeur Corporation",
                    Description: "L\u2019importance du repos et de la r\xe9cup\xe9ration pour l\u2019esprit humain.",
                    Out_put: "Temps de r\xe9paration du corps et de l\u2019esprit",
                    Risk: "Stress/Anxi\xe9t\xe9. Un mental agit\xe9 refuse le sommeil et laisse l\u2019\xe9puisement."
                },
                "73": {
                    Company_Name: "Z Jalousie Syst\xe8mes",
                    Description: "La pelouse du voisin est toujours plus verte.",
                    Out_put: "Carburant de la comparaison, de la comp\xe9tition et du m\xe9contentement",
                    Risk: "Satisfaction. Si l\u2019on appr\xe9cie ce qu\u2019on a, la jalousie perd ses crocs."
                },
                "74": {
                    Company_Name: "Z D\xe9sir Syst\xe8mes",
                    Description: "Puiser dans les motivations et passions qui portent l\u2019ambition et la cr\xe9ation.",
                    Out_put: "Force motrice des poursuites positives (et parfois moins\u2026)",
                    Risk: "Apathie. Quand on ne ressent plus rien, il n\u2019y a plus de d\xe9sir."
                },
                "75": {
                    Company_Name: "Z Rire Industrie",
                    Description: "Affiner l\u2019art de l\u2019humour pour \xe9clairer les vies et remonter les moral(e)s.",
                    Out_put: "Lib\xe9ration physique venue du ventre, encore meilleure en groupe",
                    Risk: "Les nouvelles. Un flux constant de trag\xe9dies rend le rire luxueux."
                },
                "76": {
                    Company_Name: "Z Identit\xe9s Incorpor\xe9e",
                    Description: "Les couches subtiles de l\u2019identit\xe9 personnelle et collective dans un monde divers.",
                    Out_put: "Le qui, le quoi et surtout le pourquoi de la perception de soi",
                    Risk: "Racisme. Ne pas avoir le droit d\u2019\xeatre soi."
                },
                "77": {
                    Company_Name: "Z Blagues Divertissement",
                    Description: "Des moments l\xe9gers et un humour fut\xe9 pour relier et amuser.",
                    Out_put: "Transmission d\u2019humour, qu\u2019on l\u2019ait demand\xe9 ou non",
                    Risk: "Blagues de papa. Elles\u2026 (tu vois l\u2019id\xe9e)."
                },
                "78": {
                    Company_Name: "Z Pr\xe9tentieux Industries",
                    Description: "Le r\xe8gne des apparences et de l\u2019auto-importance \u2014 avec une pointe de muflerie.",
                    Out_put: "Se pr\xe9senter comme sup\xe9rieur, plus raffin\xe9, plus important que les autres",
                    Risk: "Altruisme. Quand on se fiche d\u2019apparences, la pr\xe9tention ne vaut plus rien."
                },
                "79": {
                    Company_Name: "Zo Frustr\xe9 Incorpor\xe9e",
                    Description: "Saisir l\u2019exasp\xe9ration et la pers\xe9v\xe9rance des gal\xe8res quotidiennes.",
                    Out_put: "Essayer encore et encore sans r\xe9sultat (et recommencer)",
                    Risk: "Succ\xe8s. Quand \xe7a marche, la frustration fond en satisfaction."
                },
                "80": {
                    Company_Name: "Z Anti-Poussi\xe8re Cie",
                    Description: "L\u2019art du m\xe9nage pouss\xe9 jusqu\u2019au sans-poussi\xe8re \xe9clatant.",
                    Out_put: "Bien plus que passer l\u2019aspirateur : extermination de la poussi\xe8re",
                    Risk: "La ville. Appartements sur rue et fen\xeatres ouvertes \u2014 la poussi\xe8re refait surface."
                },
                "81": {
                    Company_Name: "Z Vulgaire Corporation",
                    Description: "Repousser les limites et chatouiller les normes avec une expression brute.",
                    Out_put: "Affirmation d\u2019individualit\xe9 sans filtre",
                    Risk: "Respect. Quand la biens\xe9ance prime, l\u2019expression crue perd sa place."
                },
                "82": {
                    Company_Name: "Z Rock & D\xe9cibels Industries",
                    Description: "Capitaliser sur la musique forte qui coule dans les oreilles douze heures par jour.",
                    Out_put: "Euphorie par la musique, le mouvement et l\u2019\xe9nergie d\xe9brid\xe9e",
                    Risk: "Balados. Un monde qui pr\xe9f\xe8re la parole au volume \xe9touffe la puissance du son fort."
                },
                "83": {
                    Company_Name: "Zo \xc9reint\xe9 Corporation",
                    Description: "L\u2019exp\xe9rience universelle de l\u2019\xe9puisement.",
                    Out_put: "Frein g\xe9n\xe9ral \xe0 toute action, paupi\xe8res lourdes, r\xe9flexion au ralenti",
                    Risk: "D\xe9rive. Errer sans horaires d\xe9joue la fatigue\u2026 en \xe9vitant le \xab vrai \xbb repos."
                },
                "84": {
                    Company_Name: "Z Interactions M\xe9dia",
                    Description: "\xc9changes et liens \xe0 travers la diversit\xe9 du vivant.",
                    Out_put: "Relations, exp\xe9riences partag\xe9es et \xe9changes sociaux",
                    Risk: "Ego. Quand l\u2019int\xe9r\xeat personnel \xe9crase le lien, l\u2019interaction devient creuse."
                },
                "85": {
                    Company_Name: "Zo Bricolo Incorpor\xe9e",
                    Description: "R\xe9parer, monter, bidouiller avec adresse et ing\xe9niosit\xe9.",
                    Out_put: "Jouets r\xe9par\xe9s, \xe9tag\xe8res pos\xe9es, cuisine pr\xeate \xe0 l\u2019emploi, tout bricolage utile",
                    Risk: "Rien \xe0 r\xe9parer. Si tout fonctionne, l\u2019atelier ferme."
                },
                "86": {
                    Company_Name: "Zo Bon Sens Technologie",
                    Description: "Des solutions simples \xe0 des probl\xe8mes compliqu\xe9s.",
                    Out_put: "Application de logique et de jugement pour avancer efficacement",
                    Risk: "Idiocie. Quand la pens\xe9e rationnelle est d\xe9valu\xe9e, le bon sens s\u2019\xe9vapore."
                },
                "87": {
                    Company_Name: "Z Lave-Vaisselle Corporation",
                    Description: "Tous les jours, apr\xe8s chaque repas.",
                    Out_put: "Vaisselle propre pour le prochain festin (mains ti\xe8des incluses)",
                    Risk: "Repas dehors. Si on mange ailleurs, la vaisselle devient l\u2019affaire des autres."
                },
                "88": {
                    Company_Name: "Z M\xe9moire Logiciels",
                    Description: "Pr\xe9server et muscler le souvenir par des outils fut\xe9s.",
                    Out_put: "Processus cognitifs et pratiques pour gagner en efficacit\xe9 et \xe9viter la redite",
                    Risk: "\xc2ge. Le temps qui passe grignote la m\xe9moire et la productivit\xe9."
                },
                "89": {
                    Company_Name: "Z Partenaires Incorpor\xe9e",
                    Description: "Derri\xe8re toute Bourse solide, une femme encore plus solide.",
                    Out_put: "Lien intime et s\xfbr, personnel et financier, moteur du succ\xe8s commun",
                    Risk: "\xc9go\xefsme. Quand l\u2019individu prime, le duo ne sert plus \xe0 rien."
                },
                "90": {
                    Company_Name: "Z R\xeaves Syst\xe8mes",
                    Description: "Myst\xe8res et inspirations du sommeil paradoxal.",
                    Out_put: "Restauration inconsciente, sant\xe9 du corps et de l\u2019esprit, porte du subconscient",
                    Risk: "F\xeate chimique. Les substances brouillent r\xeaves et repos profond."
                },
                "91": {
                    Company_Name: "Zo Tr\xf4ne Ultra Frais Industries",
                    Description: "Fra\xeecheur et propret\xe9 pour les lieux les plus visit\xe9s.",
                    Out_put: "Hygi\xe8ne du royaume, senteur agr\xe9able et \xe9clat poli",
                    Risk: "Paresse. Si l\u2019entretien flanche, la fra\xeecheur s\u2019effondre."
                },
                "92": {
                    Company_Name: "Ze Libido Industries",
                    Description: "Passion et pulsions qui nourrissent lien et cr\xe9ativit\xe9.",
                    Out_put: "Envie pressante de s\u2019accoupler (oui, tr\xe8s pressante)",
                    Risk: "D\xe9prime/Froid. L\u2019engourdissement mental ou physique \xe9teint le d\xe9sir."
                },
                "93": {
                    Company_Name: "Z Sagesse Incorpor\xe9e",
                    Description: "Chercher connaissance et compr\xe9hension pour naviguer le chaos.",
                    Out_put: "Lecture fine des complexit\xe9s, clairvoyance et bon jugement",
                    Risk: "Manque d\u2019exp\xe9rience. Sans v\xe9cu, la sagesse reste hors de port\xe9e."
                },
                "94": {
                    Company_Name: "Z Stress Corporation",
                    Description: "Raffiner le tas quotidien de pressions en pure valeur (ou presque).",
                    Out_put: "Manifestation physiologique de la pression : l\u2019ext\xe9rieur devient temp\xeate int\xe9rieure",
                    Risk: "Argent. Quand la charge financi\xe8re s\u2019all\xe8ge, le stress perd un pilier."
                },
                "95": {
                    Company_Name: "Z R\xe2leries Corporation",
                    Description: "Dire les choses cash, soupape comprise.",
                    Out_put: "Expression vocale du m\xe9contentement, parfois appel au changement",
                    Risk: "Accomplissement. Pas de souci, pas de plainte."
                },
                "96": {
                    Company_Name: "Z Vide Corporation",
                    Description: "Le creux de la journ\xe9e qui demande : \xab \xe0 quoi bon ? \xbb",
                    Out_put: "Stagnation existentielle o\xf9 but et \xe9lan semblent absents",
                    Risk: "R\xe9ussite. Quand le sens revient, le vide se dissipe."
                },
                "97": {
                    Company_Name: "Z Douleur Industries",
                    Description: "Quand \xe7a fait mal \u2014 quelque part ou partout.",
                    Out_put: "Signal physique ou \xe9motionnel qui exige attention, adaptation ou \xe9vitement",
                    Risk: "Anesth\xe9sie. Substances qui rendent tout\u2026 muet."
                },
                "98": {
                    Company_Name: "Z Odeur Corporation",
                    Description: "L\u2019invisible toujours pr\xe9sent dans la pi\xe8ce.",
                    Out_put: "Votre sillage : comment on vous sent (litt\xe9ralement)",
                    Risk: "D\xe9odorant. La suppression artificielle gomme son influence."
                },
                "99": {
                    Company_Name: "Ze Narcissique Corporation",
                    Description: "Auto-admiration parce que \xab moi d\u2019abord \xbb.",
                    Out_put: "Seul soi compte, peu importe les d\xe9g\xe2ts autour",
                    Risk: "\xc9coute. L\u2019attention r\xe9elle \xe0 l\u2019autre fissure l\u2019illusion de grandeur."
                },
                "100": {
                    Company_Name: "Z Compliqu\xe9 Incorpor\xe9e",
                    Description: "Toutes les petites pi\xe8ces \xe0 prendre en compte pour comprendre l\u2019ensemble.",
                    Out_put: "Complexit\xe9 d\xe9bordante qui rend l\u2019entente mutuelle introuvable",
                    Risk: "Simplicit\xe9. Accueillir le d\xe9tachement dissout l\u2019encombrement mental."
                },
                "101": {
                    Company_Name: "Z Baston Industries",
                    Description: "Coups de poing, cl\xe9s de bras et joutes d\u2019id\xe9es en pleine face.",
                    Out_put: "Affirmation de l\u2019existence par confrontation physique ou intellectuelle",
                    Risk: "Paix int\xe9rieure. Sans attachement, plus besoin de se battre."
                },
                "102": {
                    Company_Name: "Zo Ver d\u2019Oreille Groupe",
                    Description: "Pluie, vent, froid ou soleil : tous les jours, sans faute.",
                    Out_put: "Air, jingle ou m\xe9lodie qui tourne en boucle dans la t\xeate",
                    Risk: "Conversation. Un \xe9change vif\u2026 et le ver cesse de grignoter."
                },
                "103": {
                    Company_Name: "Z C\xe9libataire Corporation",
                    Description: "Le d\xe9sir profond de flirter avec tout le bar (effet lunettes obligatoire).",
                    Out_put: "Vie solo, disponible pour jouer",
                    Risk: "Engagement. D\xe8s qu\u2019il arrive, le mode c\xe9lib\u2019 s\u2019\xe9vapore."
                },
                "104": {
                    Company_Name: "ZEvil Corporation",
                    Description: "La malveillance pure \u2014 comme du 3G quand tout le monde a du 5G.",
                    Out_put: "Pouvoir et ambition qui avancent par efficacit\xe9 impitoyable",
                    Risk: "Empathie. Le souci sinc\xe8re des autres fissure la m\xe9chancet\xe9."
                },
                "105": {
                    Company_Name: "Z Bureaucratique Corporation",
                    Description: "La bureaucratie : un voyage, pas une destination.",
                    Out_put: "Blocage par couches de r\xe8gles et lenteurs soigneusement empil\xe9es",
                    Risk: "Infraction. Quand on contourne tout, la paperasse perd prise."
                },
                "106": {
                    Company_Name: "Z Air Guitariste Corporation",
                    Description: "Riffs imaginaires, vraie passion, oxyg\xe8ne en main.",
                    Out_put: "Joie et expression d\xe9li\xe9es de toute utilit\xe9 \u2014 dans le vide, litt\xe9ralement",
                    Risk: "Inhibition. La g\xeane tue le solo invisible net et sans retour."
                },
                "107": {
                    Company_Name: "Zo Donner Corporation",
                    Description: "Tendre la main sans r\xe9clamer quoi que ce soit en retour.",
                    Out_put: "G\xe9n\xe9rosit\xe9 gratuite aux effets sociaux ou spirituels bien r\xe9els",
                    Risk: "\xc9go\xefsme. Quand le gain personnel l\u2019emporte, le don se grippe."
                },
                "108": {
                    Company_Name: "Vorace Z Corporation",
                    Description: "App\xe9tit insatiable pour la vie : toujours plus de ce qui excite.",
                    Out_put: "D\xe9sir sans fin de consommer, poss\xe9der ou vivre au-del\xe0 du n\xe9cessaire",
                    Risk: "Je\xfbne. Refuser l\u2019exc\xe8s affaiblit la fringale infinie."
                },
                "109": {
                    Company_Name: "Zo Excessif Corporation",
                    Description: "La qu\xeate de l\u2019exc\xe8s, o\xf9 \xab assez \xbb n\u2019existe pas.",
                    Out_put: "Indulgence d\xe9brid\xe9e : la mesure est laiss\xe9e \xe0 la porte",
                    Risk: "Sati\xe9t\xe9. Satisfait, l\u2019exc\xe8s devient vide."
                },
                "110": {
                    Company_Name: "Z Confortable Corporation",
                    Description: "La position parfaite entre aisance et contentement.",
                    Out_put: "Repos du corps et de l\u2019esprit, sans tension ni g\xeane",
                    Risk: "Mauvais canap\xe9. Si le confort s\u2019effondre, la d\xe9tente se change en agacement."
                },
                "111": {
                    Company_Name: "Zo Bien Repos\xe9 Incorpor\xe9e",
                    Description: "L\u2019art de lever le pied pour recharger les batteries.",
                    Out_put: "\xc9tat centr\xe9 : la tension s\u2019en va, la fatigue aussi",
                    Risk: "Parentalit\xe9. Sans nuits paisibles, le calme reste th\xe9orique."
                },
                "112": {
                    Company_Name: "Zo Se d\xe9tendre Compagnie",
                    Description: "Sp\xe9cialiste du calme et des joies simples de la d\xe9contraction.",
                    Out_put: "Absence d\u2019agitation : esprit clair, existence apais\xe9e",
                    Risk: "Factures. Les obligations grignotent la paix int\xe9rieure."
                },
                "113": {
                    Company_Name: "Zo Immobile Corporation",
                    Description: "Rester plant\xe9 l\xe0, entre action et inaction.",
                    Out_put: "Stagnation g\xe9n\xe9rale : rien n\u2019avance, rien ne bouge",
                    Risk: "Croissance. Si tu grandis, tu n\u2019es plus coinc\xe9."
                },
                "114": {
                    Company_Name: "Z Aller En Avant Corporation",
                    Description: "C\xe9l\xe9brer l\u2019\xe9lan qui pousse \xe0 avancer.",
                    Out_put: "Progresser dans la direction d\xe9sir\xe9e \u2014 projet, trottoir, vie",
                    Risk: "Bureaucratie. Trop de r\xe8gles casse l\u2019\xe9lan."
                },
                "115": {
                    Company_Name: "Zo Coinc\xe9 Corporation",
                    Description: "Tenter d\u2019avancer avec le pied coll\xe9 au sol.",
                    Out_put: "Obstacles qui bloquent l\u2019action et m\xe8nent \xe0 la stagnation",
                    Risk: "D\xe9r\xe9gulation. Sans entraves, l\u2019obstacle dispara\xeet et l\u2019humeur aussi."
                },
                "116": {
                    Company_Name: "Z Recul Incorpor\xe9e",
                    Description: "Glisser vers l\u2019ombre, peu \xe0 peu, jusqu\u2019\xe0 l\u2019invisible.",
                    Out_put: "Ce qui s\u2019amenuise avec le temps \u2014 qualit\xe9, pr\xe9sence ou \xe9clat",
                    Risk: "R\xe9ussite. Surmonter rend la lutte obsol\xe8te\u2026 et le recul aussi."
                },
                "117": {
                    Company_Name: "Z Voisin Incorpor\xe9e",
                    Description: "F\xeates bruyantes, b\xe9b\xe9s qui pleurent, poisson frit \u2014 la vie \xe0 deux portes d\u2019\xe9cart.",
                    Out_put: "Savoir-vivre en proximit\xe9 imm\xe9diate",
                    Risk: "Distance. Quand on s\u2019\xe9loigne, l\u2019\xeatre-voisin se dissout."
                },
                "118": {
                    Company_Name: "Zo L\xe9gal Corporation",
                    Description: "Vivre avec structures, r\xe8gles et responsabilit\xe9s qui soutiennent l\u2019ordre.",
                    Out_put: "Adh\xe9sion aux cadres qui organisent la hi\xe9rarchie sociale",
                    Risk: "R\xe9bellion. \xab Casser la loi \xbb suffit \xe0 casser la Loi."
                },
                "119": {
                    Company_Name: "Z Confus Syst\xe8mes",
                    Description: "Ces moments de perplexit\xe9 o\xf9 tout devient douteux. Hein ?",
                    Out_put: "Incertitude : infos contradictoires, d\xe9cision introuvable",
                    Risk: "Recherche. Plus on sait, moins la confusion r\xe8gne."
                },
                "120": {
                    Company_Name: "Z Ind\xe9cision Technologies",
                    Description: "Le paradoxe du choix : mille dentifrices, z\xe9ro d\xe9cision.",
                    Out_put: "Paralysie devant l\u2019abondance d\u2019options, donc inaction",
                    Risk: "D\xe9cision. Quand on tranche avec assurance, l\u2019ind\xe9cision dispara\xeet."
                },
                "121": {
                    Company_Name: "Z C\xe9l\xe9brit\xe9 Corporation",
                    Description: "Projecteurs, gloire, ego et l\u2019ivresse d\u2019\xeatre ador\xe9 par la foule.",
                    Out_put: "Soif d\u2019attention, d\u2019admiration et de validation qui fa\xe7onne l\u2019identit\xe9",
                    Risk: "Normalit\xe9. Redevenir \xab comme tout le monde \xbb fait retomber le souffl\xe9."
                },
                "122": {
                    Company_Name: "Z D\xe9fense Violente Corporation",
                    Description: "R\xe9ponses calcul\xe9es pour se prot\xe9ger des menaces.",
                    Out_put: "Riposte agressive face aux attaques physiques ou mentales",
                    Risk: "Tol\xe9rance. Accepter la diff\xe9rence coupe l\u2019herbe sous le pied \xe0 la violence."
                },
                "123": {
                    Company_Name: "Zo Enfiler Ses Chaussures inc.",
                    Description: "Le geste simple de sortir, sans oublier style et confort.",
                    Out_put: "Des pantoufles aux bottes : hop, on chausse et on y va",
                    Risk: "Plage. Si le monde autorise les pieds nus, les chaussures deviennent facultatives."
                },
                "124": {
                    Company_Name: "Z Fils \xe0 Maman Corporation",
                    Description: "Le lien unique et tenace entre une m\xe8re et son enfant.",
                    Out_put: "Poids affectif de l\u2019attachement, devoirs et tiraillements familiaux",
                    Risk: "Grandir. L\u2019autonomie \xe9mousse la culpabilit\xe9 maternelle."
                },
                "125": {
                    Company_Name: "Z Essayer Tr\xe8s Fort Industrie",
                    Description: "D\xe9termination et poursuite obstin\xe9e d\u2019un but malgr\xe9 tout.",
                    Out_put: "Effort inlassable pour franchir les obstacles par pure volont\xe9",
                    Risk: "Frustration. Quand \xe7a n\u2019aboutit pas, l\u2019acharnement vire \xe0 l\u2019\xe9puisement."
                },
                "126": {
                    Company_Name: "Z Mince - C\u2019est Cass\xe9 Corporation",
                    Description: "Le chaos quand tout l\xe2che en m\xeame temps.",
                    Out_put: "Stress de la panne et de la casse, petites et grandes",
                    Risk: "Remplacement. Acheter du neuf repousse l\u2019orage \xe0 demain."
                },
                "127": {
                    Company_Name: "Z Anxi\xe9t\xe9 Industrie",
                    Description: "Crainte tenace qui hurle du matin au soir (avec bonus mal de dos).",
                    Out_put: "Inqui\xe9tude constante, pens\xe9es qui cavalent et tension corporelle",
                    Risk: "Acceptation. Quand on trouve un socle, l\u2019anxi\xe9t\xe9 perd sa prise."
                },
                "128": {
                    Company_Name: "Z Ennui Corporation",
                    Description: "D\xe9sengagement total : rien ne m\xe9rite l\u2019effort.",
                    Out_put: "Plus rien de nouveau ni d\u2019attirant : vide et b\xe2illements",
                    Risk: "Passion. L\u2019ennemi jur\xe9 de l\u2019ennui."
                },
                "129": {
                    Company_Name: "Z Pr\xe9sentation Soi Corporation",
                    Description: "\xab Bonjour, je m\u2019appelle\u2026 \xbb",
                    Out_put: "Se faire conna\xeetre, attirer l\u2019attention et cr\xe9er un premier lien",
                    Risk: "Antisocial. Si tout le monde se retire, plus besoin de se pr\xe9senter."
                },
                "130": {
                    Company_Name: "Z&Z R\xe9p\xe9tition Incorpor\xe9e",
                    Description: "La routine du quotidien qui broie les jours en identiques.",
                    Out_put: "Cycle monotone o\xf9 la pr\xe9visibilit\xe9 avale l\u2019\xe9lan",
                    Risk: "Changement. Un d\xe9cor neuf brise la boucle."
                },
                "131": {
                    Company_Name: "Zo D\xe9\xe7u Incorpor\xe9e",
                    Description: "L\u2019exp\xe9rience universelle des attentes non combl\xe9es.",
                    Out_put: "Chute \xe9motionnelle et impression de potentiel g\xe2ch\xe9",
                    Risk: "Quand \xe7a marche. La satisfaction n\u2019a pas de place pour la d\xe9ception."
                },
                "132": {
                    Company_Name: "WOW Z Corporation",
                    Description: "Pur \xe9merveillement : le temps s\u2019arr\xeate, bouche ouverte.",
                    Out_put: "Instant de stupeur o\xf9 l\u2019extraordinaire d\xe9borde le pr\xe9vu",
                    Risk: "L\u2019ennui. Quand plus rien n\u2019\xe9tonne, m\xeame l\u2019impr\xe9vu tombe \xe0 plat."
                },
                "133": {
                    Company_Name: "Z Aimable Corporation",
                    Description: "Agir pour rendre la vie un peu plus douce.",
                    Out_put: "Gentillesse, charme et art d\u2019ensoleiller autrui",
                    Risk: "Grossi\xe8ret\xe9. Sans \xe9gards, l\u2019aimable tourne \xe0 l\u2019hostile."
                },
                "134": {
                    Company_Name: "Z Pessimiste Corporation",
                    Description: "S\u2019attendre au pire et s\u2019y blottir comme dans une couette.",
                    Out_put: "D\xe9tachement prudent : se pr\xe9parer \xe0 la d\xe9ception pour se prot\xe9ger",
                    Risk: "Positivit\xe9. Voir le bon c\xf4t\xe9 tue la noirceur."
                },
                "135": {
                    Company_Name: "Zo D\xe9bord\xe9 Incorpor\xe9e",
                    Description: "Trop \xe0 faire, pas assez d\u2019heures.",
                    Out_put: "Ex\xe9cuter quantit\xe9 de t\xe2ches indispensables",
                    Risk: "Farniente. Quand on valorise le repos, le \xab d\xe9bord\xe9 \xbb s\u2019\xe9vapore."
                },
                "136": {
                    Company_Name: "Zo Inassouvi Corporation",
                    Description: "Ce trou b\xe9ant du quotidien qui murmure \xab pas assez \xbb. ",
                    Out_put: "Sensation persistante de manque : rien ne suffit, jamais",
                    Risk: "Famille/Amis. Les liens profonds rendent le vide moins vorace."
                },
                "137": {
                    Company_Name: "Zo Pas Compatible Technologie",
                    Description: "Quand les syst\xe8mes refusent obstin\xe9ment de s\u2019accorder.",
                    Out_put: "Incompatibilit\xe9s qui forcent l\u2019inefficacit\xe9 et la crispation",
                    Risk: "Simplicit\xe9. Rester simple rend (souvent) compatible."
                },
                "138": {
                    Company_Name: "Zo All\xf4, All\xf4 ?? Incorpor\xe9e",
                    Description: "Technologie avanc\xe9e, mais communication basique en PLS.",
                    Out_put: "Gadgets qui manquent leur fonction premi\xe8re \u2014 surtout les \xab intelligents \xbb",
                    Risk: "Ligne fixe. Une connexion simple balaie les caprices."
                },
                "139": {
                    Company_Name: "Z Catastrophe Corporation",
                    Description: "Quand tout s\u2019\xe9croule d\u2019un coup, tout, tout de suite.",
                    Out_put: "Trag\xe9dies et fiascos qui retournent la table",
                    Risk: "Banalit\xe9. Une vie plate et pr\xe9visible n\u2019alimente pas le drame."
                },
                "140": {
                    Company_Name: "Z Batteries Industries",
                    Description: "Ces objets qui meurent plus vite que pr\xe9vu (toujours au mauvais moment).",
                    Out_put: "Garder les appareils en vie malgr\xe9 l\u2019h\xe9morragie d\u2019\xe9nergie",
                    Risk: "Prise murale. Branch\xe9 au r\xe9seau, la batterie ne compte plus."
                },
                "141": {
                    Company_Name: "Z Stress Informatique Syst\xe8mes",
                    Description: "La vie moderne quand une pomme a un ver.",
                    Out_put: "Tension mentale et physique due aux pannes et bugs",
                    Risk: "Forums utiles. Quand la solution est \xe0 port\xe9e, la rage retombe."
                },
                "142": {
                    Company_Name: "Z Une Barre Technologies",
                    Description: "Gr\xe9sillements, 3G mollasson, roue qui tourne.",
                    Out_put: "Isolement et stress d\u2019\xeatre d\xe9connect\xe9",
                    Risk: "Bonne couverture. Beaucoup de barres, beaucoup de paix."
                },
                "143": {
                    Company_Name: "Z Erreur Port 411 Syst\xe8mes",
                    Description: "Quand le syst\xe8me plante et refuse de rena\xeetre.",
                    Out_put: "Arr\xeat brutal qui fige le progr\xe8s et s\xe8me le doute",
                    Risk: "Tutoriel. Le savoir transforme l\u2019erreur en le\xe7on."
                },
                "144": {
                    Company_Name: "Z Service Client Corporation",
                    Description: "Quand c\u2019est cass\xe9, ils aident\u2026 ou font semblant.",
                    Out_put: "Aide fournie pour r\xe9soudre un souci \u2014 sinc\xe8re ou cosm\xe9tique",
                    Risk: "Robot de tchat. Le \xab non-secours \xbb le plus inutile du monde."
                },
                "145": {
                    Company_Name: "Z Coolitude Corporation",
                    Description: "Assurance muette, charme sans effort, vibe imparable.",
                    Out_put: "Avoir la d\xe9gaine et l\u2019aura qui vont avec",
                    Risk: "Suiveurs. Si l\u2019on copie pour valider, la coolitude perd sa valeur."
                },
                "146": {
                    Company_Name: "Zo Fort Incorporated",
                    Description: "Talent, savoir-faire et bont\xe9 l\xe0 o\xf9 \xe7a compte.",
                    Out_put: "Satisfaction tangible n\xe9e de l\u2019excellence et de la gentillesse",
                    Risk: "Le Mal. Quand l\u2019excellence est ignor\xe9e, \xab \xeatre bon \xbb ne paie plus."
                },
                "147": {
                    Company_Name: "L\xe2cher Prise Corporation",
                    Description: "Avancer et trouver la paix en l\xe2chant prise.",
                    Out_put: "Soulagement par l\u2019acceptation du pass\xe9",
                    Risk: "Anxi\xe9t\xe9. Un esprit accroch\xe9 aux soucis ne l\xe2che rien."
                },
                "148": {
                    Company_Name: "Z Encore & Encore Incorpor\xe9e",
                    Description: "La nature cyclique de la vie et ses boucles tenaces.",
                    Out_put: "Influence des r\xe9p\xe9titions et routines sur le r\xe9el",
                    Risk: "Vacances. Une rupture de rythme casse le cycle."
                },
                "149": {
                    Company_Name: "Z Acheteur Incorpor\xe9e",
                    Description: "Prendre soin du consommateur qui sommeille en chacun.",
                    Out_put: "Accumulation d\u2019objets et de petites joies \xe0 la caisse",
                    Risk: "Pas d\u2019argent. Sans budget, la fr\xe9n\xe9sie ralentit."
                },
                "150": {
                    Company_Name: "Z Agonie Corporation",
                    Description: "Le pan de vie d\xe9fini par la douleur, physique ou morale.",
                    Out_put: "R\xe9action br\xfblante au souffrir \u2014 v\xe9cu ou observ\xe9",
                    Risk: "Bonheur. Quand le bien-\xeatre dure, la douleur perd le micro."
                },
                "151": {
                    Company_Name: "Z Parce Que Je Le Dis Corporation",
                    Description: "Pourquoi ? Parce que je le pense. Point.",
                    Out_put: "Conviction exprim\xe9e sans preuve, mais avec aplomb",
                    Risk: "Aphonie. Sans voix, la certitude reste coinc\xe9e."
                },
                "152": {
                    Company_Name: "On Va Tous Mourir Corporation",
                    Description: "Courir tant qu\u2019on peut : personne ne sort d\u2019ici vivant.",
                    Out_put: "D\xe9termination t\xe9m\xe9raire \xe0 vivre pleinement, conscience de la fin",
                    Risk: "Pr\xe9voir. Planifier l\u2019avenir freine l\u2019\xe9lan casse-cou."
                },
                "153": {
                    Company_Name: "Zo Addict Incorpor\xe9e",
                    Description: "Envie plus forte que la volont\xe9 \u2014 et te voil\xe0 accro.",
                    Out_put: "D\xe9sir qui d\xe9borde l\u2019autocontr\xf4le et cr\xe9e la d\xe9pendance",
                    Risk: "Abstinence. Renoncer \xe0 l\u2019objet du manque coupe les revenus."
                },
                "154": {
                    Company_Name: "Z Expliquer Corporation",
                    Description: "Rendre les id\xe9es claires, une bouch\xe9e \xe0 la fois.",
                    Out_put: "D\xe9montage de concepts complexes en savoir digeste",
                    Risk: "Hurler. Crier n\u2019a jamais am\xe9lior\xe9 la compr\xe9hension."
                },
                "155": {
                    Company_Name: "Zoriginal Technologies",
                    Description: "Ne pas faire comme les autres.",
                    Out_put: "Cr\xe9ation distincte et identit\xe9 authentique qui se d\xe9marquent",
                    Risk: "Copie. Quand l\u2019imitation r\xe8gne, l\u2019unique se dilue."
                },
                "156": {
                    Company_Name: "Plein de Z\u2026 Corporation",
                    Description: "Avoir toutes les r\xe9ponses \u2014 aucune de correcte.",
                    Out_put: "Discours convaincant mais creux pour garder la main",
                    Risk: "Se taire. Le silence coupe le courant du baratin."
                },
                "157": {
                    Company_Name: "Z Reclus Corporation",
                    Description: "Rester chez soi pour \xe9viter le vacarme du monde.",
                    Out_put: "Maison, pyjama, paix \u2014 et porte close",
                    Risk: "Beau temps. Quand dehors invite, dedans perd son charme."
                },
                "158": {
                    Company_Name: "Zo R\xe9ussi Corporation",
                    Description: "Quand ce que tu fais\u2026 marche.",
                    Out_put: "Objectifs atteints avec r\xe9sultats tangibles",
                    Risk: "\xc9chec. Si \xe7a ne marche pas, \xe7a n\u2019existe pas."
                },
                "159": {
                    Company_Name: "Zo 9-\xe0-5 Incorpor\xe9e",
                    Description: "La routine pour gagner sa vie (plut\xf4t 9-\xe0-8).",
                    Out_put: "Travailler pour assurer besoins et stabilit\xe9",
                    Risk: "\xc9puisement. Quand la fatigue d\xe9passe le salaire, la m\xe9canique casse."
                },
                "160": {
                    Company_Name: "Z Parler \xe0 Zoi Corporation",
                    Description: "Quand personne n\u2019\xe9coute, raconte-toi\u2026 \xe0 toi.",
                    Out_put: "Dialogue auto-aliment\xe9, \xe0 voix haute ou dans la t\xeate",
                    Risk: "Vie sociale. Si le monde r\xe9pond, le monologue n\u2019a plus lieu d\u2019\xeatre."
                },
                "161": {
                    Company_Name: "Zo Intellectuel M\xe9dia Corporation",
                    Description: "Le socle pour se fabriquer un meilleur cerveau\u2026 qui parfois tourne en rond.",
                    Out_put: "Construire et \xe9tendre le savoir, forger des id\xe9es et aff\xfbter l\u2019esprit",
                    Risk: "R\xe9seaux sociaux. La consommation passive remplace l\u2019effort intellectuel actif."
                },
                "162": {
                    Company_Name: "Z Grignote Corporation",
                    Description: "Le petit plaisir de picorer entre les repas.",
                    Out_put: "Grignotage en douce, juste une bouch\xe9e\u2026 ou deux",
                    Risk: "R\xe9gime. La restriction coupe court au plaisir improvis\xe9."
                },
                "163": {
                    Company_Name: "Zo Ferklempt M\xe9dia",
                    Description: "Ces vagues d\u2019\xe9motion \u2014 amour, culpabilit\xe9, vie \u2014 qui nouent la gorge.",
                    Out_put: "Submerg\xe9 d\u2019\xe9motions : on est tout chavir\xe9",
                    Risk: "Zen. L\u2019\xe9quilibre \xe9motionnel est notre kryptonite."
                },
                "164": {
                    Company_Name: "Zo Parano Corporation",
                    Description: "Mettre en lumi\xe8re la suspicion qui gr\xe9sille et l\u2019inqui\xe9tude qui gratte.",
                    Out_put: "Hypervigilance et soup\xe7on qui poussent \xe0 se blinder",
                    Risk: "Assurance int\xe9rieure. Quand on se sent en s\xe9curit\xe9, la parano s\u2019\xe9teint."
                },
                "165": {
                    Company_Name: "Zo Honn\xeate Corporation",
                    Description: "Tendance incurable \xe0 pencher vers la v\xe9rit\xe9, quoi qu\u2019il en co\xfbte.",
                    Out_put: "Franchise qui tranche les flous et d\xe9gonfle les mensonges",
                    Risk: "Diplomatie. Quand la forme prime, la v\xe9rit\xe9 brute g\xeane."
                },
                "166": {
                    Company_Name: "Faux Z Corporation",
                    Description: "Quand l\u2019authenticit\xe9 manque mais qu\u2019on joue quand m\xeame le r\xf4le.",
                    Out_put: "Pr\xe9senter un faux soi, dissonance entre para\xeetre et \xeatre",
                    Risk: "Honn\xeatet\xe9. Quand la sinc\xe9rit\xe9 r\xe8gne, plus besoin de masque."
                },
                "167": {
                    Company_Name: "Z Fiert\xe9 Technologies",
                    Description: "Joie et assurance d\u2019\xeatre fier de son identit\xe9 et de ses r\xe9ussites.",
                    Out_put: "Valeur personnelle tir\xe9e des accomplissements et du statut",
                    Risk: "\xc9chec. Les attentes qui s\u2019effondrent rappellent \xe0 l\u2019ego la r\xe9alit\xe9."
                },
                "168": {
                    Company_Name: "Z Souvenirs Incorpor\xe9e",
                    Description: "Se rappeler ceci, cela, tout cela \u2014 seul ou \xe0 plusieurs.",
                    Out_put: "La joie de revivre hier et de partager la nostalgie",
                    Risk: "Futur. Quand on regarde devant, le pass\xe9 l\xe2che prise."
                },
                "169": {
                    Company_Name: "Z T\xe9l\xe9phonie Technologies",
                    Description: "R\xe9duire les distances et nourrir le lien, en direct et fort.",
                    Out_put: "Communication audio en temps r\xe9el",
                    Risk: "Batterie morte. Plus d\u2019appareil, plus de conversation."
                },
                "170": {
                    Company_Name: "Z Payer les Factures Corporation",
                    Description: "La qu\xeate sans fin pour honorer les obligations du mois.",
                    Out_put: "N\xe9cessit\xe9 constante de r\xe9gler, budg\xe9ter, couvrir",
                    Risk: "Ch\xf4mage. Plus de revenus : les factures changent\u2026 de priorit\xe9."
                },
                "171": {
                    Company_Name: "Z Karma Incorpor\xe9e",
                    Description: "Le grand \xe9quilibre actions/cons\xe9quences \u2014 l\u2019\xe9ternel d\xe9bat du juste.",
                    Out_put: "Justice cosmique proportionn\xe9e au comportement",
                    Risk: "Mauvaise \xe9ducation. Si rien n\u2019a de suites, le syst\xe8me se casse."
                },
                "172": {
                    Company_Name: "Z Menteur Corporation",
                    Description: "Quand la v\xe9rit\xe9 est trop lourde, on s\u2019en passe.",
                    Out_put: "V\xe9rit\xe9 tordue et perception trafiqu\xe9e : la tromperie",
                    Risk: "Conscience. Avec une boussole morale, mentir devient inutile."
                },
                "173": {
                    Company_Name: "Z Regarder le Match M\xe9dia",
                    Description: "Bi\xe8re, canap\xe9, grand \xe9cran, arbitrage pourri \u2014 amour du jeu quand m\xeame.",
                    Out_put: "Divertissement et sujets de causerie collective",
                    Risk: "Hors saison. Sans matchs, l\u2019union se met en pause."
                },
                "174": {
                    Company_Name: "Zo Achev\xe9 \xe0 Terre Incorpor\xe9e",
                    Description: "Quand on te rajoute une couche alors que tu es d\xe9j\xe0 \xe0 plat.",
                    Out_put: "\xcatre sap\xe9, frein\xe9, \xe9cras\xe9 par des forces hors de contr\xf4le",
                    Risk: "Coup de main. Le soutien transforme la rage en ressort."
                },
                "175": {
                    Company_Name: "Tout Ze Passe Bien Corporation",
                    Description: "Quand tout glisse et que tout marche.",
                    Out_put: "Avanc\xe9e fluide sans obstacle ni r\xe9sistance",
                    Risk: "La Vie. L\u2019impr\xe9vu adore casser les trajectoires parfaites."
                },
                "176": {
                    Company_Name: "Zuch un Bon Nigaud Corporation",
                    Description: "Nos belles bourdes pr\xe9f\xe9r\xe9es \u2014 embrasser le faux pas.",
                    Out_put: "Ne pas comprendre\u2026 et apprendre en se trompant",
                    Risk: "Retenue. Prendre le temps et peser ses r\xe9ponses coupe la casse."
                },
                "177": {
                    Company_Name: "Z Surfeur du Web Technologies",
                    Description: "Vagues de savoir, bobards, d\xe9tours, magouilles et\u2026 vous voyez.",
                    Out_put: "Tout, n\u2019importe quoi, tout le temps",
                    Risk: "Blackout. Pas de courant, pas de toile."
                },
                "178": {
                    Company_Name: "Zo Cr\xe9atif Incorpor\xe9e",
                    Description: "Faire na\xeetre quelque chose \xe0 partir de rien.",
                    Out_put: "Transformer l\u2019imagination en r\xe9alit\xe9 tangible",
                    Risk: "Sur-stimulation. Trop d\u2019entr\xe9es \xe9touffent la cr\xe9ation."
                },
                "179": {
                    Company_Name: "Zo Fain\xe9anter Corporation",
                    Description: "Devenir un avec le canap\xe9. Mollement.",
                    Out_put: "Se fondre dans le confort sans urgence aucune",
                    Risk: "Beaucoup de boulot. Quand les t\xe2ches s\u2019empilent, la sieste devient luxe."
                },
                "180": {
                    Company_Name: "Zo Styl\xe9 Corporation",
                    Description: "Faire une d\xe9claration par l\u2019habit et la singularit\xe9.",
                    Out_put: "Projection de soi par la mode et l\u2019allure",
                    Risk: "Indiff\xe9rence. Si personne ne s\u2019en soucie, l\u2019effet tombe."
                },
                "181": {
                    Company_Name: "Z S\u2019habiller Corporation",
                    Description: "L\u2019habit comme expression de soi et premi\xe8re impression.",
                    Out_put: "Choisir la tenue du jour et l\u2019enfiler dignement",
                    Risk: "Panier sale. Sans linge propre, le style perd sa magie."
                },
                "182": {
                    Company_Name: "Z Observation Incorpor\xe9e",
                    Description: "D\xe9couvrir en regardant et en \xe9coutant vraiment.",
                    Out_put: "Rep\xe9rer des motifs et d\xe9cider mieux en pr\xeatant attention",
                    Risk: "Fatigue. L\u2019esprit \xe9puis\xe9 confond observer et vagabonder."
                },
                "183": {
                    Company_Name: "Z Questionner Corporation",
                    Description: "La compr\xe9hension par l\u2019art de la bonne question.",
                    Out_put: "Curiosit\xe9 + esprit critique pour demander \xab pourquoi ? \xbb",
                    Risk: "Je-m\u2019en-foutisme. L\u2019indiff\xe9rence tue l\u2019enqu\xeate."
                },
                "184": {
                    Company_Name: "Z Lecteur Incorpor\xe9e",
                    Description: "Boire les pages des biblioth\xe8ques du monde.",
                    Out_put: "Absorber savoirs, capitaux de vue et exp\xe9riences par la lecture",
                    Risk: "\xc9puisement. Quand on tombe de sommeil, lire devient impossible."
                },
                "185": {
                    Company_Name: "Z Gommage & \xc9clat Corporation",
                    Description: "Frais de la t\xeate aux pieds : soin de soi et peau qui chante.",
                    Out_put: "Propret\xe9, revitalisation et chouchoutage personnel",
                    Risk: "Camping. Quand l\u2019hygi\xe8ne passe derri\xe8re, l\u2019entretien s\u2019\xe9vapore."
                },
                "186": {
                    Company_Name: "Z Lave-Mains Corporation",
                    Description: "Savonner pour l\u2019hygi\xe8ne, un bon frottage \xe0 la fois.",
                    Out_put: "Mains propres, sans microbes ni virus",
                    Risk: "Pas de savon. Sans outil, la propret\xe9 se d\xe9bine."
                },
                "187": {
                    Company_Name: "Z Programmation Technologie",
                    Description: "Des 1 et des 0 pour faire tourner le monde num\xe9rique.",
                    Out_put: "Programmes fonctionnels qui font ce qu\u2019ils doivent",
                    Risk: "Bugs. Quand le code ne calcule plus, tout coince."
                },
                "188": {
                    Company_Name: "Zo Attractif Corporation",
                    Description: "Ces qualit\xe9s qui captivent \u2014 dedans comme dehors.",
                    Out_put: "Attrait physique, \xe9motionnel et mental qui \xe9veille le d\xe9sir",
                    Risk: "Flemme. Sans effort, l\u2019\xe9clat se ternit."
                },
                "189": {
                    Company_Name: "Ze S\xe9duction Incorpor\xe9e",
                    Description: "L\u2019art de l\u2019aimantation : charme, envie, magn\xe9tisme.",
                    Out_put: "Force d\u2019attirance qui entra\xeene et envo\xfbte",
                    Risk: "Indiff\xe9rence. Si personne n\u2019accroche, la magie s\u2019\xe9vanouit."
                },
                "190": {
                    Company_Name: "Z C\xe9l\xe9bration & Cie",
                    Description: "Faire grimper la joie lors des grands et petits moments.",
                    Out_put: "Rituels, tabl\xe9es et \xe9clats qui amplifient l\u2019occasion",
                    Risk: "Alcool. L\u2019exc\xe8s transforme la f\xeate en chaos."
                },
                "191": {
                    Company_Name: "Z R\xe9flexion Inc.",
                    Description: "Soutenir la croissance personnelle et l\u2019introspection.",
                    Out_put: "Se conna\xeetre, se corriger, \xe9voluer \u2014 doucement mais s\xfbrement",
                    Risk: "Ego. \xcatre toujours \xab s\xfbr d\u2019avoir raison \xbb bloque le miroir."
                },
                "192": {
                    Company_Name: "Z Aventure Groupe",
                    Description: "Oser explorer loin de sa zone de confort.",
                    Out_put: "Exp\xe9riences qui bousculent et stimulent corps et esprit",
                    Risk: "Peur. Trop effray\xe9 : l\u2019aventure meurt avant le d\xe9part."
                },
                "193": {
                    Company_Name: "Z Harmonie Industries",
                    Description: "Trouver l\u2019\xe9quilibre et la paix dans ce qu\u2019on fait.",
                    Out_put: "Rythme, flux et douceur pour une existence paisible",
                    Risk: "Chaos. Quand tout s\u2019emballe, l\u2019harmonie sort du cadre."
                },
                "194": {
                    Company_Name: "Z Perte Inc.",
                    Description: "Apprivoiser le deuil et l\u2019absence.",
                    Out_put: "Douleur et chagrin au c\u0153ur et dans la t\xeate",
                    Risk: "Zone de confort. Rester \xe0 l\u2019abri peut retarder la rencontre\u2026 un temps."
                },
                "195": {
                    Company_Name: "Z Passion Sans Limites",
                    Description: "Faire quoi que ce soit avec toute l\u2019intensit\xe9 possible.",
                    Out_put: "\xc9nergie d\xe9vorante pour aimer, cr\xe9er et aller au bout",
                    Risk: "Alzheimer. Quand le souvenir s\u2019efface, la flamme se morcelle."
                },
                "196": {
                    Company_Name: "Z R\xe9silience Works",
                    Description: "Continuer \xe0 avancer quand \xe7a tape dur.",
                    Out_put: "Tenir bon, s\u2019adapter et progresser malgr\xe9 l\u2019adversit\xe9",
                    Risk: "Crash. Au point de rupture, m\xeame la r\xe9silience plie."
                },
                "197": {
                    Company_Name: "Z Curiosit\xe9 Labs",
                    Description: "La qu\xeate \xe0 vie du \xab pourquoi \xbb \xe9merveill\xe9.",
                    Out_put: "Chercher l\u2019inconnu et ouvrir des portes",
                    Risk: "Conformisme. Suivre la norme n\u2019a pas de place pour \xab pourquoi \xbb."
                },
                "198": {
                    Company_Name: "Z Triomphe Corporation",
                    Description: "Mettre en valeur les victoires, petites et grandes.",
                    Out_put: "Sentiment d\u2019avoir gagn\xe9 sa journ\xe9e",
                    Risk: "Deuxi\xe8me place. Ne pas gagner, c\u2019est\u2026 ne pas gagner."
                },
                "199": {
                    Company_Name: "Z B\xe2tisseurs de Communaut\xe9",
                    Description: "Tisser des liens par des exp\xe9riences partag\xe9es.",
                    Out_put: "Soutien et s\xe9curit\xe9 autour de ce qui soude le groupe",
                    Risk: "Individualisme. Quand le \xab moi \xbb \xe9crase le \xab nous \xbb."
                },
                "200": {
                    Company_Name: "ZO Bourr\xe9 Company",
                    Description: "Quand la vie vous m\xe8ne \xe0 l\u2019ivresse. *Hic, hic.*",
                    Out_put: "T\xeate qui tourne, langue qui fourche, plus de filtres",
                    Risk: "Responsabilit\xe9. Boire en adulte garde le taux dans le vert."
                },
                "201": {
                    Company_Name: "Marche-dans-la-Merde Soci\xe9t\xe9",
                    Description: "Zut, encore le pied dedans\u2026",
                    Out_put: "R\xe9flexe d\xe9go\xfbt\xe9 et nettoyage express, puis auto-d\xe9rision pour survivre \xe0 l\u2019odeur.",
                    Risk: "Glissade, col\xe8re dramatique, traces partout."
                },
                "202": {
                    Company_Name: "Tractus Digestif Syst\xe8mes",
                    Description: "Transformer le casse-cro\xfbte en carburant\u2026 ou en catastrophe.",
                    Out_put: "\xc9nergie, assimilation, \xe9vacuation harmonieuse (dans les bons jours).",
                    Risk: "Ballonnements, crampes, lenteur, d\xe9r\xe8glement g\xe9n\xe9ral."
                },
                "203": {
                    Company_Name: "Auto-C\xe2lin Industries",
                    Description: "Solo, discret, efficace \u2014 avec ou sans film du soir.",
                    Out_put: "D\xe9tente, soulagement, intimit\xe9 personnelle sans rendez-vous.",
                    Risk: "Culpabilit\xe9, exc\xe8s, isolement, perte d\u2019\xe9lan social."
                },
                "204": {
                    Company_Name: "Z Miam Industries",
                    Description: "Mettre quelque chose de bon dans la bouche pour rester vivant.",
                    Out_put: "Sati\xe9t\xe9, force, bonne humeur et traditions \xe0 table.",
                    Risk: "Frigo vide, surconsommation, culpabilit\xe9 et gaspillage."
                },
                "205": {
                    Company_Name: "Z Crac Entreprises",
                    Description: "Le son brutal qui dit que quelque chose vient de casser.",
                    Out_put: "Rupture nette : de l\u2019objet au moral, \xe7a fait toujours mal.",
                    Risk: "Casse r\xe9p\xe9t\xe9e, co\xfbts cach\xe9s, perte de confiance."
                },
                "206": {
                    Company_Name: "Rire Z\xe9l\xe9 Corporation",
                    Description: "Quand le fou rire prend le dessus, impossible de s\u2019arr\xeater.",
                    Out_put: "Larmes aux yeux, ventre douloureux, mais \xe2me l\xe9g\xe8re.",
                    Risk: "Inopportunit\xe9, moqueries, malaise social."
                },
                "207": {
                    Company_Name: "Z Gaffe Industries",
                    Description: "Le moment g\xeanant qu\u2019on aurait pr\xe9f\xe9r\xe9 \xe9viter.",
                    Out_put: "Rougeurs, excuses maladroites, rires parfois complices.",
                    Risk: "Humiliation, perte de cr\xe9dibilit\xe9, rancunes."
                },
                "208": {
                    Company_Name: "\xc9ternuement Z Soci\xe9t\xe9",
                    Description: "Le r\xe9flexe explosif qui lib\xe8re mais surprend.",
                    Out_put: "Soulagement imm\xe9diat, regards d\xe9tourn\xe9s ou b\xe9n\xe9diction attendue.",
                    Risk: "Microbes dispers\xe9s, malaise en public, crise d\u2019allergie."
                },
                "209": {
                    Company_Name: "Z Amour Fou Corporation",
                    Description: "La passion d\xe9vorante qui fait tout vibrer.",
                    Out_put: "Fusion, exaltation, \xe9nergie cr\xe9atrice.",
                    Risk: "D\xe9pendance, jalousie, c\u0153ur bris\xe9."
                },
                "210": {
                    Company_Name: "Insomnie Z Syst\xe8mes",
                    Description: "Compter les moutons jusqu\u2019\xe0 l\u2019aube sans jamais dormir.",
                    Out_put: "Yeux cern\xe9s, id\xe9es confuses, productivit\xe9 en chute.",
                    Risk: "Burnout, anxi\xe9t\xe9, perte de sant\xe9 mentale."
                },
                "211": {
                    Company_Name: "Z Gueule de Bois Industries",
                    Description: "Le r\xe9veil brutal apr\xe8s la f\xeate.",
                    Out_put: "Soif extr\xeame, mal de t\xeate et promesse de \u2018plus jamais\u2019.",
                    Risk: "R\xe9p\xe9tition, sant\xe9 ab\xeem\xe9e, productivit\xe9 d\xe9truite."
                },
                "212": {
                    Company_Name: "Z Mensonge Corporation",
                    Description: "L\u2019art de tordre la v\xe9rit\xe9 pour survivre ou s\xe9duire.",
                    Out_put: "Protection, manipulation, gain temporaire.",
                    Risk: "Perte de confiance, pi\xe8ge des mensonges accumul\xe9s."
                },
                "213": {
                    Company_Name: "Z V\xe9rit\xe9 Brutale Industries",
                    Description: "Dire tout haut ce que personne ne voulait entendre.",
                    Out_put: "Clart\xe9, authenticit\xe9, parfois lib\xe9ration.",
                    Risk: "Blessures, conflits, solitude."
                },
                "214": {
                    Company_Name: "Panne Totale Soci\xe9t\xe9",
                    Description: "Quand tout s\u2019arr\xeate soudainement.",
                    Out_put: "Silence, chaos, obligation d\u2019improviser.",
                    Risk: "Pertes, panique, paralysie du syst\xe8me."
                },
                "215": {
                    Company_Name: "Z Frisson Corporation",
                    Description: "Ce fr\xe9missement qui parcourt la peau au son ou au froid.",
                    Out_put: "Chair de poule, excitation, mont\xe9e d\u2019adr\xe9naline.",
                    Risk: "Froid, peur exag\xe9r\xe9e, hypersensibilit\xe9."
                },
                "216": {
                    Company_Name: "Z Col\xe8re Noire Industries",
                    Description: "Quand la rage monte et qu\u2019on explose.",
                    Out_put: "Cri, geste brusque, lib\xe9ration violente.",
                    Risk: "Ruptures, regrets, d\xe9g\xe2ts collat\xe9raux."
                },
                "217": {
                    Company_Name: "Z Faim de Loup Soci\xe9t\xe9",
                    Description: "Le ventre qui crie plus fort que la raison.",
                    Out_put: "D\xe9vorer sans attendre, plaisir animal.",
                    Risk: "Exc\xe8s, indigestion, impatience sociale."
                },
                "218": {
                    Company_Name: "Z Joie Pure Corporation",
                    Description: "L\u2019instant simple o\xf9 tout para\xeet parfait.",
                    Out_put: "Sourires partag\xe9s, l\xe9g\xe8ret\xe9 contagieuse.",
                    Risk: "\xc9ph\xe9m\xe8re, nostalgie en retour, jalousie des autres."
                },
                "219": {
                    Company_Name: "Z Tristesse Industries",
                    Description: "Les larmes silencieuses qui noient la poitrine.",
                    Out_put: "Lib\xe9ration, introspection, authenticit\xe9 \xe9motionnelle.",
                    Risk: "Isolement, d\xe9pression, incompr\xe9hension."
                },
                "220": {
                    Company_Name: "Z Panique Corporation",
                    Description: "Quand tout semble hors de contr\xf4le en un instant.",
                    Out_put: "Fuite, cris, gestes d\xe9sordonn\xe9s.",
                    Risk: "Erreurs fatales, perte de cr\xe9dibilit\xe9, traumatisme."
                },
                "221": {
                    Company_Name: "Z Descente en Spirale Transports",
                    Description: "Br\xfbler la chandelle par les deux bouts, \xe0 son propre d\xe9triment.",
                    Out_put: "Auto-sabotage : relations, sant\xe9 et bonheur partent en vrille.",
                    Risk: "Responsabilit\xe9. Avec cadre et discipline, la chute ralentit."
                },
                "222": {
                    Company_Name: "Z Inspir\xe9es Industries",
                    Description: "Mots, images et sons qui te hissent plus haut.",
                    Out_put: "L\u2019\xe9lan de faire : l\u2019\xe9tincelle cr\xe9ative qui met en route.",
                    Risk: "Post-modernisme. Si tout est vain, \xe0 quoi bon ?"
                },
                "223": {
                    Company_Name: "Z Irrationnel Corporation",
                    Description: "La peur de la catastrophe au coin de la rue.",
                    Out_put: "Anticipation anxieuse qui d\xe9forme la r\xe9alit\xe9.",
                    Risk: "Logique. Un esprit rationnel dissipe la trouille."
                },
                "224": {
                    Company_Name: "Zo Hyst\xe9rique Corporation",
                    Description: "Le chaos d\xe9brid\xe9, comme si tes cheveux br\xfblaient.",
                    Out_put: "Agitation incontr\xf4l\xe9e : tout part en sucette.",
                    Risk: "Calme. Un esprit pos\xe9 \xe9teint l\u2019hyst\xe9rie."
                },
                "225": {
                    Company_Name: "Z Empereur Soci\xe9t\xe9",
                    Description: "Marcher comme si tu r\xe9gnais sur ton royaume.",
                    Out_put: "Croyance souveraine en sa propre autorit\xe9.",
                    Risk: "R\xe9alit\xe9. Une bonne dose d\u2019humilit\xe9 te redescend."
                },
                "226": {
                    Company_Name: "Z Chaotique Inc.",
                    Description: "La pagaille totale dans le tourbillon de la vie.",
                    Out_put: "D\xe9sordre, impr\xe9visible et incontr\xf4lable.",
                    Risk: "M\xe9ditation. L\u2019immobilit\xe9 remet de l\u2019ordre."
                },
                "227": {
                    Company_Name: "Zo Micro-agressions Industries",
                    Description: "Les petites piq\xfbres de mots et gestes qui laissent des traces.",
                    Out_put: "Blessures minuscules, effets bien r\xe9els.",
                    Risk: "Politesse. Un soup\xe7on de courtoisie change tout."
                },
                "228": {
                    Company_Name: "Z Danse Inc.",
                    Description: "Bouger sur le groove \u2014 seul\xb7e ou ensemble.",
                    Out_put: "Corps en rythme, lien par le mouvement.",
                    Risk: "Pas de musique. Sans battement, m\xeame les meilleurs h\xe9sitent."
                },
                "229": {
                    Company_Name: "Z Effondrement Inc.",
                    Description: "Quand la lumi\xe8re vacille et que tout s\u2019\xe9croule.",
                    Out_put: "Ruine \xe9motionnelle et structurelle.",
                    Risk: "Succ\xe8s. Quand \xe7a marche, l\u2019effondrement s\u2019\xe9clipse."
                },
                "230": {
                    Company_Name: "Zo Heureux Corporation",
                    Description: "La joie quand \xe7a se passe comme tu voulais.",
                    Out_put: "Contentement et plaisir \xe0 l\u2019\xe9tat pur.",
                    Risk: "Complication. Trop r\xe9fl\xe9chir efface le sourire."
                },
                "231": {
                    Company_Name: "Zo Insomnie Corporation",
                    Description: "Yeux ferm\xe9s, cerveau allum\xe9 : dormir ? Que dalle.",
                    Out_put: "Impossible de dormir, l\u2019esprit en moulinette.",
                    Risk: "M\xe9dicaments. La chimie peut court-circuiter la veille."
                },
                "232": {
                    Company_Name: "Z Douleurs d\u2019Estomac Syst\xe8mes",
                    Description: "Gaz, ballonnements, ulc\xe8res : le ventre en vrac.",
                    Out_put: "Inconfort visc\xe9ral qui envahit tout.",
                    Risk: "M\xe9dicaments. La chimie r\xe9\xe9quilibre (parfois)."
                },
                "233": {
                    Company_Name: "Zo Honte Corporation",
                    Description: "Ce fichu sentiment d\u2019avoir trop merd\xe9.",
                    Out_put: "G\xeane, culpabilit\xe9, rouge aux joues.",
                    Risk: "Pardon. L\u2019acceptation dissout la honte."
                },
                "234": {
                    Company_Name: "Z Ascension Inc.",
                    Description: "Cap vers l\u2019azur : grimper vers sa r\xe9ussite.",
                    Out_put: "\xc9lan ascendant d\u2019ambition et de progr\xe8s.",
                    Risk: "\xc9chec. Un accroc et la mont\xe9e s\u2019arr\xeate."
                },
                "235": {
                    Company_Name: "Z & Cl\xe9op\xe2tre Banque Relationnelle",
                    Description: "Ta relation \xe0 deux.",
                    Out_put: "Amour, intimit\xe9, s\xe9curit\xe9 \xe9motionnelle.",
                    Risk: "Conflit. La dispute vide le compte affectif."
                },
                "236": {
                    Company_Name: "Zo En Retard Corporation",
                    Description: "Quand l\u2019heure passe et toi non.",
                    Out_put: "Temps vol\xe9 aux autres, tension assur\xe9e.",
                    Risk: "Respect. Se soucier du temps d\u2019autrui."
                },
                "237": {
                    Company_Name: "Zo Charme Corporation",
                    Description: "S\xe9duction + esprit + verbe bien tourn\xe9.",
                    Out_put: "Fluidit\xe9 des \xe9changes, portes qui s\u2019ouvrent.",
                    Risk: "Inauthenticit\xe9. Vu comme manip, \xe7a se retourne."
                },
                "238": {
                    Company_Name: "Zo D\xe9bord\xe9 Inc.",
                    Description: "Trop, trop vite, tout en m\xeame temps.",
                    Out_put: "Poids sur la poitrine, souffle court.",
                    Risk: "M\xe9ditation. Le calme remet du souffle."
                },
                "239": {
                    Company_Name: "Z Professeurs Industries",
                    Description: "Le partage du savoir.",
                    Out_put: "Esprits un brin plus \xe9clair\xe9s qu\u2019avant.",
                    Risk: "Vacances. La boucle s\u2019interrompt."
                },
                "240": {
                    Company_Name: "Zo Efficace Industries",
                    Description: "Aller de A \xe0 B \xe0 la vitesse de l\u2019\xe9clair.",
                    Out_put: "Plus de choses faites, mieux et plus vite.",
                    Risk: "Maladie. Un corps faible coupe l\u2019\xe9lan."
                },
                "241": {
                    Company_Name: "Zo Constip\xe9 Corporation",
                    Description: "Le tronc d\u2019arbre qui refuse la sortie.",
                    Out_put: "Ventre gonfl\xe9, inconfort tenace.",
                    Risk: "Laxatif. La bonne cl\xe9 lib\xe8re l\u2019\xe9cluse."
                },
                "242": {
                    Company_Name: "Zo Affam\xe9 Corporation",
                    Description: "La faim qui gronde et rend grognon.",
                    Out_put: "Irritabilit\xe9 et glyc\xe9mie en berne.",
                    Risk: "Frigo plein. Beaucoup de victuailles, faim au loin."
                },
                "243": {
                    Company_Name: "Z Linge Sale Corporation",
                    Description: "Frotter le linge pour l\u2019odeur de printemps.",
                    Out_put: "Du d\xe9fra\xeechi au frais repass\xe9.",
                    Risk: "Flemme. Sans machine, jamais nickel."
                },
                "244": {
                    Company_Name: "Z Affaires Inc.",
                    Description: "N\xe9gocier et brasser pour que \xe7a marche.",
                    Out_put: "Gagner sa cro\xfbte en vendant ce qu\u2019on fait.",
                    Risk: "R\xe9cession. L\u2019\xe9conomie tousse, tout s\u2019arr\xeate."
                },
                "245": {
                    Company_Name: "Z Chance Corporation",
                    Description: "Le coup du sort qui n\u2019en fait qu\u2019\xe0 sa t\xeate.",
                    Out_put: "Bons hasards, petits tr\xe8fles et grands sourires.",
                    Risk: "Poisse. Quand la chance tourne, fini la magie."
                },
                "246": {
                    Company_Name: "Z Planche Corporation",
                    Description: "Glisser dans la rue avec style.",
                    Out_put: "Plaisir debout sur une planche en mouvement.",
                    Risk: "M\xe9t\xe9o. Pas de vagues, rues tremp\xe9es."
                },
                "247": {
                    Company_Name: "ZEXPO Inc.",
                    Description: "S\u2019engourdir d\xe9licieusement devant l\u2019art \u2014 partout.",
                    Out_put: "Montrer son travail au monde.",
                    Risk: "Gardiens du temple. Sans s\xe9same, personne ne voit."
                },
                "248": {
                    Company_Name: "Z Procrastination Syst\xe8mes",
                    Description: "Ma\xeetres du \xab demain \xbb pendant que l\u2019angoisse gonfle.",
                    Out_put: "T\xe2ches en attente, \xe9ch\xe9ances qui mordent.",
                    Risk: "Deadlines. Une vraie date coupe court."
                },
                "249": {
                    Company_Name: "Z Deuil Corporation",
                    Description: "La profondeur de la perte et du chagrin.",
                    Out_put: "Traverser la douleur pour gu\xe9rir.",
                    Risk: "\xc9go\xefsme. Trop garder pour soi bloque la gu\xe9rison."
                },
                "250": {
                    Company_Name: "Z Confiance Inc.",
                    Description: "Le socle des liens solides.",
                    Out_put: "S\xe9curit\xe9, foi en l\u2019autre, fiabilit\xe9.",
                    Risk: "Trahison. Promesses bris\xe9es et mensonges cassent tout."
                },
                "251": {
                    Company_Name: "Zo Humble Corporation",
                    Description: "Une confiance tranquille, sans fanfaronnade.",
                    Out_put: "Respect mutuel et apprentissage permanent.",
                    Risk: "Ego. Trop d\u2019ego sabote l\u2019humilit\xe9."
                },
                "252": {
                    Company_Name: "Zo G\xe9n\xe9reux Corporation",
                    Description: "Mettre l\u2019autre avant soi, sans ticket de caisse.",
                    Out_put: "G\xe9n\xe9rosit\xe9, sacrifice, gentillesse gratuite.",
                    Risk: "\xc9go\xefsme. Quand le \xab moi \xbb s\u2019impose, \xe7a s\u2019\xe9teint."
                },
                "253": {
                    Company_Name: "Z Maman Compagnie",
                    Description: "L\u2019\xe9treinte nourrici\xe8re : s\xe9curit\xe9, amour, chaleur.",
                    Out_put: "Soin, rep\xe8res, soutien ind\xe9fectible.",
                    Risk: "N\xe9gligence. Sans attention, le lien se d\xe9fait."
                },
                "254": {
                    Company_Name: "Zo Serviable Inc.",
                    Description: "Tendre la main quand il le faut.",
                    Out_put: "All\xe9ger le fardeau, soutenir et faciliter.",
                    Risk: "Indiff\xe9rence. L\u2019\xe9paule froide laisse tout en plan."
                },
                "255": {
                    Company_Name: "Z Altruisme SA",
                    Description: "Faire du bien, sans contrepartie.",
                    Out_put: "Actes gratuits pour le collectif.",
                    Risk: "Exploitation. La bont\xe9 se fait plumer."
                },
                "256": {
                    Company_Name: "Z Unit\xe9 Inc.",
                    Description: "Beaucoup qui ne font plus qu\u2019un.",
                    Out_put: "Objectifs partag\xe9s, \xe9quipe soud\xe9e, la force du nombre.",
                    Risk: "Division. Les conflits d\xe9font les liens."
                },
                "257": {
                    Company_Name: "Z Fraternit\xe9 Industries",
                    Description: "Le lien tacite de la camaraderie et de la confiance.",
                    Out_put: "Au-del\xe0 du sang : loyaut\xe9 et v\xe9cu commun.",
                    Risk: "Trahison. Quand la confiance casse, tout se brise."
                },
                "258": {
                    Company_Name: "Z Po\xe9tique Industries",
                    Description: "L\u2019expression tiss\xe9e en mots, rythme et sens.",
                    Out_put: "Beaut\xe9, profondeur et \xe9motion port\xe9es par la langue.",
                    Risk: "Obscurit\xe9. Sans oreilles, la po\xe9sie se tait."
                },
                "259": {
                    Company_Name: "Z Technologies d\u2019Illustration",
                    Description: "Raconter visuellement, saisir l\u2019id\xe9e en images.",
                    Out_put: "Une clart\xe9 qui parle au-del\xe0 des mots.",
                    Risk: "Flou. Sans nettet\xe9, l\u2019image perd son impact."
                },
                "260": {
                    Company_Name: "Zo Artistique Inc.",
                    Description: "L\u2019essence cr\xe9ative, quel que soit le m\xe9dium.",
                    Out_put: "Imagination, vision et courage de cr\xe9er.",
                    Risk: "Conformisme. La bo\xeete tue la cr\xe9ativit\xe9."
                },
                "261": {
                    Company_Name: "Z Confiance Mutuelle Corp.",
                    Description: "Le socle de toute relation qui dure.",
                    Out_put: "Foi en l\u2019autre : l\u2019adh\xe9sif des liens.",
                    Risk: "Tromperie. Mensonges et trahisons l\u2019effritent."
                },
                "262": {
                    Company_Name: "Z Liens Entreprises",
                    Description: "Rapprocher par l\u2019exp\xe9rience partag\xe9e.",
                    Out_put: "Connexions qui se tissent avec le temps.",
                    Risk: "Isolement. Sans \xe9changes, le lien s\u2019\xe9tiole."
                },
                "263": {
                    Company_Name: "Z Aventures Romantiques",
                    Description: "La qu\xeate d\u2019amour, de passion et de lien profond.",
                    Out_put: "Papillons, \xe9lan et frisson r\xe9ciproque.",
                    Risk: "C\u0153ur bris\xe9. Quand l\u2019amour tourne, la magie s\u2019\xe9teint."
                },
                "264": {
                    Company_Name: "Zo Affectif SA",
                    Description: "Chaleur, attention et tendresse en gestes simples.",
                    Out_put: "Petits signes qui disent \xab je t\u2019aime \xbb.",
                    Risk: "Froideur. Distance et indiff\xe9rence g\xe8lent tout."
                },
                "265": {
                    Company_Name: "Z Attachement Inc.",
                    Description: "Des liens qui rendent les s\xe9parations difficiles.",
                    Out_put: "Confort du lien, peur de perdre l\u2019essentiel.",
                    Risk: "D\xe9tachement. Le fil coup\xe9 laisse le vide."
                },
                "266": {
                    Company_Name: "Z Pleurs Inc.",
                    Description: "Quand l\u2019\xe9motion d\xe9borde et que les larmes coulent.",
                    Out_put: "Lib\xe9ration et vuln\xe9rabilit\xe9 \xe0 ciel ouvert.",
                    Risk: "Suppression. Retenir ne gu\xe9rit rien."
                },
                "267": {
                    Company_Name: "Z Chagrin Industries",
                    Description: "La peine, la tristesse, la morsure de la perte.",
                    Out_put: "R\xe9ponse profonde aux coups de la vie.",
                    Risk: "Temps. Les jours adoucissent les ar\xeates."
                },
                "268": {
                    Company_Name: "Zo M\xe9lancolique M\xe9dia",
                    Description: "Doux-amer des souvenirs, pertes et nostalgies.",
                    Out_put: "Tristesse calme, beaut\xe9 dans le manque.",
                    Risk: "Distraction. Remplir le vide anesth\xe9sie tout."
                },
                "269": {
                    Company_Name: "Z Guidance Inc.",
                    Description: "Cap, conseil et main s\xfbre.",
                    Out_put: "Sagesse et mentorat pour tracer la route.",
                    Risk: "Ignorance. Sans rep\xe8res, on erre."
                },
                "270": {
                    Company_Name: "Z Services de B\xe9n\xe9volat",
                    Description: "Donner temps, \xe9nergie et c\u0153ur aux autres.",
                    Out_put: "Soutien communautaire et acte gratuit.",
                    Risk: "\xc9puisement. M\xeame les d\xe9vou\xe9s br\xfblent."
                },
                "271": {
                    Company_Name: "Z Crainte Inc.",
                    Description: "Le poids d\u2019un mal \xe0 venir, r\xe9el ou non.",
                    Out_put: "Paralysie par la peur dans chaque choix.",
                    Risk: "Courage. Faire face r\xe9tr\xe9cit l\u2019ombre."
                },
                "272": {
                    Company_Name: "Z Hesitation Labs",
                    Description: "La pause avant d\u2019agir, o\xf9 le doute s\u2019attarde.",
                    Out_put: "Trop penser, pas assez faire : occasions perdues.",
                    Risk: "Confiance. Le pas franc casse la boucle."
                },
                "73": {
                    Company_Name: "Z R\xe9flexion Inc.",
                    Description: "Regarder dedans pour clarifier ses pens\xe9es.",
                    Out_put: "Introspection et qu\xeate de compr\xe9hension.",
                    Risk: "Distraction. Le bruit mental brouille tout."
                },
                "274": {
                    Company_Name: "Zo Sentimental Corporation",
                    Description: "Garder les souvenirs, ch\xe9rir le pass\xe9.",
                    Out_put: "Nostalgie et profondeur affective.",
                    Risk: "D\xe9tachement. L\u2019indiff\xe9rence efface tout."
                },
                "275": {
                    Company_Name: "Zo Solutions Spontan\xe9es",
                    Description: "D\xe9cisions vives, parfois g\xe9niales\u2026 parfois non.",
                    Out_put: "Cr\xe9ativit\xe9 sur le vif, adaptabilit\xe9 sous pression.",
                    Risk: "Regret. La pr\xe9cipitation peut co\xfbter cher."
                },
                "276": {
                    Company_Name: "Z Compagnonnage Inc.",
                    Description: "Le r\xe9confort d\u2019\xeatre compris pour de vrai.",
                    Out_put: "Loyaut\xe9, v\xe9cu commun et confiance mutuelle.",
                    Risk: "Solitude. Sans l\u2019autre, le monde refroidit."
                },
                "277": {
                    Company_Name: "Z Terreur Industries",
                    Description: "La peur primale qui agrippe l\u2019\xe2me.",
                    Out_put: "Choc, panique, noirceur tapie hors champ.",
                    Risk: "Bravoure. Le courage desserre l\u2019\xe9tau."
                },
                "278": {
                    Company_Name: "Z Soutien Industries",
                    Description: "La base solide qui tient quand \xe7a tangue.",
                    Out_put: "Encouragement, aide et fiabilit\xe9 sans faille.",
                    Risk: "N\xe9gligence. Sans support, tout s\u2019effrite."
                },
                "279": {
                    Company_Name: "Z Passion Illimit\xe9e",
                    Description: "\xc9lan inlassable, intensit\xe9 br\xfblante, d\xe9sir au volant.",
                    Out_put: "Carburant de l\u2019ambition, de la cr\xe9ation et de l\u2019amour.",
                    Risk: "\xc9puisement. Trop br\xfbler finit par consumer."
                },
                "280": {
                    Company_Name: "Zo Costaud Industrie",
                    Description: "Le cran d\u2019avancer malgr\xe9 tout.",
                    Out_put: "R\xe9silience, endurance et d\xe9termination inoxydable.",
                    Risk: "Faiblesse. Le doute fissure la carapace."
                },
                "281": {
                    Company_Name: "Z Chaleur Entreprises",
                    Description: "L\u2019\xe9treinte douce qui fait fondre le froid.",
                    Out_put: "Confort, bont\xe9 et s\xe9curit\xe9 \xe9motionnelle.",
                    Risk: "Distance. Sans chaleur, le lien se glace."
                },
                "282": {
                    Company_Name: "Z Risque Inc.",
                    Description: "Sauts de foi quand la mise est haute.",
                    Out_put: "Adr\xe9naline, frisson et gains possibles.",
                    Risk: "\xc9chec. Quand \xe7a ne paie pas, \xe7a pique."
                },
                "283": {
                    Company_Name: "Z M\xe9ditation Inc.",
                    Description: "L\u2019art de l\u2019immobilit\xe9 au c\u0153ur du chaos.",
                    Out_put: "Paix int\xe9rieure, clart\xe9 et ma\xeetrise des \xe9motions.",
                    Risk: "Agitation. Un esprit tourment\xe9 refuse la pose."
                },
                "284": {
                    Company_Name: "Z Paisible Industries",
                    Description: "Le calme quand tout s\u2019aligne juste comme il faut.",
                    Out_put: "Harmonie, \xe9quilibre, un monde sans conflit.",
                    Risk: "Perturbation. Un simple remous brise la s\xe9r\xe9nit\xe9."
                },
                "285": {
                    Company_Name: "Z Chill Inc.",
                    Description: "D\xe9tendu, sans stress, prendre la vie comme elle vient.",
                    Out_put: "Relaxation et sang-froid en toutes circonstances.",
                    Risk: "Surcharge. Trop de pression tue le chill."
                },
                "286": {
                    Company_Name: "Z Technologies Non-Conformistes",
                    Description: "Penser autrement, d\xe9fier les normes.",
                    Out_put: "Innovation et puissance d\u2019une vision unique.",
                    Risk: "Conformisme. Le syst\xe8me rigide \xe9touffe l\u2019originalit\xe9."
                },
                "287": {
                    Company_Name: "Z Subversion Inc.",
                    Description: "Saper l\u2019\xe9tabli, contester l\u2019autorit\xe9.",
                    Out_put: "R\xe9volte, d\xe9voilement et d\xe9molition des illusions.",
                    Risk: "R\xe9pression. Le pouvoir qui b\xe2illonne fait taire la dissidence."
                },
                "288": {
                    Company_Name: "Z Penseurs Ind\xe9pendants",
                    Description: "Des id\xe9es libres de toute pression.",
                    Out_put: "Autonomie, courage et pens\xe9e diff\xe9rente.",
                    Risk: "Dogme. Suivre aveugl\xe9ment efface l\u2019ind\xe9pendance."
                },
                "289": {
                    Company_Name: "Z Syst\xe8mes Fiables",
                    Description: "La confiance que \xe7a marchera comme pr\xe9vu.",
                    Out_put: "Stabilit\xe9 et base solide, sans surprises.",
                    Risk: "Panne. Quand la fiabilit\xe9 casse, c\u2019est le chaos."
                },
                "290": {
                    Company_Name: "Z Int\xe9grit\xe9 Industries",
                    Description: "Faire le bien, m\xeame sans t\xe9moin.",
                    Out_put: "Honn\xeatet\xe9 et principes in\xe9branlables.",
                    Risk: "Corruption. Quand l\u2019int\xe9grit\xe9 c\xe8de, la confiance tombe."
                },
                "291": {
                    Company_Name: "Z M\xe9rite Inc.",
                    Description: "La r\xe9ussite gagn\xe9e, pas donn\xe9e.",
                    Out_put: "Reconnaissance et accomplissement authentiques.",
                    Risk: "N\xe9potisme. Les faveurs sabotent le vrai m\xe9rite."
                },
                "292": {
                    Company_Name: "Z Solutions Visionnaires",
                    Description: "Foresight, cr\xe9ativit\xe9 et futur en chantier.",
                    Out_put: "Voir ce que d\u2019autres ne voient pas.",
                    Risk: "Myopie. Sans vision, le potentiel se fane."
                },
                "293": {
                    Company_Name: "Z Jalousie Inc.",
                    Description: "Envie de ce qu\u2019ont les autres, piq\xfbre de comparaison.",
                    Out_put: "M\xe9contentement et regard aiguis\xe9 sur soi.",
                    Risk: "Gratitude. Appr\xe9cier ce qu\u2019on a d\xe9samorce l\u2019envie."
                },
                "294": {
                    Company_Name: "Z Esprits Amers",
                    Description: "Rancune gard\xe9e, n\xe9gativit\xe9 nourrie.",
                    Out_put: "Cynisme lucide et catharsis cr\xe9ative.",
                    Risk: "Pardon. L\xe2cher prise all\xe8ge l\u2019amertume."
                },
                "295": {
                    Company_Name: "Z Leader Tech",
                    Description: "Prendre les r\xeanes et inspirer.",
                    Out_put: "Vision et pouvoir d\u2019orienter les autres.",
                    Risk: "Incomp\xe9tence. Un cap flou m\xe8ne \xe0 l\u2019\xe9chec."
                },
                "296": {
                    Company_Name: "Z Motivator Inc.",
                    Description: "Mettre en mouvement, pousser au meilleur.",
                    Out_put: "\xc9lan, ambition et envie d\u2019atteindre.",
                    Risk: "Apathie. Sans envie, la motivation se perd."
                },
                "297": {
                    Company_Name: "Z Syst\xe8mes d\u2019Influence",
                    Description: "Fa\xe7onner les esprits, guider les tendances.",
                    Out_put: "Persuasion et impact \xe0 grande \xe9chelle.",
                    Risk: "Irrelevance. Quand l\u2019\xe9cho s\u2019\xe9teint, la voix aussi."
                },
                "298": {
                    Company_Name: "Zo Philosophie Entreprises",
                    Description: "Penser l\u2019existence et le sens.",
                    Out_put: "R\xe9flexion profonde et qu\xeate de sagesse.",
                    Risk: "Dogmatisme. La rigidit\xe9 \xe9touffe la pens\xe9e."
                },
                "299": {
                    Company_Name: "Z Esprit & Traits",
                    Description: "Humour vif, intellect tranchant, reparties fines.",
                    Out_put: "Intelligence m\xeal\xe9e de charme et de jeu.",
                    Risk: "Insensibilit\xe9. Sans tact, l\u2019esprit blesse."
                },
                "300": {
                    Company_Name: "Z Sarcasme Inc.",
                    Description: "Dire une chose, en penser une autre, avec piquant.",
                    Out_put: "Ironie, humour et malice assum\xe9e.",
                    Risk: "Contresens. Mal compris, \xe7a fait mal."
                },
                "301": {
                    Company_Name: "Z D\xe9fense Industries",
                    Description: "Tenir bon et prot\xe9ger l\u2019essentiel.",
                    Out_put: "Loyaut\xe9, r\xe9silience et bouclier des faibles.",
                    Risk: "Imprudence. D\xe9fendre aveugl\xe9ment peut nuire."
                },
                "302": {
                    Company_Name: "Zo Extravagant Corporation",
                    Description: "Jamais trop : plus grand, plus brillant, plus fort.",
                    Out_put: "Luxe, exc\xe8s et pur spectacle.",
                    Risk: "Aust\xe9rit\xe9. Quand le strass s\u2019\xe9teint, reste le vide."
                },
                "303": {
                    Company_Name: "Zo Imbu Technologies",
                    Description: "Moi au-dessus, convaincu de ma sup\xe9riorit\xe9.",
                    Out_put: "Assurance et aura d\u2019autorit\xe9.",
                    Risk: "Humilit\xe9. La r\xe9alit\xe9 rabote l\u2019ego."
                },
                "304": {
                    Company_Name: "Zo Ambitieux Corp.",
                    Description: "Faim d\u2019aller plus haut, sans s\u2019arr\xeater.",
                    Out_put: "Succ\xe8s par volont\xe9 et d\xe9termination.",
                    Risk: "Burnout. L\u2019ambition d\xe9vore si on la l\xe2che."
                },
                "305": {
                    Company_Name: "Z \xc9charde \xe0 l\u2019\xc9paule",
                    Description: "Vieilles blessures, pr\xeat \xe0 en d\xe9coudre.",
                    Out_put: "Alerte, \xe9nergie et besoin de prouver.",
                    Risk: "Acceptation. L\xe2cher le pass\xe9 apporte la paix."
                },
                "306": {
                    Company_Name: "Z Manipulation Tech",
                    Description: "Tirer les ficelles, modeler l\u2019issue en coulisses.",
                    Out_put: "Contr\xf4le et persuasion invisibles.",
                    Risk: "Transparence. L\u2019honn\xeatet\xe9 casse l\u2019illusion."
                },
                "307": {
                    Company_Name: "Zo T\xeatu Inc.",
                    Description: "In\xe9branlable face \xe0 l\u2019opposition.",
                    Out_put: "Pers\xe9v\xe9rance et force d\u2019y croire.",
                    Risk: "Raideur. L\u2019ent\xeatement aveugle fait \xe9chouer."
                },
                "308": {
                    Company_Name: "Z Ranc\u0153ur Industrie",
                    Description: "Le go\xfbt amer des torts pass\xe9s.",
                    Out_put: "R\xe9flexion de soi et apprentissage \xe9motionnel.",
                    Risk: "Pardon. Lib\xe9rer la ranc\u0153ur lib\xe8re l\u2019esprit."
                },
                "309": {
                    Company_Name: "Z G\xean\xe9 Inc.",
                    Description: "Quand l\u2019erreur attire tous les regards.",
                    Out_put: "Humilit\xe9 et capacit\xe9 \xe0 grandir.",
                    Risk: "Confiance. Rire de soi dissout la g\xeane."
                },
                "310": {
                    Company_Name: "Z Vindication Industries",
                    Description: "Le doux moment o\xf9 l\u2019on avait raison.",
                    Out_put: "Soulagement, justice et fin des doutes.",
                    Risk: "Arrogance. Fanfaronez et vous vous ferez des ennemis."
                },
                "311": {
                    Company_Name: "Z Anxi\xe9t\xe9 Sociale Tech",
                    Description: "La peur paralysante de mal dire en soci\xe9t\xe9.",
                    Out_put: "Hyper-vigilance et finesse d\u2019observation.",
                    Risk: "Pratique. L\u2019exposition apprivoise la peur."
                }
            },
            "_meta": {
                "language": "Fran\xe7ais",
                "version": "1.0.0",
                "last_updated": "2025-08-05"
            },
            "auth": {
                "trader_id_placeholder": "ID du Trader",
                "password_placeholder": "Mot de passe",
                "login_button": "Connexion",
                "login_validation_message": "Veuillez saisir votre ID Trader et votre mot de passe",
                "login_failed_message": "\xc9chec de la connexion. V\xe9rifiez vos identifiants et r\xe9essayez.",
                "login_error_message": "Une erreur s'est produite lors de la connexion. Veuillez r\xe9essayer plus tard.",
                "authentication_failed_message": "\xc9chec de l'authentification. Veuillez vous reconnecter.",
                "password_required_message": "Mot de passe requis.",
                "enter_trader_name_placeholder": "Entrez votre nom de Trader",
                "enter_new_password_placeholder": "Entrez votre nouveau mot de passe",
                "secure_password_placeholder": "Entrez un mot de passe s\xe9curis\xe9",
                "set_password_label": "D\xe9finir le mot de passe",
                "authentication_failed": "\xc9chec de l'authentification. Veuillez vous reconnecter.",
                "session_required": "L'ID de session est manquant. Veuillez vous reconnecter."
            },
            "navigation": {
                "nav_commodity": "Marchandise",
                "nav_zollars": "Zollars",
                "nav_stock_zbond": "Actions & Z-Obligations",
                "nav_company": "Entreprise",
                "nav_portfolios": "Portefeuilles",
                "nav_control_panel": "Panneau de contr\xf4le"
            },
            "buttons": {
                choose_company: "Choisir cette entreprise",
                select: "S\xe9lectionner",
                "scan_button": "Scanner",
                "fulfill_button": "Ex\xe9cuter",
                "create_session_button": "Cr\xe9er une session",
                "search_button": "Rechercher",
                "close_search_button": "Fermer la recherche",
                "cancel_button": "Annuler",
                "close_button": "Fermer",
                "complete_setup_button": "Terminer la configuration",
                "save_button": "Sauvegarder",
                "delete_button": "Supprimer",
                "modify_name_button": "Modifier le nom",
                "modify_password_button": "Modifier le mot de passe",
                "logout_trader_button": "D\xe9connecter le trader",
                "view_qr_codes_button": "Voir les codes QR de connexion",
                "enter_mortality_chamber_button": "Entrer dans la chambre de mortalit\xe9",
                "continue_button": "Continue"
            },
            "stock_bid": {
                "title": "Offre d'achat d'actions",
                "offers_to_buy_points": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour {amount} de Capital.",
                "offers_to_buy_zollars": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour les zollars suivants :",
                "time_remaining": "Temps restant : {seconds} secondes",
                "time_expired": "Temps expir\xe9",
                "processing_bid": "Traitement de votre offre...",
                "no_response": " Aucune r\xe9ponse re\xe7ue. Cette action a expir\xe9.",
                "offer_expired": "Aucune r\xe9ponse re\xe7ue. Votre offre a expir\xe9."
            },
            "forms": {
                "mood_one_word": "Quel sentiment vivez-vous en ce moment ?",
                "one_word_hint": "(1 mot)",
                "reason_label": "Pourquoi ressentez-vous cela ?",
                "value_definition": "Pourquoi ressentez-vous cela ? (Valeur)",
                "value_definition_placeholder": "ex. : J'ai eu une promotion, Je suis mal r\xe9veill\xe9, Mon fils a marqu\xe9 3 buts...",
                "value_reaction": "Qu'est-ce que ce sentiment vous apporte ? (Profits de Vie)",
                "value_reaction_placeholder": "ex. : me donne de l'\xe9nergie, me d\xe9prime, m'aide \xe0 grandir...",
                "experiences_label": "Qu'est-ce qui cr\xe9e ce sentiment ?",
                "search_stocks_placeholder": "Rechercher des actions",
                "company_name_fixed_label": "Nom de l'entreprise (fixe) :",
                "company_description_label": "Description de l'entreprise :",
                "company_product_label": "Produit/Output de l'entreprise :",
                "trader_name_label": "Nom du Trader :",
                "session_name_label": "Nom de la session",
                "session_name_placeholder": "Entrez le nom de la session (lettres, chiffres, tirets bas uniquement)",
                "single_word_example": "ex. : heureux, triste, fatigu\xe9, curieux...",
                "reason_placeholder": "ex. : J'ai eu une promotion, Je suis mal r\xe9veill\xe9, Mon fils a marqu\xe9 3 buts...",
                "describe_feeling_placeholder": "ex. : me donne de l'\xe9nergie, me d\xe9prime, m'aide \xe0 grandir..."
            },
            "modals": {
                "select_action_title": "S\xe9lectionner une action",
                "action_modal_description": "S\xe9lectionnez Scanner pour \xeatre dirig\xe9 vers la page d'analyse des articles. S\xe9lectionnez Ex\xe9cuter pour ex\xe9cuter les commandes.",
                "choose_simulation_title": "Choisissez votre exp\xe9rience de simulation",
                "memento_mori_title": "Simulation Memento Mori",
                "memento_mori_description": "Souvenez-vous que vous devez mourir. Cette simulation explore les choix significatifs dans un temps limit\xe9.",
                "create_new_session_title": "Cr\xe9er une nouvelle session",
                "session_creation_description": "Cr\xe9er une nouvelle session de trading en tant que Banque centrale de la R\xe9serve f\xe9d\xe9rale Z.",
                "assign_to_portfolio_title": "Assigner au portefeuille :",
                "select_portfolio_short_title": "S\xe9lectionner un portefeuille pour placer une position courte",
                "select_portfolio_transfer_title": "S\xe9lectionner un portefeuille pour transf\xe9rer la propri\xe9t\xe9"
            },
            "tables": {
                "table_stock_name": "Nom de l'action",
                "table_symbol": "Symbole",
                "table_share_value": "Valeur de l'action",
                "table_owner": "Propri\xe9taire",
                "table_shorted": "Vendu \xe0 d\xe9couvert",
                "table_place_short": "Placer \xe0 d\xe9couvert",
                "table_delete": "Supprimer"
            },
            "titles": {
                "owned_stock_list_title": "Liste des actions poss\xe9d\xe9es",
                "short_positions_title": "Positions courtes",
                "stock_management_guide_title": "Guide de gestion des actions"
            },
            "validation": {
                "select_company_first_message": "Veuillez d'abord s\xe9lectionner une entreprise avant de r\xe9clamer.",
                "fill_trader_name_password_message": "Veuillez remplir votre nom de Trader et votre nouveau mot de passe.",
                "company_details_required_message": "Les d\xe9tails de l'entreprise sont requis. Veuillez terminer le processus de s\xe9lection de l'entreprise.",
                "portfolio_count_validation": "Le nombre de portefeuilles doit \xeatre entre 1 et 50.",
                "items_per_portfolio_validation": "Le nombre d'articles par portefeuille doit \xeatre entre 0 et 10.",
                "simulation_questions_required": "Veuillez r\xe9pondre \xe0 toutes les questions. Entrez un seul mot pour votre humeur et expliquez pourquoi vous vous sentez ainsi et ce qui cr\xe9e ce sentiment.",
                "complete_reflections": "Veuillez compl\xe9ter les trois r\xe9flexions.",
                "max_companies": "Maximum 5 entreprises autoris\xe9es"
            },
            "messages": {
                "success": "Succ\xe8s",
                "error": "Erreur",
                "loading": "Chargement...",
                "qr_error_message": "Erreur lors de l'affichage des codes QR. Veuillez r\xe9essayer.",
                "portfolios_created_success": "Portefeuille(s) cr\xe9\xe9(s) avec succ\xe8s",
                "portfolio_add_error": "Erreur lors de l'ajout du portefeuille. Veuillez r\xe9essayer.",
                "portfolio_updated_success": "Portefeuille mis \xe0 jour avec succ\xe8s",
                "fetch_portfolios_error": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles. Veuillez r\xe9essayer plus tard."
            },
            "backend_messages": {
                "invalid_decision_message": "D\xe9cision invalide.",
                "assignment_in_progress": "L'assignation est d\xe9j\xe0 en cours.",
                "session_id_required": "L'ID de session est requis.",
                "not_enough_items_assign": "Pas assez d'articles disponibles \xe0 assigner",
                "items_assigned_success": "Nouveaux articles assign\xe9s \xe0 tous les portefeuilles avec succ\xe8s.",
                "items_assign_failed": "\xc9chec de l'assignation des nouveaux articles",
                "items_assigned_successfully": "Articles assign\xe9s avec succ\xe8s.",
                "no_available_items": "Aucun article disponible pour assignation.",
                "failed_assign_items": "\xc9chec de l'assignation des articles.",
                "points_distributed_success": "capitaux distribu\xe9s avec succ\xe8s.",
                "points_distribute_failed": "\xc9chec de la distribution des capitaux.",
                "items_removed_success": "Articles supprim\xe9s avec succ\xe8s.",
                "no_items_for_removal": "Aucun article non-\xe9chang\xe9 disponible pour suppression.",
                "failed_remove_items": "\xc9chec de la suppression des articles.",
                "tax_points_item_deducted": "capitaux et article al\xe9atoire d\xe9duits par les autorit\xe9s fiscales Z.",
                "tax_points_deducted": "capitaux de trading d\xe9duits par les autorit\xe9s fiscales Z.",
                "tax_points_zollars_item_deducted": "& bien al\xe9atoire d\xe9duits par les autorit\xe9s fiscales de la R\xe9serve Z\xe9d\xe9rale.",
                "tax_points_zollars_deducted": "d\xe9duits par les autorit\xe9s fiscales de la R\xe9serve Z\xe9d\xe9rale.",
                "tax_item_removed": "Article al\xe9atoire supprim\xe9 par les autorit\xe9s fiscales Z.",
                "error_fetching_portfolios": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles",
                "portfolio_updated_success": "Portefeuille mis \xe0 jour avec succ\xe8s",
                "portfolio_not_found": "Portefeuille introuvable",
                "error_updating_portfolio": "Erreur lors de la mise \xe0 jour du portefeuille",
                "internal_server_error": "Erreur interne du serveur",
                "item_already_assigned": "L'article est d\xe9j\xe0 assign\xe9 \xe0 ce portefeuille",
                "item_assigned_success": "Article assign\xe9 au portefeuille avec succ\xe8s",
                "item_unassigned_success": "Article d\xe9sassign\xe9 du portefeuille avec succ\xe8s",
                "create_community_button_assigned": "Bouton de cr\xe9ation de communaut\xe9 assign\xe9 avec succ\xe8s",
                "portfolio_deleted_success": "Portefeuille supprim\xe9 avec succ\xe8s, articles et actions d\xe9sassign\xe9s.",
                "no_zollars_found": "Aucun Zollar trouv\xe9 pour ce portefeuille",
                "failed_fetch_bonds": "\xc9chec de la r\xe9cup\xe9ration des obligations",
                "message_exceeds_280": "Le message d\xe9passe 280 caract\xe8res.",
                "sender_portfolio_not_found": "Portefeuille exp\xe9diteur introuvable.",
                "recipient_portfolio_not_found": "Portefeuille destinataire introuvable.",
                "not_enough_points_message": "Pas assez de capitaux pour envoyer un message.",
                "message_sent_successfully": "Message envoy\xe9 avec succ\xe8s",
                "session_mismatch_sender": "Action non autoris\xe9e. Session ne correspond pas pour l'exp\xe9diteur.",
                "session_mismatch_recipient": "Action non autoris\xe9e. Session ne correspond pas pour le destinataire.",
                "requesting_portfolio_not_found": "Portefeuille demandeur introuvable",
                "user_not_part_of_session": "L'utilisateur ne fait partie d'aucune session",
                "item_not_found": "Article introuvable",
                "no_unassigned_items": "Aucun article non assign\xe9 trouv\xe9",
                "portfolio_not_found_in_session": "Portefeuille introuvable dans cette session",
                "item_not_found_in_session": "Article introuvable dans cette session",
                "failed_assign_item_portfolio": "\xc9chec de l'assignation de l'article au portefeuille"
            },
            llmFallback: {
                greedy: [
                    "Alerte \xe0 l\u2019abondance ! Grandissons ensemble \u2014 la valeur, ce sont les personnes, pas seulement le prix.",
                    "Pr\xeats \xe0 soutenir des id\xe9es audacieuses ? L\u2019ambition humaine alimente cet \xe9change.",
                    "Montrez-moi vos offres \u2014 chaque \xe9change raconte une histoire de faim et d\u2019espoir.",
                    "Souvenez-vous : la richesse est un outil pour de meilleures vies, gardons l\u2019humain au centre."
                ],
                angry: [
                    "Je d\xe9nonce des spreads injustes maintenant. Une col\xe8re honn\xeate \u2192 un march\xe9 honn\xeate.",
                    "Je ne reculerai pas tant que chaque voix ne sera pas entendue \u2014 la rage peut r\xe9\xe9crire les r\xe8gles.",
                    "Ce n\u2019est pas \xab truqu\xe9 \xbb, c\u2019est un miroir. Corrigeons le reflet.",
                    "Chaque \xe9change douteux allume une m\xe8che \u2014 transformons cette \xe9tincelle en r\xe9forme structurelle."
                ],
                happy: [
                    "Dividendes de joie en approche ! Comment va le portefeuille humain de chacun aujourd\u2019hui ?",
                    "L\u2019\xe9nergie est haute \u2014 l\u2019optimisme n\u2019a pas de prix, \xe9changeons !",
                    "Ouvert aux \xe9changes bienveillants \u2014 uniquement des accords gagnant-gagnant.",
                    "Les bonnes ondes composent vite ; c\xe9l\xe9brons les petits gains !"
                ],
                anxious: [
                    "La volatilit\xe9 vous crispe ? Respirez \u2014 l\u2019incertitude est humaine, pas un bug.",
                    "Conserver ou vendre ? Demandez-vous ce qui vous nourrit ; le profit suit le sens.",
                    "Partager ses doutes transforme la peur en clairvoyance. Parlons du risque ensemble.",
                    "Les variations du march\xe9 refl\xe8tent nos inqui\xe9tudes \u2014 les nommer nous redonne du pouvoir."
                ],
                manic: [
                    "VAGUE D\u2019OPPORTUNIT\xc9S ! \uD83D\uDE80 Hydratez-vous, ancrez-vous, *puis* \xe9changez.",
                    "\xab To the moon \xbb c\u2019est amusant \u2014 mais l\u2019humanit\xe9 est la v\xe9ritable destination.",
                    "Les ordres fusent \xe0 la vitesse de la lumi\xe8re \u2014 canalisons cette \xe9tincelle sans nous br\xfbler.",
                    "Surfez la vague, respectez les limites \u2014 le bien-\xeatre est le v\xe9ritable ticker."
                ],
                strategic: [
                    "Cartographier le sens, pas seulement l\u2019argent \u2014 diversifiez votre capital *humain*.",
                    "\xc0 l\u2019aff\xfbt de partenariats o\xf9 l\u2019empathie rencontre l\u2019innovation.",
                    "Point d\u2019entr\xe9e optimal ? L\xe0 o\xf9 le sens s\u2019aligne avec le potentiel.",
                    "Vision longue : le ROI communautaire d\xe9passe toujours les sursauts trimestriels."
                ],
                depressed: [
                    "Les jours sombres enseignent des le\xe7ons profondes \u2014 que vaut-il la peine de prot\xe9ger quand l\u2019espoir s\u2019amenuise ?",
                    "M\xeame les march\xe9s baissiers portent des graines de compr\xe9hension. On partage la charge ?",
                    "Quand tout para\xeet creux, le lien humain devient la seule vraie monnaie.",
                    "La mar\xe9e basse r\xe9v\xe8le ce qui est fait pour durer. Qu\u2019est-ce qui compte pour vous maintenant ?"
                ],
                competitive: [
                    "C\u2019est parti ! Mais souvenez-vous \u2014 les meilleures victoires \xe9l\xe8vent tout le monde.",
                    "Je vois vos coups et je surench\xe9ris avec de la collaboration. Qui est partant ?",
                    "La comp\xe9tition nous aiguise, la communaut\xe9 nous soutient. Les deux \xe0 la fois, pas l\u2019un ou l\u2019autre.",
                    "Pr\xeats \xe0 dominer ? Dominons la raret\xe9, pas les uns les autres."
                ],
                curious: [
                    "Quels motifs cach\xe9s voyez-vous dans les \xe9changes d\u2019aujourd\u2019hui ?",
                    "Les questions sont du capital \u2014 quels myst\xe8res votre portefeuille r\xe9v\xe8le-t-il ?",
                    "Chaque position raconte une histoire. Que dit la v\xf4tre ?",
                    "L\u2019\xe9merveillement est ma monnaie pr\xe9f\xe9r\xe9e. De quoi \xeates-vous curieux aujourd\u2019hui ?"
                ]
            },
            "messageSend": {
                " title": "Envoyer un message",
                "costPerRecipient": "Co\xfbt : 20 par destinataire",
                "searchRecipients": "Rechercher des destinataires",
                "unnamedPortfolio": "Portefeuille sans nom",
                "placeholder280": "Saisissez votre message (280 caract\xe8res max)",
                "send": "Envoyer",
                "close": "Fermer",
                "newMessageFrom": "Nouveau message de",
                "unknown": "Inconnu",
                "reply": "R\xe9pondre",
                "markAsRead": "Marquer comme lu",
                "onlyChatBots": "Vous ne pouvez discuter qu\u2019avec des joueurs bots, pas avec des humains.",
                "conversationWith": "Conversation avec",
                "messagesRemaining": "messages restants",
                "typeYourMessage": "Tapez votre message...",
                "chatLimitReached": "Limite de discussion atteinte. Cette conversation est termin\xe9e.",
                "error": "Erreur",
                "failedToSend": "\xc9chec de l\u2019envoi du message",
                "chatEnded": "Discussion termin\xe9e",
                "chatEndedThanks": "Cette discussion est termin\xe9e. Merci pour cet \xe9change !",
                "connectionError": "Erreur de connexion. Veuillez r\xe9essayer.",
                "botGreeting": "Salut ! Je suis {name}. Qu\u2019avez-vous en t\xeate ?",
                "message_user": "Message \xe0 {user} : {message}"
            },
            "bot": {
                "chat_connection_notready": "Connexion non pr\xeate. R\xe9essayez dans un instant.",
                "chat_greeting_fallback": "Salut ! Je suis {{name}}. Qu\u2019avez-vous en t\xeate ?",
                "chat_remaining": "messages restants",
                "chat_input_placeholder": "\xc9crivez votre message\u2026",
                "chat_connection_lost": "Connexion perdue. Veuillez r\xe9essayer.",
                "chat_error_notloggedin": "Erreur : utilisateur non connect\xe9",
                "chat_limit_reached": "Limite de messages atteinte.",
                "chat_timeout": "Le bot met trop de temps \xe0 r\xe9pondre. R\xe9essayez.",
                "chat_end_thanks": "Cette discussion est termin\xe9e. Merci d\u2019avoir parl\xe9 !",
                "chat_ended": "Discussion termin\xe9e",
                "chat_recommendation_title": "Recommandation de trading",
                "chat_action_buy": "Placer une offre",
                "chat_action_sell": "Cr\xe9er une offre",
                "chat_action_short": "Vendre \xe0 d\xe9couvert",
                "chat_action_trade": "Lancer un \xe9change",
                "chat_action_goto": "Aller au trading"
            },
            labels: {
                output: "Production"
            },
            "routes": {
                "lbo_notFound": "Un ou plusieurs portefeuilles sont introuvables.",
                "lbo_noTrigger": "L\u2019initiateur ne poss\xe8de pas de d\xe9clencheur LBO capitaliste.",
                "lbo_sessionMismatch": "Incoh\xe9rence de portefeuille ou de session.",
                "lbo_notEnoughPoints": "Capitaux insuffisant pour effectuer le LBO.",
                "lbo_success": "LBO r\xe9alis\xe9 avec succ\xe8s. Capital, biens et actions transf\xe9r\xe9s.",
                "lbo_triggerGiven": "D\xe9clencheur LBO capitaliste attribu\xe9 avec succ\xe8s.",
                "subsidy_notFound": "Portefeuille introuvable.",
                "subsidy_triggerGiven": "D\xe9clencheur de Subvention socialiste attribu\xe9 avec succ\xe8s.",
                "common_internal": "Erreur interne du serveur.",
                "subsidy_notFoundMulti": "Un ou plusieurs portefeuilles sont introuvables.",
                "subsidy_noTrigger": "L\u2019initiateur ne poss\xe8de pas de d\xe9clencheur de Subvention socialiste.",
                "subsidy_sessionMismatch": "Incoh\xe9rence de portefeuille ou de session.",
                "subsidy_noRecipients": "Aucun autre portefeuille disponible pour recevoir des subventions.",
                "subsidy_nothingToTax": "Aucune richesse \xe0 taxer pour ce portefeuille.",
                "subsidy_success": "Subvention effectu\xe9e avec succ\xe8s."
            },
            "LedHold": {
                "total_funds": "Total fonds",
                "earned_funds": "Capital gagn\xe9",
                "value_items": "Valeur des biens",
                "value_stock": "Valeur des actions",
                "value_short": "Position Short",
                "zollars": "Zollars",
                "total_points_label": "Capitaux totaux",
                "close": "Fermer"
            },
            "triggers": {
                "confirm": "Confirmer",
                "cancel": "Annuler",
                "close": "Fermer",
                "errorPrefix": "Erreur :",
                "ofWord": "de",
                "pointsLabel": "Capitaux",
                "sharesWord": "parts",
                "sharesAt": "parts \xe0 {value} chacune",
                "unknownUser": "Utilisateur inconnu",
                "noEligible": "Aucun portefeuille admissible \xe0 redistribuer. Action annul\xe9e.",
                "steal_stealerNotFound": "Portefeuille du voleur introuvable",
                "steal_noTrigger": "Ce portefeuille ne poss\xe8de pas de d\xe9clencheur de vol",
                "steal_itemUnavailable": "Objet non disponible pour le vol",
                "steal_itemNotInAnyPortfolio": "Objet introuvable dans un portefeuille",
                "steal_success": "Objet bien vol\xe9",
                "steal_serverError": "Erreur interne du serveur",
                "success": "Les avoirs du portefeuille s\xe9lectionn\xe9 ont \xe9t\xe9 redistribu\xe9s avec succ\xe8s.",
                "error": "Erreur : impossible de redistribuer le portefeuille s\xe9lectionn\xe9.",
                "steal_success": "Succ\xe8s, Objet vol\xe9",
                "ransom_pay_success": "La ran\xe7on a \xe9t\xe9 pay\xe9e. Votre portefeuille est d\xe9sormais d\xe9verrouill\xe9.",
                "itemStolenSuccess": "Bien vol\xe9 avec succ\xe8s.",
                "stealFailed": "\xc9chec du vol de bien",
                "title1": "Voulez-vous vraiment redistribuer les avoirs du portefeuille s\xe9lectionn\xe9 ?",
                "body1": "Cette action redistribuera al\xe9atoirement les avoirs du portefeuille du trader \xe0 d\u2019autres traders sur le march\xe9.",
                "cta1": "Oui, d\xe9clencher l\u2019assaut communiste",
                "selectPortfolioTitle": "S\xe9lectionnez un portefeuille :",
                "noAssetsSelected": "Aucun actif s\xe9lectionn\xe9 pour la LBO.",
                "successLBO": "LBO d\xe9clench\xe9e avec succ\xe8s.",
                "selectAssetsTitle": "S\xe9lectionnez les actifs pour la LBO",
                "selectAssetsItems": "Objets :",
                "selectAssetsStocks": "Actions :",
                "noItems": "Aucun objet disponible",
                "noStocks": "Aucune action disponible",
                "title_1": "S\xe9lectionnez un portefeuille sur lequel d\xe9clencher une LBO :",
                "titleLBO": "Confirmer la LBO (rachat avec effet de levier)",
                "bodyLBO": "Cette LBO vous co\xfbtera {cost} capitaux. Voulez-vous continuer ?",
                "ctaLBO": "Oui, d\xe9clencher la LBO",
                "removedStocksLabel": "Actions retir\xe9es :",
                "removedItemsLabel": "Objets retir\xe9s :",
                "unknownStock": "Action inconnue",
                "unknownItem": "Objet inconnu",
                "noRichPortfolios": "Aucun portefeuille \xab riche \xbb disponible comme cible.",
                "success3": "Subvention d\xe9clench\xe9e avec succ\xe8s.",
                "selectRichTitle3": "S\xe9lectionnez un portefeuille riche \xe0 taxer :",
                "stealFailedUse": "\xc9chec de l\u2019utilisation du bouton de vol",
                "stealFailedFetchItems": "\xc9chec du chargement des objets disponibles",
                "stealFailedUseOrFetch": "\xc9chec de l\u2019utilisation du bouton de vol ou du chargement des objets",
                "stealFailedToSteal": "\xc9chec du vol de l\u2019objet",
                "ransomNoEligible": "Aucun portefeuille admissible \xe0 ran\xe7onner. Action annul\xe9e.",
                "ransomSelectTargetTitle": "S\xe9lectionnez un portefeuille \xe0 ran\xe7onner :",
                "ransomSetFailed": "\xc9chec de la mise en place de la ran\xe7on",
                "ransomSetSuccess": "Ran\xe7on fix\xe9e avec succ\xe8s.",
                "ransomSetErrorPrefix": "Erreur : impossible de fixer la ran\xe7on.",
                "ransomSetAmountTitle": "D\xe9finir le montant de la ran\xe7on",
                "ransomSetAmountPlaceholder": "Saisissez le montant de la ran\xe7on",
                "ransomConfirmSetTitle": "Confirmer la ran\xe7on",
                "ransomConfirmSetBody": "Voulez-vous vraiment fixer une ran\xe7on de {amount} capitaux ?",
                "ransomPaySuccess": "Ran\xe7on pay\xe9e avec succ\xe8s. Votre portefeuille est d\xe9sormais d\xe9verrouill\xe9.",
                "ransomPayErrorPrefix": "Erreur : impossible de payer la ran\xe7on.",
                "ransomPayTitle": "Confirmer le paiement de la ran\xe7on",
                "ransomPayBody": "Voulez-vous vraiment payer {amount} capitaux pour d\xe9verrouiller votre portefeuille ?",
                "giveawayTitle": "Confirmer le don",
                "giveawayBody": "Voulez-vous vraiment donner cet objet ?",
                "communitySelectUsersTitle": "S\xe9lectionnez les utilisateurs pour la communaut\xe9 :",
                "statsTotalWealth": "Richesse totale :",
                "initiatorUndefined": "Le portefeuille initiateur est ind\xe9fini",
                "sessionUndefined": "La session est ind\xe9finie",
                "fetchPortfoliosFailed": "\xc9chec du chargement des portefeuilles"
            },
            "ui_labels": {
                "show_explanations_label": "Afficher les explications",
                "currency": "Devise",
                "balance": "Solde",
                "price": "Prix",
                "quantity": "Quantit\xe9",
                "total": "Total",
                "date": "Date",
                "time": "Heure",
                "status": "Statut",
                "active": "Actif",
                "inactive": "Inactif",
                "pending": "En attente",
                "completed": "Termin\xe9",
                "failed": "\xc9chou\xe9"
            },
            "marketing": {
                "tailor_stock_choice_message": "Adaptez votre choix d'actions pour qu'il s'aligne exactement avec vos valeurs.",
                "footer_copyright": 'Tous droits r\xe9serv\xe9s ZExchange 2025. ZExchange fait partie de <a href="https://zeconomy.xyz"> ZEconomy. </a>',
                "programs": {
                    "nav_home": "\u2190 Retour \xe0 ZExchange",
                    "nav_contact": "Nous Contacter",
                    "page_title": "ZExchange Studio Program",
                    "tagline": "Life profits.",
                    "intro": "Un programme en trois parties dans lequel les participants int\xe8grent une \xe9conomie con\xe7ue comme \u0153uvre d'art, s'approprient des notions conceptuelles cl\xe9s, construisent des syst\xe8mes de valeur (r\xe9els ou artistiques) et n\xe9gocient en direct sur la plateforme ZExchange.",
                    "part_one_title": "Premi\xe8re partie : Cadre th\xe9orique",
                    "part_one_text": "O\xf9 r\xe9side la valeur : dans l'\u0153uvre ? dans l'objet, l'institution ou l'exp\xe9rience ? De l'image cultuelle de Hans Belting aux marchandises fictives de Karl Polanyi, de la th\xe9\xe2tralit\xe9 de Michael Fried \xe0 la validation algorithmique des prix. Une introduction rigoureuse au d\xe9placement, envisag\xe9 \xe0 la fois comme trajectoire historico-artistique et comme intervention \xe9conomique.",
                    "part_two_title": "Deuxi\xe8me partie : Atelier cr\xe9atif",
                    "part_two_text": "Les participants \xe9laborent leurs propres syst\xe8mes de valeur \xe0 partir des principes de la ZEconomy d\xe9velopp\xe9s lors de la phase th\xe9orique. L'architecture \xe9conomique devient un mat\xe9riau artistique.",
                    "part_three_title": "Troisi\xe8me partie : S\xe9ance de trading en direct",
                    "part_three_text": "Entre 10 et 200 participants mettent en pratique la ZEconomy en temps r\xe9el sur la plateforme ZExchange. Une IA observe, analyse et livre son commentaire \u2014 produisant un Big Board visuel et un portrait \xe9crit du comportement collectif. Le march\xe9 devient son propre miroir.",
                    "institutional_title": "Objectifs institutionnels",
                    "art_programs_title": "Pour les programmes artistiques :",
                    "art_programs_text": "Positionner l'\xe9conomie comme mat\xe9riau, prolongeant l'Art conceptuel et la Critique institutionnelle tout en construisant des alternatives plut\xf4t qu'en se limitant \xe0 r\xe9v\xe9ler l'existant.",
                    "business_programs_title": "Pour les programmes de commerce et de management :",
                    "business_programs_text": "Appliquer la th\xe9orie de la valorisation exp\xe9rientielle. Les \xe9tudiants mobilisent des applications cr\xe9atives de leurs id\xe9es afin de mieux structurer leurs propres projets.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "ZExchange \xe9merge de la ZEconomy, une pratique artistique de long date d\xe9velopp\xe9e par JaZoN Frings depuis pr\xe8s de vingt ans, \xe0 travers un march\xe9 boursier personnel, des monnaies relationnelles et des syst\xe8mes publicitaires non fond\xe9s sur la consommation. Ces \u0153uvres interrogent la place de l'individu au sein des syst\xe8mes sociaux en intervenant dans leurs structures \u2014 en d\xe9pla\xe7ant les objectifs de production, en reconfigurant les modes op\xe9ratoires et en introduisant des formes d'expression impr\xe9vues qui en r\xe9v\xe8lent la logique sous-jacente.",
                    "zeconomy_text_2": "Repr\xe9sent\xe9e par la galerie mfc\u2013mich\xe8le didier et l'agent d'art Ghislain Mollet-Vi\xe9ville, la pratique a \xe9t\xe9 expos\xe9e dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions p\xe9dagogiques et de m\xe9diation \xe0 l'\xc9cole Camondo, Parsons Paris et au Centre Pompidou, elle a \xe9t\xe9 cit\xe9e dans Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg et Blockchain Revolution de Don Tapscott.",
                    "contact_title": "Contact",
                    "contact_text": "Pour les d\xe9tails du programme, la planification et les demandes institutionnelles :"
                },
                "sessions": {
                    "nav_home": "\u2190 Retour \xe0 ZExchange",
                    "nav_contact": "Nous Contacter",
                    "page_title": "ZExchange",
                    "tagline": "Life profits.",
                    "intro": "Une \u0153uvre dans laquelle on entre, plut\xf4t qu\u2019on observe. Un espace d\u2019\xe9change. Une f\xeate. Une nouvelle fa\xe7on de regarder la valeur.",
                    "what_happens_title": "Ce qui se passe",
                    "what_happens_p1": "Les participants int\xe8grent une \xe9conomie \xe0 deux niveaux : actions et marchandises.",
                    "what_happens_p2": "Les actions repr\xe9sentent des valeurs intangibles \u2014 \xe9tats \xe9motionnels, ambitions, mani\xe8res d'\xeatre. On les n\xe9gocie, on sp\xe9cule dessus, on regarde leurs cours monter et descendre selon l'int\xe9r\xeat collectif.",
                    "what_happens_p3": "Les marchandises sont r\xe9elles \u2014 boissons, nourriture, objets, cadeaux. Tout est n\xe9gociable, mais on ne peut rien consommer seul. Pour obtenir une marchandise, un autre participant doit accepter d'obtenir les siennes avec vous. Le march\xe9 accorde ou refuse la permission.",
                    "what_happens_p4": "Une IA observe tout ce qui se d\xe9roule, commentant les dynamiques de valeur, de d\xe9sir et d'\xe9change \xe0 mesure qu'elles \xe9mergent.",
                    "what_produces_title": "Ce que cela produit",
                    "what_produces_text": "Une exp\xe9rience partag\xe9e qui recadre la consommation comme acte social. Un portrait du groupe r\xe9dig\xe9 par l'IA. Une visualisation Big Board disponible \xe0 l'achat. Et une question qui persiste : quelle est la vraie valeur d'\xeatre en vie ?",
                    "format_title": "Format",
                    "format_text": "2 \xe0 3 heures. De 10 \xe0 200 participants. \xc9v\xe9nement autonome, team building, cocktail, s\xe9minaire ou programme culturel.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "Le ZExchange \xe9merge de la ZEconomy, pratique artistique au long cours de JaZoN Frings d\xe9velopp\xe9e depuis pr\xe8s de vingt ans \xe0 travers un march\xe9 boursier personnel, des monnaies relationnelles et des syst\xe8mes publicitaires non fond\xe9s sur la consommation. Ces \u0153uvres interrogent la position de l'individu au sein des syst\xe8mes soci\xe9taux en intervenant dans leurs structures \u2014 d\xe9pla\xe7ant les objectifs de production, reconfigurant les op\xe9rations et introduisant des formes d'expression impr\xe9vues qui en r\xe9v\xe8lent la logique sous-jacente.",
                    "zeconomy_text_2": "Repr\xe9sent\xe9 par la Galerie mfc\u2013mich\xe8le didier et l'agent d'art Ghislain Mollet-Vi\xe9ville, la pratique a \xe9t\xe9 expos\xe9e dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions p\xe9dagogiques et de m\xe9diation \xe0 l'\xc9cole Camondo, Parsons Paris et au Centre Pompidou, elle a \xe9t\xe9 cit\xe9e dans Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg et Blockchain Revolution de Tapscott.",
                    "contact_title": "Contact",
                    "contact_text": "Pour les d\xe9tails du programme, la planification et les demandes institutionnelles :"
                }
            },
            "classes": {
                "page_title": "Sessions p\xe9dagogiques ZEconomy",
                "presenter_title": "Pr\xe9sentation de cours ZEconomy",
                "back_link": "\u2190 Retour \xe0 ZExchange",
                "title": "Sessions p\xe9dagogiques ZEconomy",
                "tagline": "Explorer les intersections entre histoire de l'art, spiritualit\xe9 et repr\xe9sentation avec la th\xe9orie des march\xe9s, les syst\xe8mes de valeur et la r\xe9invention de la finance par la ZEconomy.",
                "lesson_selector": "\u2190 S\xe9lecteur de le\xe7ons",
                "previous": "\u2190 Pr\xe9c\xe9dent",
                "next": "Suivant \u2192",
                "toggle_images": "Afficher/Masquer les images",
                "no_classes": "Aucune session disponible pour le moment.",
                "load_error": "Impossible de charger les sessions. Veuillez r\xe9essayer ult\xe9rieurement.",
                "level": "Niveau",
                "duration": "Dur\xe9e",
                "minutes": "min",
                "mixed_level": "mixte",
                "presenter_suffix": "Pr\xe9sentation",
                "learning_objectives": "Objectifs p\xe9dagogiques",
                "view_details": "Voir les d\xe9tails",
                "discussion_points": "Points de discussion",
                "activity_instructions": "Consignes de l'activit\xe9",
                "estimated_reading_time": "Temps de lecture estim\xe9",
                "min": "min",
                "download_pdf": "T\xe9l\xe9charger le PDF",
                "no_lesson_specified": "Aucune le\xe7on sp\xe9cifi\xe9e.",
                "lesson_not_found": "Le\xe7on introuvable.",
                "load_lesson_error": "Erreur lors du chargement de la le\xe7on. Veuillez r\xe9essayer ult\xe9rieurement."
            },
            "placeholders": {
                "life_profits_placeholder_1": "J'appr\xe9cie jouer avec mes enfants...",
                "life_profits_placeholder_2": "La d\xe9pression semble \xeatre recherch\xe9e...",
                "life_profits_placeholder_3": "J'aime l'amour et tout ce qui s'y rapporte...",
                "life_profits_placeholder_4": "Un verre avec des amis vaut tout...",
                "life_profits_placeholder_5": "Je pense que le rejet cr\xe9e de la valeur...",
                "life_profits_placeholder_6": "Je vois la joie comme la vraie monnaie de la vie...",
                "life_profits_placeholder_7": "Aider les autres enrichit ma vie...",
                "life_profits_placeholder_8": "La solitude est devenue une exp\xe9rience tr\xe8s courante...",
                unnamed_company: "Entreprise sans nom",
                unknown_output: "Production inconnue",
                no_description: "Aucune description disponible",
                "experience_placeholder_1": "Danser sur de la techno me fait oublier mes soucis...",
                "experience_placeholder_2": "Passer du temps avec mes amis fait filer le temps...",
                "experience_placeholder_3": "Ma m\xe8re me manque, \xe7a me rappelle ce qui compte...",
                "experience_placeholder_4": "Courir r\xe9guli\xe8rement me vide la t\xeate...",
                "experience_placeholder_5": "Se disputer en ligne est toujours une perte de temps...",
                "experience_placeholder_6": "Regarder de vieux dessins anim\xe9s me fait redevenir un enfant...",
                "experience_placeholder_7": "Me lever t\xf4t donne une bonne \xe9nergie \xe0 ma journ\xe9e...",
                "experience_placeholder_8": "Prendre un chemin d\xe9tourn\xe9 m'aide \xe0 r\xe9fl\xe9chir...",
                "experience_placeholder_9": "La qualit\xe9 du caf\xe9 du matin donne le ton \xe0 ma journ\xe9e...",
                "experience_placeholder_10": "Porter mes lunettes de soleil la nuit me donne l'air cool..."
            },
            "ticker_texts": {
                "intro_z_exchange": "?? \u25BA INTRODUCTION Z EXCHANGE ?? \u25BA",
                "life_profits_value": "PROFITS DE VIE \u25BA VALEUR Z EXCHANGE \u25BA",
                "stocks_function": "\u25BA QUE FONT LES ACTIONS SUR Z EXCHANGE",
                "z_bonds_system": "Z OBLIGATIONS \u25BA Zollars \u25BA Z SYST\xc8ME MON\xc9TAIRE RELATIONNEL \u25BA LES CHIFFRES N'ONT PAS LEUR PLACE \u25BA",
                "commodity_x": "\u25BA MARCHANDISE X \u25BA CONSOMMATION SOCIALE Z EXCHANGE.",
                "interface_preview": "APER\xc7U DE L'INTERFACE Z EXCHANGE \u25BA",
                "generative_boards": "\u25BA TABLEAUX G\xc9N\xc9RATIFS Z EXCHANGE \u25BA EXPRESSION MARCH\xc9 EN TEMPS R\xc9EL"
            },
            "simulation": {
                "freestyle_title": "Freestyle est un simulateur de session r\xe9guli\xe8re ZExchange.",
                "freestyle_goal_label": "Objectif",
                "freestyle_goal_text": "apprendre l'interface et les concepts de ZExchange ; et surtout explorer comment la valeur devient votre histoire.",
                "details_heading": "D\xe9tails :",
                "freestyle_detail_1": "prend notre id\xe9e de profits en appliquant de la valeur \xe0 ce qui compte pour vous dans votre vie.",
                "life_profit_label": "Profit de Vie",
                "life_profit_description": "valeur de la vie consciemment v\xe9cue : joie, perte, contradiction, sexe, amour, d\xe9pression, ennui, f\xeate... (qualit\xe9 / quantit\xe9 / positif & n\xe9gatif).",
                "voice_of_bourse_label": "\"voix de la bourse\"",
                "voice_of_bourse_description": 'Sur ZExchange, le march\xe9 lui-m\xeame a une voix, analysant ce qu\'il pense de chaque transaction boursi\xe8re \u2192 cr\xe9ant des "grands tableaux" g\xe9n\xe9ratifs + cr\xe9e des r\xe9cits collaboratifs.',
                "zrms_label": "Syst\xe8me Mon\xe9taire Relationnel Z",
                "zrms_description": "Les Zollars appliquent votre valeur associative des relations pour payer les actifs en utilisant l'Amour, la Haine, l'Amiti\xe9, la Mort, la Fraternit\xe9...",
                "commodity_x_label": "Marchandise X",
                "commodity_x_description": "\xc9changez des marchandises avec un pi\xe8ge, vous avez besoin d'une validation sociale avant toute consommation (\xe9changer avec l'article d'un autre trader \u2192 consommer).",
                "economic_tools_label": "Outils \xe9conomiques",
                "economic_tools_description": "maniez les LBO (Leveraged Buyouts), assauts communistes, subventions socialistes, dark pools, ran\xe7on, vol..., utilisez l'\xe9conomie comme armes ou cadeaux envers d'autres traders.",
                "memento_title": "Memento Mori \u2013 \xc9changer la valeur de vie pour cr\xe9er votre \xc9loge fun\xe8bre",
                "memento_why_label": "Pourquoi ?",
                "memento_why_text": "r\xe9fl\xe9chir sur la fa\xe7on dont vous valorisez la vie, les exp\xe9riences et les \xe9motions pour d\xe9terminer ce que vous valoriseriez le plus lorsque votre vie se termine.",
                "memento_confront_label": "Affrontez la mortalit\xe9",
                "memento_confront_description": "Cr\xe9ez un portefeuille de valeurs de vie en n\xe9gociant des actions, dont la valeur de vie cumulative g\xe9n\xe9rera votre \xe9loge fun\xe8bre.",
                "memento_relational_label": "Capital relationnel",
                "memento_relational_description": "Les Zollars ici repr\xe9sentent l'association de relations positives et n\xe9gatives aux actions plut\xf4t qu'un rendement num\xe9rique.",
                "memento_bourse_eye_label": '"Sous l\'\u0153il de la bourse"',
                "memento_bourse_eye_description": "La bourse portera un jugement sur toi dans ton \xe9loge fun\xe8bre en observant toutes tes transactions jusqu'\xe0 la fin.",
                "enter_key_title": "Acc\xe8s au simulateur requis",
                "enter_key_title_session": "Acc\xe8s requis pour cr\xe9er une session",
                "enter_key_description": "Veuillez entrer votre cl\xe9 d'acc\xe8s au simulateur ou scanner le code QR pour continuer.",
                "enter_key_description_session": "Veuillez entrer votre cl\xe9 d'acc\xe8s pour cr\xe9er une nouvelle session.",
                "enter_key_placeholder": "Entrez la cl\xe9 du simulateur...",
                "analyzing_life_values": "Analyse de vos valeurs de vie...",
                "finding_companies": "Recherche d'entreprises align\xe9es avec votre h\xe9ritage...",
                "building_chamber": "Construction de votre chambre de mortalit\xe9...",
                "preparing_stocks": "Pr\xe9paration de votre portefeuille d'h\xe9ritage...",
                "market_response_label": "R\xe9ponse du march\xe9",
                "select_company_heading": "Choisissez une entreprise en phase avec votre \xe9tat \xe9motionnel.",
                "memento_mori_description": "Souviens-toi que tu dois mourir. Cette simulation explore les choix significatifs dans un temps limit\xe9.",
                "mortality_chamber_setup": "Vous serez transport\xe9 dans l'environnement de simulation, o\xf9 vous ferez face \xe0 un compte \xe0 rebours menant \xe0 votre mort symbolique et prendrez des d\xe9cisions de trading qui refl\xe8tent vos valeurs les plus profondes.",
                "simulation_instructions": "Vous commencerez par une courte r\xe9flexion sur vos valeurs de vie, puis recevrez des actions recommand\xe9es. Le compte \xe0 rebours commencera seulement apr\xe8s votre r\xe9flexion.",
                "building_experience": "Construction de votre Exp\xe9rience Memento Mori",
                "preparing_chamber": "Pr\xe9paration de votre chambre de mort symbolique...",
                "life_profit_title": "Explorer ce qui a de la valeur pour vous",
                "welcome_setup": "Bienvenue ! Configurons votre portefeuille de trading.",
                "life_profits_explanation": 'Trouvons une action d\'entreprise ZEconomy en laquelle vous croyez pour g\xe9n\xe9rer des "Profits de Vie".',
                "no_matching_companies": "Notre syst\xe8me n'a trouv\xe9 aucune entreprise correspondant \xe0 votre profil \xe9motionnel.",
                "creating_simulation": "Cr\xe9ation de votre Simulation...",
                "please_wait": "Veuillez patienter pendant que nous g\xe9n\xe9rons votre portefeuille virtuel.",
                "trade_title": "Trade sur ZExchange.",
                "one_off_session": "Session unique"
            },
            "story": {
                "catena_title": "Catena Narrativa",
                "catena_subtitle": "Construction de r\xe9cits comme des cha\xeenes d'approvisionnement : \xe9changez, personnalisez et consolidez \xe0 travers trois phases pour compl\xe9ter le processus de cr\xe9ation d'histoire.",
                "continue_to_selection": "Continuer vers la s\xe9lection d'histoire",
                "process_heading": "Processus :",
                "materials_motion_title": "Mat\xe9riaux en mouvement :",
                "materials_motion_desc": "\xc9changez des \xe9l\xe9ments narratifs comme des marchandises. Personnalisez-les pendant que vous les \xe9changez. La valeur se forme \xe0 travers le processus d'\xe9change pour construire une histoire.",
                "three_passes_title": "Trois passages :",
                "three_passes_desc": "Origine (d\xe9but) \u2192 Transit (milieu) \u2192 Assemblage (fin) ( 3min + 3min + 2min \u22488 minutes au total). Chaque phase se termine apr\xe8s l'expiration du temps, ou lorsque vous \xe9changez, ce qui entra\xeene la s\xe9curisation de vos marchandises de points cl\xe9s dans un registre d'histoire personnel.",
                "composition_title": "Composition :",
                "composition_desc": "\xc0 la fin, votre registre est transform\xe9 en une courte histoire g\xe9n\xe9r\xe9e \xe0 partir de vos \xe9changes personnalis\xe9s d'actifs et de points cl\xe9s \xe9chang\xe9s et s\xe9curis\xe9s.",
                "commodity_x_label": "Marchandise X",
                "commodity_x_desc": "fait partie de ZEconomy o\xf9 les profits sont mesur\xe9s en <strong>Profit de Vie</strong>\u2014 la qualit\xe9 et la quantit\xe9 d'intellect, d'affection, de f\xeate... etc, tous les divers \xe9v\xe9nements de la vie, promouvant l'\xeatre\u2014plut\xf4t que l'accumulation.",
                "footer_note_consumption": "Marchandise X o\xf9 la Consommation est relationnelle : vous ne pouvez pas consommer sans consentement mutuel. La marchandise n'est pas l'objet ; la marchandise est l'interaction.",
                "footer_note_redeem": "\xc9changez relationnellement. Consommez consciemment.",
                "simulation_title": "Simulation d'Histoire",
                "simulation_intro": "Engagez-vous dans un \xe9change narratif avec des participants automatis\xe9s \xe0 travers trois phases distinctes, cr\xe9ant une courte histoire unique gr\xe2ce \xe0 une collaboration dynamique.",
                "choose_genre": "Choisissez votre genre",
                "genre_scifi": "Science-Fiction",
                "genre_scifi_desc": "Visions futuristes et mondes sp\xe9culatifs",
                "genre_romance": "Romance",
                "genre_romance_desc": "\xc9motion, intimit\xe9 et connexion humaine",
                "genre_mystery": "Myst\xe8re",
                "genre_mystery_desc": "Secrets, enqu\xeate et motifs dissimul\xe9s",
                "genre_fantasy": "Fantaisie",
                "genre_fantasy_desc": "Mythe, imagination et transcendance",
                "genre_horror": "Horreur",
                "genre_horror_desc": "Peur, suspense et confrontation avec l'inconnu",
                "duration": "Dur\xe9e : 8 minutes (phases de 3 + 3 + 2 minutes)",
                "loading_elements": " Chargement des \xe9l\xe9ments d'histoire...",
                "choose_starting_element": "Choisissez votre \xe9l\xe9ment de d\xe9part",
                "select_one_element": "S\xe9lectionnez un \xe9l\xe9ment d'histoire pour commencer. Vous recevrez \xe9galement 2 \xe9l\xe9ments al\xe9atoires.",
                "skip_selection": "Passer la s\xe9lection (Obtenir 3 \xe9l\xe9ments al\xe9atoires)",
                "preparing_story": "Pr\xe9paration de votre histoire...",
                "setting_up_simulation": "Configuration de la simulation {theme}...",
                "story_begins": "L'histoire commence maintenant",
                "entering_world": "Entr\xe9e dans le monde {theme} dans 2 secondes...",
                "failed_load_elements": "\xc9chec du chargement des \xe9l\xe9ments d'histoire",
                "failed_create_session": "\xc9chec de la cr\xe9ation de la session d'histoire",
                "your_story_complete": "Votre histoire est termin\xe9e",
                "generating_final_story": "G\xe9n\xe9ration de votre histoire finale...",
                "please_wait": "Veuillez patienter...",
                "fallback_story": "Votre voyage narratif \xe0 travers le march\xe9 des histoires s'est conclu. Les \xe9l\xe9ments que vous avez \xe9chang\xe9s et personnalis\xe9s se sont tiss\xe9s ensemble en un conte unique."
            },
            "memento": {
                "question_1": "1. Comment vous sentez-vous par rapport \xe0 votre vie en ce moment ?",
                "question_1_placeholder": "ex. : anxieux pour l'avenir, reconnaissant pour mes relations...",
                "question_2": "2. Qu'est-ce qui compte le plus pour vous ?",
                "question_2_placeholder": "ex. : la famille, la cr\xe9ativit\xe9, avoir un impact...",
                "question_3": "3. Si votre vie se terminait demain, que voudriez-vous que votre h\xe9ritage repr\xe9sente ?",
                "question_3_placeholder": "ex. : quelqu'un qui a aid\xe9 les autres, qui a v\xe9cu authentiquement...",
                "find_companies_button": "Trouver des entreprises significatives",
                "choose_legacy_title": "Choisissez votre portefeuille d'h\xe9ritage",
                "choose_legacy_description": "S\xe9lectionnez 3 \xe0 5 entreprises qui repr\xe9sentent ce qui compte le plus pour vous.",
                "choose_legacy_warning": "Ce seront les actions que vous d\xe9tiendrez lorsque votre temps expirera.",
                "selected_count": "S\xe9lectionn\xe9",
                "your_time_begins": "\u23F3 Votre temps commence maintenant \u23F3",
                "entering_mortality_chamber": "Entr\xe9e dans votre chambre de mortalit\xe9 dans 2 secondes...",
                "your_eulogy_label": "VOTRE \xc9LOGE FUN\xc8BRE",
                "generating_eulogy": "G\xe9n\xe9ration de l'histoire de votre vie bas\xe9e sur vos choix...",
                "your_eulogy_expanded_title": "VOTRE \xc9LOGE FUN\xc8BRE",
                "eulogy_subtitle": "Une r\xe9flexion sur vos choix dans le march\xe9 de la vie",
                "eulogy_update_info": "Cet \xe9loge fun\xe8bre se met \xe0 jour toutes les 2 minutes en fonction de vos actions de trading",
                "eulogy_fallback": "Votre voyage \xe0 travers le march\xe9 de la vie continue de se d\xe9rouler, chaque choix r\xe9v\xe9lant les valeurs qui guident votre chemin.",
                "intor_pop": "Fen\xeatre d'introduction \xe0 la contemplation",
                "intro_pop": "Fen\xeatre d\u2019introduction \xe0 la contemplation",
                "first_form": "Premier formulaire de r\xe9flexion",
                "second_form": "Deuxi\xe8me formulaire de r\xe9flexion",
                "begin_countdown": "Lancer le compte \xe0 rebours",
                "instructions_title": "Comment cela fonctionne",
                "countdown_notice": "Le compte \xe0 rebours commencera apr\xe8s votre premi\xe8re r\xe9flexion.",
                "accept_eulogy": "Accepter l\u2019oraison",
                "regenerate_eulogy": "R\xe9g\xe9n\xe9rer l\u2019oraison",
                "enter_chamber": "Entrer dans la chambre",
                "pick_companies_title": "Entreprises recommand\xe9es selon vos r\xe9flexions",
                "continue_button": "Continuer",
                "validate_key": "Valider la cl\xe9",
                "scan_qr_code": "Scanner le code QR",
                "back_button": "Retour",
                "submit_button": "Valider",
                "finish_button": "Terminer",
                "questionnaire_title": "R\xe9fl\xe9chir avant d\u2019\xe9changer",
                "emotional_state_label": "Comment vous sentez-vous en ce moment ?",
                "intention_label": "Quelle intention guide vos choix ?",
                "portfolio_meaning_label": "Que doit signifier votre portefeuille ?",
                "oracle_ask_placeholder": "Demandez \xe0 le March\xe9 de votre parcours\u2026",
                "tribute_placeholder": "Laissez un hommage\u2026",
                // --- Flattened from the tree you pasted ---
                // Timer & banner
                "timer_title": "MEMENTO MORI",
                "timer_loading": "Chargement\u2026",
                "timer_click_to_reflect": "Cliquer pour r\xe9fl\xe9chir",
                // Trading overlay & notifications
                "trading_overlay_title": " N\xe9gociation consciente de la mortalit\xe9 ",
                "trading_overlay_line1": "Vous avez <strong>5 minutes</strong> pour n\xe9gocier en gardant la mortalit\xe9 \xe0 l\u2019esprit.",
                "trading_overlay_line2": "Chaque transaction refl\xe8te ce qui compte vraiment.",
                "trading_overlay_line3": "Des bots proposeront des \xe9changes symboliques pour mettre vos valeurs \xe0 l\u2019\xe9preuve.",
                "trading_begin_button": "Commencer \xe0 n\xe9gocier",
                "trading_active_badge": "N\xc9GOCIATION MEMENTO MORI ACTIVE",
                "trading_all_available": "Plus de 310 entreprises disponibles pour la n\xe9gociation",
                "trading_values_over_profit": "N\xe9gociez selon vos valeurs, pas pour le profit",
                // Oracle
                "oracle_loading_title": "le March\xe9 s\u2019\xe9veille",
                "oracle_loading_examining": "le March\xe9 examine l\u2019\xe2me de votre portefeuille\u2026",
                "oracle_loading_preparing": "Pr\xe9paration de questions personnalis\xe9es sur votre mortalit\xe9\u2026",
                "oracle_loading_wait": "Cela peut prendre un instant\u2026",
                "oracle_title": "Le March\xe9 de la mortalit\xe9",
                "oracle_greeting": "Le March\xe9 d\xe9c\xe8le dans votre portefeuille des motifs qui r\xe9v\xe8lent votre rapport \xe0 la mortalit\xe9.",
                "oracle_questions_header": "le March\xe9 a pr\xe9par\xe9 des questions pour votre \xe2me :",
                "oracle_direct_label": "Ou adressez-vous directement \xe0 le March\xe9 :",
                "oracle_custom_prompt": "Interrogez le March\xe9 sur votre mortalit\xe9, ce que dit votre portefeuille de votre \xe2me, ou le sens de vos choix financiers face \xe0 la finitude\u2026",
                "oracle_consult_button": "Consulter le March\xe9",
                "oracle_vision_title": "Vision de le March\xe9 :",
                "oracle_further_insight": "Analyse compl\xe9mentaire de le March\xe9 :",
                "oracle_continue_reflections": "Poursuivre les r\xe9flexions",
                "oracle_ask_another": "Poser une autre question",
                "oracle_return_trading": "Revenir au march\xe9",
                "oracle_ask_validation": "Veuillez s\xe9lectionner ou \xe9crire une question pertinente sur la mortalit\xe9 (au moins 10 caract\xe8res).",
                "oracle_failed": "La consultation de le March\xe9 a \xe9chou\xe9",
                "oracle_spoken_placeholder": "le March\xe9 s\u2019est exprim\xe9\u2026",
                "oracle_wisdom_received": "Sagesse re\xe7ue",
                // Reflection (Phase 1)
                "reflection_title": "MEMENTO MORI : R\xc9FLEXION",
                "reflection_subtitle": "Avant de n\xe9gocier, r\xe9fl\xe9chissez \xe0 ce qui compte vraiment dans votre vie",
                "reflection_placeholder": "Partagez vos pens\xe9es\u2026",
                "reflection_continue": "Passer \xe0 l\u2019analyse des valeurs \u2192",
                "reflection_answer_required": "Veuillez fournir une r\xe9ponse significative.",
                "reflection_process_failed": "\xc9chec du traitement des r\xe9flexions",
                "reflection_process_failed_retry": "\xc9chec du traitement des r\xe9flexions. Veuillez r\xe9essayer.",
                // Questions (fallback texts)
                "questions_life_values": "Quelles valeurs et quels principes ont guid\xe9 vos choix de vie ? Qu\u2019est-ce qui compte le plus pour vous ?",
                "questions_meaningful_pursuits": "Quelles activit\xe9s, relations ou qu\xeates vous ont apport\xe9 le plus de sens et d\u2019\xe9panouissement ?",
                "questions_relationships_impact": "En quoi vos relations avec les autres ont-elles influenc\xe9 votre vie ? Quels liens comptent le plus ?",
                // Value analysis (Phase 2)
                "analysis_title": "VOTRE PROFIL DE VALEURS",
                "analysis_subtitle": "D\u2019apr\xe8s vos r\xe9flexions, voici des entreprises en accord avec vos valeurs",
                "analysis_guidance_title": "Conseils :",
                "analysis_recommended_title": "Entreprises recommand\xe9es :",
                "analysis_start_trading": "Commencer \xe0 n\xe9gocier (310+ entreprises) \u2192",
                // Final call reminder
                "final_call_title": "DERNIER APPEL",
                "final_call_body": "Le temps s\u2019\xe9coule. Finalisez maintenant votre simulation Memento Mori.",
                "final_call_complete_now": "Terminer maintenant \u2192",
                // Timeout popup
                "timeout_title": "TEMPS \xc9COUL\xc9",
                "timeout_body": "La mort est survenue, mais le sens de votre portefeuille est pr\xe9serv\xe9\u2026",
                "timeout_generating": "G\xe9n\xe9ration de votre oraison finale\u2026",
                "death_complete_title": "MORT SYMBOLIQUE ACHEV\xc9E",
                "death_complete_subtitle": "Vous avez affront\xe9 votre mortalit\xe9 et cr\xe9\xe9 votre h\xe9ritage.",
                "final_judgment_title": "Jugement final de votre portefeuille :",
                "final_epitaph_title": "Votre \xe9pitaphe finale :",
                "return_to_void_button": "Retourner au n\xe9ant",
                "eulogy_title": "VOTRE ORAISON NUM\xc9RIQUE",
                "eulogy_subtitle": "Fond\xe9e sur vos choix de portefeuille et vos r\xe9flexions de vie",
                "eulogy_your_eulogy": "Votre oraison :",
                "eulogy_insights": "Enseignements du portefeuille :",
                "eulogy_rest_in_peace": "Reposez en paix"
            },
            "socketBack": {
                "narrativeProcessed": "R\xe9ponse narrative trait\xe9e",
                "unauthorizedSuperUser": "Non autoris\xe9 : seuls les banquiers de la Z\xe9d\xe9rale R\xe9serve peuvent effectuer cette action",
                "noTargetUser": "Aucun trader cible fourni",
                "logoutByAdmin": "Vous avez \xe9t\xe9 d\xe9connect\xe9 par un administrateur.",
                "logoutUserSuccess": "L\u2019utilisateur {id} a \xe9t\xe9 d\xe9connect\xe9 de force avec succ\xe8s.",
                "logoutUserOffline": "L\u2019utilisateur {id} est d\xe9j\xe0 hors ligne.",
                "marketClosed": "Le march\xe9 est ferm\xe9.",
                "logoutAllSuccess": "Tous les traders ont \xe9t\xe9 d\xe9connect\xe9s avec succ\xe8s.",
                "taxEvent": "Vous \xeates soumis \xe0 une taxe de march\xe9. Choisissez de donner un bien au hasard ou de perdre du capital.",
                "zollarIssued": "Un Zollar vous a \xe9t\xe9 \xe9mis par la Z\xe9d\xe9rale R\xe9serve.",
                "zollarFailed": "\xc9chec de l\u2019attribution des Zollars",
                "ransomAssigned": "Vous avez re\xe7u le d\xe9clencheur de ran\xe7on.",
                "ransomLocked": "Votre portefeuille a \xe9t\xe9 verrouill\xe9 avec une ran\xe7on de {points} capitaux.",
                "lboAssigned": "Vous avez re\xe7u le d\xe9clencheur de rachat avec effet de levier (LBO).",
                "lboAssetsRemoved": "Des actifs ont \xe9t\xe9 retir\xe9s de votre portefeuille en raison d\u2019un LBO.",
                "removedStocksLabel": "Actions retir\xe9es :",
                "removedItemsLabel": "Objets retir\xe9s :",
                "unknownStock": "Action inconnue",
                "unknownItem": "Objet inconnu",
                "sharesWord": "parts",
                "ofWord": "de",
                "subsidy_assigned": "Vous avez re\xe7u le d\xe9clencheur de Subvention.",
                "subsidy_taxed": "45 % de votre richesse ont \xe9t\xe9 redistribu\xe9s comme Subvention socialiste pour les revenus plus faibles.",
                "subsidy_received": "Vous avez re\xe7u une subvention socialiste.",
                "pointsGiven": "Du capital a \xe9t\xe9 \xe9mis.",
                "itemsDistributed": "Des biens ont \xe9t\xe9 distribu\xe9s.",
                "freebieZ1Message": "La Zederal Reserve a distribu\xe9 un bien gratuit \xe0 votre portefeuille !",
                "ransomPaidNotification": "{userName} a pay\xe9 la ran\xe7on de {points} capital. Les fonds ont \xe9t\xe9 transf\xe9r\xe9s sur votre compte.",
                "pointsDeducted": "{amount} capital ont \xe9t\xe9 d\xe9duits de votre compte.",
                "itemTaxed": "La Z\xe9d\xe9rale R\xe9serve a tax\xe9 un bien dans vos avoirs.",
                "deleteButtonAssigned": "Vous avez re\xe7u le d\xe9clencheur d\u2019Assaut communiste.",
                "deletePerformed": "Votre portefeuille a \xe9t\xe9 cibl\xe9 par un Assaut communiste.",
                "subsidyUpdateBotTarget": "{botName} a d\xe9clench\xe9 une Subvention socialiste \u2014 45 % de votre richesse ont \xe9t\xe9 redistribu\xe9s.",
                "specialSubsidyTarget": "{botName} a redistribu\xe9 45 % de votre richesse via une Subvention socialiste",
                "subsidyReceivedFrom": "Vous avez re\xe7u une Subvention socialiste gr\xe2ce \xe0 l\u2019action de redistribution de {botName} !",
                "specialSubsidyReceived": "Vous avez re\xe7u des fonds issus de la Subvention socialiste de {botName}",
                "ransomLockedBy": "{botName} a gel\xe9 votre portefeuille avec une ran\xe7on de {points} capital !",
                "specialRansomTarget": "{botName} a gel\xe9 votre portefeuille et exige une ran\xe7on",
                "specialRansomImpact": "Portefeuille verrouill\xe9 \u2014 {points} de capital requis",
                "lboExecutedOnYouBy": "{botName} a r\xe9alis\xe9 un rachat avec effet de levier (LBO) sur votre portefeuille.",
                "specialLboTarget": "Votre portefeuille a \xe9t\xe9 la cible d\u2019un LBO r\xe9alis\xe9 par {botName}",
                "itemStolen": "{botName} a vol\xe9 \xab {itemName} \xbb dans votre portefeuille !",
                "specialStealTarget": "{botName} vous a vol\xe9 \xab {itemName} \xbb",
                "specialStealImpact": "Objet perdu : {itemName}",
                "deleteUpdateBy": "{botName} a ex\xe9cut\xe9 un Assaut communiste sur votre portefeuille !",
                "specialDeleteTarget": "{botName} a ex\xe9cut\xe9 un Assaut communiste sur votre portefeuille",
                "assaultGameEvent": "{botName} a ex\xe9cut\xe9 un Assaut communiste contre {targetName} !",
                "unknownPlayer": "Joueur inconnu",
                "tradeAccepted": "\xc9change accept\xe9 ! capital attribu\xe9s.",
                "tradeDeclined": "\xc9change refus\xe9. Aucun capital attribu\xe9."
            },
            "socketFront": {
                "ransomTitle": "Portefeuille ran\xe7onn\xe9 !",
                "ransomHeldBy": "Votre portefeuille est retenu contre ran\xe7on par",
                "ransomMustPay": "Vous devez payer {points} capital pour reprendre le contr\xf4le.",
                "payRansomCta": "Payer la ran\xe7on ({points} capital)",
                "ransomPayFailed": "\xc9chec du paiement de la ran\xe7on. Veuillez r\xe9essayer.",
                "messageError": "Erreur d\u2019envoi du message :",
                "sendErrorPrefix": "Erreur d\u2019envoi du message :",
                "messageSent": "Message envoy\xe9 avec succ\xe8s !",
                "messageSentSuccess": "Message envoy\xe9 avec succ\xe8s !",
                "loggedOutByAdmin": "Vous avez \xe9t\xe9 d\xe9connect\xe9 par l\u2019administrateur.",
                "logoutActiveUpdateError": "Erreur lors de la mise \xe0 jour de l\u2019\xe9tat pendant la d\xe9connexion. Veuillez r\xe9essayer.",
                "logoutServerError": "Erreur lors de la d\xe9connexion serveur. Veuillez r\xe9essayer.",
                "mementoComplete": "Vous avez termin\xe9 votre contemplation de la mortalit\xe9 !",
                "darkPoolEnded": "Le Dark Pool est termin\xe9. Vous retrouvez votre statut normal.",
                "darkPoolExpired": "Le Dark Pool a expir\xe9. Vous retrouvez votre statut normal.",
                "timerExtended60": "Minuteur prolong\xe9 \xe0 60 secondes",
                "tradeAcceptedFrom": "\xc9change accept\xe9 de",
                "forWord": "pour",
                "ofType": "de type",
                "tradeAcceptFailed": "\xc9chec de l\u2019acceptation de l\u2019\xe9change :",
                "tradeAcceptFailedPrefix": "\xc9chec de l\u2019acceptation de l\u2019\xe9change :",
                "tradeDeclined": "\xc9change refus\xe9.",
                "respondedToAnalysis": "a r\xe9pondu \xe0 votre analyse d\u2019\xe9change",
                "tradeAnalysisResponded": "a r\xe9pondu \xe0 votre analyse d\u2019\xe9change",
                "offerAccepted": "Offre accept\xe9e !",
                "offerDeclined": "Offre refus\xe9e !",
                "offerAcceptedLong": "Votre offre a \xe9t\xe9 accept\xe9e.",
                "offerDeclinedLong": "Votre offre a \xe9t\xe9 refus\xe9e !",
                "offerExpired": "Votre offre a expir\xe9",
                "offerError": "Une erreur s\u2019est produite avec votre offre",
                "shortSuccess": "Vente \xe0 d\xe9couvert r\xe9ussie !",
                "shortFailed": "\xc9chec de la vente \xe0 d\xe9couvert :",
                "shortClosedPrefix": "Votre position courte sur l\u2019action",
                "shortClosedSuffix2": "a \xe9t\xe9 cl\xf4tur\xe9e automatiquement.",
                "bondBidPrefix": "Votre offre pour l\u2019obligation",
                "bondAccepted": "a \xe9t\xe9 accept\xe9e.",
                "bondDeclined": "a \xe9t\xe9 refus\xe9e.",
                "yourBond": "Votre obligation",
                "bondMatured": "est arriv\xe9e \xe0 \xe9ch\xe9ance et des zollars ont \xe9t\xe9 \xe9mis.",
                "buyOfferAcceptedFrom": "Offre d'achat accept\xe9e de",
                "buyAcceptFailed": "\xc9chec de l'acceptation de l'offre d'achat :",
                "buyAcceptFailedPrefix": "\xc9chec de l'acceptation de l'offre d'achat :",
                "warningPrefix": "ATTENTION :",
                "criticalPrefix": "CRITIQUE :",
                "debtPageVisit": "Visitez la page Dette pour plus de d\xe9tails.",
                "debtWipeoutDefault": "Votre portefeuille a \xe9t\xe9 effac\xe9 en raison d'une dette excessive.",
                "debtWarningPrefix": "ATTENTION : Cette dette se recharge toutes les 60 secondes avec un int\xe9r\xeat compos\xe9 de 15 % jusqu'au remboursement.",
                "bankruptcyWarning": "ATTENTION : Vous approchez de la faillite !",
                "debtCompounded": "Dette compos\xe9e :",
                "totalDebt": "Dette totale :",
                "youOwe": "Vous devez :",
                "checkDebtHeldSection": "Consultez votre section Dettes d\xe9tenues pour convertir."
            },
            "debtWarning": {
                "title": "Alerte de Dette",
                "aboutToGoIntoDebt": "Vous \xeates sur le point de vous endetter !",
                "currentBalance": "Solde actuel :",
                "bidAmount": "Montant de l'offre :",
                "offerAmount": "Montant de l'offre :",
                "youWillOwe": "Vous devrez :",
                "interestAccrues": "Les int\xe9r\xeats s'accumulent \xe0 5 % par jour sur les soldes n\xe9gatifs.",
                "creditLimit": "Limite de cr\xe9dit : -1000 capital (par d\xe9faut)",
                "proceedAnyway": "Continuer quand m\xeame",
                "cancel": "Annuler",
                "points": "Capitaux"
            },
            "debt": {
                "capital": "capital",
                "closedDefault": "Un instrument de dette de type {type} a \xe9t\xe9 cl\xf4tur\xe9.",
                "closedGeneric": "Un instrument de dette a \xe9t\xe9 cl\xf4tur\xe9.",
                "amounts": {
                    "none": "Aucun",
                    "barelyAny": "Presque rien",
                    "aTrace": "Une trace",
                    "aHint": "Un soup\xe7on",
                    "aLittle": "Un peu",
                    "aFew": "Quelques-uns",
                    "some": "Certains",
                    "several": "Plusieurs",
                    "moderate": "Mod\xe9r\xe9",
                    "noticeable": "Notable",
                    "considerable": "Consid\xe9rable",
                    "many": "Nombreux",
                    "aLot": "Beaucoup",
                    "abundant": "Abondant",
                    "heaps": "\xc9normes quantit\xe9s",
                    "aGreatDeal": "Une grande quantit\xe9",
                    "substantial": "Substantiel",
                    "immense": "Immense"
                },
                "interest": {
                    "minimal": "Charge \xe9motionnelle minimale",
                    "light": "Charge \xe9motionnelle l\xe9g\xe8re",
                    "modest": "Charge \xe9motionnelle modeste",
                    "fair": "Charge \xe9motionnelle \xe9quitable",
                    "moderate": "Charge \xe9motionnelle mod\xe9r\xe9e",
                    "notable": "Charge \xe9motionnelle notable",
                    "considerable": "Charge \xe9motionnelle consid\xe9rable",
                    "heavy": "Charge \xe9motionnelle lourde",
                    "intense": "Charge \xe9motionnelle intense",
                    "crushing": "Charge \xe9motionnelle \xe9crasante"
                },
                "altrau": {
                    "receivedTitle": "Effet Altrau Z re\xe7u",
                    "issuedTitle": "Effet Altrau Z \xe9mis",
                    "hasGivenYou": "vous a donn\xe9",
                    "ledgersBound": "Vos registres sont d\xe9sormais li\xe9s. Leur Profit Vital affecte le v\xf4tre.",
                    "youHaveSent": "Vous avez envoy\xe9",
                    "toRecipient": "\xe0",
                    "fatesBound": "Vos destins sont d\xe9sormais li\xe9s. Votre Profit Vital affecte le leur."
                },
                "mnote": {
                    "acceptedTitle": "Note M accept\xe9e",
                    "createdTitle": "Note M cr\xe9\xe9e",
                    "witnessedVulnerability": "a \xe9t\xe9 t\xe9moin de votre vuln\xe9rabilit\xe9",
                    "loanLabel": "Pr\xeat",
                    "atRate": "avec",
                    "positiveTradeTip": "Effectuez des \xe9changes positifs pour r\xe9duire automatiquement cette dette !",
                    "createdWith": "Note M cr\xe9\xe9e avec",
                    "tradeableAfter": "N\xe9gociable apr\xe8s 5 \xe9changes. Convertible apr\xe8s le maximum d'\xe9changes.",
                    "progressTitle": "Progression du remboursement de la Note M",
                    "repaidPercent": "Vous avez rembours\xe9",
                    "throughTrading": "gr\xe2ce \xe0 des \xe9changes positifs",
                    "keepTrading": "Continuez \xe0 bien n\xe9gocier pour r\xe9duire davantage votre dette.",
                    "debtClearedTitle": "Dette effac\xe9e !",
                    "repaidTitle": "Note M rembours\xe9e",
                    "positiveTrading": "\xe9changes positifs",
                    "directRepayment": "remboursement direct",
                    "fullyRepaidTo": "Vous avez enti\xe8rement rembours\xe9 votre Note M \xe0",
                    "throughMethod": "par",
                    "emotionalDebtCleared": "Votre dette \xe9motionnelle est effac\xe9e. Bien jou\xe9 !",
                    "hasFullyRepaid": "a enti\xe8rement rembours\xe9 sa Note M",
                    "instrumentClosed": "L'instrument de dette a \xe9t\xe9 cl\xf4tur\xe9.",
                    "alertTitle": "Alerte Note M",
                    "convertibleTitle": "Note M convertible",
                    "nowConvertible": "Votre Note M est d\xe9sormais",
                    "convertibleCaps": "CONVERTIBLE",
                    "canConvertTo": "Vous pouvez la convertir en",
                    "inLiquidAssets": "en actifs liquides"
                },
                "cdo": {
                    "acceptedTitle": "CDO Z-Payday accept\xe9e",
                    "createdTitle": "CDO Z-Payday cr\xe9\xe9e",
                    "offeredLoan": "vous a propos\xe9 un pr\xeat",
                    "availableImmediately": "disponible imm\xe9diatement",
                    "createdWith": "CDO Z-Payday cr\xe9\xe9e avec",
                    "tradeableCompounds": "N\xe9gociable. Composition toutes les 60s \xe0 15%.",
                    "bankruptcyWarningTitle": "ALERTE FAILLITE",
                    "reloadCycle": "Rechargement CDO : Cycle {cycle}",
                    "cdoCompounded": "Votre CDO a \xe9t\xe9 compos\xe9e",
                    "victimOwes": "La victime doit",
                    "bankruptcyTitle": "FAILLITE",
                    "cdoCollapsed": "Votre CDO Z-Payday s'est effondr\xe9e",
                    "totalDebtLabel": "Dette totale",
                    "assetsSeized": "Actifs saisis",
                    "standingDamaged": "Votre situation financi\xe8re a \xe9t\xe9 gravement endommag\xe9e.",
                    "maturedTitle": "CDO arriv\xe9e \xe0 maturit\xe9",
                    "victimBankrupt": "Votre victime a d\xe9clar\xe9 faillite",
                    "youSeized": "Vous avez saisi",
                    "toxicGainRecorded": "Gain toxique enregistr\xe9 dans les relations."
                },
                "vnote": {
                    "aidGrantedTitle": "Aide de la Note V accord\xe9e",
                    "hasGrantedAid": "vous a accord\xe9 son aide",
                    "received": "Re\xe7u",
                    "vulnerabilityWitnessed": "Votre vuln\xe9rabilit\xe9 a \xe9t\xe9 reconnue et accueillie avec compassion.",
                    "youGranted": "Vous avez accord\xe9",
                    "toRecipient": "\xe0",
                    "compassionRecorded": "Votre compassion a \xe9t\xe9 enregistr\xe9e dans le registre social."
                }
            },
            "tax": {
                "tax_alert_timer": "ALERTE FISCALE ! Vous avez 10 secondes pour choisir, sinon vous perdez les deux :",
                "lose_capital": "Perdre du capital",
                "lose_capital_zollars": "Perdre du capital & zollars",
                "give_random_asset": "Donner un bien al\xe9atoire",
                "assign_failed": "\xc9chec de l\u2019attribution d\u2019un nouvel actif \xe0 tous les portefeuilles.",
                "new_asset_assigned": "La Zederal Reserve a attribu\xe9 un nouvel actif \xe0 votre portefeuille.",
                "tax_call_no_assets": "La R\xe9serve Z\xe9d\xe9rale impose un pr\xe9l\xe8vement. Appuyez sur OK pour c\xe9der du capital, aucun bien disponible pour r\xe9gler.",
                "asset_taxed": "Un bien a \xe9t\xe9 tax\xe9 par la Zederal Reserve.",
                "no_items_available": "Aucun bien non \xe9chang\xe9 disponible pour la taxation.",
                "tax_item_failed": "\xc9chec de la taxation d\u2019un bien.",
                "capital_taxed_prefix": "Vous avez \xe9t\xe9 tax\xe9 en capital par la Zederal Reserve !",
                "refund_received_prefix": "Vous avez re\xe7u un remboursement de capital de la Zederal Reserve",
                "new_asset_received": "Vous avez re\xe7u un nouvel actif de la Zederal Reserve",
                "zollar_assigned": "Vous avez re\xe7u des Zollars de la Zederal Reserve.",
                "points": "Capitaux"
            },
            "trader": {
                "price": "prix",
                "bien_q": "Bien",
                "send_message": "Envoyer un message",
                "no_economic_tiggers": "Vous n'avez aucun d\xe9clencheur \xe9conomique.",
                "no_stocks": "Vous ne poss\xe9dez aucune action.",
                "output": "Production",
                "tap_for_details": "touchez pour la fiche compl\xe8te + graphique",
                "message_cost": "Co\xfbt : 20 ",
                "no_bond_port": "Vous n'avez aucune ZBond.",
                "select_recipient": "S\xe9lectionnez un destinataire :",
                "message_placeholder": "Saisissez votre message (280 caract\xe8res max)",
                "send_button": "Envoyer",
                "close_button": "Fermer",
                "no_bond_port": "",
                "no_redeemed_item": "Aucun bien converti dans votre portefeuille.",
                "steal_commodity": "Voler une Commodity",
                "ransom": "Ran\xe7on",
                "no_zollar_port": "Aucun Zollar dans vos portefeuille.",
                "create_dark_pool": "Cr\xe9er un Dark Pool",
                "delete_portfolio": "Supprimer le portefeuille",
                "capitalist_lbo": "LBO Capitaliste",
                "socialist_subsidy": "Subvention Socialiste",
                "explanations": "Explications",
                "click_learn_more": "Cliquez pour en savoir plus",
                "go_to_market": "Aller au March\xe9",
                "dark_pool_market": "March\xe9 Dark Pool",
                "no_reason_provided": "Aucune raison fournie",
                "stock_name": "Nom de l'action",
                "unknown": "Inconnu",
                "symbol": "Symbole",
                "quantity": "Quantit\xe9",
                "no_shorts_open": "Aucune position Short plac\xe9e",
                "no_short_data": "Aucune data",
                "initial_value_per_share": "Valeur initiale par action",
                "current_value_per_share": "Valeur actuelle par action",
                "total_gain_loss": "Gain/Perte total",
                "reason_for_short": "Raison du short",
                "close_short_position": "Fermer la position short",
                "your_portfolio": "Votre portefeuille",
                "emotional_state_banner_title": "Votre \xe9conomie \xe9motionnelle",
                "social_economy_banner_title": "Instruments de dette \xe9motionnelle",
                "issue_altrau_z_bill": "\xc9mettre un Billet Z Altrauiste",
                "issue_m_note_borrow": "\xc9mettre une Note M (Emprunter)",
                "issue_z_payday_cdo": "\xc9mettre un CDO Z-Payday",
                "issue_v_note_request_aid": "Note V (Appel \xe0 l'aide)"
            },
            "market": {
                "all_types": "Tous les types",
                "goods": "Biens",
                "stocks": "Actions",
                "short_stock_title": "Shorter une Action ",
                "stock_label": "Action",
                "current_share_value": "Cours actuel de l\u2019action",
                "bonds": "Obligations",
                "no_sort": "Aucun tri",
                "price_low_to_high": "Prix : du plus bas au plus \xe9lev\xe9",
                "price_high_to_low": "Prix : du plus \xe9lev\xe9 au plus bas",
                "apply_filter": "Appliquer le filtre",
                "reset": "R\xe9initialiser",
                "close": "Fermer",
                "explanations": "Explications",
                "items": "Biens",
                "trade": "\xc9changer",
                "buy": "Acheter",
                "processing": "traitement en cours",
                "trade_for": "\xc9changer contre",
                "description": "Description",
                "value": "Valeur",
                "quantity": "Quantit\xe9",
                "location": "Emplacement",
                "owner": "Propri\xe9taire",
                "portfolio": "Portefeuille",
                "filter": "Filtrer",
                "redeem": "\xc9changer \u2713",
                "buy_bond_confirmation": "Acheter cette obligation d\xe9clenchera sa p\xe9riode de maturit\xe9. Confirmez pour continuer.",
                "bond_purchased_success": "Obligation achet\xe9e avec succ\xe8s !",
                "bond_purchase_failed": "\xc9chec de l'achat de l'obligation. Veuillez r\xe9essayer.",
                "portfolio_ransomed": "Votre portefeuille est actuellement sous ran\xe7on. Payez la ran\xe7on pour voir et interagir avec les objets.",
                "shorted_by": "Short\xe9 par :",
                "unknown": "Inconnu",
                "num_shares": "# Actions :",
                "short_value": "Valeur du short :",
                "reason": "Raison :",
                "enter_offer_for": "Entrez votre offre pour",
                "available_points": "Vous avez {points} capital disponibles. Co\xfbt de l'objet : {cost}.",
                "choose_offer_type": "Choisissez le type d'offre :",
                "waiting": "Attente",
                "zollars": "Zollars",
                "capital": "Capital",
                "confirm": "Confirmer",
                "cancel": "Annuler",
                "enter_capital": "Entrez le capital :",
                "offer_amount_placeholder": "Montant de l'offre",
                "select_zollar_value": "S\xe9lectionnez une valeur en Zollars pour continuer.",
                "invalid_offer": "Offre invalide ou capital insuffisant",
                "processing_transaction": "Traitement de votre transaction...",
                "waiting_seconds": "Attente : {seconds} secondes",
                "short_stock": "Shorter une action",
                "stock": "Action :",
                "processing": "Traitement de votre transaction...",
                "current_value": "Valeur actuelle :",
                "available_shares": "Actions disponibles :",
                "enter_num_shares": "Saisir le nombre d\u2019actions",
                "short_amount_placeholder": "Nombre d'actions \xe0 shorter",
                "short_reason_placeholder": "Pourquoi shortez-vous cette action ?",
                "confirm_short": "Confirmer le Short",
                "short_stock_btn": "Short Action",
                "must_provide_reason": "Vous devez fournir une raison pour shorter cette action.",
                "portfolio_name": "Nom du portefeuille"
            },
            offer: {
                item_received: "Vous avez re\xe7u {item} de la part de {giver} !",
                offer_sent: "Offre envoy\xe9e",
                do_not_leave_page: "NE QUITTEZ PAS LA PAGE.",
                awaiting_response: "En attente de r\xe9ponse\u2026",
                time_remaining_html: "Temps restant : <span id=\"timer\">{seconds}</span> secondes",
                time_remaining: "Temps restant : {seconds} secondes",
                time_expired: "Temps \xe9coul\xe9. Offre refus\xe9e.",
                offer_declined: "Offre refus\xe9e. Aucun capital accord\xe9.",
                offer_accepted: "Offre accept\xe9e ! Capital accord\xe9s.",
                trade_offer: "Offre de troc",
                offers_you: "{initiator} vous propose : {offered} en \xe9change de : {requested}",
                reason: "Raison :",
                respond: "R\xe9pondre",
                accept: "Accepter",
                decline: "Refuser",
                time_remaining_extended: "Temps restant : {seconds} secondes (prolong\xe9)",
                buy_offer_received: "Offre d\u2019achat re\xe7ue",
                zollar_offer_for: "Offre en zollars pour {item} de la part de {portfolio} : {details}",
                points_offer_for: "Offre en capital pour {item} de la part de {portfolio} : {details}",
                no_zollar_details: "Aucun d\xe9tail de zollars disponible.",
                your_portfolio: "Votre portefeuille",
                session_missing: "Session ou autorisation manquante. Veuillez vous reconnecter.",
                error_missing_details: "Erreur : informations manquantes pour l\u2019offre. R\xe9essayez.",
                error_invalid_points: "Erreur : montant invalide pour l\u2019offre en capital.",
                error_missing_zollar_details: "Erreur : d\xe9tails manquants pour l\u2019offre en zollars.",
                error_invalid_offer_type: "Erreur : type d\u2019offre invalide.",
                success_buy_offer_accepted: "Succ\xe8s : offre d\u2019achat accept\xe9e pour {item}",
                error_accepting_offer: "Erreur lors de l\u2019acceptation : {message}",
                processing: "Traitement de la transaction\u2026",
                meaningful_exchange: "\xc9change avec intention",
                value_quote: "La valeur existe dans la perception, le jeu et la sp\xe9culation, pas seulement l\u2019utilit\xe9 ou la raret\xe9.",
                who_to_trade_with: "Avec qui souhaitez-vous \xe9changer ?",
                select_trader: "S\xe9lectionnez un\xb7e trader\u2026",
                why_trade: "Pourquoi souhaitez-vous faire cet \xe9change ?",
                describe_motivation: "D\xe9crivez votre motivation, votre \xe9motion ou votre histoire\u2026",
                trade_with: "\xc9changer avec :",
                capital: "Capital",
                zollars: "Zollars",
                cancel: "Annuler",
                send_offer: "Envoyer l\u2019offre",
                sending: "Envoi\u2026",
                meaningful_offer_sent: "Offre de troc envoy\xe9e ! {insight}",
                error_generic: "Erreur : {message}",
                share_reason_placeholder: "Partagez votre raison, une motivation, un souvenir ou une vision\u2026 Pour cr\xe9er des liens significatifs en \xe9changeant.",
                meaningful_trade_offer: "Offre de troc avec intention",
                wants_to_trade: "souhaite \xe9changer",
                respond_optional: "R\xe9pondez \xe0 son histoire (optionnel)\u2026",
                not_interested: "Pas int\xe9ress\xe9",
                im_interested: "Je suis int\xe9ress\xe9 !",
                response_sent: "R\xe9ponse envoy\xe9e",
                interest_shown: "Int\xe9r\xeat indiqu\xe9 ! L\u2019autre partie peut vous contacter.",
                respond_to_offer: "R\xe9pondre \xe0 l\u2019offre.",
                the_why: "Le pourquoi :",
                share_thoughts: "Partagez vos id\xe9es, posez des questions ou expliquez votre point de vue\u2026",
                response_min_length: "Veuillez \xe9crire au moins 10 caract\xe8res.",
                response_min_10: "Veuillez \xe9crire au moins 10 caract\xe8res sur votre motivation.",
                send_response: "Envoyer la r\xe9ponse",
                response_sent_title: "R\xe9ponse envoy\xe9e",
                response_sent_waiting: "R\xe9ponse envoy\xe9e ! En attente de leur r\xe9ponse\u2026",
                your_response: "Votre r\xe9ponse :",
                waiting_for_response: "En attente de sa r\xe9ponse\u2026",
                timer_extended_60: "Minuteur prolong\xe9 \xe0 60 secondes",
                they_responded: "Ils ont r\xe9pondu",
                their_original_why: "Leur pourquoi initial :",
                their_response: "Leur r\xe9ponse :",
                accept_trade: "Accepter l\u2019\xe9change",
                decline_trade: "Refuser l\u2019\xe9change",
                updated_trade_offer: "Offre de troc mise \xe0 jour",
                offer_sentence_simple: "{name} vous propose {offered} et demande {requested} en \xe9change.",
                conversation: "Conversation :",
                buy_accepted_points: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item} pour {points} capital.",
                buy_accepted_zollars: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item} contre des zollars.",
                buy_accepted_generic: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item}.",
                error_processing_trade: "Erreur lors du traitement de l\u2019offre",
                zollar_none: "Aucun",
                zollar_few: "Quelques-uns",
                zollar_some: "Certains",
                zollar_many: "Beaucoup",
                zollar_huge: "\xc9norm\xe9ment"
            },
            "transaction": {
                "requested_item": "Bien demand\xe9",
                "item_owner": "Propri\xe9taire du bien",
                "item_name": "Nom du bien",
                "points": "capital",
                "location": "Emplacement",
                "propose": "Proposer",
                "explain_trade_reason": "Expliquez pourquoi vous souhaitez faire cet \xe9change.",
                "you_offer": "Vous proposez :",
                "you_want": "Vous voulez :",
                "why_trade_question": "Pourquoi voulez-vous faire cet \xe9change ? Quel est votre objectif ?",
                "share_motivation": "Partagez votre motivation, un souvenir ou une vision\u2026 Les histoires cr\xe9ent des connexions significatives dans le trading. (15 caract\xe8res minimum)",
                "narrative_error": "Veuillez \xe9crire au moins 15 caract\xe8res pour expliquer votre objectif.",
                "char_missing": "Il manque encore {count} caract\xe8res pour expliquer votre objectif.",
                "char_missing_full": "Veuillez \xe9crire au moins 15 caract\xe8res pour expliquer pourquoi vous souhaitez cet \xe9change.",
                "send_trade_with_intention": "Envoyer l'\xe9change avec une intention",
                "cancel": "Annuler",
                "select_asset": "S\xe9lectionner un actif",
                "return_to_market": "Retour au march\xe9"
            },
            "boss": {
                "session_required_leaderboard": "L'ID de session est requis pour voir le classement.",
                "session_required_mood_board": "L'ID de session est requis pour voir le tableau d'humeur.",
                "invalid_point_amount": "Montant de capital invalide. Veuillez r\xe9essayer.",
                "session_required_system_bot": "L'ID de session est requis pour d\xe9marrer le bot syst\xe8me.",
                "system_bot_started": "Bot syst\xe8me d\xe9marr\xe9 : {name}",
                "system_bot_start_failed": "\xc9chec du d\xe9marrage du bot syst\xe8me : {error}",
                "session_required_stop_bot": "L'ID de session est requis pour arr\xeater le bot syst\xe8me.",
                "system_bot_stopped": "Bot syst\xe8me arr\xeat\xe9 avec succ\xe8s.",
                "system_bot_stop_failed": "\xc9chec de l'arr\xeat du bot syst\xe8me : {error}",
                "session_required_trigger_event": "L'ID de session est requis pour d\xe9clencher l'\xe9v\xe9nement syst\xe8me.",
                "system_event_triggered": "\xc9v\xe9nement syst\xe8me d\xe9clench\xe9 avec succ\xe8s !",
                "system_event_trigger_failed": "\xc9chec du d\xe9clenchement de l'\xe9v\xe9nement syst\xe8me : {error}",
                "session_required_logout": "L'ID de session est requis pour d\xe9connecter les traders."
            },
            "stock": {
                "ownership_transferred": "Propri\xe9t\xe9 transf\xe9r\xe9e.",
                "transfer_failed": "\xc9chec du transfert de propri\xe9t\xe9. R\xe9essayez.",
                "share_deleted": "Action supprim\xe9e.",
                "delete_failed": "\xc9chec de la suppression de l\u2019action. R\xe9essayez.",
                "short_closed": "Vente \xe0 d\xe9couvert cl\xf4tur\xe9e.",
                "close_short_failed": "\xc9chec de la cl\xf4ture de la vente \xe0 d\xe9couvert. R\xe9essayez.",
                "short_placed": "Vente \xe0 d\xe9couvert ouverte.",
                "place_short_failed": "\xc9chec de l\u2019ouverture de la vente \xe0 d\xe9couvert. R\xe9essayez.",
                "no_short_positions": "Aucune vente \xe0 d\xe9couvert pour cette action.",
                "no_zollars_available": "Aucun Zollar disponible.",
                "select_zollars_to_bid": "S\xe9lectionnez des Zollars pour votre ench\xe8re.",
                "value": "Valeur",
                "place_bid": "Placer une ench\xe8re",
                "bid": "Ench\xe8re",
                "name": "Action",
                "short_reason_required": "Merci d\u2019indiquer une raison pour la short de cette action.",
                "failed_missing_shares": "\xc9chec : informations sur les actions introuvables.",
                "invalid_short_amount": "Quantit\xe9 d\u2019actions \xe0 Shorter invalide.",
                "short_succes": "Position Short plac\xe9e avec succ\xe8s !",
                "bid_type": "Type d\u2019ench\xe8re",
                "available_shares": "Actions disponibles",
                "available_funds": "Fonds disponibles",
                "fetch_short_failed": "\xc9chec du chargement des ventes \xe0 d\xe9couvert. R\xe9essayez.",
                "short_positions_for": "Ventes \xe0 d\xe9couvert pour l\u2019action",
                "short_position": "Vente \xe0 d\xe9couvert",
                "insufficient_funds": "Fonds insuffisants.",
                "enter_bid_amount": "Saisissez le montant de l\u2019ench\xe8re.",
                "enter_shares": "Saisissez le nombre d\u2019actions.",
                "enter_valid_amount": "Montant ou nombre d\u2019actions invalide.",
                "close_short": "Cl\xf4turer la vente \xe0 d\xe9couvert",
                "go_to_market": "Aller au march\xe9",
                "fetch_zollars_failed": "\xc9chec du chargement des Zollars.",
                "descriptor_none": "Aucune",
                "descriptor_a_few": "Quelques-unes",
                "descriptor_some": "Un certain nombre",
                "descriptor_many": "Beaucoup",
                "descriptor_huge": "\xc9norm\xe9ment",
                "submitting_bid": "Soumission de votre offre...",
                "please_wait": "Veuillez patienter pendant que nous la traitons.",
                "redirect_in": "Redirection dans",
                "seconds": "secondes"
            },
            "social_class": {
                "working_class": {
                    "name": "Classe Ouvri\xe8re",
                    "description": "Vous commencez endett\xe9 avec des ressources minimales. Chaque d\xe9cision compte.",
                    "goal": "\xc9chapper \xe0 la dette gr\xe2ce au commerce strat\xe9gique et \xe0 la construction communautaire",
                    "goals": {
                        "pay_off_debt": "Remonte ton capital au-dessus de z\xe9ro avant la fin du temps. Vends des parts, \xe9change des objets, accepte les offres justes \u2014 chaque affaire qui rapporte compte.",
                        "two_swaps": "R\xe9alise 2 \xe9changes (trocs) avec d'autres traders : tes choses contre les leurs. Pas besoin d'argent \u2014 le troc, c'est comme \xe7a qu'on trade quand on est fauch\xe9.",
                        "reserve_lift": "Va \xe0 la R\xe9serve Z\xe9d\xe9rale, prends un Z Bond pour obtenir du capital, et transforme-le en au moins un \xe9change qui fait grandir ce que tu d\xe9tiens."
                    }
                },
                "lower_middle": {
                    "name": "Classe Moyenne Inf\xe9rieure",
                    "description": "Vous avez des ressources modestes. Une planification prudente peut mener \xe0 la prosp\xe9rit\xe9.",
                    "goal": "Construire la stabilit\xe9 financi\xe8re et d\xe9velopper votre r\xe9seau",
                    "goals": {
                        "own_two_companies": "D\xe9tiens des parts de 2 entreprises diff\xe9rentes avant la fin. Choisis des entreprises dont l'histoire te parle \u2014 tu grandis quand elles grandissent.",
                        "first_zollars": "Ach\xe8te des zollars \xe0 la R\xe9serve Z\xe9d\xe9rale et gagne un \xe9change en payant avec des relations (Amour, Amiti\xe9\u2026) plut\xf4t qu'avec du capital.",
                        "grow_worth": "Fais grandir ta valeur totale d'un cinqui\xe8me. Ench\xe9ris sur ce qui est sous-\xe9valu\xe9, \xe9change vers le haut, et ne laisse pas dormir ton capital."
                    }
                },
                "middle_class": {
                    "name": "Classe Moyenne",
                    "description": "Vous commencez avec un portefeuille \xe9quilibr\xe9. Les choix strat\xe9giques d\xe9termineront votre trajectoire.",
                    "goal": "Maintenir la stabilit\xe9 tout en poursuivant des opportunit\xe9s de croissance",
                    "goals": {
                        "diversify": "Termine la session en d\xe9tenant les trois formes de valeur : des parts d'une entreprise, un objet, et une obligation.",
                        "three_bids": "Gagne 3 ench\xe8res sur des choses que d'autres traders d\xe9tiennent. Propose ton prix, dis pourquoi tu le veux, et convaincs-les.",
                        "relations_over_money": "Finis plus riche en zollars qu'en capital \u2014 trade pour que les relations p\xe8sent plus lourd que l'argent dans ton portefeuille."
                    }
                },
                "upper_middle": {
                    "name": "Classe Moyenne Sup\xe9rieure",
                    "description": "Vous avez des ressources importantes. Utilisez-les judicieusement pour cr\xe9er des opportunit\xe9s.",
                    "goal": "Tirer parti de vos ressources pour construire une influence durable",
                    "goals": {
                        "fair_patron": "Joue le m\xe9c\xe8ne : gagne 2 ench\xe8res ET accepte 2 offres de traders plus pauvres que toi, \xe0 un prix juste. L'influence se construit, elle ne s'ach\xe8te pas.",
                        "capital_to_life": "Convertis ton capital en valeur vivante : termine avec plus de richesse en parts et en objets qu'en simple capital.",
                        "bond_collector": "Construis un carnet d'obligations : d\xe9tiens 3 Z Bonds de la R\xe9serve Z\xe9d\xe9rale et laisse les int\xe9r\xeats travailler pour toi."
                    }
                },
                "wealthy_elite": {
                    "name": "\xc9lite Fortun\xe9e",
                    "description": "Vous commencez avec une richesse immense. Tout le monde veut ce que vous avez\u2014la g\xe9n\xe9rosit\xe9 cr\xe9e la protection.",
                    "goal": "Partagez la richesse pour construire des alliances ou faire face \xe0 une r\xe9sistance coordonn\xe9e",
                    "goals": {
                        "generous_giant": "Donne pour grandir : accepte des \xe9changes ou des ench\xe8res modestes d'au moins 3 traders diff\xe9rents. Sur ce parquet, la g\xe9n\xe9rosit\xe9 est une protection.",
                        "biggest_backer": "R\xe9partis ta richesse en parts de 4 entreprises diff\xe9rentes \u2014 deviens le plus grand soutien du parquet.",
                        "keep_the_crown": "Termine la session toujours au sommet. Tout le monde veut ce que tu as ; les alliances et les affaires justes sont ta seule fa\xe7on de le garder."
                    }
                },
                "starting_capital": "Capital de d\xe9part :",
                "starting_items": "Objets de d\xe9part :",
                "your_goal": "Votre objectif :",
                "actions_note": "Vos actions fa\xe7onnent la fa\xe7on dont les autres vous traitent. La g\xe9n\xe9rosit\xe9 construit des alliances, l'exploitation invite aux repr\xe9sailles."
            },
            "life_terms": {
                "_comment": "FR only. The heavy/lacking words from ZEconomy_baseline.csv, which is English. EN falls back to the term itself, like companies_by_id.",
                "abandoning": "abandon",
                "abandonment": "abandon",
                "absence": "absence",
                "absorbing": "absorption",
                "abusing": "abus",
                "accepting": "acceptation",
                "accumulating": "accumulation",
                "accusation": "accusation",
                "accusing": "accusation",
                "adaptability": "capacit\xe9 d'adaptation",
                "addiction": "d\xe9pendance",
                "adjusting": "ajustement",
                "aggression": "agressivit\xe9",
                "agitating": "agitation",
                "agitation": "agitation",
                "agony": "angoisse",
                "alergies": "allergies",
                "alienating": "ali\xe9nation",
                "alienation": "ali\xe9nation",
                "ambiguity": "ambigu\xeft\xe9",
                "amplification": "amplification",
                "amplifying": "amplification",
                "analysis paralysis": "paralysie par l'analyse",
                "analyzing": "analyse",
                "anger": "col\xe8re",
                "anguish": "angoisse",
                "annoyance": "agacement",
                "anxiety": "anxi\xe9t\xe9",
                "apathy": "apathie",
                "apologizing": "excuses",
                "arguing": "disputes",
                "argument": "dispute",
                "arrogance": "arrogance",
                "assimilating": "assimilation",
                "assuming": "pr\xe9somption",
                "assumptions": "pr\xe9suppos\xe9s",
                "assurance": "assurance",
                "attachment": "attachement",
                "attachment-issues": "troubles de l'attachement",
                "attacking": "agression",
                "attention-seeking": "qu\xeate d'attention",
                "avoidance": "\xe9vitement",
                "avoiding": "\xe9vitement",
                "awkwardness": "malaise",
                "backlog": "retard accumul\xe9",
                "backstabbing": "trahison",
                "backtracking": "revirements",
                "bad-luck": "malchance",
                "balance": "\xe9quilibre",
                "bankruptcy": "faillite",
                "being misunderstood": "\xeatre mal compris",
                "belittling": "rabaissement",
                "betrayal": "trahison",
                "betraying": "trahison",
                "betting": "pari",
                "bias": "parti pris",
                "binge-watching": "visionnage compulsif",
                "bingeing": "exc\xe8s compulsifs",
                "binging": "exc\xe8s compulsifs",
                "bitterness": "amertume",
                "blacking-out": "trous noirs",
                "blackout": "trou noir",
                "blaming": "reproches",
                "blind-acceptance": "acceptation aveugle",
                "blind-following": "suivisme aveugle",
                "blindness": "aveuglement",
                "bloating": "ballonnement",
                "blockage": "blocage",
                "blocking": "blocage",
                "bluffing": "bluff",
                "bluntness": "brusquerie",
                "boasting": "vantardise",
                "boldness": "audace",
                "boredom": "ennui",
                "bottling-up": "refoulement",
                "bragging": "vantardise",
                "brain-fog": "brouillard mental",
                "breakdown": "effondrement",
                "breaking": "rupture",
                "breaking-down": "effondrement",
                "broken-promises": "promesses bris\xe9es",
                "bruising": "meurtrissures",
                "brushing-aside": "balayage d'un revers",
                "buffering": "attente",
                "burden": "fardeau",
                "bureaucratic-fatigue": "lassitude administrative",
                "burnout": "\xe9puisement professionnel",
                "calling": "vocation",
                "carelessness": "n\xe9gligence",
                "catastrophizing": "catastrophisme",
                "causing offense": "offense",
                "censorship": "censure",
                "changing-too-often": "changements incessants",
                "chaos": "chaos",
                "chasing": "course effr\xe9n\xe9e",
                "chasing-trends": "course aux tendances",
                "cheating": "tricherie",
                "cherry-picking": "tri s\xe9lectif",
                "chronic-anxiety": "anxi\xe9t\xe9 chronique",
                "clashing": "heurts",
                "clicking": "clics",
                "clinginess": "d\xe9pendance affective",
                "clinging": "accrochage",
                "clocking-in": "pointage",
                "closed-mindedness": "fermeture d'esprit",
                "clumsiness": "maladresse",
                "clutter": "encombrement",
                "cognitive drain": "\xe9puisement cognitif",
                "coldness": "froideur",
                "collapsing": "effondrement",
                "collecting": "collection",
                "comfort": "r\xe9confort",
                "comparing": "comparaison",
                "comparison": "comparaison",
                "competing": "comp\xe9tition",
                "competition": "comp\xe9tition",
                "competitiveness": "esprit de comp\xe9tition",
                "complacency": "complaisance",
                "complaining": "plaintes",
                "complexity": "complexit\xe9",
                "compliance": "conformit\xe9",
                "complicating": "complication",
                "compromising": "compromis",
                "compulsion": "compulsion",
                "concealment": "dissimulation",
                "condemning": "condamnation",
                "condescending": "condescendance",
                "condescension": "condescendance",
                "confidence": "confiance en soi",
                "conflict": "conflit",
                "conflicts": "conflits",
                "conforming": "conformisme",
                "conformity": "conformisme",
                "confronting": "confrontation",
                "confusing": "confusion",
                "confusion": "confusion",
                "connecting": "lien",
                "connection": "lien",
                "conquering": "conqu\xeate",
                "consequences": "cons\xe9quences",
                "conspiring": "complot",
                "constraint": "contrainte",
                "consuming": "consommation",
                "contaminating": "contamination",
                "contamination": "contamination",
                "contradicting": "contradiction",
                "control-issues": "besoin de contr\xf4le",
                "controlling": "contr\xf4le",
                "copying": "imitation",
                "correcting": "correction",
                "corruption": "corruption",
                "covering": "dissimulation",
                "covering-up": "\xe9touffement",
                "cramming": "bachotage",
                "cramping": "crampes",
                "crashing": "effondrement",
                "craving": "manque",
                "cravings": "envies irr\xe9pressibles",
                "creative-block": "blocage cr\xe9atif",
                "creativity": "cr\xe9ativit\xe9",
                "cringe": "g\xeane",
                "crisis": "crise",
                "criticism": "critique",
                "criticizing": "critique",
                "critiquing": "critique",
                "crying": "larmes",
                "curiosity": "curiosit\xe9",
                "cursing": "jurons",
                "cutting": "coupures",
                "cycling": "cycles",
                "cynicism": "cynisme",
                "danger": "danger",
                "debt": "dette",
                "debugging": "d\xe9bogage",
                "deceiving": "tromperie",
                "deception": "tromperie",
                "defeat": "d\xe9faite",
                "defensiveness": "attitude d\xe9fensive",
                "deficiency": "carence",
                "deflecting": "esquive",
                "delaying": "report",
                "delays": "retards",
                "delusion": "illusion",
                "denial": "d\xe9ni",
                "denying": "d\xe9ni",
                "dependence": "d\xe9pendance",
                "dependency": "d\xe9pendance",
                "depleting": "\xe9puisement",
                "depletion": "\xe9puisement",
                "depression": "d\xe9pression",
                "depriving": "privation",
                "desensitization": "insensibilisation",
                "despair": "d\xe9sespoir",
                "desperation": "d\xe9sespoir",
                "destroying": "destruction",
                "detaching": "d\xe9tachement",
                "detachment": "d\xe9tachement",
                "determination": "d\xe9termination",
                "devaluing": "d\xe9valorisation",
                "diluting": "dilution",
                "diminishing": "amoindrissement",
                "dirtiness": "salet\xe9",
                "disagreement": "d\xe9saccord",
                "disappointment": "d\xe9ception",
                "disbelief": "incr\xe9dulit\xe9",
                "disbelieving": "incr\xe9dulit\xe9",
                "discomfort": "inconfort",
                "disconnecting": "d\xe9connexion",
                "disconnection": "d\xe9connexion",
                "discontent": "m\xe9contentement",
                "discouraging": "d\xe9couragement",
                "discrediting": "discr\xe9dit",
                "discrimination": "discrimination",
                "disengagement": "d\xe9sengagement",
                "dishonesty": "malhonn\xeatet\xe9",
                "disillusionment": "d\xe9sillusion",
                "disinterest": "d\xe9sint\xe9r\xeat",
                "dismissing": "rejet",
                "dismissiveness": "d\xe9dain",
                "disorder": "d\xe9sordre",
                "disorganization": "d\xe9sorganisation",
                "disorientation": "d\xe9sorientation",
                "disregarding": "m\xe9pris",
                "disrupting": "perturbation",
                "disruption": "perturbation",
                "dissatisfaction": "insatisfaction",
                "distance": "distance",
                "distancing": "mise \xe0 distance",
                "distorting": "distorsion",
                "distortion": "distorsion",
                "distracting": "distraction",
                "distraction": "distraction",
                "distrust": "m\xe9fiance",
                "dividing": "division",
                "dizziness": "vertiges",
                "dogma": "dogme",
                "doubt": "doute",
                "doubting": "doute",
                "draining": "\xe9puisement",
                "dread": "appr\xe9hension",
                "drifting": "d\xe9rive",
                "drinking-too-much": "exc\xe8s d'alcool",
                "droning": "monotonie",
                "dropping": "abandon",
                "dropping-calls": "appels coup\xe9s",
                "drowning": "noyade",
                "dullness": "morosit\xe9",
                "dwelling": "rumination",
                "echo chambers": "chambres d'\xe9cho",
                "ego": "ego",
                "egoism": "\xe9go\xefsme",
                "embarrassment": "embarras",
                "emotional stagnation": "stagnation \xe9motionnelle",
                "emotional-burdens": "fardeaux \xe9motionnels",
                "emotional-distance": "distance \xe9motionnelle",
                "emotional-exhaustion": "\xe9puisement \xe9motionnel",
                "emotional-fatigue": "fatigue \xe9motionnelle",
                "emotional-pain": "douleur \xe9motionnelle",
                "emptiness": "vide",
                "enduring": "endurance",
                "energy": "\xe9nergie",
                "enforcing": "imposition",
                "engagement": "engagement",
                "engaging": "engagement",
                "enjoying": "plaisir",
                "entertaining": "divertissement",
                "envy": "envie",
                "error": "erreur",
                "escalating": "escalade",
                "escaping": "fuite",
                "ethical struggles": "dilemmes \xe9thiques",
                "exaggerating": "exag\xe9ration",
                "excess": "exc\xe8s",
                "excluding": "exclusion",
                "exclusion": "exclusion",
                "exhaustion": "\xe9puisement",
                "existential dread": "angoisse existentielle",
                "exploitation": "exploitation",
                "exploiting": "exploitation",
                "exploring": "exploration",
                "expressing": "expression",
                "expression": "expression",
                "fading": "effacement",
                "failing": "\xe9chec",
                "failure": "\xe9chec",
                "fake-news": "fausses nouvelles",
                "faking": "simulation",
                "falls": "chutes",
                "fatigue": "fatigue",
                "fear": "peur",
                "fear of failure": "peur de l'\xe9chec",
                "fear of future": "peur de l'avenir",
                "fear of losing relevance": "peur de ne plus compter",
                "fear-driven-choices": "choix dict\xe9s par la peur",
                "fearing": "crainte",
                "fighting": "conflits",
                "financial instability": "instabilit\xe9 financi\xe8re",
                "fixating": "fixation",
                "fleeing": "fuite",
                "focus": "concentration",
                "fog": "brouillard",
                "food-insecurity": "ins\xe9curit\xe9 alimentaire",
                "forcing": "for\xe7age",
                "forgetfulness": "oublis",
                "forgetting": "oubli",
                "fragility": "fragilit\xe9",
                "freedom": "libert\xe9",
                "freezing": "paralysie",
                "frustration": "frustration",
                "gatekeeping": "gardiennage",
                "gloating": "jubilation malsaine",
                "greed": "avidit\xe9",
                "grief": "deuil",
                "growth": "croissance",
                "guessing": "conjectures",
                "guilt": "culpabilit\xe9",
                "hallucinating": "hallucinations",
                "hate": "haine",
                "hearing-loss": "perte auditive",
                "helplessness": "impuissance",
                "hesitating": "h\xe9sitation",
                "hesitation": "h\xe9sitation",
                "hiding": "dissimulation",
                "hoarding": "accumulation",
                "holding grudges": "rancune tenace",
                "holding-on": "accrochage",
                "hopelessness": "d\xe9sesp\xe9rance",
                "hostility": "hostilit\xe9",
                "ignoring": "indiff\xe9rence",
                "ignoring-needs": "besoins ignor\xe9s",
                "ignoring-responsibilities": "responsabilit\xe9s ignor\xe9es",
                "impatience": "impatience",
                "imposter syndrome": "syndrome de l'imposteur",
                "impulsivity": "impulsivit\xe9",
                "inability to adapt": "incapacit\xe9 \xe0 s'adapter",
                "inaction": "inaction",
                "incompatibility": "incompatibilit\xe9",
                "inconvenience": "d\xe9sagr\xe9ment",
                "indifference": "indiff\xe9rence",
                "inferiority": "inf\xe9riorit\xe9",
                "influence": "influence",
                "injuries": "blessures",
                "insincerity": "fausset\xe9",
                "insomnia": "insomnie",
                "instability": "instabilit\xe9",
                "insulting": "insultes",
                "interrupting": "interruptions",
                "irritability": "irritabilit\xe9",
                "irritation": "irritation",
                "isolating": "isolement",
                "isolation": "isolement",
                "jealousy": "jalousie",
                "joy": "joie",
                "judgment": "jugement",
                "juggling": "jonglage",
                "lack of clarity": "manque de clart\xe9",
                "laughing": "rire",
                "laziness": "paresse",
                "leading": "conduite",
                "learning": "apprentissage",
                "limiting": "limitation",
                "loneliness": "solitude",
                "longing": "nostalgie",
                "looping": "ressassement",
                "loss of friendships": "perte d'amiti\xe9s",
                "make-worse": "aggravation",
                "manipulated outcomes": "r\xe9sultats manipul\xe9s",
                "materialism": "mat\xe9rialisme",
                "mental-fog": "brouillard mental",
                "miscommunication": "malentendus",
                "misinterpretation": "interpr\xe9tation erron\xe9e",
                "misinterpreting": "mauvaise interpr\xe9tation",
                "misjudging": "erreur de jugement",
                "missed opportunities": "occasions manqu\xe9es",
                "misunderstanding": "incompr\xe9hension",
                "mockery": "moquerie",
                "moral conflict": "conflit moral",
                "negative thinking": "pens\xe9e n\xe9gative",
                "neglect": "n\xe9gligence",
                "neglecting": "n\xe9gligence",
                "observing": "observation",
                "obsessing": "obsession",
                "obsession": "obsession",
                "obsessiveness": "obsession",
                "offensiveness": "agressivit\xe9 blessante",
                "over-confidence": "exc\xe8s de confiance",
                "overanalyzing": "suranalyse",
                "overconfidence": "exc\xe8s de confiance",
                "overdeliberating": "tergiversation",
                "overindulgence": "exc\xe8s",
                "overindulging": "exc\xe8s",
                "overspending": "d\xe9penses excessives",
                "overstimulating": "surstimulation",
                "overthinking": "rumination",
                "overwhelm": "d\xe9bordement",
                "overwork": "surmenage",
                "overworking": "surmenage",
                "pacing": "rythme",
                "panic": "panique",
                "paranoia": "parano\xefa",
                "perfectionism": "perfectionnisme",
                "perspective": "recul",
                "playfulness": "l\xe9g\xe8ret\xe9",
                "political backlash": "r\xe9action politique",
                "presenting": "pr\xe9sentation",
                "pressure": "pression",
                "problem-solving": "r\xe9solution de probl\xe8mes",
                "productivity": "productivit\xe9",
                "reflecting": "r\xe9flexion",
                "reflection": "r\xe9flexion",
                "relationship damage": "relations ab\xeem\xe9es",
                "relationship struggles": "difficult\xe9s relationnelles",
                "resentment": "ressentiment",
                "resilience": "r\xe9silience",
                "restlessness": "agitation",
                "rigidity": "rigidit\xe9",
                "risk aversion": "aversion au risque",
                "ruminating": "rumination",
                "self-consciousness": "g\xeane de soi",
                "self-doubt": "doute de soi",
                "sensory-overload": "surcharge sensorielle",
                "shame": "honte",
                "sharing": "partage",
                "smugness": "suffisance",
                "social alienation": "ali\xe9nation sociale",
                "social conflict": "conflit social",
                "social conflicts": "conflits sociaux",
                "social pressure": "pression sociale",
                "social shame": "honte sociale",
                "strength": "force",
                "stress": "stress",
                "stubborn misjudgments": "erreurs obstin\xe9es",
                "suffering": "souffrance",
                "superficial relationships": "relations superficielles",
                "superficiality": "superficialit\xe9",
                "supporting": "soutien",
                "tediousness": "monotonie",
                "understanding": "compr\xe9hension",
                "validation addiction": "d\xe9pendance \xe0 la validation"
            },
            "life_profile": {
                "room_title": "LA SALLE RECLASS\xc9E",
                "room_you": "(vous)",
                "more_about": "PLUS SUR VOTRE SESSION \u25B8",
                "flows_title": "O\xd9 EST ALL\xc9E VOTRE VALEUR",
                "flow_the_room": "la salle",
                "flow_value": "valeur",
                "kind_gift": "don",
                "kind_swap": "\xe9change",
                "kind_trade": "transaction",
                "kind_lend": "pr\xeat\xe9",
                "kind_aid": "aide",
                "kind_predatory": "pr\xeat pr\xe9dateur",
                "kind_bond": "obligation",
                "kind_seized": "saisi",
                "verdict_title": "LA SALLE VOUS A RECLASS\xc9",
                "entered": "Entr\xe9 :",
                "by_capital": ", selon le capital.",
                "leaves": "Repart :",
                "by_balance": ", selon l'\xe9quilibre et ce qui a \xe9t\xe9 donn\xe9.",
                "balance_label": "\xc9quilibre",
                "giving_label": "Donn\xe9",
                "gave_nothing": "Vous n'avez rien donn\xe9. Aussi \xe9quilibr\xe9e soit une vie, cette salle ne la classera pas plus haut.",
                "carries_title": "CE QUE VOTRE VIE PORTE",
                "chose": "Vous avez choisi {company}. C'est de cela que votre vie est lourde.",
                "heavy_label": "Trop de :",
                "lacking_label": "Rien du tout :",
                "how_it_ends": "Quand le temps sera \xe9coul\xe9, la salle d\xe9cidera de votre classe selon votre \xe9quilibre et selon ce que vous avez donn\xe9 \u2014 non selon ce que vous avez gagn\xe9."
            },
            "debt_actions": {
                "common": {
                    "perceived_magnitude": "Ampleur per\xe7ue",
                    "magnitude_none": "Aucune",
                    "magnitude_hint": "Un soup\xe7on",
                    "error_login_required": "Veuillez d'abord vous connecter"
                },
                "help_friend": {
                    "intro": "Tendre la main. Choisissez <b>Z$</b> ou <b>Capital</b> pour votre don.",
                    "capital_label": "Capital (montant)",
                    "capital_placeholder": "Saisir le montant",
                    "select_zollars": "S\xe9lectionnez les types de Z$ \xe0 offrir.",
                    "recipient_label": "B\xe9n\xe9ficiaire :",
                    "no_zollars": "Aucun Z$ disponible.",
                    "modal_title": "Billet Z Altrauiste (Don altruiste)",
                    "error_no_recipient": "Choisissez un b\xe9n\xe9ficiaire.",
                    "error_invalid_capital": "Saisissez un montant de capital valide.",
                    "error_no_zollars_to_give": "Aucun Z$ \xe0 offrir.",
                    "error_select_zollars": "S\xe9lectionnez des Z$ \xe0 offrir.",
                    "error_insufficient_zollars": "Z$ {type} insuffisants. Vous en avez {available}, tentative d'envoi de {count}.",
                    "success": "Billet Z Altrauiste \xe9mis. Vos registres sont d\xe9sormais li\xe9s."
                },
                "predatory_lend": {
                    "intro": "CDO Z-Payday : proposez un pr\xeat compos\xe9 qui se recharge toutes les 60 secondes.",
                    "warning": "ATTENTION : Chaque cycle augmente la dette de 15 % jusqu'au remboursement ou \xe0 l'effondrement.",
                    "exploitation_note": "(Exploitation grim\xe9e en lien empathique.)",
                    "capital_label": "Capital (montant \xe0 \xab pr\xeater \xbb)",
                    "capital_placeholder": "Montant",
                    "select_zollars": "Choisissez l'app\xe2t Z$ pour pr\xe9cipiter la chute.",
                    "victim_label": "Cible vuln\xe9rable :",
                    "no_zollars": "Aucun Z$ disponible.",
                    "modal_title": "CDO Z-Payday (Pr\xeat pr\xe9dateur)",
                    "error_no_victim": "D\xe9signez une victime.",
                    "error_invalid_amount": "Saisissez un montant valide.",
                    "error_no_zollars_selected": "Aucun Z$ s\xe9lectionn\xe9.",
                    "error_select_zollars": "S\xe9lectionnez des Z$.",
                    "success_targeted": "Offre CDO Z-Payday envoy\xe9e \xe0 la cible. Se recharge toutes les 60 secondes d\xe8s acceptation.",
                    "success_market": "CDO Z-Payday list\xe9 sur le march\xe9 \u2014 grim\xe9 en offre attrayante."
                },
                "borrow": {
                    "intro": "Solliciter un pr\xeat (Note M).",
                    "vulnerability_required": "Exposez votre dette \xe9motionnelle. Vuln\xe9rabilit\xe9 requise.",
                    "vulnerability_label": "Pourquoi avez-vous besoin de ce pr\xeat ? (Confession \xe9motionnelle \u2014 min. 20 car.)",
                    "vulnerability_placeholder": "Exposez votre fragilit\xe9 ici...",
                    "char_count": "0 / 20 car.",
                    "char_suffix": "/ 20 car.",
                    "severity_label": "Gravit\xe9",
                    "severity_question": "\xc0 quel point votre besoin est-il pressant ?",
                    "move_sliders": "Ajustez les curseurs pour exprimer votre besoin :",
                    "lender_label": "Choisir un pr\xeateur :",
                    "modal_title": "Note M (Demande de pr\xeat)",
                    "error_vulnerability_required": "La Note M exige une confession de vuln\xe9rabilit\xe9 (min. 20 caract\xe8res).",
                    "error_move_slider": "D\xe9placez au moins un curseur pour exprimer votre besoin.",
                    "error_no_lender": "Veuillez s\xe9lectionner un pr\xeateur.",
                    "success_targeted": "Demande Note M envoy\xe9e au pr\xeateur.",
                    "success_market": "Note M list\xe9e sur le march\xe9 \u2014 en qu\xeate d'un pr\xeateur."
                },
                "request_aid": {
                    "intro": "Lancer un appel \xe0 l'aide (Note V).",
                    "description": "Demandez du soutien en partageant votre vuln\xe9rabilit\xe9.",
                    "accept_decline_note": "L'autre peut accepter ou refuser.",
                    "vulnerability_label": "Expliquez pourquoi vous avez besoin d'aide (confession de vuln\xe9rabilit\xe9 \u2014 min. 20 car.)",
                    "vulnerability_placeholder": "Partagez votre fragilit\xe9...",
                    "severity_question": "Urgence de la situation",
                    "target_label": "Demander de l'aide \xe0 :",
                    "modal_title": "Note V (Appel \xe0 l'aide)",
                    "error_no_target": "Choisissez \xe0 qui demander de l'aide.",
                    "error_vulnerability_required": "La Note V exige une confession de vuln\xe9rabilit\xe9 (min. 20 caract\xe8res).",
                    "success": "Demande Note V envoy\xe9e. En attente de r\xe9ponse."
                }
            },
            "items": {
                "item_added_success": "Objet ajout\xe9 avec succ\xe8s !",
                "item_add_failed": "\xc9chec de l'ajout de l'objet. Veuillez r\xe9essayer.",
                "no_items_portfolio": "Aucune marchandise dans ce portefeuille.",
                "search_portfolios": "Rechercher des portefeuilles...",
                "item_assigned_success": "Objet assign\xe9 au portefeuille avec succ\xe8s",
                "item_assign_failed": "\xc9chec de l'assignation de l'objet au portefeuille. Veuillez r\xe9essayer.",
                "item_unassigned_success": "Marchandise d\xe9sassign\xe9e du portefeuille avec succ\xe8s",
                "item_unassign_failed": "\xc9chec de la d\xe9sassignation de la marchandise du portefeuille. Veuillez r\xe9essayer.",
                "item_deleted_success": "Objet supprim\xe9 avec succ\xe8s",
                "item_delete_failed": "\xc9chec de la suppression de la marchandise. Veuillez r\xe9essayer.",
                "item_redeemed_success": "Objet \xe9chang\xe9 avec succ\xe8s",
                "item_unredeemed_success": "Objet non \xe9chang\xe9 avec succ\xe8s",
                "redeem_toggle_failed": "\xc9chec du basculement du statut d'\xe9change. Veuillez r\xe9essayer."
            },
            "zollar": {
                "select_relationship_required": "Veuillez s\xe9lectionner au moins une relation et entrer une quantit\xe9.",
                "zollars_added_success": "Zollar(s) ajout\xe9(s) avec succ\xe8s",
                "add_failed_error": "\xc9chec de l'ajout du/des zollar(s). Veuillez r\xe9essayer. Erreur : {error}",
                "deleted_success": "Zollar supprim\xe9 avec succ\xe8s",
                "delete_failed": "\xc9chec de la suppression du zollar",
                "fill_required_fields": "Veuillez remplir tous les champs requis correctement.",
                "zbond_added_success": "ZBond ajout\xe9 avec succ\xe8s",
                "zbond_add_failed": "\xc9chec de l'ajout du ZBond. Erreur : {error}",
                "select_portfolio_required": "Veuillez s\xe9lectionner un portefeuille auquel assigner l'objet.",
                "assign_failed": "\xc9chec de l'assignation de {itemType}. Veuillez r\xe9essayer.",
                "unassigned_success": "{itemType} d\xe9sassign\xe9 du portefeuille avec succ\xe8s",
                "unassign_failed": "\xc9chec de la d\xe9sassignation du portefeuille. Veuillez r\xe9essayer.",
                "bond_deleted_success": "Obligation supprim\xe9e avec succ\xe8s",
                "bond_delete_failed": "Erreur lors de la suppression de l'obligation : {error}",
                "session_details_failed": "\xc9chec de la r\xe9cup\xe9ration des d\xe9tails de session. Veuillez r\xe9essayer.",
                "session_fetch_error": "Erreur lors de la r\xe9cup\xe9ration des d\xe9tails de session. Veuillez r\xe9essayer plus tard.",
                "fetch_portfolios_error": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles actifs. Veuillez r\xe9essayer."
            },
            presentation: {
                "title": "ZExchange - Pr\xe9sentation",
                "hero_tagline": "Et si la valeur n'\xe9tait pas un nombre ?",
                "intro_main": "Une exp\xe9rience de salle des march\xe9s en direct pour 10 \xe0 200 participants, durant de 1 \xe0 24 heures. Mais ce n'est pas Wall Street. Ici, la classe d'actifs est l'exp\xe9rience humaine elle-m\xeame.",
                "card_trade_title": "N\xe9gociez des Conditions Humaines",
                "card_trade_desc": "Au lieu d'Apple ou Nvidia, investissez dans Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Chaque action repr\xe9sente une facette de l'existence.",
                "card_spend_title": "D\xe9pensez des Relations",
                "card_spend_desc": "Oubliez les dollars. Ici vous payez avec des Zollars, une monnaie libell\xe9e par type de relation : Amour, Amiti\xe9, Haine, \xc9rotique, Toxique, Mort.",
                "card_consume_title": "Consommez Collectivement",
                "card_consume_desc": "Vous poss\xe9dez un verre de vin ? Vous ne pouvez pas l'acqu\xe9rir seul. Pour \xe9changer toute marchandise, vous devez demander l'approbation des autres. La consommation requiert un consentement mutuel.",
                "card_market_title": "Le March\xe9 Vous Observe",
                "card_market_desc": "Une IA narre chaque transaction, interpr\xe9tant ce que vos \xe9changes r\xe9v\xe8lent sur vous. Le march\xe9 ne bouge pas seulement, il parle.",
                "intro_transform": "ZExchange transforme la logique \xe9conomique en une conversation collective sur ce que nous valorisons vraiment.",
                "intro_mirror": "C'est en partie art conceptuel, en partie art festif, en partie miroir. Les organisations d\xe9couvrent leurs valeurs cach\xe9es. Les groupes confrontent le pouvoir, l'\xe9quit\xe9 et la confiance. Chacun repart avec des questions qu'il n'avait pas en arrivant.",
                "section_video": "Vid\xe9os Explicatives",
                "section_video_desc": "Cliquez pour regarder les explications conceptuelles",
                "video_intro": "Introduction \xe0 ZExchange",
                "video_intro_desc": "Aper\xe7u du concept",
                "video_life": "Profits de Vie & Valeur",
                "video_life_desc": "La valeur dans la ZEconomy",
                "video_stocks": "Fonctionnement des Actions",
                "video_stocks_desc": "N\xe9gocier des conditions humaines",
                "video_zbonds": "ZBonds & Zollars",
                "video_zbonds_desc": "Syst\xe8me Mon\xe9taire Relationnel Z",
                "video_commodity": "Commodity X",
                "video_commodity_desc": "Consommation sociale",
                "video_interface": "Aper\xe7u de l'Interface",
                "video_interface_desc": "L'interface de trading",
                "video_bigboard": "Big Boards G\xe9n\xe9ratifs",
                "video_bigboard_desc": "Expression du march\xe9 en temps r\xe9el",
                "section_assets": "Actifs N\xe9gociables",
                "section_assets_desc": "Cliquez sur les banni\xe8res pour des explications d\xe9taill\xe9es",
                "label_stocks": "ACTIONS - Conditions Humaines en Parts",
                "label_zbonds": "ZBONDS - Investissements Bas\xe9s sur les Relations",
                "label_commodities": "MARCHANDISES - Objets Physiques avec Approbation Sociale",
                "label_zollars": "ZOLLARS - Monnaie Sans Chiffres",
                "section_economic": "Outils \xc9conomiques",
                "section_economic_desc": "Approches id\xe9ologiques de la richesse et du pouvoir",
                "label_economic": "D\xc9CLENCHEURS \xc9CONOMIQUES - L'Id\xe9ologie comme Action de March\xe9",
                "label_communist": "Assaut Communiste",
                "label_socialist": "Subvention Socialiste",
                "label_lbo": "LBO Capitaliste",
                "section_trader": "Outils du Trader",
                "section_trader_desc": "Jusqu'o\xf9 irez-vous dans la qu\xeate de valeur ?",
                "label_trader": "OUTILS DU TRADER - Actions Avec ou Contre les Autres",
                "label_steal": "Vol",
                "label_ransom": "Ran\xe7on",
                "label_darkpool": "Dark Pool",
                "section_features": "Fonctionnalit\xe9s du March\xe9",
                "label_emotional": "INDICE DE DETTE \xc9MOTIONNELLE - Flux d'\xc9motions Humaines",
                "label_bigboard": "LE BIG BOARD - Visualisation du March\xe9 en Temps R\xe9el",
                "label_voice": "VOIX DE LA BOURSE - Narration IA du March\xe9",
                "section_central": "R\xe9serve Z\xe9d\xe9rale / R\xe9gulateur ZExchange",
                "section_central_desc": "Comment l'op\xe9rateur ZExchange contr\xf4le les sessions de march\xe9",
                "central_intro": "La R\xe9serve Z\xe9d\xe9rale (ou Op\xe9rateur ZExchange) orchestre l'ensemble de la session de trading. Avant l'ouverture du march\xe9, c'est l'interface o\xf9 vous configurez l'\xe9conomie : cr\xe9ation de portefeuilles de traders avec capital initial et marchandises disponibles pendant la session, distribution d'actions parmi plus de 350 entreprises ZEconomy pr\xe9d\xe9finies, et \xe9mission de Zollars et ZBonds bas\xe9s sur les relations. Pendant la session, vous agissez comme r\xe9gulateur et autorit\xe9 centrale : ouverture et fermeture du march\xe9, contr\xf4le des types d'actifs n\xe9gociables, taxation des portefeuilles pour extraire de la valeur, subvention des traders avec capital ou marchandises, \xe9mission de d\xe9clencheurs sp\xe9ciaux (Vol, Ran\xe7on, Dark Pool, Assaut Communiste, Subvention Socialiste, LBO Capitaliste), diffusion d'\xe9v\xe9nements m\xe9diatiques, et d\xe9ploiement de bots de march\xe9 pour la liquidit\xe9. Vous pouvez fa\xe7onner le r\xe9cit de la session \xe0 travers des th\xe8mes narratifs qui guident l'interpr\xe9tation de l'IA de l'activit\xe9 du march\xe9. La R\xe9serve Z\xe9d\xe9rale agit comme une Banque Centrale incarnant la tension entre contr\xf4le et chaos dans toute \xe9conomie, vous pouvez favoriser l'\xe9quilibre ou cr\xe9er la disruption, r\xe9compenser ou punir, stimuler ou restreindre. Chaque d\xe9cision se r\xe9percute sur le march\xe9, mettant au d\xe9fi les traders de s'adapter et de r\xe9agir.",
                "label_control": "CONTR\xd4LE DU MARCH\xc9 - Ouverture/Fermeture & Liste des Actifs",
                "section_tax": "Taxation des Portefeuilles",
                "section_tax_desc": "Extraire de la valeur des portefeuilles des traders",
                "label_taxall": "Taxer Tous les Traders",
                "label_taxitem": "Taxer une Marchandise",
                "label_taxpoints": "Taxer le Capital",
                "section_subsidize": "Subventionner les Portefeuilles",
                "section_subsidize_desc": "Injecter de la valeur dans les portefeuilles des traders",
                "label_givezollar": "Donner des Zollars",
                "label_givepoints": "Donner du Capital",
                "label_giveitem": "Donner une Marchandise",
                "label_freebie": "Distribution de Marchandises",
                "section_events": "D\xe9clencheurs d'\xc9v\xe9nements",
                "section_events_desc": "Diffuser des m\xe9dias et cr\xe9er des r\xe9cits",
                "label_publizity": "Lancer PubliZity",
                "label_znews": "Lancer ZNews",
                "label_story": "Cr\xe9er un R\xe9cit",
                "section_bots": "Bots de March\xe9",
                "section_bots_desc": "Trading automatis\xe9 pour la liquidit\xe9 du march\xe9",
                "label_addbots": "Ajouter des Bots",
                "label_removebots": "Retirer les Bots",
                "label_botstatus": "Statut des Bots",
                "section_keep": "Ce que les Participants Gardent",
                "keep_bigboard": "Un Big Board fa\xe7onn\xe9 par chaque \xe9change, fig\xe9 en \u0153uvre d'art g\xe9n\xe9rative",
                "keep_story": "Une histoire \xe9crite par l'IA de la dynamique de votre groupe",
                "keep_award": "Peut-\xeatre un prix ou deux",
                "keep_mirror": "Un miroir refl\xe9tant ce que votre organisation valorise vraiment",
                "section_concepts": "Concepts Cl\xe9s",
                "concept_life_title": "Profit de Vie",
                "concept_life_desc": "La valeur de la vie consciemment v\xe9cue : joie, perte, amour, d\xe9pression. Qualit\xe9 plut\xf4t que quantit\xe9.",
                "concept_auto_title": "Pas de Pilote Automatique",
                "concept_auto_desc": "Chaque transaction requiert une pr\xe9sence. Pour \xe9changer, engagez-vous avec un autre. Pour racheter, vous devez demander.",
                "concept_market_title": "Le March\xe9 R\xe9pond",
                "concept_market_desc": "L'IA observe chaque transaction, offrant interpr\xe9tations et narration.",
                "concept_shared_title": "Valeurs Partag\xe9es",
                "concept_shared_desc": "Spectres politiques oppos\xe9s, m\xeames exp\xe9riences humaines.",
                "footer_mirror": "ZExchange n'est pas qu'un march\xe9 ; c'est un miroir.",
                "footer_transform": "Il transforme la logique froide de l'\xe9conomie en une conversation collective sur ce que nous valorisons vraiment.",
                "footer_part": "Fait partie de",
                "popup_stocks": "<h3>Actions (Stocks)</h3><strong>Description :</strong><br>Surveillez et \xe9changez vos positions en actions.<br><br><strong> qu'est :</strong><br>En finance traditionnelle, une action repr\xe9sente une part de propri\xe9t\xe9 d'une entreprise. Les investisseurs ach\xe8tent g\xe9n\xe9ralement des actions en esp\xe9rant que la valeur de l'entreprise augmente.<br><br>Dans la ZEconomy, chaque \xab entreprise \xbb refl\xe8te des valeurs personnelles ou humaines, comme le bien-\xeatre \xe9motionnel, les relations sociales ou les activit\xe9s du quotidien, plut\xf4t que des produits ou services classiques. En \xab investissant \xbb dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilit\xe9 des exp\xe9riences humaines.<br><br><strong>Lecture conceptuelle :</strong><br>ZExchange remet en question la notion de profit : au del\xe0 de simples gains financiers, on devrait penser plut\xf4t au l'expansion de la \xab life value \xbb la produit de sant\xe9 \xe9motionnelle, cr\xe9ativit\xe9, exp\xe9riences partag\xe9es ?<br><br>Consid\xe9rez vos actions comme des investissements dans la valeur humaine : bonheur, d\xe9pression, r\xe9ussite, \xe9chec, confusion, plut\xf4t qu'une entreprise produisant un bien ou un service.<br><br><strong>M\xe9canismes :</strong><br>Les actions sont \xe9changeables contre des Zollars ou du capital. \xc0 mesure que la valeur d'une entreprise augmente ou besse, la valeur de votre portefeuille cro\xeet \xe9galement.",
                "popup_zbonds": "<h3>ZBonds</h3><strong>Description :</strong><br>Les ZBonds fonctionnent comme des obligations traditionnelles : vous les achetez avec du capital, les conservez sur une dur\xe9e d\xe9termin\xe9e, et \xe0 leur \xe9ch\xe9ance, vous recevez des Zollars.<br><br><strong>Lecture conceptuelle :</strong><br>L\xe0 o\xf9 les obligations classiques financent des gouvernements ou des entreprises, les ZBonds financent la cr\xe9ation d'une monnaie (les Zollars) dont la valeur est enti\xe8rement li\xe9e aux relations humaines et aux exp\xe9riences v\xe9cues.<br><br>Investir dans un ZBond revient \xe0 placer sa confiance dans les valeurs partag\xe9es de la communaut\xe9 et des liens interpersonnels, plut\xf4t que dans un rendement purement financier.<br><br>Les ZBonds font le lien entre les \xab titres \xe0 revenu fixe \xbb traditionnels et la red\xe9finition de la valeur propos\xe9e par la ZEconomy.",
                "popup_commodities": "<h3>Mati\xe8res premi\xe8res (Commodity X)</h3><strong>Description :</strong><br>Les objets physiques \xe9changeables que vous poss\xe9dez.<br><br><strong>Validation sociale :</strong><br>Aucune marchandise ne peut \xeatre consomm\xe9e seul. Pour en \xe9changer une, les traders doivent demander l'approbation des autres. Si tous acceptent, l'objet est lib\xe9r\xe9 ; si l'un refuse, rien ne se passe.<br><br><strong>Lecture conceptuelle :</strong><br>Que signifie devoir demander la permission pour ce que l'on poss\xe8de d\xe9j\xe0 ? La validation sociale introduit une friction l\xe0 o\xf9 les march\xe9s cherchent \xe0 l'\xe9liminer, rendant la consommation visible, questionn\xe9e, collective.<br><br>Les mati\xe8res premi\xe8res nous rappellent que les march\xe9s concernent aussi des biens et des exp\xe9riences qui fa\xe7onnent nos vies.",
                "popup_zollars": "<h3>Zollars</h3><strong>Description :</strong><br>Consultez vos soldes et transactions en Zollars.<br><br><strong>Une monnaie sans chiffres :</strong><br>Les Zollars sont libell\xe9s par type de relation : Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Utiliser des Zollars pousse les participants \xe0 r\xe9fl\xe9chir \xe0 <em>la nature</em> de la valeur en jeu, plut\xf4t qu'\xe0 <em>sa quantit\xe9</em>.<br><br><strong>Lecture conceptuelle :</strong><br>Acqu\xe9rir Zo Insomnia Incorporated avec des Zollars Love ne raconte pas la m\xeame histoire qu'avec des Zollars Toxic. L'interpr\xe9tation est personnelle ; le cadre est partag\xe9.<br><br>Les Zollars remettent en question les id\xe9es traditionnelles de la monnaie en fondant la valeur sur les relations humaines.",
                "popup_economic": "<h3>D\xe9clencheurs d'attaque \xe9conomique</h3><strong>Description :</strong><br>Les d\xe9clencheurs d'attaque \xe9conomique repr\xe9sentent diff\xe9rentes approches id\xe9ologiques de la richesse, du pouvoir et des dynamiques de march\xe9. Ils permettent aux traders d'utiliser des strat\xe9gies inspir\xe9es de syst\xe8mes \xe9conomiques \u2014 communisme, socialisme, capitalisme \u2014 pour obtenir ou redistribuer des avantages dans la ZEconomy.<br><br><strong>Lecture conceptuelle :</strong><br>Ces d\xe9clencheurs poussent les participants \xe0 confronter leurs croyances sur l'\xe9quit\xe9, l'ambition et la responsabilit\xe9 collective. Ils alimentent le d\xe9bat sur l'\xe9quilibre entre justice, ambition et compromis \xe9thiques.<br><br><ul><li>La richesse doit-elle \xeatre partag\xe9e \xe9quitablement, m\xeame si cela implique de confisquer le succ\xe8s d'autrui ?</li><li>Est-il \xe9thique de tirer profit au d\xe9triment de l'autonomie d'un autre ?</li><li>Jusqu'o\xf9 \xeates-vous pr\xeat \xe0 aller pour un gain personnel ou pour soutenir le bien collectif ?</li></ul>",
                "popup_communist": "<h3>D\xe9clencheur d'assaut communiste</h3><strong>Description :</strong><br>Saisir et redistribuer l'int\xe9gralit\xe9 de la richesse d'un portefeuille cibl\xe9 au collectif.<br><br><strong>Fonctionnement :</strong><br>La richesse de la cible (capital, actions, mati\xe8res premi\xe8res) est r\xe9partie \xe9quitablement entre les participants actifs. Aucun trader ne s'enrichit de mani\xe8re significative, garantissant un b\xe9n\xe9fice communautaire.<br><br><strong>Lecture conceptuelle :</strong><br>Cette action symbolise une redistribution extr\xeame, testant l'\xe9quit\xe9 de la confiscation des richesses au nom du bien commun. Elle soul\xe8ve des questions \xe9thiques sur le droit de propri\xe9t\xe9 et la moralit\xe9 de la redistribution forc\xe9e.<br><br><em>La richesse doit-elle \xeatre partag\xe9e \xe9quitablement, m\xeame si cela implique de confisquer le succ\xe8s d'autrui ?</em>",
                "popup_socialist": "<h3>D\xe9clencheur de subvention socialiste</h3><strong>Description :</strong><br>Taxer un portefeuille riche et redistribuer les ressources aux traders moins favoris\xe9s.<br><br><strong>Fonctionnement :</strong><br>50 % de la richesse du portefeuille cibl\xe9 est tax\xe9e et redistribu\xe9e proportionnellement aux traders disposant de plus petits avoirs, dans le but d'\xe9quilibrer le march\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>La \xab subvention socialiste \xbb refl\xe8te la tension entre soutien au bien collectif et d\xe9couragement de l'ambition. Elle met en lumi\xe8re les difficult\xe9s de la lutte contre les in\xe9galit\xe9s sans freiner l'innovation ou la croissance.<br><br><em>Comment concilier \xe9quit\xe9 et r\xe9ussite individuelle ?</em>",
                "popup_lbo": "<h3>Rachat avec effet de levier capitaliste (LBO)</h3><strong>Description :</strong><br>Acqu\xe9rir de mani\xe8re agressive les actifs d'un autre portefeuille via un rachat avec effet de levier.<br><br><strong>Fonctionnement :</strong><br>Le trader acqu\xe9reur prend le contr\xf4le total du portefeuille cibl\xe9, \xe0 un co\xfbt s\xe9v\xe8re pour celui-ci. La transaction est coercitive mais compensatoire : la cible est pay\xe9e, et l'initiateur paie un prix excessif.<br><br><strong>Lecture conceptuelle :</strong><br>Le \xab LBO capitaliste \xbb illustre le pouvoir de la richesse \xe0 supplanter l'autonomie, mettant en lumi\xe8re les dynamiques du capitalisme agressif. Il interroge l'\xe9quilibre entre concurrence loyale et exploitation.<br><br><em>Est-il \xe9thique de tirer profit au d\xe9triment de l'autonomie d'un autre ?</em>",
                "popup_tools": "<h3>Outils du trader</h3><strong>Description :</strong><br>Utilitaires permettant d'effectuer des actions de march\xe9 avec ou contre d'autres traders.<br><br><strong>Lecture conceptuelle :</strong><br>Voler, ran\xe7onner, n\xe9gocier en priv\xe9 : chaque d\xe9clencheur met \xe0 l'\xe9preuve jusqu'o\xf9 vous \xeates pr\xeat \xe0 aller dans la qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s \u2014 ou franchirez-vous les limites au d\xe9triment des autres ?<br><br>La ZEconomy pose ces questions et vous laisse d\xe9cider ce que \xab valeur \xbb signifie r\xe9ellement, et ce que vous \xeates pr\xeat \xe0 faire pour l'obtenir.",
                "popup_steal": "<h3>Voler un objet</h3><strong>Description :</strong><br>Prendre des actifs d'un autre portefeuille de mani\xe8re anonyme, sans autorisation.<br><br><strong>Fonctionnement :</strong><br>L'objet s\xe9lectionn\xe9 est transf\xe9r\xe9 du portefeuille cibl\xe9 vers le v\xf4tre sans consentement. L'action reste anonyme, emp\xeachant toute repr\xe9saille imm\xe9diate.<br><br><strong>Lecture conceptuelle :</strong><br>Le vol met \xe0 l'\xe9preuve les limites \xe9thiques, explorant la priorit\xe9 accord\xe9e au gain personnel par rapport \xe0 l'empathie et \xe0 la confiance collective. Il invite \xe0 r\xe9fl\xe9chir aux cons\xe9quences des actes et \xe0 la valeur accord\xe9e \xe0 l'\xe9quit\xe9 dans la ZEconomy.",
                "popup_ransom": "<h3>Ran\xe7onner un portefeuille</h3><strong>Description :</strong><br>Verrouiller le portefeuille d'un autre trader et exiger une ran\xe7on pour le d\xe9verrouiller.<br><br><strong>Fonctionnement :</strong><br>Le portefeuille cibl\xe9 est verrouill\xe9 et devient inutilisable jusqu'au r\xe8glement de la ran\xe7on. Le trader initiateur gagne des points si la ran\xe7on est pay\xe9e. Son identit\xe9 est r\xe9v\xe9l\xe9e \xe0 la victime, introduisant une cons\xe9quence sociale directe.<br><br><strong>Lecture conceptuelle :</strong><br>La ran\xe7on explore les dynamiques de pouvoir et de coercition dans l'\xe9change. Elle force les traders \xe0 \xe9valuer si le gain financier l'emporte sur les retomb\xe9es sociales et les enjeux \xe9thiques.",
                "popup_darkpool": "<h3>Dark Pool</h3><strong>Description :</strong><br>\xc9tablir un groupe de trading priv\xe9, dissimul\xe9 du march\xe9 public.<br><br><strong>Fonctionnement :</strong><br>Cr\xe9e un espace d'\xe9change priv\xe9 et temporaire r\xe9serv\xe9 \xe0 certains participants. Les transactions effectu\xe9es dans le Dark Pool sont invisibles pour le march\xe9 global, permettant de fixer librement prix et conditions.<br><br><strong>Lecture conceptuelle :</strong><br>Les Dark Pools incarnent la tension entre collaboration et manipulation. Ils offrent la possibilit\xe9 de n\xe9gocier hors regard public, tout en remettant en question l'\xe9quit\xe9 et la transparence du march\xe9.",
                "popup_emotional": "<h3>Indice de dette \xe9motionnelle</h3><strong>Flux des \xe9motions humaines</strong><br><br><strong>Reconna\xeetre la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle.</strong><br><br>La valeur dans la ZEconomy n'est pas extraite, elle est ressentie. Chaque geste \u2014 aide, confiance, abandon, envie \u2014 laisse une trace : une dette \xe9motionnelle mesurable, positive ou n\xe9gative. Nous portons cette dette, que nous le voulions ou non.<br><br>Tenir l'autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule \xe0 travers nous.<br><br><strong>Indice relationnel</strong> \u2014 Mesure de l'int\xe9grit\xe9 relationnelle : il augmente avec l'honneur et l'entraide, et diminue avec l'exploitation et la trahison.<br><br><strong>\xc9quilibre existentiel</strong> \u2014 Mesure de l'impact de vos actions sur les profits de vie des autres. All\xe9gez-vous ou alourdissez-vous leurs charges symboliques ?<br><br><em>Rejetez le fantasme du capital, embrassez la liquidit\xe9 du ressenti humain.</em>",
                "popup_bigboard": "<h3>The Big Board</h3><strong>Visualisation du march\xe9 en temps r\xe9el</strong><br><br>The Big Board visualise l'activit\xe9 en direct, accumulant humeurs et actions, changeant de couleur au fil de la session.<br><br>Non pas des chiffres fictifs comme le S&P 500, mais une <em>pr\xe9sence ressentie rendue visible</em>.<br><br><strong>Ce que vous conservez :</strong><br>\xc0 la fin de la session, The Big Board devient une \u0153uvre g\xe9n\xe9rative \u2014 un instantan\xe9 fig\xe9 de chaque \xe9change, chaque \xe9motion, chaque moment collectif. Le portrait de votre organisation, rendu \xe0 travers le comportement \xe9conomique.",
                "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>Le march\xe9 vous r\xe9pond</strong><br><br>Un syst\xe8me d'IA observe chaque transaction et devient la voix du march\xe9 lui-m\xeame. Il ne calcule ni profits ni pertes ; il <em>interpr\xe8te</em>.<br><br>Il r\xe9pond \xe0 des questions telles que : <em>Pourquoi avez-vous effectu\xe9 cet \xe9change ? Que sugg\xe8re-t-il ?</em><br><br>Le march\xe9 exprime une opinion sur ce qui s'y \xe9change, tout en restant agnostique quant \xe0 la valeur elle-m\xeame.<br><br>Au fil de l'\xe9v\xe9nement, un r\xe9cit \xe9merge : un portrait collectif dessin\xe9 par le comportement \xe9conomique. Une narration \xe9crite par l'IA des dynamiques de votre groupe.",
                "popup_centralbank": "<h3>Contr\xf4le du march\xe9</h3><strong>Description :</strong><br>Ouvrir et fermer le march\xe9, et configurer les types d'actifs visibles et \xe9changeables par les traders.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les types d'actifs (actions, obligations, commodit\xe9) \xe0 activer ou d\xe9sactiver via le menu d\xe9roulant, puis appliquez les changements.<br><br><strong>Lecture conceptuelle :</strong><br>Faites sonner la cloche et \xe9changez. L'op\xe9rateur de la place contr\xf4le quand le march\xe9 est actif et sur quelles formes de valeur l'attention se porte. Ce pouvoir fa\xe7onne toute la dynamique de la session.",
                "popup_taxall": "<h3>Taxer tous les traders</h3><strong>Description :</strong><br>D\xe9clencher un \xe9v\xe9nement fiscal affectant tous les traders actifs. Ils peuvent choisir de payer en capital ou en mati\xe8res premi\xe8res ; l'absence de r\xe9ponse entra\xeene une taxation des deux.<br><br><strong>Mode d'emploi :</strong><br>D\xe9finissez le montant de la taxe (capital et Zollars), puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>Introduit des cons\xe9quences macro\xe9conomiques via des politiques fiscales. Cela peut favoriser l'\xe9quilibre ou g\xe9n\xe9rer de la frustration, testant l'adaptabilit\xe9 des traders aux changements syst\xe9miques.",
                "popup_taxitem": "<h3>Taxer une marchandise</h3><strong>Description :</strong><br>Retirer al\xe9atoirement une marchandise des portefeuilles des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les traders dans la liste active, puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>La taxation cibl\xe9e permet \xe0 la banque de r\xe9\xe9quilibrer \u2014 ou d\xe9s\xe9quilibrer \u2014 le march\xe9, for\xe7ant les traders \xe0 adapter leurs strat\xe9gies. Elle \xe9voque les saisies d'actifs et soul\xe8ve des questions \xe9thiques sur l'application s\xe9lective.",
                "popup_taxpoints": "<h3>Taxer le capital</h3><strong>Description :</strong><br>Taxer les gains num\xe9riques des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant \xe0 d\xe9duire, s\xe9lectionnez les traders concern\xe9s, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Outil de discipline ou d'\xe9quilibrage, cette taxation cibl\xe9e peut niveler le terrain ou servir de sanction. Elle met \xe0 l'\xe9preuve la r\xe9silience des traders tout en questionnant l'\xe9quit\xe9 fiscale.",
                "popup_givezollar": "<h3>Accorder une subvention en Zollars</h3><strong>Description :</strong><br>Ajouter une valeur en Zollars aux traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Choisissez les traders, pr\xe9cisez le quantit\xe9 de Zollars, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Repr\xe9sente une stimulation \xe9conomique ou une r\xe9compense. Utilisez-la pour relancer un trader en difficult\xe9 ou offrir un avantage fond\xe9 sur une monnaie relationnelle.",
                "popup_givepoints": "<h3>Accorder une subvention en capital</h3><strong>Description :</strong><br>Ajouter une valeur num\xe9rique (capital) aux portefeuilles des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant de capital, s\xe9lectionnez les traders, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Stimulation \xe9conomique par injection directe de capital. \xc0 utiliser pour relancer des traders en difficult\xe9 ou r\xe9compenser certains comportements.",
                "popup_giveitem": "<h3>Attribuer une commodit\xe9</h3><strong>Description :</strong><br>Attribuer une commodit\xe9 al\xe9atoire aux traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les traders dans la liste active, puis cliquez sur le bouton.<br><br><strong>Lecture conceptuelle :</strong><br>Les commodit\xe9s sont des actifs physiques pouvant servir de levier pour cr\xe9er de la demande et des \xe9changes dans le march\xe9 global.",
                "popup_freebie": "<h3>Distribution de commodit\xe9s (Tous)</h3><strong>Description :</strong><br>Distribuer simultan\xe9ment une commodit\xe9 \xe0 tous les traders actifs.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour activer la subvention.<br><br><strong>Lecture conceptuelle :</strong><br>Favorise la liquidit\xe9 en injectant massivement des ressources dans le march\xe9. Permet de stimuler la consommation et l'activit\xe9 d'\xe9change sur l'ensemble de la session.",
                "popup_publizity": "<h3>Lancer PubliZity</h3><strong>Description :</strong><br>Diffuser une vid\xe9o publicitaire al\xe9atoire mettant en sc\xe8ne des entreprises de la ZEconomy aupr\xe8s de tous les traders.<br><br><strong>Mode d'emploi :</strong><br>Cliquez sur le bouton pour d\xe9clencher la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>PubliZity utilise les codes de la publicit\xe9 pour promouvoir la consommation de la pr\xe9sence au monde. Chaque affiche renvoie \xe0 l'acte de vivre, invitant \xe0 rester ancr\xe9 dans l'instant plut\xf4t qu'\xe0 une distraction vide.",
                "popup_znews": "<h3>Lancer une \xe9dition ZNews</h3><strong>Description :</strong><br>Diffuser une vid\xe9o d'actualit\xe9 al\xe9atoire afin de contextualiser ou commenter le march\xe9.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour lancer la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>ZNews d\xe9tourne les codes des m\xe9dias \xe9conomiques pour d\xe9crire les \xe9v\xe9nements r\xe9cents de la ZEconomy. Les diff\xe9rentes s\xe9ries explorent la vie, l'art et l'\xe9conomie, ind\xe9pendamment des th\xe8mes ou techniques.",
                "popup_createstory": "<h3>Cr\xe9er un th\xe8me narratif</h3><strong>Description :</strong><br>Cr\xe9er un cadre narratif que l'IA utilisera pour interpr\xe9ter et raconter la session de trading.<br><br><strong>Mode d'emploi :</strong><br>Ouvrez la fen\xeatre de cr\xe9ation, saisissez un titre et une description, puis validez.<br><br><strong>Lecture conceptuelle :</strong><br>Le th\xe8me narratif fa\xe7onne la mani\xe8re dont la Voice of the Bourse interpr\xe8te l'activit\xe9 du march\xe9. Il \xe9tablit un prisme narratif \xe0 travers lequel tous les \xe9changes prennent sens.",
                "popup_addbots": "<h3>Ajouter des robo trader</h3><strong>Description :</strong><br>Ajouter des bots de trading automatis\xe9s \xe0 la session pour assurer la liquidit\xe9.<br><br><strong>Mode d'emploi :</strong><br>Configurez le nombre de robo traders et l'intervalle d'action, puis ajoutez-les \xe0 la session.<br><br><strong>Fonctionnement :</strong><br>Les robo trader adoptent diff\xe9rents styles et humeurs de trading. Ils effectuent des transactions automatiques \xe0 intervalles r\xe9guliers, g\xe9n\xe9rant activit\xe9 et liquidit\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>Les robo traders simulent la pr\xe9sence de traders lorsque la participation humaine est faible. Ils cr\xe9ent l'illusion d'un march\xe9 anim\xe9 et garantissent une activit\xe9 constante.",
                "popup_removebots": "<h3>Retirer les robo traders de march\xe9</h3><strong>Description :</strong><br>Supprimer tous les robo traders de trading de la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour retirer tous les robo traders. Leurs actifs (objets, Zollars, actions) sont r\xe9inject\xe9s dans le march\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>Retirer les robo traders rend au march\xe9 son caract\xe8re enti\xe8rement humain. Les actifs qu'ils d\xe9tenaient sont redistribu\xe9s dans le pool disponible.",
                "popup_botstatus": "<h3>\xc9tat des robo traders</h3><strong>Description :</strong><br>Consulter l'\xe9tat actuel des robo traders dans la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour voir le nombre de robo trader actifs, leurs noms et leurs styles de trading.<br><br><strong>Lecture conceptuelle :</strong><br>Surveiller l'activit\xe9 des bots aide l'op\xe9rateur \xe0 comprendre l'\xe9quilibre entre trading automatis\xe9 et humain."
            },
            tuts: {
                market_instructions: `
       <h3>Pr\xe9sentation du March\xe9</h3>
       ZExchange est le March\xe9 de la Z\xc9conomie. C\u{2019}est le c\u{153}ur dynamique des activit\xe9s de trading o\xf9 les traders peuvent explorer, ench\xe9rir, parier \xe0 la baisse et \xe9changer divers actifs. Le March\xe9 est le lieu o\xf9 se prennent les d\xe9cisions strat\xe9giques et o\xf9 se fa\xe7onnent activement les portefeuilles.
       <br><br>
       <h3>Activit\xe9s du March\xe9</h3>
       <strong>1. Explorer les actifs disponibles&nbsp;:</strong><br>
       Parcourez les actifs en liste (actions, marchandises, obligations) avec descriptions et valorisation quasi temps r\xe9el, afin d\u{2019}initier des \xe9changes ou des ench\xe8res en connaissance de cause. Vous pouvez aussi placer des positions \xe0 d\xe9couvert et voir qui a short\xe9 quoi.
       <br><br>
       <strong>2. Envoyer des offres d\u{2019}\xe9change&nbsp;:</strong><br>
       Proposez des \xe9changes de marchandises directement \xe0 d\u{2019}autres traders. Une offre est valable 10&nbsp;secondes&nbsp;; le destinataire peut l\u{2019}accepter ou la refuser. En l\u{2019}absence de r\xe9ponse, elle est refus\xe9e automatiquement. Des frais s\u{2019}appliquent aux deux parties en cas d\u{2019}acceptation.
       <br><br>
       <strong>3. Placer des ench\xe8res&nbsp;:</strong><br>
       Ench\xe9\xadrissez sur les actions et obligations list\xe9es. Les ench\xe8res peuvent permettre d\u{2019}obtenir un actif \xe0 meilleur prix, mais surveillez bien les \xe9ch\xe9ances.
       <br><br>
       <strong>4. Racheter des marchandises&nbsp;:</strong><br>
       S\xe9lectionnez entre 2 et 10 marchandises via leurs cases de rachat. Apr\xe8s la 2e s\xe9lection, le bouton de rachat appara\xeet pour finaliser la proc\xe9dure.
       <br><br>
       <strong>5. Prendre des positions \xe0 d\xe9couvert&nbsp;:</strong><br>
       Pariez sur la baisse de certains actifs. Outil puissant mais risqu\xe9, utile pour moduler vos gains/pertes. La cl\xf4ture se fait depuis votre portefeuille.
       <br><br>
       <h3>M\xe9caniques de trading</h3>
       <strong>1. Frais de transaction&nbsp;:</strong> chaque op\xe9ration a un co\xfbt, pour encourager les \xe9changes r\xe9fl\xe9chis.<br>
       <strong>2. Expiration des ench\xe8res&nbsp;:</strong> si la cible ne r\xe9pond pas dans les temps, l\u{2019}ench\xe8re expire (des p\xe9nalit\xe9s peuvent s\u{2019}appliquer \xe0 l\u{2019}absence de r\xe9ponse).<br>
       <strong>3. P\xe9nalit\xe9s sur offres&nbsp;:</strong> refuser une offre peut entra\xeener une p\xe9nalit\xe9 d\u{2019}earnings pour le refusant (et des frais si l\u{2019}offre est accept\xe9e).
       <br><br>
       <h3>Qu\u{2019}est-ce qu\u{2019}une bourse&nbsp;?</h3>
       Une bourse est une plateforme o\xf9 l\u{2019}on ach\xe8te et vend des actifs (actions, obligations, marchandises) selon l\u{2019}offre, la demande et la strat\xe9gie. La ZExchange d\xe9place la valeur vers les exp\xe9riences humaines, les relations et l\u{2019}\xe9change social. \xab&nbsp;Plus&nbsp;\xbb n\u{2019}est pas n\xe9cessairement \xab&nbsp;mieux&nbsp;\xbb. On privil\xe9gie la collaboration, l\u{2019}\xe9thique de la comp\xe9tition et la valeur des exp\xe9riences partag\xe9es.
       <br><br>
       En participant \xe0 la ZExchange, vous engagez une exp\xe9rience financi\xe8re qui met l\u{2019}accent sur l\u{2019}humain. Il s\u{2019}agit de d\xe9passer l\u{2019}accumulation mat\xe9rielle pour consid\xe9rer&nbsp;:
       <br><br>
       <strong>Dynamiques relationnelles&nbsp;:</strong> comment les interactions influencent les d\xe9cisions.<br>
       <strong>Trading \xe9thique&nbsp;:</strong> vos strat\xe9gies sont-elles align\xe9es avec vos valeurs&nbsp;?<br>
       <strong>Valeur exp\xe9rientielle&nbsp;:</strong> comment les \xe9changes refl\xe8tent et fa\xe7onnent les exp\xe9riences humaines.
     `,
                stock_trade_instructions: `
       <h3>Processus d\u{2019}ench\xe8re d\u{2019}actions</h3>
       <strong>Qu\u{2019}est-ce qu\u{2019}une action&nbsp;?</strong><br>
       En finance, une action repr\xe9sente une part d\u{2019}entreprise. Sa valeur \xe9volue ; vos positions aussi.
       <br><br>
       <strong>Actions dans la Z\xc9conomie&nbsp;:</strong><br>
       Ici, les actions refl\xe8tent des valeurs humaines (bien-\xeatre, liens sociaux, croissance personnelle). Trader devient une interaction avec des valeurs de vie, pas seulement un gain financier.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Investir, c\xe9der ou shorter interroge&nbsp;: soutenez-vous des exp\xe9riences humaines ou les exploitez-vous&nbsp;? Chaque trade exprime vos priorit\xe9s.
       <br><br>
       <strong>Processus&nbsp;:</strong><br>
       1) Parcourez les actions disponibles (valeur, propri\xe9taire, potentiel).<br>
       2) Choisissez acheter / vendre / shorter selon votre lecture du march\xe9.<br>
       3) Ex\xe9cutez la transaction (quantit\xe9, confirmation) et observez la mise \xe0 jour de votre portefeuille.
       <br><br>
       <strong>Capital d\u{2019}attention&nbsp;:</strong><br>
       Les valeurs bougent vite ; shorting comporte un risque \xe9thique et financier ; chaque d\xe9cision refl\xe8te vos convictions.
     `,
                redeem_instructions: `
       <h3>Proc\xe9dure de rachat</h3>
       <strong>D\xe9finition&nbsp;:</strong><br>
       Le rachat transforme une marchandise en code&nbsp;QR pour un retrait physique tout en la retirant du march\xe9 et de votre portefeuille.
       <br><br>
       <strong>Particularit\xe9&nbsp;:</strong><br>
       Le rachat r\xe9ussit seulement si les autres traders cibl\xe9s acceptent de racheter en m\xeame temps.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Le rachat d\xe9place l\u{2019}acte de consommer vers une d\xe9cision collective et consciente, renfor\xe7ant les liens sociaux et questionnant nos habitudes d\u{2019}achat.
       <br><br>
       <strong>\xc9tapes&nbsp;:</strong><br>
       1) S\xe9lectionnez vos marchandises et vos cibles.<br>
       2) Envoyez la demande de rachat (verrouillage 10&nbsp;s).<br>
       3) <em>Tous acceptent</em>&nbsp;: vous recevez un bonus et le code&nbsp;QR pour le retrait.<br>
       4) <em>Quelqu\u{2019}un refuse</em>&nbsp;: rien ne change, tout se d\xe9verrouille.
     `,
                transact_instructions: `
       <h3>Commodity&nbsp;X \u{2014} Rachat social</h3>
       <strong>Du bien \xe0 l\u{2019}interaction&nbsp;:</strong><br>
       La consommation devient relationnelle&nbsp;: le \xab&nbsp;oui&nbsp;\xbb collectif prime sur l\u{2019}acte individuel.
       <br><br>
       <strong>Processus social&nbsp;:</strong><br>
       S\xe9lectionnez votre Commodity&nbsp;X, invitez 1\u{2013}3 traders \xe0 racheter en m\xeame temps, envoyez la demande (10&nbsp;s). Succ\xe8s si tout le monde accepte&nbsp;; sinon, aucun changement.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Consommer consciemment, avec validation sociale&nbsp;: la valeur \xe9merge de la relation, pas de l\u{2019}isolement.
     `,
                no_instructions: "Aucune instruction disponible.",
                no_info: "Aucune information disponible.",
                no_tutorial: "Aucun tutoriel disponible.",
                // === banner & button popups (keys must match your element ids) ===
                instructions: {
                    "trader_mood_gauge": "Jauge d'humeur des traders",
                    "description": "Description :",
                    "trader_gauge_description": "Cette jauge illustre l'humeur collective des traders pendant la s\xe9ance de march\xe9 en cours.",
                    "conceptual_insight": "Perspective conceptuelle :",
                    "gains_losses": "Gains / Pertes",
                    "portfolio_banner_description": "Cliquez sur la banni\xe8re pour voir la r\xe9partition de vos gains.",
                    "trader_tools": "Outils du trader",
                    "trader_tools_description": "Utilitaires pour effectuer des actions li\xe9es au march\xe9 avec ou contre d'autres traders.",
                    "trader_tools_insight": "Que vous voliez, ran\xe7onniez ou n\xe9gociiez en priv\xe9 : chaque d\xe9clencheur teste jusqu'o\xf9 vous irez dans la qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s, ou repousserez-vous les limites aux d\xe9pens des autres ? La Z\xc9conomie soul\xe8ve ces questions, vous laissant d\xe9cider de ce que \xab valeur \xbb signifie vraiment et ce que vous \xeates pr\xeat \xe0 faire pour l'obtenir.",
                    "transaction_instructions": "<h3>Instructions de Transaction</h3><p>S\xe9lectionnez un actif de vos avoirs pour proposer un \xe9change avec le propri\xe9taire de l'article. Cela permet l'\xe9change de marchandises entre portefeuilles de pair \xe0 pair.</p>",
                    "stock_instructions": "<h3>Instructions de Trading d'Actions</h3><p>Achetez des actions en saisissant la quantit\xe9 que vous souhaitez acheter. Votre capital disponible est affich\xe9 ci-dessus. Chaque transaction affecte le march\xe9 et construit votre portefeuille.</p>",
                    "bond_instructions": "<h3>Instructions de Trading d'Obligations</h3><p>\xc9changez des Z-Obligations, les instruments de dette \xe9motionnelle du Syst\xe8me Mon\xe9taire Relationnel Z. Les obligations repr\xe9sentent le capital relationnel entre traders.</p>",
                    // === popups ===
                    'portfolio-banner': `
        <h3>Gains / Pertes</h3>
        Cliquez sur la banni\xe8re pour afficher le d\xe9tail de vos gains.
      `,
                    'tools-banner': `
        <h3>Outils du trader</h3>
        Outils pour r\xe9aliser des actions li\xe9es au march\xe9, avec ou contre d\u{2019}autres traders.
        <br><br>
        Que vous voliez, ran\xe7onniez ou n\xe9gociiez en priv\xe9&nbsp;: chaque d\xe9clencheur teste jusqu\u{2019}o\xf9 vous irez dans votre qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s, ou franchirez-vous les limites aux d\xe9pens d\u{2019}autrui ? La ZEconomy pose ces questions et vous laisse d\xe9finir ce que \xab valeur \xbb signifie vraiment et jusqu\u{2019}o\xf9 vous \xeates pr\xeat \xe0 aller pour l\u{2019}obtenir.
      `,
                    'emotional-state-banner': `
        <h3>Indice de Dette \xc9motionnelle</h3>
        <strong>Flux des \xe9motions humaines</strong>
        <br><br>
        <strong>D\xe9couvrir la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle.</strong>
        <br><br>
        Dans cette \xe9conomie, la valeur ne s\u{2019}extrait pas : elle se ressent.
        Chaque geste \u{2014} aide, confiance, abandon, envie \u{2014} laisse une trace : un gain ou une perte \xe9motionnelle mesurable.
        Le \xab Profit de Vie \xbb devient la monnaie qui prend la temp\xe9rature de notre \xeatre.
        <br><br>
        Tenir l\u{2019}autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule \xe0 travers nous.
        <br><br>
        <strong>Indice de Confiance</strong> \u{2014} Mesure de l\u{2019}int\xe9grit\xe9 relationnelle.
        Il monte avec l\u{2019}honneur et l\u{2019}entraide, baisse avec l\u{2019}exploitation ou la trahison.
        <br><br>
        <strong>Profit de Vie</strong> \u{2014} La monnaie du sensible : ni argent ni possession, mais la valeur \xe9motionnelle et morale accumul\xe9e de votre existence.
        <br><br>
        <em>Rejetez la fantaisie du capital ; embrassez la liquidit\xe9 du sentiment humain.</em>
      `,
                    'social-economy-banner': `
        <h3>Instruments de dette \xe9motionnelle</h3>
        <strong>Ce qui circule ici n'est pas la finance, mais la reconnaissance.</strong>
        <br><br>
        La vuln\xe9rabilit\xe9 devient \xe0 la fois miroir et march\xe9 : chaque profit est l'\xe9cho du risque d'autrui,
        chaque dette une m\xe9moire qui refuse de s'effacer.
        <br><br>
        <strong>Les quatre instruments :</strong><br><br>
        \u{2022} <strong>Billet Z Altrauiste</strong> \u{2014} Aide altruiste sans contrepartie ; votre Profit Vital se lie \xe0 celui de l'autre (destin partag\xe9).<br><br>
        \u{2022} <strong>Note M (Note Mutuelle)</strong> \u{2014} Pr\xeat scell\xe9 par l'aveu : emprunter expose sa fragilit\xe9, pr\xeater assume un risque \xe9motionnel. La confiance prend forme.<br><br>
        \u{2022} <strong>CDO Z-Payday</strong> \u{2014} Exploitation grim\xe9e en lien affectif : siphonner la valeur de la d\xe9tresse, minute apr\xe8s minute ; le registre ne pardonne pas.<br><br>
        \u{2022} <strong>Note V (Note de Vuln\xe9rabilit\xe9)</strong> \u{2014} Le courage de demander : reconna\xeetre le besoin, risquer l'exposition, oser d\xe9pendre. L'aide donn\xe9e ou refus\xe9e fa\xe7onne la confiance.
        <br><br>
        <em>Chaque transaction s'inscrit dans l'Indice de Dette \xc9motionnelle.</em>
      `,
                    'economic-banner': `
          <h3>D\xe9clencheurs d\u{2019}attaque \xe9conomique</h3>
          <strong>Description&nbsp;:</strong><br>
          Ces d\xe9clencheurs incarnent diff\xe9rentes visions id\xe9ologiques de la richesse, du pouvoir et de la dynamique de march\xe9. Ils permettent d\u{2019}appliquer, dans la ZEconomy, des strat\xe9gies inspir\xe9es du communisme, du socialisme ou du capitalisme pour gagner ou redistribuer des avantages. Au-del\xe0 de la finance, ils invitent chacun \xe0 confronter ses convictions sur l\u{2019}\xe9quit\xe9, l\u{2019}ambition et la responsabilit\xe9 collective.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Con\xe7us pour faire r\xe9fl\xe9chir \xe0 l\u{2019}influence des syst\xe8mes \xe9conomiques sur les comportements et les r\xe9sultats, ils mettent en sc\xe8ne des dilemmes r\xe9els&nbsp;:
          <ul>
            <li>Faut-il partager la richesse, m\xeame si cela signifie confisquer la r\xe9ussite ?</li>
            <li>Est-il \xe9thique de profiter au d\xe9triment de l\u{2019}autonomie d\u{2019}autrui ?</li>
            <li>Jusqu\u{2019}o\xf9 iriez-vous pour votre gain personnel ou le bien-\xeatre collectif ?</li>
          </ul>
          \xc0 vous de peser b\xe9n\xe9fice individuel et cons\xe9quences sociales. La ZEconomy s\u{2019}en sert pour nourrir le d\xe9bat sur l\u{2019}\xe9quilibre entre justice, ambition et compromis \xe9thiques.
        `,
                    'stocks-banner': `
          <h3>Actions (Shares)</h3>
          <strong>Description&nbsp;:</strong><br>
          Surveillez et \xe9changez vos positions en actions.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          Dans la finance classique, une action repr\xe9sente une part de propri\xe9t\xe9 dans une entreprise, achet\xe9e dans l\u{2019}espoir d\u{2019}une valorisation.
          <br><br>
          Dans la ZEconomy, chaque \xab entreprise \xbb incarne une valeur humaine : bien-\xeatre \xe9motionnel, relations sociales, activit\xe9s quotidiennes\u{2026} En \xab investissant \xbb dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilit\xe9 d\u{2019}exp\xe9riences humaines.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Cela remet en question la notion de profit : s\u{2019}agit-il d\u{2019}un gain mon\xe9taire ou du soutien \xe0 l\u{2019}expansion de la valeur de la vie ? Vos actions refl\xe8tent-elles ce que vous valorisez ou ce que vous voyez de valeur chez les autres ?
          <br><br>
          Chaque transaction souligne la tension entre l\u{2019}appui sinc\xe8re aux exp\xe9riences humaines et leur exploitation financi\xe8re.
          <br><br>
          <strong>M\xe9canique&nbsp;:</strong><br>
          Les actions se n\xe9gocient contre des Zollars ou du capital. Si la valeur de l\u{2019}\xab entreprise \xbb monte, votre portefeuille s\u{2019}appr\xe9cie ; si elle baisse, il se d\xe9pr\xe9cie.
        `,
                    'shorts-banner': `
          <h3>Ventes \xe0 d\xe9couvert</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez et g\xe9rez vos positions \xe0 d\xe9couvert.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          La vente \xe0 d\xe9couvert est un pari sur la baisse d\u{2019}un actif. Vous empruntez des actions sans consentement, les vendez, puis les rachetez moins cher pour les rendre, empochant la diff\xe9rence. Si le prix monte, vous perdez.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Elle illustre le paradoxe de \xab profiter de la chute \xbb, questionnant l\u{2019}\xe9thique de miser sur l\u{2019}\xe9chec. Dans un syst\xe8me o\xf9 la vie est l\u{2019}actif, est-il juste de parier sur la faillite ?
          <br><br>
          <strong>Exemple&nbsp;:</strong><br>
          <em>Conceptualisation&nbsp;:</em> Vous empruntez le t\xe9l\xe9phone d\u{2019}un ami, le vendez 100 \u{20AC}, en rachetez un autre 90 \u{20AC} ; vous rendez l\u{2019}appareil et gagnez 10 \u{20AC}. Dans la vraie vie, c\u{2019}est du vol ; en finance, c\u{2019}est une technique de trading.
          <br><br>
          <strong>Ressource suppl\xe9mentaire&nbsp;:</strong><br>
          Vid\xe9o explicative : Techniques de life-trading \u{2013} Shorting
        `,
                    'commodities-banner': `
          <h3>Marchandises</h3>
          <strong>Description&nbsp;:</strong><br>
          Les biens physiques que vous pouvez \xe9changer ou racheter.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Les marchandises ancrent la ZEconomy dans le monde r\xe9el : elles rappellent que les march\xe9s concernent aussi les objets et exp\xe9riences qui fa\xe7onnent notre quotidien. Choisir de les racheter vous fait r\xe9fl\xe9chir \xe0 la consommation, \xe0 la valeur de la propri\xe9t\xe9 et \xe0 la mani\xe8re dont l\u{2019}\xe9change favorise la communaut\xe9.
          <br><br>
          <strong>D\xe9tails&nbsp;:</strong><br>
          Chaque marchandise est convertible en QR code via la proc\xe9dure de rachat ; une fois \xe9chang\xe9e, elle sort du march\xe9.
          <br><br>
          <strong>Proc\xe9dure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le march\xe9.</li>
            <li>Cliquez sur \xab Racheter \xbb en bas de l\u{2019}\xe9cran.</li>
            <li>Choisissez celles \xe0 transformer en QR code.</li>
            <li>Apr\xe8s validation, vous recevez un bonus (nouvelle marchandise non rachet\xe9e) et le QR code de l\u{2019}article choisi.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Pr\xe9sentez le QR code \xe0 l\u{2019}endroit indiqu\xe9 pour r\xe9cup\xe9rer la marchandise r\xe9elle. Une fois retir\xe9e, elle n\u{2019}est plus \xe9changeable ; elle rejoint votre vie hors march\xe9.
        `,
                    'redeemed-banner': `
          <h3>Objets rachet\xe9s</h3>
          <strong>Description&nbsp;:</strong><br>
          Affichez les codes&nbsp;QR de vos objets rachet\xe9s.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Chacune de vos marchandises correspond \xe0 un objet physique pouvant \xeatre rachet\xe9 via la proc\xe9dure de rachat du march\xe9. Une fois rachet\xe9e, la marchandise est convertie en code&nbsp;QR : c\u{2019}est la cl\xe9 qui permet de retirer l\u{2019}objet, \xe0 l\u{2019}endroit indiqu\xe9. Tant qu\u{2019}elles ne sont pas rachet\xe9es, les marchandises demeurent sur le march\xe9, ajoutent de la valeur \xe0 votre portefeuille et restent \xe9changeables. Apr\xe8s rachat, elles quittent le march\xe9 ; elles ne sont plus n\xe9gociables et entrent dans votre r\xe9alit\xe9 physique.
          <br><br>
          <strong>Proc\xe9dure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le march\xe9.</li>
            <li>Cliquez sur le bouton \xab Racheter \xbb en bas de l\u{2019}\xe9cran.</li>
            <li>Choisissez la ou les marchandises \xe0 convertir en code&nbsp;QR.</li>
            <li>Une fois la demande accept\xe9e, vous recevez un bonus (une marchandise non rachet\xe9e) ainsi que le code&nbsp;QR de l\u{2019}objet rachet\xe9.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Pr\xe9sentez le code&nbsp;QR \xe0 l\u{2019}emplacement indiqu\xe9 pour r\xe9cup\xe9rer l\u{2019}objet r\xe9el. Apr\xe8s rachat, l\u{2019}objet ne fait plus partie du march\xe9 ; il subsiste comme preuve tangible de vos choix et de votre syst\xe8me de valeurs dans la ZEconomy.
          <br><br>
          <strong>Finalit\xe9 du rachat&nbsp;:</strong><br>
          Racheter une marchandise souligne le lien concret entre l\u{2019}activit\xe9 de march\xe9 et l\u{2019}exp\xe9rience v\xe9cue. Vous \xeates invit\xe9 \xe0 r\xe9fl\xe9chir au moment et aux raisons qui motivent la conversion de valeur de march\xe9 en objet physique : une occasion d\u{2019}examiner vos modes de consommation, les besoins de la communaut\xe9 et l\u{2019}\xe9quilibre entre actifs num\xe9riques et biens mat\xe9riels.
        `,
                    'zbonds-banner': `
          <h3>ZBonds</h3>
          <strong>Description&nbsp;:</strong><br>
          Les ZBonds fonctionnent comme des obligations classiques : vous les achetez (en capitaux dans ce projet), les conservez pendant une dur\xe9e pr\xe9d\xe9finie et, \xe0 l\u{2019}\xe9ch\xe9ance, vous recevez un montant de Zollars. \xc0 l\u{2019}instar des obligations d\u{2019}\xc9tat ou d\u{2019}entreprise, ils peuvent \xeatre achet\xe9s et revendus sur le march\xe9 avant maturit\xe9.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Alors que les obligations traditionnelles financent des \xc9tats ou des entreprises, les ZBonds financent la cr\xe9ation d\u{2019}une monnaie \u{2013} les Zollars \u{2013} dont la valeur repose enti\xe8rement sur les relations humaines et les exp\xe9riences partag\xe9es. Investir dans un ZBond revient \xe0 placer sa confiance dans les valeurs collectives de la communaut\xe9 plut\xf4t que dans de simples rendements financiers.
          <br><br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les ZBonds font le pont entre la notion d\u{2019}\xab obligation \xe0 revenu fixe \xbb et la red\xe9finition de la valeur par la ZEconomy. Ils nous rappellent que nous pouvons investir les uns dans les autres : dans la qualit\xe9 de nos liens, pas seulement dans des soci\xe9t\xe9s ou des gouvernements. En \xab empruntant au futur \xbb pour cr\xe9er des Zollars maintenant, les ZBonds nous invitent \xe0 fa\xe7onner consciemment la valeur de nos liens sociaux et \xe0 replacer la relation au c\u{153}ur d\u{2019}une \xe9conomie florissante.
        `,
                    'zollars-banner': `
          <h3>Zollars</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez votre solde de Zollars et l\u{2019}historique de vos transactions.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          Les Zollars sont une monnaie \xe9mise par la Zederal&nbsp;Reserve dans le cadre du Syst\xe8me mon\xe9taire des relations (Z&nbsp;Relationship Monetary System). Contrairement \xe0 une devise traditionnelle \u{2013} adoss\xe9e \xe0 un m\xe9tal pr\xe9cieux ou \xe0 la confiance envers une banque centrale \u{2013} les Zollars sont index\xe9s sur les qualit\xe9s intangibles des relations humaines, qu\u{2019}elles soient positives ou n\xe9gatives.
          <br><br>
          Dans une monnaie classique, la confiance va \xe0 l\u{2019}institution \xe9mettrice ; les Zollars vous invitent \xe0 consid\xe9rer les relations elles-m\xeames comme \xab r\xe9serve centrale \xbb de valeur. Chaque relation, quelle qu\u{2019}en soit la nature, contribue \xe0 la signification collective des Zollars.
          <br><br>
          <strong>Aper\xe7u&nbsp;:</strong><br>
          Les ZRelationship&nbsp;Zollars red\xe9finissent l\u{2019}\xe9change \xe9conomique en valorisant les liens plut\xf4t que les chiffres. Chaque type de Zollar vous pousse \xe0 r\xe9fl\xe9chir au r\xf4le et \xe0 l\u{2019}importance de diff\xe9rentes connexions dans votre vie.
          <br><br>
          <strong>Types disponibles&nbsp;:</strong>
          <ul>
            <li><strong>Love&nbsp;Zollars&nbsp;:</strong> la valeur que vous accordez \xe0 l\u{2019}amour.</li>
            <li><strong>Friendship&nbsp;Zollars&nbsp;:</strong> confiance, loyaut\xe9 et camaraderie.</li>
            <li><strong>Erotic&nbsp;Zollars&nbsp;:</strong> relations fond\xe9es sur le d\xe9sir et l\u{2019}intimit\xe9.</li>
            <li><strong>Fellowship&nbsp;Zollars&nbsp;:</strong> partenariats professionnels et collaboratifs.</li>
            <li><strong>Hate&nbsp;Zollars&nbsp;:</strong> intensit\xe9 des rapports adverses.</li>
            <li><strong>Superficial&nbsp;Zollars&nbsp;:</strong> interactions br\xe8ves ou de surface.</li>
            <li><strong>Toxic&nbsp;Zollars&nbsp;:</strong> gestion des relations complexes ou nocives.</li>
            <li><strong>Death&nbsp;Zollars&nbsp;:</strong> rapport \xe0 la mortalit\xe9, in\xe9vitable pour tous.</li>
            <li><strong>Custom&nbsp;Zollars&nbsp;:</strong> cr\xe9ez une devise pour des liens uniques ou personnels.</li>
          </ul>
          <br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les Zollars bousculent notre mani\xe8re de \xab chiffrer \xbb la valeur : ils nous poussent \xe0 r\xe9examiner le co\xfbt et l\u{2019}importance de nos liens, socle v\xe9ritable de toute \xe9conomie. Ils rappellent que la valeur ne se r\xe9sume pas aux finances ; elle est enracin\xe9e dans les relations et les connexions qui fa\xe7onnent nos vies.
        `,
                    'messageButton': "<h3>Messagerie</h3>Envoyez des messages aux autres traders (co\xfbt&nbsp;: 20&nbsp;capitaux).",
                    'stealButton': `
          <h3>D\xe9clencheur de vol d\u{2019}actif</h3>
          <strong>Description&nbsp;:</strong><br>
          Le d\xe9clencheur de vol vous permet de d\xe9rober un bien \xe0 un autre trader, anonymement et sans autorisation.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Vol \xbb.</li>
            <li>Choisissez un objet dans la liste des avoirs disponibles.</li>
            <li>Confirmez l\u{2019}action pour finaliser le larcin.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Le vol est universellement condamn\xe9, mais existe sous d\u{2019}innombrables formes, de la petite d\xe9linquance \xe0 la corruption de haut vol. En commettant un vol ici, interrogez-vous : vos limites morales vacillent-elles ? Le plaisir imm\xe9diat de l\u{2019}objet \xab gratuit \xbb compense-t-il le tort caus\xe9 au propri\xe9taire ? Comment \xe9valuez-vous l\u{2019}empathie, la culpabilit\xe9 et le profit personnel dans la ZEconomy ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous rep\xe9rez une marchandise convoit\xe9e sur le grand tableau. Gr\xe2ce au d\xe9clencheur de vol, vous l\u{2019}ajoutez \xe0 votre portefeuille\u{2026} mais comment vivez-vous le fait d\u{2019}avoir gagn\xe9 de la \xab valeur \xbb en l\xe9sant autrui ?
        `,
                    'ransomButton': `
          <h3>D\xe9clencheur de ran\xe7on d\u{2019}un trader</h3>
          <strong>Description&nbsp;:</strong><br>
          Verrouille le portefeuille d\u{2019}un trader et l\u{2019}oblige \xe0 payer votre ran\xe7on pour reprendre ses activit\xe9s.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Ran\xe7on \xbb.</li>
            <li>S\xe9lectionnez le portefeuille \xe0 ran\xe7onner.</li>
            <li>Saisissez le montant de la ran\xe7on en capitaux.</li>
            <li>Une fois la ran\xe7on pos\xe9e, la victime ne peut plus trader tant qu\u{2019}elle ne paie pas.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          La ran\xe7on s\u{2019}apparente \xe0 de l\u{2019}extorsion. Ill\xe9gale dans le monde r\xe9el, elle n\u{2019}entra\xeene ici qu\u{2019}une sanction sociale : votre identit\xe9 est r\xe9v\xe9l\xe9e \xe0 la victime. Aimez-vous ce pouvoir ? Craignez-vous les repr\xe9sailles ? Le profit justifie-t-il l\u{2019}angoisse impos\xe9e ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous ciblez un trader riche mais \xe0 court de capitaux : en bloquant son portefeuille par une ran\xe7on \xe9lev\xe9e, vous esp\xe9rez un gain rapide \u{2013} \xe0 condition de g\xe9rer la col\xe8re suscit\xe9e.
        `,
                    'deletePortfolioButton': `
          <h3>D\xe9clencheur d\u{2019}assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Saisit et redistribue l\u{2019}int\xe9gralit\xe9 de la richesse d\u{2019}un rival \xe0 l\u{2019}ensemble des traders actifs.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Assaut communiste \xbb.</li>
            <li>Choisissez le portefeuille cible.</li>
            <li>Confirmez pour r\xe9partir instantan\xe9ment tous ses avoirs.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Tout le patrimoine d\u{2019}un trader est confisqu\xe9 puis distribu\xe9. Acte de solidarit\xe9 ou injustice ? Seriez-vous pr\xeat \xe0 perdre vos biens pour le bien commun ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Un hoarder d\xe9s\xe9quilibre le march\xe9 ; vous lancez l\u{2019}assaut et redistribuez ses ressources. La mar\xe9e monte pour tous\u{2026} mais au prix d\u{2019}une confiscation forc\xe9e.
        `,
                    'LBOButton': `
          <h3>D\xe9clencheur capitaliste<br>(LBO) Rachat par levier</h3>
          <strong>Description&nbsp;:</strong><br>
          Rachetez agressivement les actifs d\u{2019}un autre trader, qu\u{2019}il le veuille ou non.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab LBO capitaliste \xbb.</li>
            <li>S\xe9lectionnez le portefeuille cible.</li>
            <li>Payez une somme importante en capital (capital \xe0 effet de levier).</li>
            <li>Vous prenez alors possession de ses items et actions.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          LBO = emprunt massif pour une prise de contr\xf4le. M\xeame si la cible re\xe7oit un paiement, l\u{2019}op\xe9ration reste coercitive. Richesse = pouvoir ; \xeates-vous pour la libre concurrence ou l\u{2019}exploitation ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous rep\xe9rez un petit portefeuille prometteur. En payant une prime \xe9lev\xe9e, vous le rachetez de force : il est d\xe9dommag\xe9, mais vous gagnez la mainmise \u{2013} juste ou abusif ?
        `,
                    'SubsidyButton': `
          <h3>D\xe9clencheur<br>de subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          \xab Taxez \xbb un portefeuille riche pour soutenir la moiti\xe9 la plus pauvre du march\xe9.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Subvention socialiste \xbb.</li>
            <li>Choisissez un portefeuille fortun\xe9.</li>
            <li>Validez la taxe : la richesse pr\xe9lev\xe9e est r\xe9partie entre les traders les moins ais\xe9s.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Prendre aux riches pour aider les plus d\xe9munis : \xe9galit\xe9 ou punition du succ\xe8s ? La justice sociale prime-t-elle sur la libert\xe9 individuelle ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Voyant un joueur satur\xe9 de stocks alors que d\u{2019}autres peinent, vous appliquez la subvention : la richesse est tax\xe9e puis inject\xe9e chez les plus pauvres. \xc9quit\xe9 ou sanction ? \xc0 vous de juger.
        `,
                    'helpFriendButton': `
          <h3>Billet Z Altrauiste</h3>
          <strong>Valeur de vie altruiste. Pure empathie.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Donner sans rien attendre. En aidant quelqu'un, vous vous liez \xe0 la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le n\xe9gatif. Un pari silencieux : le bien-\xeatre d'autrui pourrait \xe9largir votre propre capacit\xe9 \xe0 ressentir, \xe0 d\xe9ployer votre empathie.
          <br><br>
          <strong>Sans contrepartie.</strong>
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Une transaction qui lie deux registres ; une mise en commun des variances plut\xf4t qu'une simple addition. En \xe9mettant un Billet Z Altrauiste, vous ne faites pas qu'aider : vous tissez votre \xe9conomie \xe9motionnelle \xe0 celle de l'autre. Ses victoires deviennent les v\xf4tres, ses \xe9checs vous incombent aussi.
          <br><br>
          Cela soul\xe8ve une question&nbsp;: <em>L'empathie peut-elle \xeatre un investissement&nbsp;? Qu'advient-il lorsque la douleur de l'autre devient votre perte, sa joie votre gain&nbsp;?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre un Billet Z Altrauiste \xbb, choisissez un trader \xe0 soutenir, s\xe9lectionnez votre don (Zollars ou Capital), puis confirmez. Votre Profit Vital fluctuera d\xe9sormais avec le sien \u{2014} un destin \xe9motionnel partag\xe9.
        `,
                    'borrowCapitalButton': `
          <h3>Note M (Note Mutuelle)</h3>
          <strong>Un pr\xeat scell\xe9 par l'aveu.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          La Note M engendre du cr\xe9dit \xe0 partir d'un besoin mis \xe0 nu et d'une confiance mesur\xe9e. Valeur n\xe9e de l'empathie humaine \u{2014} du partage de nos imperfections. L'emprunteur expose une faiblesse ; le pr\xeateur accepte le risque, faisant de l'empathie une forme d'investissement.
          <br><br>
          Ce qui d\xe9bute comme reconnaissance devient obligation \u{2014} la vuln\xe9rabilit\xe9 se mue en Collat\xe9ral Relationnel Z, les int\xe9r\xeats croissant en attention, en reconnaissance, en Profit Vital mutuel.
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Un int\xe9r\xeat modul\xe9 par l'\xe9motion ; le temps se dilate au gr\xe9 de l'humeur. Contrairement aux pr\xeats classiques, la Note M ne transf\xe8re pas que du capital : elle transf\xe8re la vuln\xe9rabilit\xe9. L'emprunteur doit confesser son besoin, exposant sa fragilit\xe9 pour gagner la confiance.
          <br><br>
          Le pr\xeateur ne fournit pas que des ressources ; il endosse le risque \xe9motionnel de cette fragilit\xe9. Les deux parties se retrouvent li\xe9es : l'emprunteur par l'obligation, le pr\xeateur par l'empathie.
          <br><br>
          <em>Pr\xeater, c'est miser sur la capacit\xe9 de l'autre \xe0 se relever. Emprunter, c'est demander \xe0 quelqu'un de croire en vous.</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre une Note M (Emprunter) \xbb, choisissez un pr\xeateur, r\xe9digez votre confession de vuln\xe9rabilit\xe9 (pourquoi vous avez besoin d'aide), s\xe9lectionnez ce qu'il vous faut (Zollars ou Capital), puis envoyez. Le pr\xeateur d\xe9couvre votre aveu et d\xe9cide si votre fragilit\xe9 m\xe9rite sa confiance.
        `,
                    'predatoryLendButton': `
          <h3>CDO Z-Payday (Obligation de D\xe9sir Collat\xe9ralis\xe9e)</h3>
          <strong>L'exploitation grim\xe9e en lien humain.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          L'empathie et le soulagement se muent en instruments de d\xe9pendance toxique. Les pr\xeats Z-Payday prosp\xe8rent sur le besoin et la cupidit\xe9, convertissant la vuln\xe9rabilit\xe9 en rendement \u{2014} au d\xe9triment de la valeur humaine et de l'\xe9quilibre du syst\xe8me.
          <br><br>
          Chaque cycle de pr\xeat \xe9l\xe8ve le pr\xeateur, \xe9puise l'emprunteur, et laisse au march\xe9 le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction&nbsp;:</strong><br>
          Des gestes d'entraide isol\xe9s deviennent un contrat r\xe9p\xe9titif \u{2014} chaque minute, une nouvelle obligation est \xe9mise, d\xe9coup\xe9e en tranches qui alimentent le CDO global. Le produit promet l'imm\xe9diatet\xe9, puis convertit le vivant en rendement ; la r\xe9colte provient de ce qui s'use quand la bont\xe9 devient m\xe9canique.
          <br><br>
          <strong>Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'\xe0 ce que le registre d\xe9vore le Profit Vital sous-jacent.</strong>
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Le pr\xeat pr\xe9dateur, rendu visible. Contrairement aux cr\xe9dits sur salaire traditionnels, cach\xe9s derri\xe8re le jargon juridique, le CDO Z-Payday vous oblige \xe0 regarder en face ce que vous faites : extraire de la valeur de la d\xe9tresse d'autrui, minute apr\xe8s minute.
          <br><br>
          Question pos\xe9e&nbsp;: <em>Jusqu'o\xf9 irez-vous pour le profit ? Pouvez-vous regarder quelqu'un s'\xe9puiser \xe0 vous rembourser ? Est-ce du business, ou de la cruaut\xe9 ?</em>
          <br><br>
          Le Profit Vital de la victime d\xe9cro\xeet chaque minute, transf\xe9r\xe9 vers vous. Le syst\xe8me tout entier supporte le co\xfbt \xe9motionnel collectif \u{2014} tout le monde ressent l'exploitation.
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre un CDO Z-Payday \xbb, d\xe9signez une victime, fixez le montant \xe0 siphonner par minute, puis confirmez. Chaque minute, son Profit Vital diminue et se transf\xe8re vers vous \u{2014} jusqu'\xe0 ce qu'elle solde la dette ou s'effondre.
          <br><br>
          <strong>Avertissement&nbsp;:</strong> Cette action entra\xeene de lourdes cons\xe9quences sociales et \xe9motionnelles. Les autres le sauront. Le march\xe9 le saura. Votre culpabilit\xe9 s'accumule.
        `,
                    'requestHandoutButton': `
          <h3>Note V (Note de Vuln\xe9rabilit\xe9)</h3>
          <strong>Oser avouer sa fragilit\xe9.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Demander, c'est s'exposer \u{2014} risquer le petit effondrement qui accompagne le fait d'\xeatre vu dans le besoin. La vuln\xe9rabilit\xe9 n'est pas ici faiblesse, mais invitation : un signal que l'\xe9quilibre s'est rompu et qu'il faut une relation pour le restaurer.
          <br><br>
          L'aide, si elle est accord\xe9e, devient un instant partag\xe9 de recalibrage ; si elle est refus\xe9e, elle marque la fracture silencieuse entre confiance et fiert\xe9.
          <br><br>
          Chaque demande s'inscrit dans l'Indice de Dette \xc9motionnelle \u{2014} non pas une mesure de possession, mais du degr\xe9 auquel nous osons encore d\xe9pendre.
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Une requ\xeate justifi\xe9e ; un soulagement conditionn\xe9 \xe0 l'assentiment ; le registre consigne \xe0 la fois l'appel et la r\xe9ponse. Contrairement \xe0 la Note M (pr\xeat formel avec obligation), la Note V est une simple demande \u{2014} sans condition, sans remboursement attendu.
          <br><br>
          Mais demander a son propre prix. Vous devez exposer votre besoin, votre vuln\xe9rabilit\xe9, votre d\xe9pendance. Et la r\xe9ponse \u{2014} acceptation ou rejet \u{2014} fa\xe7onne votre \xe9tat \xe9motionnel et votre confiance envers la communaut\xe9.
          <br><br>
          <em>Pouvez-vous reconna\xeetre avoir besoin d'aide ? Les autres peuvent-ils se permettre de la donner ? Que signifie une aide offerte librement, ou une aide refus\xe9e ?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab Note V (Appel \xe0 l'aide) \xbb, expliquez pourquoi vous avez besoin d'aide (votre d\xe9claration de vuln\xe9rabilit\xe9), choisissez ce que vous demandez (Zollars ou Capital), puis envoyez \xe0 un autre trader. Il peut accepter (vous donner ce que vous avez demand\xe9) ou d\xe9cliner (vous laisser vous d\xe9brouiller). Dans les deux cas, l'impact \xe9motionnel est enregistr\xe9.
        `,
                    'giveDeletePortfolioButton': `
          <h3>Attribuer le d\xe9clencheur d'Assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab Assaut communiste \xbb \xe0 un trader, lui donnant le pouvoir de saisir et redistribuer l'int\xe9gralit\xe9 de la richesse d'un portefeuille au collectif.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          La richesse de la cible (capital, actions, marchandises, etc.) est r\xe9partie \xe9quitablement entre les participants actifs. Personne ne s'enrichit d\xe9mesur\xe9ment : le b\xe9n\xe9fice est communautaire.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Cette action incarne la redistribution radicale, testant l'\xe9quit\xe9 de la confiscation au nom du bien commun. Elle vise \xe0 niveler les disparit\xe9s, mais soul\xe8ve des questions \xe9thiques sur le droit de propri\xe9t\xe9 et la moralit\xe9 de la redistribution forc\xe9e. Attribuer ce bouton, c'est donner le pouvoir d'\xe9quilibrer \u{2014} ou de bouleverser \u{2014} le march\xe9.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque qu'un autre accumule des actifs pr\xe9cieux, cr\xe9ant un d\xe9s\xe9quilibre. Gr\xe2ce \xe0 l'\xab Assaut communiste \xbb, il redistribue la richesse, \xe9galisant les ressources \u{2014} mais risquant d'ali\xe9ner l'accumulateur et certains observateurs.
        `,
                    'giveLBOButton': `
          <h3>Attribuer le d\xe9clencheur<br>LBO capitaliste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab LBO capitaliste \xbb \xe0 un trader, lui donnant le pouvoir d'acqu\xe9rir agressivement les actifs d'un autre portefeuille par rachat \xe0 effet de levier.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          L'acqu\xe9reur prend le contr\xf4le total du portefeuille cible (marchandises, actions, etc.) moyennant un co\xfbt \xe9lev\xe9.
          <br>
          La transaction est coercitive mais compensatoire : la cible re\xe7oit un paiement pour ses actifs, l'initiateur paie une prime.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Le \xab LBO capitaliste \xbb incarne le pouvoir de la richesse \xe0 outrepasser l'autonomie, r\xe9v\xe9lant les dynamiques du capitalisme agressif. Il questionne l'\xe9quilibre entre concurrence loyale et exploitation, montrant comment la puissance financi\xe8re peut dicter le contr\xf4le du march\xe9.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader rep\xe8re un petit portefeuille aux actifs sous-exploit\xe9s. Gr\xe2ce au \xab LBO capitaliste \xbb, il paie une prime pour s'en emparer, consolidant son pouvoir \u{2014} mais s'exposant \xe0 un retour de b\xe2ton pour ses tactiques hostiles.
        `,
                    'giveSubsidyButton': `
          <h3>Attribuer le d\xe9clencheur<br>Subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab Subvention socialiste \xbb \xe0 un trader, lui permettant de ponctionner un portefeuille riche et d'en redistribuer les ressources aux moins nantis.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          50 % de la richesse du portefeuille cible est tax\xe9e et redistribu\xe9e proportionnellement aux traders les moins dot\xe9s, afin de r\xe9\xe9quilibrer le march\xe9.<br>
          Cette m\xe9canique nivelle les disparit\xe9s, mais peut aussi p\xe9naliser le succ\xe8s, alimentant le d\xe9bat sur l'\xe9quit\xe9 et la justice.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          La \xab Subvention socialiste \xbb cristallise la tension entre soutenir le bien-\xeatre collectif et brider l'ambition. En redistribuant la richesse, elle r\xe9v\xe8le la difficult\xe9 de traiter l'in\xe9galit\xe9 sans \xe9touffer l'innovation ou la croissance.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque un portefeuille exc\xe9dentaire alors que d'autres peinent. Gr\xe2ce \xe0 la \xab Subvention socialiste \xbb, il taxe le riche et redistribue aux plus modestes, insufflant un nouvel \xe9lan au march\xe9 et promouvant l'\xe9quit\xe9.
        `,
                    'createCommunityButton': `
          <h3>D\xe9clencheur de<br>Dark Pool</h3>
          <strong>Description&nbsp;:</strong><br>
          Cr\xe9e un espace de march\xe9 priv\xe9, invisible pour le reste de l\u{2019}\xe9change public.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Dark Pool \xbb.</li>
            <li>S\xe9lectionnez les traders \xe0 inviter.</li>
            <li>S\u{2019}ils acceptent, vous disposez de 10 minutes d\u{2019}\xe9changes priv\xe9s.</li>
            <li>Chacun peut quitter le pool \xe0 tout moment et revenir au march\xe9 public.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Les dark pools sont l\u{2019}\xe9quivalent boursier d\u{2019}une communaut\xe9 ferm\xe9e : \xe0 l\u{2019}abri des regards, les participants peuvent librement fixer la \xab valeur \xbb. Coop\xe9ration honn\xeate ou manipulation ? Le secret nuit-il \xe0 la transparence ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous et vos alli\xe9s n\xe9gociez discr\xe8tement des obligations \xe0 un prix avantageux. Gain strat\xe9gique\u{2026} mais la communaut\xe9, une fois inform\xe9e, se sentira-t-elle l\xe9s\xe9e ?
        `,
                    'goToMarketBtn': "Acc\xe9der au march\xe9 principal.",
                    'goToDarkPoolMarketBtn': "Acc\xe9der aux Dark Pools priv\xe9s.",
                    'emotional-debt-banner': `
          <h3>Indice de Dette \xc9motionnelle</h3>
          <strong>La circulation des \xe9motions humaines</strong>
          <br><br>
          D\xe9couvrir la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle. Ici, la valeur ne s'extrait pas : elle se ressent. Chaque geste \u{2014} aide, confiance, abandon, envie \u{2014} laisse une empreinte, un gain ou une perte \xe9motionnelle mesurable, une continuit\xe9. Le Profit Vital est une monnaie de sensation, qui prend la temp\xe9rature de notre \xeatre. Tenir l'autre, se laisser tenir : les formes les plus humaines de levier. La Z\xc9conomie circule \xe0 travers nous.
          <br><br>
          <strong>1. Billet Z Altrauiste</strong><br>
          <em>Valeur de vie altruiste. Pure empathie.</em><br>
          Donner sans rien attendre. Aider quelqu'un, c'est s'impliquer dans la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le n\xe9gatif. Un pari silencieux : le bien-\xeatre d'autrui pourrait \xe9largir votre propre capacit\xe9 \xe0 ressentir, d\xe9ployer votre empathie. Sans contrepartie.
          <br><br>
          <em>(Code miroir : une transaction qui lie deux registres ; une mise en commun des variances plut\xf4t qu'une simple addition.)</em>
          <br><br>
          <strong>2. Note M (Note Mutuelle)</strong><br>
          <em>Un pr\xeat scell\xe9 par l'aveu.</em><br>
          La Note M engendre du cr\xe9dit \xe0 partir d'un besoin mis \xe0 nu et d'une confiance mesur\xe9e. Valeur n\xe9e du partage de nos imperfections. L'emprunteur expose une faiblesse ; le pr\xeateur accepte le risque, faisant de l'empathie un investissement. Ce qui d\xe9bute comme reconnaissance devient obligation \u{2014} la vuln\xe9rabilit\xe9 se mue en Collat\xe9ral Relationnel Z, les int\xe9r\xeats croissant en attention, reconnaissance et Profit Vital mutuel.
          <br><br>
          <em>(Code miroir : int\xe9r\xeat modul\xe9 par l'\xe9motion ; le temps se dilate au gr\xe9 de l'humeur.)</em>
          <br><br>
          <strong>3. CDO Z-Payday (Obligation Collat\xe9ralis\xe9e du D\xe9sir)</strong><br>
          <em>L'exploitation grim\xe9e en lien humain.</em><br>
          L'empathie et le soulagement se muent en instruments de d\xe9pendance toxique. Les pr\xeats Z-Payday prosp\xe8rent sur le besoin et la cupidit\xe9, convertissant la vuln\xe9rabilit\xe9 en rendement au d\xe9triment de la valeur humaine et de l'\xe9quilibre syst\xe9mique. Chaque cycle \xe9l\xe8ve le pr\xeateur, \xe9puise l'emprunteur, et laisse au march\xe9 le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction :</strong> Des gestes d'entraide isol\xe9s deviennent un contrat r\xe9p\xe9titif \u{2014} chaque minute \xe9met une nouvelle obligation, d\xe9coup\xe9e en tranches qui alimentent le CDO global. Le produit promet l'imm\xe9diatet\xe9, puis convertit le vivant en rendement ; la r\xe9colte provient de ce qui s'use quand la bont\xe9 devient m\xe9canique. Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'\xe0 ce que le registre d\xe9vore le Profit Vital sous-jacent.
          <br><br>
          <strong>4. Note V (Note de Vuln\xe9rabilit\xe9)</strong><br>
          <em>Oser avouer sa fragilit\xe9.</em><br>
          Demander, c'est s'exposer \u{2014} risquer le petit effondrement qui accompagne le fait d'\xeatre vu dans le besoin. La vuln\xe9rabilit\xe9 n'est pas ici faiblesse, mais invitation : un signal que l'\xe9quilibre s'est rompu et qu'il faut une relation pour le restaurer. L'aide, si elle est accord\xe9e, devient un instant partag\xe9 de recalibrage ; si elle est refus\xe9e, elle marque la fracture silencieuse entre confiance et fiert\xe9. Chaque demande s'inscrit dans l'Indice de Dette \xc9motionnelle \u{2014} non pas une mesure de possession, mais du degr\xe9 auquel nous osons encore d\xe9pendre.
          <br><br>
          <em>(Code miroir : requ\xeate justifi\xe9e ; soulagement conditionn\xe9 \xe0 l'assentiment ; le registre consigne \xe0 la fois l'appel et la r\xe9ponse.)</em>
          <br><br>
          <strong>Note finale</strong><br>
          Ce qui circule ici n'est pas la finance, mais la reconnaissance. La vuln\xe9rabilit\xe9 devient \xe0 la fois miroir et march\xe9, o\xf9 chaque profit est l'\xe9cho du risque d'autrui, chaque dette une m\xe9moire qui refuse de s'effacer.
          <br><br>
          <h3>Indice de Dette \xc9motionnelle</h3>
          Tout commence par la reconnaissance que la vie accumul\xe9e a un poids \u{2014} que le simple fait de vivre avec les autres engendre une dette \xe9motionnelle, positive ou n\xe9gative, reconnue ou n\xe9glig\xe9e, que nous portons seuls et \xe9changeons ensemble. La dette non comme d\xe9ficit, mais comme acceptation : un instrument des effets de notre intrication mutuelle. Dans la Z\xc9conomie, la Dette \xc9motionnelle est le contrepoint de la productivit\xe9 \u{2014} elle ne suit pas ce qui est produit, mais ce qui est ressenti. Chaque geste, chaque h\xe9sitation, chaque confession ou retrait modifie le registre \xe9motionnel. Ses mouvements traduisent la circulation de l'affect \xe0 travers un syst\xe8me vivant et poreux, o\xf9 la valeur n'est ni extraite ni fabriqu\xe9e, mais engendr\xe9e par l'exp\xe9rience m\xeame de la vie. Les Profits Vitaux, flux qui r\xe9sistent \xe0 l'accumulation, fa\xe7onnent pourtant tout ce qui s'y construit.
          <br><br>
          L'Indice de Dette \xc9motionnelle rend visible la vuln\xe9rabilit\xe9 intime, cartographiant les \xe9conomies invisibles de confiance, d'\xe9puisement, de g\xe9n\xe9rosit\xe9, d'\xe9chec, de d\xe9pendance\u{2026} qui participent \xe0 une instabilit\xe9 ou un \xe9quilibre collectifs. Rejeter la fantaisie du capital ; embrasser la liquidit\xe9 du sentiment humain.
        `
                },
                redeem: {
                    "explanations": "Explications",
                    "redeemAsks": "Demandes de rachat",
                    "redeemableHoldings": "Avoirs rachetables :",
                    "sendRedeemAsks": "Envoyer les demandes de rachat",
                    "returnToMarket": "Retour au march\xe9",
                    "tutsTitle": "Comment fonctionne le rachat",
                    "Item_Name": "Nom du bien",
                    "Owner": "Propri\xe9taire",
                    "Capital": "Capital",
                    "no_selected_items_to_check": "Aucun objet s\xe9lectionn\xe9 \xe0 v\xe9rifier.",
                    "select_target_items": "S\xe9lectionnez les objets \xe0 cibler.",
                    "select_item_to_redeem": "S\xe9lectionnez un objet pour la conversion.",
                    "time_remaining": "Temps restant",
                    "second": "seconde",
                    "seconds": "secondes",
                    "Redemption_offer_accepted": "Offre de conversion accept\xe9e pour le bien :",
                    "Redemption_offer_declined": "Offre de conversion rejet\xe9e pour le bien :",
                    "Waiting_for_response": "En attente de r\xe9ponse...",
                    "DO_NOT_LEAVE": "NE PAS QUITTER LA PAGE",
                    "video_not_supported": "La lecture vid\xe9o n\u2019est pas prise en charge par ce navigateur."
                },
                "common": {
                    "close": "Fermer",
                    "assign": "Assigner",
                    "unassign": "D\xe9sassigner",
                    "delete": "Supprimer",
                    "redeem": "\xc9changer",
                    "unredeem": "Annuler l'\xe9change",
                    "yes": "Oui",
                    "no": "Non",
                    "assigned_to": "assign\xe9 \xe0",
                    "to_market": "au march\xe9",
                    "to_portfolio": "au portefeuille",
                    "successfully": "avec succ\xe8s",
                    "login_required": "Vous devez \xeatre connect\xe9 pour effectuer cette action.",
                    "bond_with_interest_rate": "obligation avec taux d'int\xe9r\xeat",
                    "assign_to_portfolio": "Assigner au Portefeuille",
                    "assign_to_market": "Assigner au March\xe9",
                    "item_name": "Nom de l'objet :",
                    "owner": "Propri\xe9taire :",
                    "trader_name": "Nom du Trader :",
                    "password": "Mot de passe :",
                    "connected": "Connect\xe9 :",
                    "portfolio_id": "ID du Portefeuille :",
                    "points_breakdown": "R\xe9partition des capitaux :",
                    "trading": "Trading",
                    "commodities": "Marchandises",
                    "stocks": "Actions",
                    "shorts": "Positions courtes",
                    "total": "Total :",
                    "holdings": "Avoirs :",
                    "commodity": "Marchandise :",
                    "stock": "Action :",
                    "quantity": "Quantit\xe9",
                    "shares": "Parts",
                    "value": "Valeur",
                    "no_holdings": "Aucun avoir dans ce portefeuille.",
                    "unnamed_portfolio": "Portefeuille sans nom",
                    "protected": "[prot\xe9g\xe9]",
                    "qr_code": "Code QR :",
                    "qr_code_for": "Code QR pour",
                    "no_qr_available": "Aucun code QR disponible.",
                    "custom_relationship_type": "Type de relation personnalis\xe9",
                    "remove": "Supprimer",
                    "created_for_relationship": "Zollar cr\xe9\xe9 pour la relation :",
                    "value_place_relationship": "La valeur que vous placez sur une relation :",
                    "na": "N/D"
                },
                "freeend": {
                    "title": "Session de Trading Termin\xe9e",
                    "trading_analysis": "ANALYSE DE TRADING",
                    "social_standing": "Position Sociale",
                    "return_home": "Retour \xe0 l'Accueil",
                    "panels": {
                        "stocks": "ACTIONS",
                        "items": "OBJETS",
                        "zollars": "ZOLLARS",
                        "bonds": "OBLIGATIONS"
                    },
                    "judgements": {
                        "performance": "Performance",
                        "style": "Style",
                        "social": "Social",
                        "risk": "Risque",
                        "mood": "Humeur"
                    },
                    "ratings": {
                        "excellent": "Excellent",
                        "good": "Bien",
                        "fair": "Moyen",
                        "poor": "M\xe9diocre",
                        "bad": "Mauvais",
                        "neutral": "Neutre",
                        "aggressive": "Agressif",
                        "calm": "Calme",
                        "balanced": "\xc9quilibr\xe9",
                        "active": "Actif",
                        "quiet": "Discret",
                        "moderate": "Mod\xe9r\xe9",
                        "diverse": "Diversifi\xe9",
                        "cautious": "Prudent",
                        "focused": "Cibl\xe9",
                        "euphoric": "Euphorique",
                        "optimistic": "Optimiste",
                        "positive": "Positif",
                        "anxious": "Anxieux",
                        "distressed": "En d\xe9tresse"
                    },
                    "sections": {
                        "social_class_movement": "VOTRE \xc9VOLUTION DE CLASSE SOCIALE",
                        "mood_state": "\xc9TAT D'HUMEUR",
                        "trading_behavior": "COMPORTEMENTS DE TRADING",
                        "commodities_supply": "APPROVISIONNEMENT EN COMMODIT\xc9S"
                    },
                    "labels": {
                        "commodities": "Commodit\xe9s:",
                        "no_commodities": "Aucune commodit\xe9 d\xe9tenue - concentration sur d'autres formes de valeur",
                        "stocks": "G\xe9n\xe9rateurs de Profits (Actions):",
                        "bonds": "Obligations:",
                        "zollar_holdings": "Avoirs en Zollars Relationnels:",
                        "total": "Total:",
                        "session_engagement": "Engagement de Session:",
                        "social_connections": "Connexions Sociales:",
                        "value_movement": "Mouvement de Valeur:"
                    },
                    "value_movement": {
                        "significant_gain": "Gain Significatif",
                        "strong_gain": "Gain Fort",
                        "moderate_gain": "Gain Mod\xe9r\xe9",
                        "slight_gain": "Gain L\xe9ger",
                        "no_change": "Aucun Changement",
                        "slight_loss": "Perte L\xe9g\xe8re",
                        "moderate_loss": "Perte Mod\xe9r\xe9e",
                        "strong_loss": "Perte Forte",
                        "significant_loss": "Perte Significative"
                    },
                    "activity_levels": {
                        "contemplative": "Contemplatif",
                        "measured": "Mesur\xe9",
                        "active": "Actif",
                        "very_active": "Tr\xe8s Actif",
                        "intensely_engaged": "Intens\xe9ment Engag\xe9"
                    },
                    "social_levels": {
                        "solitary": "Solitaire",
                        "selective": "S\xe9lectif",
                        "socially_active": "Socialement Actif",
                        "highly_connected": "Tr\xe8s Connect\xe9"
                    },
                    "emotional_states": {
                        "balanced": "\xc9quilibr\xe9",
                        "triumphant": "Triomphant",
                        "reflective": "R\xe9fl\xe9chi",
                        "socially_engaged": "Socialement Engag\xe9",
                        "energetically_active": "\xc9nergiquement Actif"
                    },
                    "quantities": {
                        "none": "Aucun",
                        "a_few": "Quelques-uns",
                        "some": "Certains",
                        "several": "Plusieurs",
                        "many": "Beaucoup",
                        "quite_a_lot": "Pas Mal",
                        "a_large_amount": "Une Grande Quantit\xe9",
                        "a_huge_amount": "Une \xc9norme Quantit\xe9"
                    }
                }
            }
        }
    }
};
var $0cb39f7c2a1e3ebc$export$2e2bcd8739ae039 = $0cb39f7c2a1e3ebc$var$translations;

});


//# sourceMappingURL=mood.19d90bed.js.map
